/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from 'protobufjs/minimal';
import * as Long from 'long';
$protobuf.util.Long = Long;
$protobuf.configure();

const $Reader = $protobuf.Reader,
  $Writer = $protobuf.Writer,
  $util = $protobuf.util;

const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = {});

export const im_proto = ($root.im_proto = (() => {
  const im_proto = {};

  im_proto.Frame = (function () {
    function Frame(p) {
      this.headers = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    Frame.prototype.seqid = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    Frame.prototype.logid = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    Frame.prototype.service = 0;
    Frame.prototype.method = 0;
    Frame.prototype.headers = $util.emptyArray;
    Frame.prototype.payload_encoding = '';
    Frame.prototype.payload_type = '';
    Frame.prototype.payload = $util.newBuffer([]);

    Frame.create = function create(properties) {
      return new Frame(properties);
    };

    Frame.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).uint64(m.seqid);
      w.uint32(16).uint64(m.logid);
      w.uint32(24).int32(m.service);
      w.uint32(32).int32(m.method);
      if (m.headers != null && m.headers.length) {
        for (var i = 0; i < m.headers.length; ++i)
          $root.im_proto.Frame.ExtendedEntry.encode(m.headers[i], w.uint32(42).fork()).ldelim();
      }
      if (m.payload_encoding != null && Object.hasOwnProperty.call(m, 'payload_encoding'))
        w.uint32(50).string(m.payload_encoding);
      if (m.payload_type != null && Object.hasOwnProperty.call(m, 'payload_type')) w.uint32(58).string(m.payload_type);
      if (m.payload != null && Object.hasOwnProperty.call(m, 'payload')) w.uint32(66).bytes(m.payload);
      return w;
    };

    Frame.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.Frame();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.seqid = r.uint64();
            break;
          case 2:
            m.logid = r.uint64();
            break;
          case 3:
            m.service = r.int32();
            break;
          case 4:
            m.method = r.int32();
            break;
          case 5:
            if (!(m.headers && m.headers.length)) m.headers = [];
            m.headers.push($root.im_proto.Frame.ExtendedEntry.decode(r, r.uint32()));
            break;
          case 6:
            m.payload_encoding = r.string();
            break;
          case 7:
            m.payload_type = r.string();
            break;
          case 8:
            m.payload = r.bytes();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('seqid')) throw $util.ProtocolError("missing required 'seqid'", { instance: m });
      if (!m.hasOwnProperty('logid')) throw $util.ProtocolError("missing required 'logid'", { instance: m });
      if (!m.hasOwnProperty('service')) throw $util.ProtocolError("missing required 'service'", { instance: m });
      if (!m.hasOwnProperty('method')) throw $util.ProtocolError("missing required 'method'", { instance: m });
      return m;
    };

    Frame.ExtendedEntry = (function () {
      function ExtendedEntry(p) {
        if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      ExtendedEntry.prototype.key = '';
      ExtendedEntry.prototype.value = '';

      ExtendedEntry.create = function create(properties) {
        return new ExtendedEntry(properties);
      };

      ExtendedEntry.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        w.uint32(10).string(m.key);
        w.uint32(18).string(m.value);
        return w;
      };

      ExtendedEntry.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.im_proto.Frame.ExtendedEntry();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.key = r.string();
              break;
            case 2:
              m.value = r.string();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        if (!m.hasOwnProperty('key')) throw $util.ProtocolError("missing required 'key'", { instance: m });
        if (!m.hasOwnProperty('value')) throw $util.ProtocolError("missing required 'value'", { instance: m });
        return m;
      };

      return ExtendedEntry;
    })();

    return Frame;
  })();

  im_proto.IMCMD = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'IMCMD_NOT_USED')] = 0;
    values[(valuesById[100] = 'SEND_MESSAGE')] = 100;
    values[(valuesById[200] = 'GET_MESSAGES_BY_USER')] = 200;
    values[(valuesById[201] = 'GET_MESSAGES_BY_USER_INIT')] = 201;
    values[(valuesById[202] = 'REPORT_GET_MESSAGES_CURSOR')] = 202;
    values[(valuesById[203] = 'GET_MESSAGES_BY_USER_INIT_V2')] = 203;
    values[(valuesById[206] = 'GET_MESSAGES_BY_CONVERSATION_SEARCH')] = 206;
    values[(valuesById[210] = 'CHECK_MESSAGES_BY_USER')] = 210;
    values[(valuesById[211] = 'GET_MESSAGE_INFO_BY_SERVER_ID')] = 211;
    values[(valuesById[300] = 'GET_CONVERSATION_LIST')] = 300;
    values[(valuesById[301] = 'GET_MESSAGES_BY_CONVERSATION')] = 301;
    values[(valuesById[302] = 'GET_MESSAGES_CHECKINFO_IN_CONVERSATION')] = 302;
    values[(valuesById[303] = 'GET_MESSAGES_CHECK_INFO_V2')] = 303;
    values[(valuesById[400] = 'SEND_ONLINE')] = 400;
    values[(valuesById[401] = 'SEND_OFFLINE')] = 401;
    values[(valuesById[402] = 'SEND_CLIENT_FOREGROUND')] = 402;
    values[(valuesById[403] = 'SEND_CLIENT_BACKGROUND')] = 403;
    values[(valuesById[410] = 'SEND_USER_ACTION')] = 410;
    values[(valuesById[411] = 'SEND_INPUT_STATUS')] = 411;
    values[(valuesById[500] = 'NEW_MSG_NOTIFY')] = 500;
    values[(valuesById[501] = 'MARK_READ_NOTIFY')] = 501;
    values[(valuesById[502] = 'CONVERSATION_INFO_UPDATED_NOTIFY')] = 502;
    values[(valuesById[504] = 'NEW_DIRECT_PUSH_NOTIFY')] = 504;
    values[(valuesById[510] = 'NEW_INPUT_STATUS_NOTIFY')] = 510;
    values[(valuesById[505] = 'NEW_BROADCAST_MSG_NOTIFY')] = 505;
    values[(valuesById[506] = 'NEW_BROADCAST_CMD_MSG_NOTIFY')] = 506;
    values[(valuesById[507] = 'NEW_PREVIEW_MSG_NOTIFY')] = 507;
    values[(valuesById[508] = 'NEW_FRIEND_MSG_NOTIFY')] = 508;
    values[(valuesById[511] = 'BIZ_DIRECT_PUSH_NOTIFY')] = 511;
    values[(valuesById[600] = 'GET_CONVERSATION_INFO')] = 600;
    values[(valuesById[601] = 'SET_CONVERSATION_INFO')] = 601;
    values[(valuesById[602] = 'CREATE_CONVERSATION')] = 602;
    values[(valuesById[603] = 'MARK_CONVERSATION_DELETE')] = 603;
    values[(valuesById[604] = 'MARK_CONVERSATION_READ')] = 604;
    values[(valuesById[607] = 'GET_CONVERSATION_INFO_LIST')] = 607;
    values[(valuesById[608] = 'GET_CONVERSATION_INFO_V2')] = 608;
    values[(valuesById[609] = 'CREATE_CONVERSATION_V2')] = 609;
    values[(valuesById[610] = 'GET_CONVERSATION_INFO_LIST_V2')] = 610;
    values[(valuesById[611] = 'GET_CONVERSATION_INFO_LIST_BY_FAVORITE_V2')] = 611;
    values[(valuesById[612] = 'GET_CONVERSATION_INFO_LIST_BY_TOP_V2')] = 612;
    values[(valuesById[613] = 'BATCH_MARK_CONVERSATION_READ')] = 613;
    values[(valuesById[614] = 'DISSOLVE_CONVERSATION')] = 614;
    values[(valuesById[615] = 'GET_CONVERSATIONS_CHECKINFO')] = 615;
    values[(valuesById[616] = 'GET_CONVERSATIONS_CHECK_INFO_V2')] = 616;
    values[(valuesById[617] = 'BATCH_DELETE_CONVERSATIONS')] = 617;
    values[(valuesById[605] = 'CONVERSATION_PARTICIPANTS_LIST')] = 605;
    values[(valuesById[650] = 'ADD_CONVERSATION_PARTICIPANTS')] = 650;
    values[(valuesById[651] = 'REMOVE_CONVERSATION_PARTICIPANTS')] = 651;
    values[(valuesById[652] = 'LEAVE_CONVERSATION')] = 652;
    values[(valuesById[653] = 'CONVERSATION_SET_ROLE')] = 653;
    values[(valuesById[654] = 'MGET_CONVERSATION_PARTICIPANTS')] = 654;
    values[(valuesById[655] = 'UPDATE_CONVERSATION_PARTICIPANT')] = 655;
    values[(valuesById[656] = 'BATCH_UPDATE_CONVERSATION_PARTICIPANT')] = 656;
    values[(valuesById[690] = 'GET_CONVERSATION_GROUP_LIST')] = 690;
    values[(valuesById[701] = 'DELETE_MESSAGE')] = 701;
    values[(valuesById[702] = 'RECALL_MESSAGE')] = 702;
    values[(valuesById[703] = 'REACTION_MESSAGE')] = 703;
    values[(valuesById[704] = 'SYNC_MESSAGE')] = 704;
    values[(valuesById[705] = 'SET_MESSAGE_PROPERTY')] = 705;
    values[(valuesById[706] = 'ACK_MESSAGE')] = 706;
    values[(valuesById[801] = 'GET_GROUP_INFO')] = 801;
    values[(valuesById[802] = 'SET_GROUP_INFO')] = 802;
    values[(valuesById[803] = 'GET_GROUP_INFO_LIST')] = 803;
    values[(valuesById[901] = 'GET_CONVERSATION_CORE_INFO')] = 901;
    values[(valuesById[902] = 'SET_CONVERSATION_CORE_INFO')] = 902;
    values[(valuesById[903] = 'GET_CONVERSATION_CORE_INFO_LIST')] = 903;
    values[(valuesById[904] = 'UPSERT_CONVERSATION_CORE_EXT_INFO')] = 904;
    values[(valuesById[920] = 'GET_CONVERSATION_SETTING_INFO')] = 920;
    values[(valuesById[921] = 'SET_CONVERSATION_SETTING_INFO')] = 921;
    values[(valuesById[922] = 'UPSERT_CONVERSATION_SETTING_EXT_INFO')] = 922;
    values[(valuesById[1001] = 'GET_STRANGER_CONVERSATION_LIST')] = 1001;
    values[(valuesById[1002] = 'GET_STRANGER_MESSAGES_IN_CONVERSATION')] = 1002;
    values[(valuesById[1003] = 'DELETE_STRANGER_MESSAGE')] = 1003;
    values[(valuesById[1004] = 'DELETE_STRANGER_CONVERSATION')] = 1004;
    values[(valuesById[1005] = 'DELETE_ALL_STRANGER_CONVERSATIONS')] = 1005;
    values[(valuesById[1006] = 'MARK_STRANGER_CONVERSATION_READ')] = 1006;
    values[(valuesById[1007] = 'MARK_ALL_STRANGER_CONVERSATIONS_READ')] = 1007;
    values[(valuesById[1008] = 'GET_STRANGER_UNREAD_COUNT')] = 1008;
    values[(valuesById[1099] = 'STRANGER_NEW_MSG_NOTIFY')] = 1099;
    values[(valuesById[2000] = 'GET_CONVERSATION_PARTICIPANTS_READ_INDEX_V3')] = 2000;
    values[(valuesById[2001] = 'GET_CONVERSATION_PARTICIPANTS_MIN_INDEX_V3')] = 2001;
    values[(valuesById[2002] = 'MARK_CONVERSATION_READ_V3')] = 2002;
    values[(valuesById[2003] = 'GET_MEDIA_UPLOAD_TOKEN')] = 2003;
    values[(valuesById[2004] = 'GET_MEDIA_URLS')] = 2004;
    values[(valuesById[2005] = 'GET_TICKET')] = 2005;
    values[(valuesById[2006] = 'GET_USER_CONVERSATION_LIST')] = 2006;
    values[(valuesById[2007] = 'BROADCAST_SEND_MESSAGE')] = 2007;
    values[(valuesById[2008] = 'BROADCAST_RECV_MESSAGE')] = 2008;
    values[(valuesById[2009] = 'BROADCAST_USER_COUNTER')] = 2009;
    values[(valuesById[2010] = 'CLIENT_ACK')] = 2010;
    values[(valuesById[2011] = 'CREATE_VOIP')] = 2011;
    values[(valuesById[2012] = 'CALL_VOIP')] = 2012;
    values[(valuesById[2013] = 'UPDATE_VOIP')] = 2013;
    values[(valuesById[2014] = 'HEARTBEAT_CHANNEL')] = 2014;
    values[(valuesById[2015] = 'PROFILE_GET_INFO')] = 2015;
    values[(valuesById[2016] = 'REPORT_CLIENT_METRICS')] = 2016;
    values[(valuesById[2017] = 'GET_CONFIGS')] = 2017;
    values[(valuesById[2018] = 'UNREAD_COUNT_REPORT')] = 2018;
    values[(valuesById[2019] = 'BLOCK_MEMBERS')] = 2019;
    values[(valuesById[2020] = 'BLOCK_CONVERSATION')] = 2020;
    values[(valuesById[2021] = 'MODIFY_MESSAGE_EXT')] = 2021;
    values[(valuesById[2022] = 'GET_CONVERSATION_AUDIT_SWITCH')] = 2022;
    values[(valuesById[2023] = 'UPDATE_CONVERSATION_AUDIT_SWITCH')] = 2023;
    values[(valuesById[2024] = 'SEND_CONVERSATION_APPLY')] = 2024;
    values[(valuesById[2025] = 'ACK_CONVERSATION_APPLY')] = 2025;
    values[(valuesById[2026] = 'GET_CONVERSATION_APPLY')] = 2026;
    values[(valuesById[2027] = 'GET_CONVERSATION_AUDIT_LIST')] = 2027;
    values[(valuesById[2028] = 'GET_CONVERSATION_AUDIT_UNREAD')] = 2028;
    values[(valuesById[2029] = 'CLEAR_CONVERSATION_AUDIT_UNREAD')] = 2029;
    values[(valuesById[2030] = 'GET_UNREAD_COUNT')] = 2030;
    values[(valuesById[2031] = 'SEND_MESSAGE_P2P')] = 2031;
    values[(valuesById[2032] = 'GET_BLOCKLIST')] = 2032;
    values[(valuesById[2033] = 'SET_BLOCKLIST')] = 2033;
    values[(valuesById[2034] = 'CHECK_IN_BLOCKLIST')] = 2034;
    values[(valuesById[2035] = 'GET_MESSAGE_INFO_BY_INDEX_V2')] = 2035;
    values[(valuesById[2036] = 'MARK_MESSAGE')] = 2036;
    values[(valuesById[2037] = 'PULL_MARK_MESSAGE')] = 2037;
    values[(valuesById[2038] = 'BATCH_GAT_CONVERSATION_PARTICIPANTS_READINDEX')] = 2038;
    values[(valuesById[2039] = 'GET_RECENT_MESSAGE')] = 2039;
    values[(valuesById[2040] = 'GET_CMD_MESSAGE')] = 2040;
    values[(valuesById[2041] = 'GET_MESSAGE_INFO_BY_INDEX_V2_RANGE')] = 2041;
    values[(valuesById[2042] = 'BATCH_GET_CONVERSATION_AUDIT_UNREAD')] = 2042;
    values[(valuesById[2043] = 'GET_MESSAGE_BY_INIT')] = 2043;
    values[(valuesById[2044] = 'PREVIEWER_GET_MESSAGES_BY_CONVERSATION')] = 2044;
    values[(valuesById[2045] = 'PREVIEWER_GET_CONVERSATION_INFO_LIST')] = 2045;
    values[(valuesById[2046] = 'SEND_FRIEND_APPLY')] = 2046;
    values[(valuesById[2047] = 'GET_FRIEND_APPLY_LIST')] = 2047;
    values[(valuesById[2048] = 'GET_FRIEND_RECEIVE_APPLY_LIST')] = 2048;
    values[(valuesById[2049] = 'REPLY_FRIEND_APPLY')] = 2049;
    values[(valuesById[2050] = 'GET_FRIEND_LIST')] = 2050;
    values[(valuesById[2051] = 'DELETE_FRIEND')] = 2051;
    values[(valuesById[2052] = 'PROFILE_BATCH_GET_INFO')] = 2052;
    values[(valuesById[2053] = 'PROFILE_SEARCH_INFO')] = 2053;
    values[(valuesById[2054] = 'MARK_MSG_UNREAD_COUNT_REPORT')] = 2054;
    values[(valuesById[2055] = 'MARK_MSG_GET_UNREAD_COUNT')] = 2055;
    values[(valuesById[2056] = 'BATCH_UNMARK_MESSAGE')] = 2056;
    values[(valuesById[2057] = 'CLIENT_BATCH_ACK')] = 2057;
    values[(valuesById[2058] = 'JOIN_VOIP')] = 2058;
    values[(valuesById[2059] = 'GET_MEDIA_UPLOAD_CONFIG')] = 2059;
    values[(valuesById[2060] = 'GET_MEDIA_STATUS')] = 2060;
    values[(valuesById[2100] = 'GLOBAL_MESSAGE_SEARCH')] = 2100;
    values[(valuesById[2101] = 'GLOBAL_GROUP_SEARCH')] = 2101;
    values[(valuesById[2102] = 'CONVERSATION_MESSAGE_SEARCH')] = 2102;
    values[(valuesById[2103] = 'CONVERSATION_MESSAGE_PRE_VIEW')] = 2103;
    values[(valuesById[2200] = 'GET_MESSAGES')] = 2200;
    values[(valuesById[9999] = 'VCD_CLEAN')] = 9999;
    return values;
  })();

  im_proto.StatusCode = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'OK')] = 0;
    values[(valuesById[1] = 'INVALID_TOKEN')] = 1;
    values[(valuesById[100] = 'EXPIRED_TOKEN')] = 100;
    values[(valuesById[2] = 'INVALID_TICKET')] = 2;
    values[(valuesById[3] = 'CONVERSATION_NOT_FOUND')] = 3;
    values[(valuesById[4] = 'INVALID_REQUEST')] = 4;
    values[(valuesById[5] = 'INVALID_CMD')] = 5;
    values[(valuesById[6] = 'SERVER_ERR')] = 6;
    values[(valuesById[11] = 'USER_FORBIDDEN')] = 11;
    values[(valuesById[7] = 'DEVICE_NOT_BIND')] = 7;
    values[(valuesById[8] = 'MESSAGE_ILLEGAL')] = 8;
    values[(valuesById[9] = 'USER_ILLEGAL')] = 9;
    values[(valuesById[10] = 'USER_NOT_FRIENDS')] = 10;
    values[(valuesById[12] = 'USER_SILENCE')] = 12;
    values[(valuesById[13] = 'USER_NOT_IN_GROUP')] = 13;
    values[(valuesById[14] = 'USER_BANNED_TO_POST')] = 14;
    values[(valuesById[500] = 'INTERNAL_ERROR')] = 500;
    values[(valuesById[15] = 'MESSAGE_TARGET_CONVERSATION_NOT_EXIST')] = 15;
    values[(valuesById[16] = 'DEGRADATION_ERROR')] = 16;
    values[(valuesById[17] = 'RECALL_TIMEOUT')] = 17;
    values[(valuesById[18] = 'TOUCH_LIMIT')] = 18;
    values[(valuesById[19] = 'CALLBACK_DENY')] = 19;
    values[(valuesById[100017] = 'CONV_NOT_FOUND')] = 100017;
    return values;
  })();

  im_proto.VoipStatusCode = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'SUCCESS')] = 0;
    values[(valuesById[4] = 'VOIP_PARAMS_ERROR')] = 4;
    values[(valuesById[18] = 'VOIP_STATUS_ERROR')] = 18;
    values[(valuesById[19] = 'VOIP_CANCEL_ERROR')] = 19;
    values[(valuesById[20] = 'VOIP_OTHER_RESPONSE_ERROR')] = 20;
    values[(valuesById[21] = 'VOIP_CALLBACK_ERROR')] = 21;
    return values;
  })();

  im_proto.SendMessageStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'SEND_SUCCEED')] = 0;
    values[(valuesById[1] = 'USER_NOT_IN_CONVERSATION')] = 1;
    values[(valuesById[2] = 'CHECK_CONV_NOT_PASS')] = 2;
    values[(valuesById[3] = 'CHECK_MSG_NOT_PASS')] = 3;
    values[(valuesById[4] = 'CHECK_MSG_NOT_PASS_BUT_SELF_VISIBLE')] = 4;
    values[(valuesById[5] = 'USER_HAS_BEEN_BLOCKED')] = 5;
    return values;
  })();

  im_proto.ConversationOperationStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'OP_SUCCEED')] = 0;
    values[(valuesById[1] = 'REJECTED')] = 1;
    values[(valuesById[2] = 'PARTLY_REJECTED')] = 2;
    values[(valuesById[3] = 'APPLY_REJECTED')] = 3;
    values[(valuesById[4] = 'APPLY_SUCCEED')] = 4;
    values[(valuesById[5] = 'CALLBACK_REJECTED')] = 5;
    values[(valuesById[6] = 'TOUCH_LIMITS')] = 6;
    return values;
  })();

  im_proto.Refer = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'REFER_NOT_USED')] = 0;
    values[(valuesById[1] = 'ANDROID')] = 1;
    values[(valuesById[2] = 'IOS')] = 2;
    values[(valuesById[3] = 'PC')] = 3;
    values[(valuesById[4] = 'SERVER')] = 4;
    return values;
  })();

  im_proto.ConversationType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'ONE_TO_ONE_CHAT')] = 1;
    values[(valuesById[2] = 'GROUP_CHAT')] = 2;
    values[(valuesById[3] = 'LIVE_CHAT')] = 3;
    values[(valuesById[4] = 'BROADCAST_CHAT')] = 4;
    return values;
  })();

  im_proto.BlockType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'MEMBER')] = 1;
    values[(valuesById[2] = 'CONVERSATION_NOT_MANAGERS')] = 2;
    values[(valuesById[3] = 'CONVERSATION_ALL')] = 3;
    return values;
  })();

  im_proto.MessageType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'LEGACY_MESSAGE_TYPE_SYSTEM')] = 1;
    values[(valuesById[5] = 'LEGACY_MESSAGE_TYPE_EMOJI')] = 5;
    values[(valuesById[7] = 'LEGACY_MESSAGE_TYPE_TEXT')] = 7;
    values[(valuesById[8] = 'LEGACY_MESSAGE_TYPE_USER_CARD')] = 8;
    values[(valuesById[11] = 'MsgTypeShareSubOnlyVideo')] = 11;
    values[(valuesById[15] = 'MsgTypeHelloSticker')] = 15;
    values[(valuesById[16] = 'MsgTypeForwardComment')] = 16;
    values[(valuesById[19] = 'MsgTypeShareChallenge')] = 19;
    values[(valuesById[21] = 'MsgTypeShareLiveMsg')] = 21;
    values[(valuesById[22] = 'MsgTypeShareVideoBGM')] = 22;
    values[(valuesById[25] = 'MsgTypeShareProfile')] = 25;
    values[(valuesById[26] = 'MsgTypeH5Card')] = 26;
    values[(valuesById[33] = 'MsgTypeShareQnA')] = 33;
    values[(valuesById[40] = 'MsgTypeShareComment')] = 40;
    values[(valuesById[43] = 'MsgTypeShareProduct')] = 43;
    values[(valuesById[71] = 'MsgTypeShareMixVideo')] = 71;
    values[(valuesById[72] = 'MsgTypeShareEffect')] = 72;
    values[(valuesById[101] = 'MsgTypeFile')] = 101;
    values[(valuesById[1006] = 'MsgTypeSystemNotice')] = 1006;
    values[(valuesById[1007] = 'MsgTypeStrongSystemNotice')] = 1007;
    values[(valuesById[1021] = 'MsgTypeShareLive')] = 1021;
    values[(valuesById[1025] = 'MsgTypeShareStory')] = 1025;
    values[(valuesById[1030] = 'MsgTypeGroupWelcomeAvatar')] = 1030;
    values[(valuesById[1031] = 'MsgTypeGroupNotice')] = 1031;
    values[(valuesById[1032] = 'MsgTypeSystemCardMsg')] = 1032;
    values[(valuesById[1033] = 'MsgTypeShareGroupInvite')] = 1033;
    values[(valuesById[1034] = 'MsgTypeShareLiveEvent')] = 1034;
    values[(valuesById[1036] = 'MsgTypeSharedSearch')] = 1036;
    values[(valuesById[1037] = 'MsgTypeSmallSystemCardMsg')] = 1037;
    values[(valuesById[1038] = 'MsgTypeShareSubscribeInvite')] = 1038;
    values[(valuesById[1801] = 'MsgTypeTemplateImageCard')] = 1801;
    values[(valuesById[1802] = 'MsgTypeTemplatePictureCard')] = 1802;
    values[(valuesById[1803] = 'MsgTypeTemplateVideoCard')] = 1803;
    values[(valuesById[1804] = 'MsgTypeTemplateInfoCard')] = 1804;
    values[(valuesById[1805] = 'MsgTypeTemplateStickerCard')] = 1805;
    values[(valuesById[1806] = 'MsgTypeTemplatePortraitCard')] = 1806;
    values[(valuesById[1807] = 'MsgTypeTemplateBotAnswerCard')] = 1807;
    values[(valuesById[1808] = 'MsgTypeTemplateInteractiveNoticeCard')] = 1808;
    values[(valuesById[1809] = 'MsgTypeTemplateShareVideo')] = 1809;
    values[(valuesById[1810] = 'MsgTypeTemplateBubbleCard')] = 1810;
    values[(valuesById[1811] = 'MsgTypeTemplateShareCommentCard')] = 1811;
    values[(valuesById[1900] = 'MsgTypeTemplateCommonCard')] = 1900;
    values[(valuesById[2000] = 'MsgTypeTemplateDynamicCard')] = 2000;
    values[(valuesById[3001] = 'MsgTypeTemplatePlaylistImageCard')] = 3001;
    values[(valuesById[0] = 'MESSAGE_TYPE_NOT_USED')] = 0;
    values[(valuesById[2] = 'LEGACY_MESSAGE_TYPE_IMAGE')] = 2;
    values[(valuesById[3] = 'LEGACY_MESSAGE_TYPE_AUDIO')] = 3;
    values[(valuesById[4] = 'LEGACY_MESSAGE_TYPE_VIDEO')] = 4;
    values[(valuesById[6] = 'LEGACY_MESSAGE_TYPE_FILE')] = 6;
    values[(valuesById[9] = 'LEGACY_MESSAGE_TYPE_TOAST')] = 9;
    values[(valuesById[10] = 'LEGACY_MESSAGE_TYPE_GROUP_CARD')] = 10;
    values[(valuesById[81] = 'LEGACY_MESSAGE_TYPE_SHARE_PLAYLIST')] = 81;
    values[(valuesById[10001] = 'MESSAGE_TYPE_TEXT')] = 10001;
    values[(valuesById[10002] = 'MESSAGE_TYPE_STICKER')] = 10002;
    values[(valuesById[10003] = 'MESSAGE_TYPE_IMAGE')] = 10003;
    values[(valuesById[10004] = 'MESSAGE_TYPE_VIDEO')] = 10004;
    values[(valuesById[10005] = 'MESSAGE_TYPE_FILE')] = 10005;
    values[(valuesById[10006] = 'MESSAGE_TYPE_AUDIO')] = 10006;
    values[(valuesById[10007] = 'MESSAGE_TYPE_LOCATION')] = 10007;
    values[(valuesById[10008] = 'MESSAGE_TYPE_SYSTEM')] = 10008;
    values[(valuesById[10009] = 'MESSAGE_TYPE_LINK')] = 10009;
    values[(valuesById[10011] = 'MESSAGE_TYPE_GSDK_AUDIO')] = 10011;
    values[(valuesById[50000] = 'MESSAGE_TYPE_STATUS')] = 50000;
    values[(valuesById[50001] = 'MESSAGE_TYPE_COMMAND')] = 50001;
    values[(valuesById[50002] = 'MESSAGE_TYPE_UPDATE_MESSAGE_EXT')] = 50002;
    values[(valuesById[50005] = 'MESSAGE_TYPE_CONVERSATION_DESTROY')] = 50005;
    values[(valuesById[50010] = 'MESSAGE_TYPE_MODE_CHANGE')] = 50010;
    values[(valuesById[50013] = 'MESSAGE_TYPE_READ_COMMAND')] = 50013;
    values[(valuesById[50020] = 'MESSAGE_TYPE_REFRESH_MESSAGE')] = 50020;
    values[(valuesById[50021] = 'MESSAGE_TYPE_RECALL_MESSAGE')] = 50021;
    values[(valuesById[50022] = 'MESSAGE_TYPE_HIDE_VIOLATIVE_MESSAGE')] = 50022;
    values[(valuesById[50023] = 'MESSAGE_TYPE_RE_FETCH_MESSAGE')] = 50023;
    values[(valuesById[70002] = 'MESSAGE_TYPE_UPDATE_MESSAGE_PROPERTY')] = 70002;
    values[(valuesById[61000] = 'MESSAGE_TYPE_CONVERSATION_GROUP_LIST_UPDATE')] = 61000;
    values[(valuesById[50003] = 'MESSAGE_TYPE_UPDATE_MIN_INDEX')] = 50003;
    values[(valuesById[50004] = 'MESSAGE_TYPE_USER_ACTION')] = 50004;
    values[(valuesById[50011] = 'MESSAGE_TYPE_BLOCK_COMMAND')] = 50011;
    values[(valuesById[50012] = 'MESSAGE_TYPE_MARK_COMMAND')] = 50012;
    values[(valuesById[50014] = 'MESSAGE_TYPE_SEND_FAILED_RESP')] = 50014;
    values[(valuesById[50015] = 'MESSAGE_TYPE_NOTIFY_STRANGER')] = 50015;
    values[(valuesById[50016] = 'MESSAGE_TYPE_BATCH_UNMARK_COMMAND')] = 50016;
    values[(valuesById[50017] = 'MESSAGE_TYPE_VISIBLE_MESSAGE_COMMAND')] = 50017;
    values[(valuesById[60001] = 'MESSAGE_TYPE_NOTIFY_COMMAND')] = 60001;
    values[(valuesById[70001] = 'MESSAGE_TYPE_MESSAGE_PROPERTY')] = 70001;
    values[(valuesById[80001] = 'MESSAGE_TYPE_VOIP_COMMAND')] = 80001;
    values[(valuesById[80002] = 'MESSAGE_TYPE_VOIP_CARD_COMMAND')] = 80002;
    values[(valuesById[80003] = 'MESSAGE_TYPE_VOIP_SINGLE_CHAT_STATUS_COMMAND')] = 80003;
    values[(valuesById[80004] = 'MESSAGE_TYPE_VOIP_CALLEE_LIST_UPDATE_NOTIFY')] = 80004;
    values[(valuesById[80005] = 'MESSAGE_TYPE_VOIP_ROOM_DISMISS_NOTIFY')] = 80005;
    values[(valuesById[90001] = 'MESSAGE_TYPE_CONVERSATION_APPLY_NOTIFY')] = 90001;
    values[(valuesById[90002] = 'MESSAGE_TYPE_CONVERSATION_AUDIT_ACK_NOTIFY')] = 90002;
    values[(valuesById[100001] = 'MsgTypeStreakCommandMessage')] = 100001;
    return values;
  })();

  im_proto.CommandType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'CmdTypeUnknown')] = 0;
    values[(valuesById[1] = 'CmdTypeMarkConversationRead')] = 1;
    values[(valuesById[2] = 'CmdTypeDeleteMessage')] = 2;
    values[(valuesById[3] = 'CmdTypeDeleteConversation')] = 3;
    values[(valuesById[4] = 'CmdTypeUpdateConvSetting')] = 4;
    values[(valuesById[6] = 'CmdTypeUpdateConvCoreInfo')] = 6;
    values[(valuesById[7] = 'CmdTypeUpdateConvParticipant')] = 7;
    values[(valuesById[8] = 'CmdTypeFirstMessage')] = 8;
    values[(valuesById[100] = 'CmdTypeTriggerConvPull')] = 100;
    return values;
  })();

  im_proto.GroupRole = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'ORDINARY')] = 0;
    values[(valuesById[1] = 'OWNER')] = 1;
    values[(valuesById[2] = 'MANAGER')] = 2;
    values[(valuesById[3] = 'VISITOR')] = 3;
    values[(valuesById[4] = 'SYSTEM')] = 4;
    return values;
  })();

  im_proto.GroupAuth = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'UPDATE_GROUP_NAME')] = 0;
    values[(valuesById[1] = 'RECALL_ORDINARY_MESSAGE')] = 1;
    values[(valuesById[2] = 'RECALL_MANAGER_MESSAGE')] = 2;
    values[(valuesById[3] = 'ADD_PARTICIPANT')] = 3;
    values[(valuesById[4] = 'REMOVE_PARTICIPANT')] = 4;
    values[(valuesById[5] = 'SET_MANAGER')] = 5;
    values[(valuesById[6] = 'DISSOLVE_GROUP')] = 6;
    values[(valuesById[7] = 'PUBLISH_NOTICE')] = 7;
    values[(valuesById[8] = 'BLOCKS_ORDINARY')] = 8;
    values[(valuesById[9] = 'BLOCKS_MANAGER')] = 9;
    values[(valuesById[10] = 'BLOCKS_CONVERSATION')] = 10;
    values[(valuesById[11] = 'UPDATE_GROUP_AUDIT')] = 11;
    values[(valuesById[12] = 'ACK_CONVERSATION_AUDIT')] = 12;
    values[(valuesById[13] = 'UPDATE_RANK_LIST')] = 13;
    values[(valuesById[20] = 'CAN_SEND_MESSAGE')] = 20;
    values[(valuesById[21] = 'ACCEPT_MESSAGE')] = 21;
    return values;
  })();

  im_proto.TicketType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'TICKET_TYPE_APP')] = 1;
    values[(valuesById[2] = 'TICKET_TYPE_PC')] = 2;
    values[(valuesById[3] = 'TICKET_TYPE_WEB')] = 3;
    return values;
  })();

  im_proto.RetentionStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'NOT_STARTED')] = 0;
    values[(valuesById[1] = 'IN_PROGRESS')] = 1;
    values[(valuesById[2] = 'DONE')] = 2;
    values[(valuesById[3] = 'FAILED')] = 3;
    return values;
  })();

  im_proto.ParticipantRole = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'PARTICIPANT_ROLE_NORMAL')] = 0;
    values[(valuesById[1] = 'PARTICIPANT_ROLE_OWNER')] = 1;
    values[(valuesById[2] = 'PARTICIPANT_ROLE_ADMIN')] = 2;
    values[(valuesById[3] = 'PARTICIPANT_ROLE_VISITOR')] = 3;
    return values;
  })();

  im_proto.InitType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'TYPE_BY_CONVERSATION')] = 1;
    values[(valuesById[2] = 'TYPE_BY_USER')] = 2;
    values[(valuesById[3] = 'TYPE_BY_RANK')] = 3;
    return values;
  })();

  im_proto.MessageDirection = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'OLDER')] = 1;
    values[(valuesById[2] = 'NEWER')] = 2;
    values[(valuesById[3] = 'FROM_LATEST')] = 3;
    return values;
  })();

  im_proto.ConversationListDirection = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'CONVERSATION_DESC')] = 0;
    values[(valuesById[1] = 'CONVERSATION_ASC')] = 1;
    return values;
  })();

  im_proto.UserActionType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'ENTER_CONVERSATION')] = 1;
    values[(valuesById[2] = 'EXIT_CONVERSATION')] = 2;
    return values;
  })();

  im_proto.InputStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[3] = 'TYPING')] = 3;
    values[(valuesById[4] = 'CLEAR_INPUT')] = 4;
    return values;
  })();

  im_proto.BlockStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'UNBLOCK')] = 0;
    values[(valuesById[1] = 'BLOCK')] = 1;
    return values;
  })();

  im_proto.ActionType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'UNKNOWN_ACTION')] = 0;
    values[(valuesById[1] = 'FAVORITE')] = 1;
    values[(valuesById[2] = 'PIN')] = 2;
    values[(valuesById[3] = 'UNREAD')] = 3;
    return values;
  })();

  im_proto.SendType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'BY_CONVERSATION')] = 0;
    values[(valuesById[1] = 'BY_USER')] = 1;
    return values;
  })();

  im_proto.NewMessageNotifyType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'PER_USER')] = 1;
    values[(valuesById[2] = 'PER_CONVERSATION')] = 2;
    return values;
  })();

  im_proto.MsgTraceMetrics = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'GATEWAY')] = 0;
    values[(valuesById[1] = 'BEFORE_CALLBACK')] = 1;
    values[(valuesById[2] = 'AFTER_CALLBACK')] = 2;
    values[(valuesById[3] = 'BEFORE_CONVERSATION_KAFKA')] = 3;
    values[(valuesById[4] = 'AFTER_CONVERSATION_KAFKA')] = 4;
    values[(valuesById[5] = 'BEFORE_USER_KAFKA')] = 5;
    values[(valuesById[6] = 'AFTER_USER_KAFKA')] = 6;
    values[(valuesById[7] = 'PUSH')] = 7;
    return values;
  })();

  im_proto.MsgTracePath = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'FROM_UNKNOWN')] = 0;
    values[(valuesById[1] = 'FROM_FRONTIER')] = 1;
    values[(valuesById[2] = 'FROM_HTTP')] = 2;
    values[(valuesById[3] = 'FROM_SERVER')] = 3;
    return values;
  })();

  im_proto.MuteMessageType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'TYPE_MENTION')] = 1;
    values[(valuesById[2] = 'TYPE_SEND_BY_GROUP_OWNER')] = 2;
    values[(valuesById[3] = 'TYPE_AUTO_SEND_BY_SERVER')] = 3;
    values[(valuesById[4] = 'TYPE_MENTION_AND_SEND_BY_GROUP_OWNER')] = 4;
    return values;
  })();

  im_proto.FriendMessageType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'SendApply')] = 1;
    values[(valuesById[2] = 'DeleteFriend')] = 2;
    values[(valuesById[3] = 'AddFriend')] = 3;
    return values;
  })();

  im_proto.PreviewOperationStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'PREVIEW_OP_SUCCEED')] = 0;
    values[(valuesById[1] = 'PREVIEW_OP_PREVIEW_STATUS_NOT_OPEN')] = 1;
    values[(valuesById[2] = 'PREVIEW_OP_CALLBACK_NOT_PASS')] = 2;
    values[(valuesById[3] = 'PREVIEW_OP_CONVERSATION_NOT_FOUND')] = 3;
    return values;
  })();

  im_proto.MessagePropertyType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'REACTION')] = 0;
    values[(valuesById[1] = 'SYNC')] = 1;
    return values;
  })();

  im_proto.ReactionStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'POSITIVE')] = 0;
    values[(valuesById[1] = 'NEGATIVE')] = 1;
    return values;
  })();

  im_proto.SyncStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'S_SEND')] = 0;
    values[(valuesById[1] = 'S_NOTIFY')] = 1;
    values[(valuesById[2] = 'S_PULL')] = 2;
    values[(valuesById[3] = 'S_READ')] = 3;
    values[(valuesById[4] = 'R_CLICK')] = 4;
    return values;
  })();

  im_proto.OPERATION_TYPE = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'ADD_PROPERTY_ITEM')] = 0;
    values[(valuesById[1] = 'REMOVE_PROPERTY_ITEM')] = 1;
    values[(valuesById[2] = 'SET_PROPERTY')] = 2;
    values[(valuesById[3] = 'DEL_PROPERTY')] = 3;
    values[(valuesById[4] = 'XSET_PROPERTY')] = 4;
    values[(valuesById[5] = 'MODIFY_PROPERTY')] = 5;
    return values;
  })();

  im_proto.ModifyMessagePropertyStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'MODIFY_PROPERTY_SUCCESS')] = 0;
    values[(valuesById[1] = 'MODIFY_PROPERTY_REPEAT_REQUEST')] = 1;
    values[(valuesById[2] = 'MODIFY_PROPERTY_INVALID_LENGTH')] = 2;
    values[(valuesById[3] = 'MODIFY_PROPERTY_INVALID_REQUEST')] = 3;
    values[(valuesById[4] = 'MODIFY_PROPERTY_CALLBACK_ERROR')] = 4;
    values[(valuesById[500] = 'MODIFY_PROPERTY_INTERNAL_ERROR')] = 500;
    return values;
  })();

  im_proto.MediaType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'IMG')] = 1;
    values[(valuesById[2] = 'VIDEO')] = 2;
    values[(valuesById[3] = 'AUDIO')] = 3;
    values[(valuesById[4] = 'FILE')] = 4;
    values[(valuesById[10] = 'OTHER')] = 10;
    return values;
  })();

  im_proto.MediaTokenType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'VSDK')] = 1;
    values[(valuesById[2] = 'IMAGEX')] = 2;
    values[(valuesById[3] = 'VSDK_V5')] = 3;
    values[(valuesById[4] = 'IMAGEX_V5')] = 4;
    return values;
  })();

  im_proto.ReadURLFrom = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'URL_VSDK')] = 1;
    values[(valuesById[2] = 'URL_IMAGEX')] = 2;
    return values;
  })();

  im_proto.SortType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'JOIN_TIME')] = 1;
    values[(valuesById[2] = 'CREATED_TIME')] = 2;
    values[(valuesById[3] = 'GROUP_NAME')] = 3;
    values[(valuesById[4] = 'ACTIVE_TIME')] = 4;
    return values;
  })();

  im_proto.NetworkType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'UNKNOWN')] = 0;
    values[(valuesById[1] = 'WIFI')] = 1;
    values[(valuesById[2] = 'MOBILE_2G')] = 2;
    values[(valuesById[3] = 'MOBILE_3G')] = 3;
    values[(valuesById[4] = 'MOBILE_4G')] = 4;
    values[(valuesById[5] = 'MOBILE_5G')] = 5;
    return values;
  })();

  im_proto.MsgReportType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'NOT_USE')] = 0;
    values[(valuesById[1] = 'MSG_RECEIVE_BY_WS')] = 1;
    values[(valuesById[2] = 'MSG_RECEIVE_BY_USER')] = 2;
    values[(valuesById[3] = 'MSG_RECEIVE_BY_INIT')] = 3;
    values[(valuesById[4] = 'MSG_RECEIVE_BY_LOAD_HISTORY')] = 4;
    values[(valuesById[5] = 'MSG_RECEIVE_BY_LOAD_NEWER')] = 5;
    values[(valuesById[6] = 'MSG_RECEIVE_BY_CHECK_MSG_V1')] = 6;
    values[(valuesById[7] = 'MSG_RECEIVE_BY_CHECK_MSG_V2')] = 7;
    values[(valuesById[8] = 'MSG_RECEIVE_BY_STRANGER')] = 8;
    values[(valuesById[9] = 'MSG_SHOW')] = 9;
    return values;
  })();

  im_proto.VoipStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'IDLE')] = 0;
    values[(valuesById[1] = 'CALLING')] = 1;
    values[(valuesById[2] = 'RINGING')] = 2;
    values[(valuesById[3] = 'ACCEPTED')] = 3;
    values[(valuesById[4] = 'ONTHECALL')] = 4;
    values[(valuesById[101] = 'TERMINATED')] = 101;
    values[(valuesById[102] = 'OCCUPIED')] = 102;
    values[(valuesById[103] = 'REFUSED')] = 103;
    values[(valuesById[104] = 'CANCELLED')] = 104;
    values[(valuesById[105] = 'UNAVAILABLE')] = 105;
    values[(valuesById[106] = 'RTCERROR')] = 106;
    values[(valuesById[107] = 'RTC_ENGINE_MISMATCH')] = 107;
    return values;
  })();

  im_proto.VoipType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'VOIP_TYPE_NOT_USED')] = 0;
    values[(valuesById[1] = 'VOIP_TYPE_ALL')] = 1;
    values[(valuesById[2] = 'VOIP_TYPE_VIDEOONLY')] = 2;
    values[(valuesById[3] = 'VOIP_TYPE_AUDIOONLY')] = 3;
    return values;
  })();

  im_proto.VoipMode = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'VOIP_MODE_DOUBLE')] = 0;
    values[(valuesById[1] = 'VOIP_MODE_MULTIPLAYER')] = 1;
    return values;
  })();

  im_proto.ChannelStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'CHANNEL_STATUS_NOT_USED')] = 0;
    values[(valuesById[1] = 'ONLINE')] = 1;
    values[(valuesById[2] = 'OFFLINE')] = 2;
    return values;
  })();

  im_proto.ClientMetricType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'COUNTER')] = 0;
    values[(valuesById[1] = 'TIMER')] = 1;
    return values;
  })();

  im_proto.ApplyErrorCode = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'APPLY_SUCCESS')] = 0;
    values[(valuesById[1] = 'UPDATE_STATUS_ERR')] = 1;
    values[(valuesById[2] = 'CALLBACK_NOT_PASS')] = 2;
    values[(valuesById[3] = 'APPLY_NOT_EXIST')] = 3;
    values[(valuesById[4] = 'APPLY_PARAMS_ERR')] = 4;
    values[(valuesById[5] = 'CONV_SWITCH_CLOSED')] = 5;
    values[(valuesById[6] = 'USER_NO_PERMISSION')] = 6;
    values[(valuesById[7] = 'USER_ALREADY_IN_GROUP')] = 7;
    values[(valuesById[8] = 'CALLBACK_NO_NEED_AUDIT')] = 8;
    values[(valuesById[9] = 'APPLY_CONVERSATION_NOT_FOUND')] = 9;
    values[(valuesById[10] = 'CONVERSATION_IS_FULL')] = 10;
    values[(valuesById[500] = 'APPLY_INTERNAL_ERR')] = 500;
    return values;
  })();

  im_proto.ApplyStatusCode = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'APPLYING')] = 1;
    values[(valuesById[2] = 'AGREE')] = 2;
    values[(valuesById[3] = 'DENY')] = 3;
    values[(valuesById[4] = 'INVALID')] = 4;
    return values;
  })();

  im_proto.MessageStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'AVAILABLE')] = 0;
    values[(valuesById[1] = 'NOT_EXIST')] = 1;
    values[(valuesById[2] = 'INVISIBLE')] = 2;
    values[(valuesById[3] = 'RECALLED')] = 3;
    values[(valuesById[4] = 'DELETED')] = 4;
    return values;
  })();

  im_proto.FriendErrorCode = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'FRIEND_SUCCESS')] = 0;
    values[(valuesById[1] = 'FRIEND_DUPLICATE_APPLY')] = 1;
    values[(valuesById[2] = 'FRIEND_SEND_APPLY_LIMIT')] = 2;
    values[(valuesById[3] = 'FRIEND_RECEIVE_APPLY_LIMIT')] = 3;
    values[(valuesById[4] = 'FRIEND_ALREADY_FRIEND')] = 4;
    values[(valuesById[500] = 'FRIEND_INTERNAL_ERR')] = 500;
    return values;
  })();

  im_proto.AuthType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'UNKNOWN_AUTH')] = 0;
    values[(valuesById[1] = 'SESSION_AUTH')] = 1;
    values[(valuesById[2] = 'TOKEN_AUTH')] = 2;
    values[(valuesById[3] = 'SUBSTITUTE_AUTH')] = 3;
    return values;
  })();

  im_proto.TokenType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'DEFAULT_TOKEN')] = 0;
    values[(valuesById[1] = 'APP_TOKEN')] = 1;
    values[(valuesById[2] = 'SERVER_TOKEN')] = 2;
    return values;
  })();

  im_proto.ConversationsListPolicy = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'ALL')] = 1;
    values[(valuesById[2] = 'HOT')] = 2;
    return values;
  })();

  im_proto.PushType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'Internal')] = 1;
    values[(valuesById[2] = 'External')] = 2;
    return values;
  })();

  im_proto.DirectPushStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'Success')] = 1;
    values[(valuesById[2] = 'AsyncSuccess')] = 2;
    values[(valuesById[3] = 'Fail')] = 3;
    values[(valuesById[4] = 'Offline')] = 4;
    return values;
  })();

  im_proto.ConvRankUpdateRule = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'IgnoreSenderRankUpdate')] = 1;
    values[(valuesById[2] = 'IgnoreReceiverRankUpdate')] = 2;
    values[(valuesById[3] = 'IgnoreAllRankUpdate')] = 3;
    return values;
  })();

  im_proto.InboxPageCategory = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'NormalUserInbox')] = 1;
    values[(valuesById[2] = 'StrangerMessageRequest')] = 2;
    values[(valuesById[3] = 'StrangerFilteredRequest')] = 3;
    return values;
  })();

  im_proto.FilterReason = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'FilteredReasonRisk')] = 1;
    values[(valuesById[2] = 'FilteredRequestKeyword')] = 2;
    return values;
  })();

  im_proto.EmojiProperty = (function () {
    function EmojiProperty(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    EmojiProperty.prototype.icon_url = '';
    EmojiProperty.prototype.text = '';

    EmojiProperty.create = function create(properties) {
      return new EmojiProperty(properties);
    };

    EmojiProperty.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.icon_url != null && Object.hasOwnProperty.call(m, 'icon_url')) w.uint32(10).string(m.icon_url);
      if (m.text != null && Object.hasOwnProperty.call(m, 'text')) w.uint32(18).string(m.text);
      return w;
    };

    EmojiProperty.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.EmojiProperty();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.icon_url = r.string();
            break;
          case 2:
            m.text = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return EmojiProperty;
  })();

  im_proto.PropertyValue = (function () {
    function PropertyValue(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    PropertyValue.prototype.required_min_version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PropertyValue.prototype.type = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PropertyValue.prototype.emoji_data = null;

    PropertyValue.create = function create(properties) {
      return new PropertyValue(properties);
    };

    PropertyValue.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.required_min_version != null && Object.hasOwnProperty.call(m, 'required_min_version'))
        w.uint32(8).int64(m.required_min_version);
      if (m.type != null && Object.hasOwnProperty.call(m, 'type')) w.uint32(16).int64(m.type);
      if (m.emoji_data != null && Object.hasOwnProperty.call(m, 'emoji_data'))
        $root.im_proto.EmojiProperty.encode(m.emoji_data, w.uint32(26).fork()).ldelim();
      return w;
    };

    PropertyValue.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.PropertyValue();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.required_min_version = r.int64();
            break;
          case 2:
            m.type = r.int64();
            break;
          case 3:
            m.emoji_data = $root.im_proto.EmojiProperty.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PropertyValue;
  })();

  im_proto.PropertyItem = (function () {
    function PropertyItem(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    PropertyItem.prototype.uid = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PropertyItem.prototype.sec_uid = '';
    PropertyItem.prototype.create_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PropertyItem.prototype.idempotent_id = '';
    PropertyItem.prototype.value = '';
    PropertyItem.prototype.create_time_micro = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    PropertyItem.create = function create(properties) {
      return new PropertyItem(properties);
    };

    PropertyItem.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.uid != null && Object.hasOwnProperty.call(m, 'uid')) w.uint32(8).int64(m.uid);
      if (m.sec_uid != null && Object.hasOwnProperty.call(m, 'sec_uid')) w.uint32(18).string(m.sec_uid);
      if (m.create_time != null && Object.hasOwnProperty.call(m, 'create_time')) w.uint32(24).int64(m.create_time);
      if (m.idempotent_id != null && Object.hasOwnProperty.call(m, 'idempotent_id'))
        w.uint32(34).string(m.idempotent_id);
      if (m.value != null && Object.hasOwnProperty.call(m, 'value')) w.uint32(42).string(m.value);
      if (m.create_time_micro != null && Object.hasOwnProperty.call(m, 'create_time_micro'))
        w.uint32(48).int64(m.create_time_micro);
      return w;
    };

    PropertyItem.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.PropertyItem();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.uid = r.int64();
            break;
          case 2:
            m.sec_uid = r.string();
            break;
          case 3:
            m.create_time = r.int64();
            break;
          case 4:
            m.idempotent_id = r.string();
            break;
          case 5:
            m.value = r.string();
            break;
          case 6:
            m.create_time_micro = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PropertyItem;
  })();

  im_proto.PropertyItemList = (function () {
    function PropertyItemList(p) {
      this.Items = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    PropertyItemList.prototype.Items = $util.emptyArray;

    PropertyItemList.create = function create(properties) {
      return new PropertyItemList(properties);
    };

    PropertyItemList.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.Items != null && m.Items.length) {
        for (var i = 0; i < m.Items.length; ++i)
          $root.im_proto.PropertyItem.encode(m.Items[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    PropertyItemList.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.PropertyItemList();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.Items && m.Items.length)) m.Items = [];
            m.Items.push($root.im_proto.PropertyItem.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PropertyItemList;
  })();

  im_proto.MessageBody = (function () {
    function MessageBody(p) {
      this.ext = {};
      this.property_list = {};
      this.user_profile = {};
      this.media_info_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessageBody.prototype.conversation_id = '';
    MessageBody.prototype.conversation_type = 0;
    MessageBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessageBody.prototype.index_in_conversation = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessageBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessageBody.prototype.message_type = 0;
    MessageBody.prototype.sender = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessageBody.prototype.content = '';
    MessageBody.prototype.ext = $util.emptyObject;
    MessageBody.prototype.create_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessageBody.prototype.version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessageBody.prototype.status = 0;
    MessageBody.prototype.order_in_conversation = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessageBody.prototype.sec_sender = '';
    MessageBody.prototype.property_list = $util.emptyObject;
    MessageBody.prototype.user_profile = $util.emptyObject;
    MessageBody.prototype.index_in_conversation_v2 = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessageBody.prototype.reference_info = null;
    MessageBody.prototype.index_in_conversation_v1 = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessageBody.prototype.content_pb = $util.newBuffer([]);
    MessageBody.prototype.scene = '';
    MessageBody.prototype.conv_rank_update_rule = 1;
    MessageBody.prototype.ttl = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessageBody.prototype.media_info_list = $util.emptyArray;
    MessageBody.prototype.pre_conversation_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    MessageBody.create = function create(properties) {
      return new MessageBody(properties);
    };

    MessageBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.server_message_id != null && Object.hasOwnProperty.call(m, 'server_message_id'))
        w.uint32(24).int64(m.server_message_id);
      if (m.index_in_conversation != null && Object.hasOwnProperty.call(m, 'index_in_conversation'))
        w.uint32(32).int64(m.index_in_conversation);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(40).int64(m.conversation_short_id);
      if (m.message_type != null && Object.hasOwnProperty.call(m, 'message_type')) w.uint32(48).int32(m.message_type);
      if (m.sender != null && Object.hasOwnProperty.call(m, 'sender')) w.uint32(56).int64(m.sender);
      if (m.content != null && Object.hasOwnProperty.call(m, 'content')) w.uint32(66).string(m.content);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(74).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      if (m.create_time != null && Object.hasOwnProperty.call(m, 'create_time')) w.uint32(80).int64(m.create_time);
      if (m.version != null && Object.hasOwnProperty.call(m, 'version')) w.uint32(88).int64(m.version);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(96).int32(m.status);
      if (m.order_in_conversation != null && Object.hasOwnProperty.call(m, 'order_in_conversation'))
        w.uint32(104).int64(m.order_in_conversation);
      if (m.sec_sender != null && Object.hasOwnProperty.call(m, 'sec_sender')) w.uint32(114).string(m.sec_sender);
      if (m.property_list != null && Object.hasOwnProperty.call(m, 'property_list')) {
        for (var ks = Object.keys(m.property_list), i = 0; i < ks.length; ++i) {
          w.uint32(122).fork().uint32(10).string(ks[i]);
          $root.im_proto.PropertyItemList.encode(m.property_list[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
        }
      }
      if (m.user_profile != null && Object.hasOwnProperty.call(m, 'user_profile')) {
        for (var ks = Object.keys(m.user_profile), i = 0; i < ks.length; ++i) {
          w.uint32(130).fork().uint32(10).string(ks[i]).uint32(18).string(m.user_profile[ks[i]]).ldelim();
        }
      }
      if (m.index_in_conversation_v2 != null && Object.hasOwnProperty.call(m, 'index_in_conversation_v2'))
        w.uint32(136).int64(m.index_in_conversation_v2);
      if (m.reference_info != null && Object.hasOwnProperty.call(m, 'reference_info'))
        $root.im_proto.ReferenceInfo.encode(m.reference_info, w.uint32(146).fork()).ldelim();
      if (m.index_in_conversation_v1 != null && Object.hasOwnProperty.call(m, 'index_in_conversation_v1'))
        w.uint32(152).int64(m.index_in_conversation_v1);
      if (m.content_pb != null && Object.hasOwnProperty.call(m, 'content_pb')) w.uint32(162).bytes(m.content_pb);
      if (m.scene != null && Object.hasOwnProperty.call(m, 'scene')) w.uint32(170).string(m.scene);
      if (m.conv_rank_update_rule != null && Object.hasOwnProperty.call(m, 'conv_rank_update_rule'))
        w.uint32(176).int32(m.conv_rank_update_rule);
      if (m.ttl != null && Object.hasOwnProperty.call(m, 'ttl')) w.uint32(184).int64(m.ttl);
      if (m.media_info_list != null && m.media_info_list.length) {
        for (var i = 0; i < m.media_info_list.length; ++i)
          $root.im_proto.MediaInfo.encode(m.media_info_list[i], w.uint32(194).fork()).ldelim();
      }
      if (m.pre_conversation_index != null && Object.hasOwnProperty.call(m, 'pre_conversation_index'))
        w.uint32(200).int64(m.pre_conversation_index);
      return w;
    };

    MessageBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessageBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.server_message_id = r.int64();
            break;
          case 4:
            m.index_in_conversation = r.int64();
            break;
          case 5:
            m.conversation_short_id = r.int64();
            break;
          case 6:
            m.message_type = r.int32();
            break;
          case 7:
            m.sender = r.int64();
            break;
          case 8:
            m.content = r.string();
            break;
          case 9:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          case 10:
            m.create_time = r.int64();
            break;
          case 11:
            m.version = r.int64();
            break;
          case 12:
            m.status = r.int32();
            break;
          case 13:
            m.order_in_conversation = r.int64();
            break;
          case 14:
            m.sec_sender = r.string();
            break;
          case 15:
            if (m.property_list === $util.emptyObject) m.property_list = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = null;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = $root.im_proto.PropertyItemList.decode(r, r.uint32());
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.property_list[k] = value;
            break;
          case 16:
            if (m.user_profile === $util.emptyObject) m.user_profile = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.user_profile[k] = value;
            break;
          case 17:
            m.index_in_conversation_v2 = r.int64();
            break;
          case 18:
            m.reference_info = $root.im_proto.ReferenceInfo.decode(r, r.uint32());
            break;
          case 19:
            m.index_in_conversation_v1 = r.int64();
            break;
          case 20:
            m.content_pb = r.bytes();
            break;
          case 21:
            m.scene = r.string();
            break;
          case 22:
            m.conv_rank_update_rule = r.int32();
            break;
          case 23:
            m.ttl = r.int64();
            break;
          case 24:
            if (!(m.media_info_list && m.media_info_list.length)) m.media_info_list = [];
            m.media_info_list.push($root.im_proto.MediaInfo.decode(r, r.uint32()));
            break;
          case 25:
            m.pre_conversation_index = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MessageBody;
  })();

  im_proto.ReferenceInfo = (function () {
    function ReferenceInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ReferenceInfo.prototype.referenced_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ReferenceInfo.prototype.hint = '';
    ReferenceInfo.prototype.ref_message_type = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ReferenceInfo.prototype.referenced_message_status = 0;
    ReferenceInfo.prototype.root_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ReferenceInfo.prototype.root_message_conv_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ReferenceInfo.prototype.sender = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    ReferenceInfo.create = function create(properties) {
      return new ReferenceInfo(properties);
    };

    ReferenceInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.referenced_message_id);
      w.uint32(18).string(m.hint);
      w.uint32(24).int64(m.ref_message_type);
      w.uint32(32).int32(m.referenced_message_status);
      if (m.root_message_id != null && Object.hasOwnProperty.call(m, 'root_message_id'))
        w.uint32(40).int64(m.root_message_id);
      if (m.root_message_conv_index != null && Object.hasOwnProperty.call(m, 'root_message_conv_index'))
        w.uint32(48).int64(m.root_message_conv_index);
      if (m.sender != null && Object.hasOwnProperty.call(m, 'sender')) w.uint32(56).int64(m.sender);
      return w;
    };

    ReferenceInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ReferenceInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.referenced_message_id = r.int64();
            break;
          case 2:
            m.hint = r.string();
            break;
          case 3:
            m.ref_message_type = r.int64();
            break;
          case 4:
            m.referenced_message_status = r.int32();
            break;
          case 5:
            m.root_message_id = r.int64();
            break;
          case 6:
            m.root_message_conv_index = r.int64();
            break;
          case 7:
            m.sender = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('referenced_message_id'))
        throw $util.ProtocolError("missing required 'referenced_message_id'", { instance: m });
      if (!m.hasOwnProperty('hint')) throw $util.ProtocolError("missing required 'hint'", { instance: m });
      if (!m.hasOwnProperty('ref_message_type'))
        throw $util.ProtocolError("missing required 'ref_message_type'", { instance: m });
      if (!m.hasOwnProperty('referenced_message_status'))
        throw $util.ProtocolError("missing required 'referenced_message_status'", { instance: m });
      return m;
    };

    return ReferenceInfo;
  })();

  im_proto.RetentionResult = (function () {
    function RetentionResult(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    RetentionResult.prototype.user_id = '';
    RetentionResult.prototype.timestamp = '';
    RetentionResult.prototype.status = 0;

    RetentionResult.create = function create(properties) {
      return new RetentionResult(properties);
    };

    RetentionResult.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(10).string(m.user_id);
      if (m.timestamp != null && Object.hasOwnProperty.call(m, 'timestamp')) w.uint32(18).string(m.timestamp);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(24).int32(m.status);
      return w;
    };

    RetentionResult.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.RetentionResult();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.string();
            break;
          case 2:
            m.timestamp = r.string();
            break;
          case 3:
            m.status = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return RetentionResult;
  })();

  im_proto.Participant = (function () {
    function Participant(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    Participant.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Participant.prototype.sort_order = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Participant.prototype.role = 0;
    Participant.prototype.alias = '';
    Participant.prototype.sec_uid = '';
    Participant.prototype.blocked = 0;
    Participant.prototype.left_block_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Participant.prototype.ext = $util.emptyObject;

    Participant.create = function create(properties) {
      return new Participant(properties);
    };

    Participant.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(8).int64(m.user_id);
      if (m.sort_order != null && Object.hasOwnProperty.call(m, 'sort_order')) w.uint32(16).int64(m.sort_order);
      if (m.role != null && Object.hasOwnProperty.call(m, 'role')) w.uint32(24).int32(m.role);
      if (m.alias != null && Object.hasOwnProperty.call(m, 'alias')) w.uint32(34).string(m.alias);
      if (m.sec_uid != null && Object.hasOwnProperty.call(m, 'sec_uid')) w.uint32(42).string(m.sec_uid);
      if (m.blocked != null && Object.hasOwnProperty.call(m, 'blocked')) w.uint32(48).int32(m.blocked);
      if (m.left_block_time != null && Object.hasOwnProperty.call(m, 'left_block_time'))
        w.uint32(56).int64(m.left_block_time);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(66).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    Participant.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.Participant(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.int64();
            break;
          case 2:
            m.sort_order = r.int64();
            break;
          case 3:
            m.role = r.int32();
            break;
          case 4:
            m.alias = r.string();
            break;
          case 5:
            m.sec_uid = r.string();
            break;
          case 6:
            m.blocked = r.int32();
            break;
          case 7:
            m.left_block_time = r.int64();
            break;
          case 8:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Participant;
  })();

  im_proto.ParticipantsPage = (function () {
    function ParticipantsPage(p) {
      this.participants = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ParticipantsPage.prototype.participants = $util.emptyArray;
    ParticipantsPage.prototype.has_more = false;
    ParticipantsPage.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    ParticipantsPage.create = function create(properties) {
      return new ParticipantsPage(properties);
    };

    ParticipantsPage.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.participants != null && m.participants.length) {
        for (var i = 0; i < m.participants.length; ++i)
          $root.im_proto.Participant.encode(m.participants[i], w.uint32(10).fork()).ldelim();
      }
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(16).bool(m.has_more);
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(24).int64(m.cursor);
      return w;
    };

    ParticipantsPage.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ParticipantsPage();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.participants && m.participants.length)) m.participants = [];
            m.participants.push($root.im_proto.Participant.decode(r, r.uint32()));
            break;
          case 2:
            m.has_more = r.bool();
            break;
          case 3:
            m.cursor = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ParticipantsPage;
  })();

  im_proto.ConversationInfo = (function () {
    function ConversationInfo(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationInfo.prototype.conversation_id = '';
    ConversationInfo.prototype.conversation_type = 0;
    ConversationInfo.prototype.first_page_participants = null;
    ConversationInfo.prototype.participants_count = 0;
    ConversationInfo.prototype.min_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationInfo.prototype.read_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationInfo.prototype.mute = 0;
    ConversationInfo.prototype.stick_on_top = 0;
    ConversationInfo.prototype.ext = $util.emptyObject;
    ConversationInfo.prototype.ticket = '';
    ConversationInfo.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationInfo.prototype.conversation_version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationInfo.prototype.is_participant = false;
    ConversationInfo.prototype.read_index_v2 = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationInfo.prototype.min_index_v2 = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationInfo.prototype.server_unread_count = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationInfo.prototype.last_message_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationInfo.prototype.con_model_scene = '';

    ConversationInfo.create = function create(properties) {
      return new ConversationInfo(properties);
    };

    ConversationInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.first_page_participants != null && Object.hasOwnProperty.call(m, 'first_page_participants'))
        $root.im_proto.ParticipantsPage.encode(m.first_page_participants, w.uint32(26).fork()).ldelim();
      if (m.participants_count != null && Object.hasOwnProperty.call(m, 'participants_count'))
        w.uint32(32).int32(m.participants_count);
      if (m.min_index != null && Object.hasOwnProperty.call(m, 'min_index')) w.uint32(40).int64(m.min_index);
      if (m.read_index != null && Object.hasOwnProperty.call(m, 'read_index')) w.uint32(48).int64(m.read_index);
      if (m.mute != null && Object.hasOwnProperty.call(m, 'mute')) w.uint32(64).int32(m.mute);
      if (m.stick_on_top != null && Object.hasOwnProperty.call(m, 'stick_on_top')) w.uint32(72).int32(m.stick_on_top);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(82).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      if (m.ticket != null && Object.hasOwnProperty.call(m, 'ticket')) w.uint32(90).string(m.ticket);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(96).int64(m.conversation_short_id);
      if (m.conversation_version != null && Object.hasOwnProperty.call(m, 'conversation_version'))
        w.uint32(104).int64(m.conversation_version);
      if (m.is_participant != null && Object.hasOwnProperty.call(m, 'is_participant'))
        w.uint32(112).bool(m.is_participant);
      if (m.read_index_v2 != null && Object.hasOwnProperty.call(m, 'read_index_v2'))
        w.uint32(120).int64(m.read_index_v2);
      if (m.min_index_v2 != null && Object.hasOwnProperty.call(m, 'min_index_v2')) w.uint32(128).int64(m.min_index_v2);
      if (m.server_unread_count != null && Object.hasOwnProperty.call(m, 'server_unread_count'))
        w.uint32(160).int64(m.server_unread_count);
      if (m.last_message_index != null && Object.hasOwnProperty.call(m, 'last_message_index'))
        w.uint32(168).int64(m.last_message_index);
      if (m.con_model_scene != null && Object.hasOwnProperty.call(m, 'con_model_scene'))
        w.uint32(178).string(m.con_model_scene);
      return w;
    };

    ConversationInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationInfo(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.first_page_participants = $root.im_proto.ParticipantsPage.decode(r, r.uint32());
            break;
          case 4:
            m.participants_count = r.int32();
            break;
          case 5:
            m.min_index = r.int64();
            break;
          case 6:
            m.read_index = r.int64();
            break;
          case 8:
            m.mute = r.int32();
            break;
          case 9:
            m.stick_on_top = r.int32();
            break;
          case 10:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          case 11:
            m.ticket = r.string();
            break;
          case 12:
            m.conversation_short_id = r.int64();
            break;
          case 13:
            m.conversation_version = r.int64();
            break;
          case 14:
            m.is_participant = r.bool();
            break;
          case 15:
            m.read_index_v2 = r.int64();
            break;
          case 16:
            m.min_index_v2 = r.int64();
            break;
          case 20:
            m.server_unread_count = r.int64();
            break;
          case 21:
            m.last_message_index = r.int64();
            break;
          case 22:
            m.con_model_scene = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationInfo;
  })();

  im_proto.ConversationInfoV2 = (function () {
    function ConversationInfoV2(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationInfoV2.prototype.conversation_id = '';
    ConversationInfoV2.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationInfoV2.prototype.conversation_type = 0;
    ConversationInfoV2.prototype.ticket = '';
    ConversationInfoV2.prototype.first_page_participants = null;
    ConversationInfoV2.prototype.participants_count = 0;
    ConversationInfoV2.prototype.is_participant = false;
    ConversationInfoV2.prototype.inbox_type = 0;
    ConversationInfoV2.prototype.badge_count = 0;
    ConversationInfoV2.prototype.badge_count_v2 = 0;
    ConversationInfoV2.prototype.conversation_rank_version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationInfoV2.prototype.user_info = null;
    ConversationInfoV2.prototype.conversation_core_info = null;
    ConversationInfoV2.prototype.conversation_setting_info = null;
    ConversationInfoV2.prototype.biz_ext = $util.newBuffer([]);

    ConversationInfoV2.create = function create(properties) {
      return new ConversationInfoV2(properties);
    };

    ConversationInfoV2.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.ticket != null && Object.hasOwnProperty.call(m, 'ticket')) w.uint32(34).string(m.ticket);
      if (m.first_page_participants != null && Object.hasOwnProperty.call(m, 'first_page_participants'))
        $root.im_proto.ParticipantsPage.encode(m.first_page_participants, w.uint32(50).fork()).ldelim();
      if (m.participants_count != null && Object.hasOwnProperty.call(m, 'participants_count'))
        w.uint32(56).int32(m.participants_count);
      if (m.is_participant != null && Object.hasOwnProperty.call(m, 'is_participant'))
        w.uint32(64).bool(m.is_participant);
      if (m.inbox_type != null && Object.hasOwnProperty.call(m, 'inbox_type')) w.uint32(72).int32(m.inbox_type);
      if (m.badge_count != null && Object.hasOwnProperty.call(m, 'badge_count')) w.uint32(80).int32(m.badge_count);
      if (m.badge_count_v2 != null && Object.hasOwnProperty.call(m, 'badge_count_v2'))
        w.uint32(88).int32(m.badge_count_v2);
      if (m.conversation_rank_version != null && Object.hasOwnProperty.call(m, 'conversation_rank_version'))
        w.uint32(96).int64(m.conversation_rank_version);
      if (m.user_info != null && Object.hasOwnProperty.call(m, 'user_info'))
        $root.im_proto.Participant.encode(m.user_info, w.uint32(162).fork()).ldelim();
      if (m.conversation_core_info != null && Object.hasOwnProperty.call(m, 'conversation_core_info'))
        $root.im_proto.ConversationCoreInfo.encode(m.conversation_core_info, w.uint32(402).fork()).ldelim();
      if (m.conversation_setting_info != null && Object.hasOwnProperty.call(m, 'conversation_setting_info'))
        $root.im_proto.ConversationSettingInfo.encode(m.conversation_setting_info, w.uint32(410).fork()).ldelim();
      if (m.biz_ext != null && Object.hasOwnProperty.call(m, 'biz_ext')) w.uint32(802).bytes(m.biz_ext);
      return w;
    };

    ConversationInfoV2.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationInfoV2();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.ticket = r.string();
            break;
          case 6:
            m.first_page_participants = $root.im_proto.ParticipantsPage.decode(r, r.uint32());
            break;
          case 7:
            m.participants_count = r.int32();
            break;
          case 8:
            m.is_participant = r.bool();
            break;
          case 9:
            m.inbox_type = r.int32();
            break;
          case 10:
            m.badge_count = r.int32();
            break;
          case 11:
            m.badge_count_v2 = r.int32();
            break;
          case 12:
            m.conversation_rank_version = r.int64();
            break;
          case 20:
            m.user_info = $root.im_proto.Participant.decode(r, r.uint32());
            break;
          case 50:
            m.conversation_core_info = $root.im_proto.ConversationCoreInfo.decode(r, r.uint32());
            break;
          case 51:
            m.conversation_setting_info = $root.im_proto.ConversationSettingInfo.decode(r, r.uint32());
            break;
          case 100:
            m.biz_ext = r.bytes();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationInfoV2;
  })();

  im_proto.ConversationCoreInfo = (function () {
    function ConversationCoreInfo(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationCoreInfo.prototype.conversation_id = '';
    ConversationCoreInfo.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationCoreInfo.prototype.conversation_type = 0;
    ConversationCoreInfo.prototype.info_version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationCoreInfo.prototype.name = '';
    ConversationCoreInfo.prototype.desc = '';
    ConversationCoreInfo.prototype.icon = '';
    ConversationCoreInfo.prototype.inbox_type = 0;
    ConversationCoreInfo.prototype.notice = '';
    ConversationCoreInfo.prototype.ext = $util.emptyObject;
    ConversationCoreInfo.prototype.owner = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationCoreInfo.prototype.sec_owner = '';
    ConversationCoreInfo.prototype.block_status = 0;
    ConversationCoreInfo.prototype.block_normal_only = false;
    ConversationCoreInfo.prototype.mode = 0;
    ConversationCoreInfo.prototype.creator_uid = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    ConversationCoreInfo.create = function create(properties) {
      return new ConversationCoreInfo(properties);
    };

    ConversationCoreInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.info_version != null && Object.hasOwnProperty.call(m, 'info_version')) w.uint32(32).int64(m.info_version);
      if (m.name != null && Object.hasOwnProperty.call(m, 'name')) w.uint32(42).string(m.name);
      if (m.desc != null && Object.hasOwnProperty.call(m, 'desc')) w.uint32(50).string(m.desc);
      if (m.icon != null && Object.hasOwnProperty.call(m, 'icon')) w.uint32(58).string(m.icon);
      if (m.inbox_type != null && Object.hasOwnProperty.call(m, 'inbox_type')) w.uint32(64).int32(m.inbox_type);
      if (m.notice != null && Object.hasOwnProperty.call(m, 'notice')) w.uint32(74).string(m.notice);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(90).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      if (m.owner != null && Object.hasOwnProperty.call(m, 'owner')) w.uint32(96).int64(m.owner);
      if (m.sec_owner != null && Object.hasOwnProperty.call(m, 'sec_owner')) w.uint32(106).string(m.sec_owner);
      if (m.block_status != null && Object.hasOwnProperty.call(m, 'block_status')) w.uint32(112).int32(m.block_status);
      if (m.block_normal_only != null && Object.hasOwnProperty.call(m, 'block_normal_only'))
        w.uint32(120).bool(m.block_normal_only);
      if (m.mode != null && Object.hasOwnProperty.call(m, 'mode')) w.uint32(128).int32(m.mode);
      if (m.creator_uid != null && Object.hasOwnProperty.call(m, 'creator_uid')) w.uint32(136).int64(m.creator_uid);
      return w;
    };

    ConversationCoreInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationCoreInfo(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.info_version = r.int64();
            break;
          case 5:
            m.name = r.string();
            break;
          case 6:
            m.desc = r.string();
            break;
          case 7:
            m.icon = r.string();
            break;
          case 8:
            m.inbox_type = r.int32();
            break;
          case 9:
            m.notice = r.string();
            break;
          case 11:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          case 12:
            m.owner = r.int64();
            break;
          case 13:
            m.sec_owner = r.string();
            break;
          case 14:
            m.block_status = r.int32();
            break;
          case 15:
            m.block_normal_only = r.bool();
            break;
          case 16:
            m.mode = r.int32();
            break;
          case 17:
            m.creator_uid = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationCoreInfo;
  })();

  im_proto.ConversationSettingInfo = (function () {
    function ConversationSettingInfo(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationSettingInfo.prototype.conversation_id = '';
    ConversationSettingInfo.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationSettingInfo.prototype.conversation_type = 0;
    ConversationSettingInfo.prototype.min_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationSettingInfo.prototype.read_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationSettingInfo.prototype.mute = 0;
    ConversationSettingInfo.prototype.stick_on_top = 0;
    ConversationSettingInfo.prototype.inbox_type = 0;
    ConversationSettingInfo.prototype.ext = $util.emptyObject;
    ConversationSettingInfo.prototype.setting_version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationSettingInfo.prototype.favorite = 0;
    ConversationSettingInfo.prototype.set_top_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationSettingInfo.prototype.set_favorite_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationSettingInfo.prototype.read_index_v2 = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationSettingInfo.prototype.min_index_v2 = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationSettingInfo.prototype.read_badge_count = 0;
    ConversationSettingInfo.prototype.read_badge_count_v2 = 0;

    ConversationSettingInfo.create = function create(properties) {
      return new ConversationSettingInfo(properties);
    };

    ConversationSettingInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.min_index != null && Object.hasOwnProperty.call(m, 'min_index')) w.uint32(32).int64(m.min_index);
      if (m.read_index != null && Object.hasOwnProperty.call(m, 'read_index')) w.uint32(40).int64(m.read_index);
      if (m.mute != null && Object.hasOwnProperty.call(m, 'mute')) w.uint32(48).int32(m.mute);
      if (m.stick_on_top != null && Object.hasOwnProperty.call(m, 'stick_on_top')) w.uint32(56).int32(m.stick_on_top);
      if (m.inbox_type != null && Object.hasOwnProperty.call(m, 'inbox_type')) w.uint32(64).int32(m.inbox_type);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(74).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      if (m.setting_version != null && Object.hasOwnProperty.call(m, 'setting_version'))
        w.uint32(80).int64(m.setting_version);
      if (m.favorite != null && Object.hasOwnProperty.call(m, 'favorite')) w.uint32(88).int32(m.favorite);
      if (m.set_top_time != null && Object.hasOwnProperty.call(m, 'set_top_time')) w.uint32(96).int64(m.set_top_time);
      if (m.set_favorite_time != null && Object.hasOwnProperty.call(m, 'set_favorite_time'))
        w.uint32(104).int64(m.set_favorite_time);
      if (m.read_index_v2 != null && Object.hasOwnProperty.call(m, 'read_index_v2'))
        w.uint32(112).int64(m.read_index_v2);
      if (m.min_index_v2 != null && Object.hasOwnProperty.call(m, 'min_index_v2')) w.uint32(120).int64(m.min_index_v2);
      if (m.read_badge_count != null && Object.hasOwnProperty.call(m, 'read_badge_count'))
        w.uint32(128).int32(m.read_badge_count);
      if (m.read_badge_count_v2 != null && Object.hasOwnProperty.call(m, 'read_badge_count_v2'))
        w.uint32(136).int32(m.read_badge_count_v2);
      return w;
    };

    ConversationSettingInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationSettingInfo(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.min_index = r.int64();
            break;
          case 5:
            m.read_index = r.int64();
            break;
          case 6:
            m.mute = r.int32();
            break;
          case 7:
            m.stick_on_top = r.int32();
            break;
          case 8:
            m.inbox_type = r.int32();
            break;
          case 9:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          case 10:
            m.setting_version = r.int64();
            break;
          case 11:
            m.favorite = r.int32();
            break;
          case 12:
            m.set_top_time = r.int64();
            break;
          case 13:
            m.set_favorite_time = r.int64();
            break;
          case 14:
            m.read_index_v2 = r.int64();
            break;
          case 15:
            m.min_index_v2 = r.int64();
            break;
          case 16:
            m.read_badge_count = r.int32();
            break;
          case 17:
            m.read_badge_count_v2 = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationSettingInfo;
  })();

  im_proto.GroupInfo = (function () {
    function GroupInfo(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GroupInfo.prototype.conversation_id = '';
    GroupInfo.prototype.info_version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GroupInfo.prototype.group_name = '';
    GroupInfo.prototype.group_desc = '';
    GroupInfo.prototype.group_icon = '';
    GroupInfo.prototype.ext = $util.emptyObject;

    GroupInfo.create = function create(properties) {
      return new GroupInfo(properties);
    };

    GroupInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.info_version != null && Object.hasOwnProperty.call(m, 'info_version')) w.uint32(16).int64(m.info_version);
      if (m.group_name != null && Object.hasOwnProperty.call(m, 'group_name')) w.uint32(42).string(m.group_name);
      if (m.group_desc != null && Object.hasOwnProperty.call(m, 'group_desc')) w.uint32(50).string(m.group_desc);
      if (m.group_icon != null && Object.hasOwnProperty.call(m, 'group_icon')) w.uint32(58).string(m.group_icon);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(82).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    GroupInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GroupInfo(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.info_version = r.int64();
            break;
          case 5:
            m.group_name = r.string();
            break;
          case 6:
            m.group_desc = r.string();
            break;
          case 7:
            m.group_icon = r.string();
            break;
          case 10:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GroupInfo;
  })();

  im_proto.MessagesPerUserRequestBody = (function () {
    function MessagesPerUserRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessagesPerUserRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesPerUserRequestBody.prototype.limit = 50;
    MessagesPerUserRequestBody.prototype.interval = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesPerUserRequestBody.prototype.new_user = 0;

    MessagesPerUserRequestBody.create = function create(properties) {
      return new MessagesPerUserRequestBody(properties);
    };

    MessagesPerUserRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(8).int64(m.cursor);
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(16).int32(m.limit);
      if (m.interval != null && Object.hasOwnProperty.call(m, 'interval')) w.uint32(24).int64(m.interval);
      if (m.new_user != null && Object.hasOwnProperty.call(m, 'new_user')) w.uint32(32).int32(m.new_user);
      return w;
    };

    MessagesPerUserRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessagesPerUserRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cursor = r.int64();
            break;
          case 2:
            m.limit = r.int32();
            break;
          case 3:
            m.interval = r.int64();
            break;
          case 4:
            m.new_user = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MessagesPerUserRequestBody;
  })();

  im_proto.MessagesPerUserResponseBody = (function () {
    function MessagesPerUserResponseBody(p) {
      this.messages = [];
      this.conversation_badge_count = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessagesPerUserResponseBody.prototype.messages = $util.emptyArray;
    MessagesPerUserResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesPerUserResponseBody.prototype.has_more = false;
    MessagesPerUserResponseBody.prototype.next_interval = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesPerUserResponseBody.prototype.next_conversation_version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesPerUserResponseBody.prototype.conversation_badge_count = $util.emptyArray;
    MessagesPerUserResponseBody.prototype.next_cmd_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    MessagesPerUserResponseBody.create = function create(properties) {
      return new MessagesPerUserResponseBody(properties);
    };

    MessagesPerUserResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(10).fork()).ldelim();
      }
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(16).int64(m.next_cursor);
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(24).bool(m.has_more);
      if (m.next_interval != null && Object.hasOwnProperty.call(m, 'next_interval'))
        w.uint32(32).int64(m.next_interval);
      if (m.next_conversation_version != null && Object.hasOwnProperty.call(m, 'next_conversation_version'))
        w.uint32(40).int64(m.next_conversation_version);
      if (m.conversation_badge_count != null && m.conversation_badge_count.length) {
        for (var i = 0; i < m.conversation_badge_count.length; ++i)
          $root.im_proto.ConversationBadgeCountInfo.encode(m.conversation_badge_count[i], w.uint32(50).fork()).ldelim();
      }
      if (m.next_cmd_index != null && Object.hasOwnProperty.call(m, 'next_cmd_index'))
        w.uint32(56).int64(m.next_cmd_index);
      return w;
    };

    MessagesPerUserResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessagesPerUserResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          case 2:
            m.next_cursor = r.int64();
            break;
          case 3:
            m.has_more = r.bool();
            break;
          case 4:
            m.next_interval = r.int64();
            break;
          case 5:
            m.next_conversation_version = r.int64();
            break;
          case 6:
            if (!(m.conversation_badge_count && m.conversation_badge_count.length)) m.conversation_badge_count = [];
            m.conversation_badge_count.push($root.im_proto.ConversationBadgeCountInfo.decode(r, r.uint32()));
            break;
          case 7:
            m.next_cmd_index = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MessagesPerUserResponseBody;
  })();

  im_proto.ConversationBadgeCountInfo = (function () {
    function ConversationBadgeCountInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationBadgeCountInfo.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationBadgeCountInfo.prototype.badge_count = 0;
    ConversationBadgeCountInfo.prototype.conversation_index_v2 = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationBadgeCountInfo.prototype.conversation_id = '';

    ConversationBadgeCountInfo.create = function create(properties) {
      return new ConversationBadgeCountInfo(properties);
    };

    ConversationBadgeCountInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.conversation_short_id);
      w.uint32(16).int32(m.badge_count);
      w.uint32(24).int64(m.conversation_index_v2);
      w.uint32(34).string(m.conversation_id);
      return w;
    };

    ConversationBadgeCountInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationBadgeCountInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_short_id = r.int64();
            break;
          case 2:
            m.badge_count = r.int32();
            break;
          case 3:
            m.conversation_index_v2 = r.int64();
            break;
          case 4:
            m.conversation_id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('conversation_short_id'))
        throw $util.ProtocolError("missing required 'conversation_short_id'", { instance: m });
      if (!m.hasOwnProperty('badge_count'))
        throw $util.ProtocolError("missing required 'badge_count'", { instance: m });
      if (!m.hasOwnProperty('conversation_index_v2'))
        throw $util.ProtocolError("missing required 'conversation_index_v2'", { instance: m });
      if (!m.hasOwnProperty('conversation_id'))
        throw $util.ProtocolError("missing required 'conversation_id'", { instance: m });
      return m;
    };

    return ConversationBadgeCountInfo;
  })();

  im_proto.InboxMessagesPerUser = (function () {
    function InboxMessagesPerUser(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    InboxMessagesPerUser.prototype.inbox_type = 0;
    InboxMessagesPerUser.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    InboxMessagesPerUser.create = function create(properties) {
      return new InboxMessagesPerUser(properties);
    };

    InboxMessagesPerUser.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.inbox_type != null && Object.hasOwnProperty.call(m, 'inbox_type')) w.uint32(8).int32(m.inbox_type);
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(16).int64(m.cursor);
      return w;
    };

    InboxMessagesPerUser.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.InboxMessagesPerUser();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.inbox_type = r.int32();
            break;
          case 2:
            m.cursor = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return InboxMessagesPerUser;
  })();

  im_proto.CheckMessagePerUserRequestBody = (function () {
    function CheckMessagePerUserRequestBody(p) {
      this.checks = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    CheckMessagePerUserRequestBody.prototype.checks = $util.emptyArray;

    CheckMessagePerUserRequestBody.create = function create(properties) {
      return new CheckMessagePerUserRequestBody(properties);
    };

    CheckMessagePerUserRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.checks != null && m.checks.length) {
        for (var i = 0; i < m.checks.length; ++i)
          $root.im_proto.InboxMessagesPerUser.encode(m.checks[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    CheckMessagePerUserRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.CheckMessagePerUserRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.checks && m.checks.length)) m.checks = [];
            m.checks.push($root.im_proto.InboxMessagesPerUser.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return CheckMessagePerUserRequestBody;
  })();

  im_proto.InboxMessagesPerUserResponseBody = (function () {
    function InboxMessagesPerUserResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    InboxMessagesPerUserResponseBody.prototype.inbox_type = 0;
    InboxMessagesPerUserResponseBody.prototype.has_more = false;

    InboxMessagesPerUserResponseBody.create = function create(properties) {
      return new InboxMessagesPerUserResponseBody(properties);
    };

    InboxMessagesPerUserResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.inbox_type != null && Object.hasOwnProperty.call(m, 'inbox_type')) w.uint32(8).int32(m.inbox_type);
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(16).bool(m.has_more);
      return w;
    };

    InboxMessagesPerUserResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.InboxMessagesPerUserResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.inbox_type = r.int32();
            break;
          case 2:
            m.has_more = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return InboxMessagesPerUserResponseBody;
  })();

  im_proto.CheckMessagesPerUserResponseBody = (function () {
    function CheckMessagesPerUserResponseBody(p) {
      this.messages = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    CheckMessagesPerUserResponseBody.prototype.messages = $util.emptyArray;

    CheckMessagesPerUserResponseBody.create = function create(properties) {
      return new CheckMessagesPerUserResponseBody(properties);
    };

    CheckMessagesPerUserResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.InboxMessagesPerUserResponseBody.encode(m.messages[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    CheckMessagesPerUserResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.CheckMessagesPerUserResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.InboxMessagesPerUserResponseBody.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return CheckMessagesPerUserResponseBody;
  })();

  im_proto.MessagesPerUserInitRequestBody = (function () {
    function MessagesPerUserInitRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessagesPerUserInitRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesPerUserInitRequestBody.prototype.new_user = 0;
    MessagesPerUserInitRequestBody.prototype.init_sub_type = 0;

    MessagesPerUserInitRequestBody.create = function create(properties) {
      return new MessagesPerUserInitRequestBody(properties);
    };

    MessagesPerUserInitRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(8).int64(m.cursor);
      if (m.new_user != null && Object.hasOwnProperty.call(m, 'new_user')) w.uint32(16).int32(m.new_user);
      if (m.init_sub_type != null && Object.hasOwnProperty.call(m, 'init_sub_type'))
        w.uint32(24).int32(m.init_sub_type);
      return w;
    };

    MessagesPerUserInitRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessagesPerUserInitRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cursor = r.int64();
            break;
          case 2:
            m.new_user = r.int32();
            break;
          case 3:
            m.init_sub_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MessagesPerUserInitRequestBody;
  })();

  im_proto.MessagesPerUserInitResponseBody = (function () {
    function MessagesPerUserInitResponseBody(p) {
      this.messages = [];
      this.conversations = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessagesPerUserInitResponseBody.prototype.messages = $util.emptyArray;
    MessagesPerUserInitResponseBody.prototype.conversations = $util.emptyArray;
    MessagesPerUserInitResponseBody.prototype.per_user_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesPerUserInitResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesPerUserInitResponseBody.prototype.has_more = false;
    MessagesPerUserInitResponseBody.prototype.init_type = 1;

    MessagesPerUserInitResponseBody.create = function create(properties) {
      return new MessagesPerUserInitResponseBody(properties);
    };

    MessagesPerUserInitResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(10).fork()).ldelim();
      }
      if (m.conversations != null && m.conversations.length) {
        for (var i = 0; i < m.conversations.length; ++i)
          $root.im_proto.ConversationInfo.encode(m.conversations[i], w.uint32(18).fork()).ldelim();
      }
      if (m.per_user_cursor != null && Object.hasOwnProperty.call(m, 'per_user_cursor'))
        w.uint32(24).int64(m.per_user_cursor);
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(32).int64(m.next_cursor);
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(40).bool(m.has_more);
      if (m.init_type != null && Object.hasOwnProperty.call(m, 'init_type')) w.uint32(48).int32(m.init_type);
      return w;
    };

    MessagesPerUserInitResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessagesPerUserInitResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          case 2:
            if (!(m.conversations && m.conversations.length)) m.conversations = [];
            m.conversations.push($root.im_proto.ConversationInfo.decode(r, r.uint32()));
            break;
          case 3:
            m.per_user_cursor = r.int64();
            break;
          case 4:
            m.next_cursor = r.int64();
            break;
          case 5:
            m.has_more = r.bool();
            break;
          case 6:
            m.init_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MessagesPerUserInitResponseBody;
  })();

  im_proto.MessagesPerUserInitV2RequestBody = (function () {
    function MessagesPerUserInitV2RequestBody(p) {
      this.siderank_keys = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessagesPerUserInitV2RequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesPerUserInitV2RequestBody.prototype.new_user = 0;
    MessagesPerUserInitV2RequestBody.prototype.init_sub_type = 0;
    MessagesPerUserInitV2RequestBody.prototype.with_empty_conv = false;
    MessagesPerUserInitV2RequestBody.prototype.siderank_keys = $util.emptyArray;

    MessagesPerUserInitV2RequestBody.create = function create(properties) {
      return new MessagesPerUserInitV2RequestBody(properties);
    };

    MessagesPerUserInitV2RequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(8).int64(m.cursor);
      if (m.new_user != null && Object.hasOwnProperty.call(m, 'new_user')) w.uint32(16).int32(m.new_user);
      if (m.init_sub_type != null && Object.hasOwnProperty.call(m, 'init_sub_type'))
        w.uint32(24).int32(m.init_sub_type);
      if (m.with_empty_conv != null && Object.hasOwnProperty.call(m, 'with_empty_conv'))
        w.uint32(32).bool(m.with_empty_conv);
      if (m.siderank_keys != null && m.siderank_keys.length) {
        for (var i = 0; i < m.siderank_keys.length; ++i) w.uint32(42).string(m.siderank_keys[i]);
      }
      return w;
    };

    MessagesPerUserInitV2RequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessagesPerUserInitV2RequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cursor = r.int64();
            break;
          case 2:
            m.new_user = r.int32();
            break;
          case 3:
            m.init_sub_type = r.int32();
            break;
          case 4:
            m.with_empty_conv = r.bool();
            break;
          case 5:
            if (!(m.siderank_keys && m.siderank_keys.length)) m.siderank_keys = [];
            m.siderank_keys.push(r.string());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MessagesPerUserInitV2RequestBody;
  })();

  im_proto.MessagesPerUserInitV2ResponseBody = (function () {
    function MessagesPerUserInitV2ResponseBody(p) {
      this.messages = [];
      this.conversations = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessagesPerUserInitV2ResponseBody.prototype.messages = $util.emptyArray;
    MessagesPerUserInitV2ResponseBody.prototype.conversations = $util.emptyArray;
    MessagesPerUserInitV2ResponseBody.prototype.per_user_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesPerUserInitV2ResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesPerUserInitV2ResponseBody.prototype.has_more = false;
    MessagesPerUserInitV2ResponseBody.prototype.init_type = 1;
    MessagesPerUserInitV2ResponseBody.prototype.cmd_start_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesPerUserInitV2ResponseBody.prototype.next_conversation_version = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    MessagesPerUserInitV2ResponseBody.create = function create(properties) {
      return new MessagesPerUserInitV2ResponseBody(properties);
    };

    MessagesPerUserInitV2ResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(10).fork()).ldelim();
      }
      if (m.conversations != null && m.conversations.length) {
        for (var i = 0; i < m.conversations.length; ++i)
          $root.im_proto.ConversationInfoV2.encode(m.conversations[i], w.uint32(18).fork()).ldelim();
      }
      if (m.per_user_cursor != null && Object.hasOwnProperty.call(m, 'per_user_cursor'))
        w.uint32(24).int64(m.per_user_cursor);
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(32).int64(m.next_cursor);
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(40).bool(m.has_more);
      if (m.init_type != null && Object.hasOwnProperty.call(m, 'init_type')) w.uint32(48).int32(m.init_type);
      if (m.cmd_start_index != null && Object.hasOwnProperty.call(m, 'cmd_start_index'))
        w.uint32(56).int64(m.cmd_start_index);
      if (m.next_conversation_version != null && Object.hasOwnProperty.call(m, 'next_conversation_version'))
        w.uint32(64).int64(m.next_conversation_version);
      return w;
    };

    MessagesPerUserInitV2ResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessagesPerUserInitV2ResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          case 2:
            if (!(m.conversations && m.conversations.length)) m.conversations = [];
            m.conversations.push($root.im_proto.ConversationInfoV2.decode(r, r.uint32()));
            break;
          case 3:
            m.per_user_cursor = r.int64();
            break;
          case 4:
            m.next_cursor = r.int64();
            break;
          case 5:
            m.has_more = r.bool();
            break;
          case 6:
            m.init_type = r.int32();
            break;
          case 7:
            m.cmd_start_index = r.int64();
            break;
          case 8:
            m.next_conversation_version = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MessagesPerUserInitV2ResponseBody;
  })();

  im_proto.ReportGetMessagesCursorRequestBody = (function () {
    function ReportGetMessagesCursorRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ReportGetMessagesCursorRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    ReportGetMessagesCursorRequestBody.create = function create(properties) {
      return new ReportGetMessagesCursorRequestBody(properties);
    };

    ReportGetMessagesCursorRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(8).int64(m.cursor);
      return w;
    };

    ReportGetMessagesCursorRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ReportGetMessagesCursorRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cursor = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ReportGetMessagesCursorRequestBody;
  })();

  im_proto.ConversationsListRequestBody = (function () {
    function ConversationsListRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationsListRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationsListRequestBody.prototype.policy = 1;

    ConversationsListRequestBody.create = function create(properties) {
      return new ConversationsListRequestBody(properties);
    };

    ConversationsListRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(8).int64(m.cursor);
      if (m.policy != null && Object.hasOwnProperty.call(m, 'policy')) w.uint32(16).int32(m.policy);
      return w;
    };

    ConversationsListRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationsListRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cursor = r.int64();
            break;
          case 2:
            m.policy = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationsListRequestBody;
  })();

  im_proto.ConversationsListResponseBody = (function () {
    function ConversationsListResponseBody(p) {
      this.conversations = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationsListResponseBody.prototype.conversations = $util.emptyArray;
    ConversationsListResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationsListResponseBody.prototype.has_more = false;

    ConversationsListResponseBody.create = function create(properties) {
      return new ConversationsListResponseBody(properties);
    };

    ConversationsListResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversations != null && m.conversations.length) {
        for (var i = 0; i < m.conversations.length; ++i)
          $root.im_proto.ConversationInfo.encode(m.conversations[i], w.uint32(10).fork()).ldelim();
      }
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(16).int64(m.next_cursor);
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(24).bool(m.has_more);
      return w;
    };

    ConversationsListResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationsListResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conversations && m.conversations.length)) m.conversations = [];
            m.conversations.push($root.im_proto.ConversationInfo.decode(r, r.uint32()));
            break;
          case 2:
            m.next_cursor = r.int64();
            break;
          case 3:
            m.has_more = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationsListResponseBody;
  })();

  im_proto.MessageIDIndexEntry = (function () {
    function MessageIDIndexEntry(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessageIDIndexEntry.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessageIDIndexEntry.prototype.index_in_conversation = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    MessageIDIndexEntry.create = function create(properties) {
      return new MessageIDIndexEntry(properties);
    };

    MessageIDIndexEntry.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.server_message_id);
      w.uint32(16).int64(m.index_in_conversation);
      return w;
    };

    MessageIDIndexEntry.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessageIDIndexEntry();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.server_message_id = r.int64();
            break;
          case 2:
            m.index_in_conversation = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('server_message_id'))
        throw $util.ProtocolError("missing required 'server_message_id'", { instance: m });
      if (!m.hasOwnProperty('index_in_conversation'))
        throw $util.ProtocolError("missing required 'index_in_conversation'", { instance: m });
      return m;
    };

    return MessageIDIndexEntry;
  })();

  im_proto.GetMessagesRequestBody = (function () {
    function GetMessagesRequestBody(p) {
      this.entries = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMessagesRequestBody.prototype.conversation_id = '';
    GetMessagesRequestBody.prototype.conversation_type = 0;
    GetMessagesRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetMessagesRequestBody.prototype.entries = $util.emptyArray;

    GetMessagesRequestBody.create = function create(properties) {
      return new GetMessagesRequestBody(properties);
    };

    GetMessagesRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(10).string(m.conversation_id);
      w.uint32(16).int32(m.conversation_type);
      w.uint32(24).int64(m.conversation_short_id);
      if (m.entries != null && m.entries.length) {
        for (var i = 0; i < m.entries.length; ++i)
          $root.im_proto.MessageIDIndexEntry.encode(m.entries[i], w.uint32(34).fork()).ldelim();
      }
      return w;
    };

    GetMessagesRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMessagesRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            if (!(m.entries && m.entries.length)) m.entries = [];
            m.entries.push($root.im_proto.MessageIDIndexEntry.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('conversation_id'))
        throw $util.ProtocolError("missing required 'conversation_id'", { instance: m });
      if (!m.hasOwnProperty('conversation_type'))
        throw $util.ProtocolError("missing required 'conversation_type'", { instance: m });
      if (!m.hasOwnProperty('conversation_short_id'))
        throw $util.ProtocolError("missing required 'conversation_short_id'", { instance: m });
      return m;
    };

    return GetMessagesRequestBody;
  })();

  im_proto.GetMessagesResponseBody = (function () {
    function GetMessagesResponseBody(p) {
      this.messages = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMessagesResponseBody.prototype.messages = $util.emptyArray;

    GetMessagesResponseBody.create = function create(properties) {
      return new GetMessagesResponseBody(properties);
    };

    GetMessagesResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    GetMessagesResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMessagesResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetMessagesResponseBody;
  })();

  im_proto.MessagesPerConversationSearchRequestBody = (function () {
    function MessagesPerConversationSearchRequestBody(p) {
      this.tags = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessagesPerConversationSearchRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesPerConversationSearchRequestBody.prototype.limit = 0;
    MessagesPerConversationSearchRequestBody.prototype.tags = $util.emptyArray;

    MessagesPerConversationSearchRequestBody.create = function create(properties) {
      return new MessagesPerConversationSearchRequestBody(properties);
    };

    MessagesPerConversationSearchRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(8).int64(m.cursor);
      w.uint32(16).int32(m.limit);
      if (m.tags != null && m.tags.length) {
        for (var i = 0; i < m.tags.length; ++i) w.uint32(26).string(m.tags[i]);
      }
      return w;
    };

    MessagesPerConversationSearchRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessagesPerConversationSearchRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cursor = r.int64();
            break;
          case 2:
            m.limit = r.int32();
            break;
          case 3:
            if (!(m.tags && m.tags.length)) m.tags = [];
            m.tags.push(r.string());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('limit')) throw $util.ProtocolError("missing required 'limit'", { instance: m });
      return m;
    };

    return MessagesPerConversationSearchRequestBody;
  })();

  im_proto.MessagesPerConversationSearchResponseBody = (function () {
    function MessagesPerConversationSearchResponseBody(p) {
      this.messages = [];
      this.conversations = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessagesPerConversationSearchResponseBody.prototype.messages = $util.emptyArray;
    MessagesPerConversationSearchResponseBody.prototype.conversations = $util.emptyArray;
    MessagesPerConversationSearchResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesPerConversationSearchResponseBody.prototype.has_more = false;

    MessagesPerConversationSearchResponseBody.create = function create(properties) {
      return new MessagesPerConversationSearchResponseBody(properties);
    };

    MessagesPerConversationSearchResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(10).fork()).ldelim();
      }
      if (m.conversations != null && m.conversations.length) {
        for (var i = 0; i < m.conversations.length; ++i)
          $root.im_proto.ConversationInfoV2.encode(m.conversations[i], w.uint32(18).fork()).ldelim();
      }
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(24).int64(m.next_cursor);
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(32).bool(m.has_more);
      return w;
    };

    MessagesPerConversationSearchResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessagesPerConversationSearchResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          case 2:
            if (!(m.conversations && m.conversations.length)) m.conversations = [];
            m.conversations.push($root.im_proto.ConversationInfoV2.decode(r, r.uint32()));
            break;
          case 3:
            m.next_cursor = r.int64();
            break;
          case 4:
            m.has_more = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MessagesPerConversationSearchResponseBody;
  })();

  im_proto.MessagesInConversationRequestBody = (function () {
    function MessagesInConversationRequestBody(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessagesInConversationRequestBody.prototype.conversation_id = '';
    MessagesInConversationRequestBody.prototype.conversation_type = 0;
    MessagesInConversationRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    MessagesInConversationRequestBody.prototype.direction = 1;
    MessagesInConversationRequestBody.prototype.anchor_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesInConversationRequestBody.prototype.limit = 50;
    MessagesInConversationRequestBody.prototype.ext = $util.emptyObject;

    MessagesInConversationRequestBody.create = function create(properties) {
      return new MessagesInConversationRequestBody(properties);
    };

    MessagesInConversationRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.direction != null && Object.hasOwnProperty.call(m, 'direction')) w.uint32(32).int32(m.direction);
      if (m.anchor_index != null && Object.hasOwnProperty.call(m, 'anchor_index')) w.uint32(40).int64(m.anchor_index);
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(48).int32(m.limit);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(58).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    MessagesInConversationRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessagesInConversationRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.direction = r.int32();
            break;
          case 5:
            m.anchor_index = r.int64();
            break;
          case 6:
            m.limit = r.int32();
            break;
          case 7:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MessagesInConversationRequestBody;
  })();

  im_proto.MessagesInConversationResponseBody = (function () {
    function MessagesInConversationResponseBody(p) {
      this.messages = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessagesInConversationResponseBody.prototype.messages = $util.emptyArray;
    MessagesInConversationResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesInConversationResponseBody.prototype.has_more = false;

    MessagesInConversationResponseBody.create = function create(properties) {
      return new MessagesInConversationResponseBody(properties);
    };

    MessagesInConversationResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(10).fork()).ldelim();
      }
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(16).int64(m.next_cursor);
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(24).bool(m.has_more);
      return w;
    };

    MessagesInConversationResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessagesInConversationResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          case 2:
            m.next_cursor = r.int64();
            break;
          case 3:
            m.has_more = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MessagesInConversationResponseBody;
  })();

  im_proto.GetMessagesCheckInfoInConversationRequestBody = (function () {
    function GetMessagesCheckInfoInConversationRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMessagesCheckInfoInConversationRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    GetMessagesCheckInfoInConversationRequestBody.prototype.conversation_id = '';
    GetMessagesCheckInfoInConversationRequestBody.prototype.conversation_type = 0;
    GetMessagesCheckInfoInConversationRequestBody.prototype.cursor_reverse_begin = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    GetMessagesCheckInfoInConversationRequestBody.prototype.cursor_reverse_end = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    GetMessagesCheckInfoInConversationRequestBody.prototype.expect_msg_total_count = 0;

    GetMessagesCheckInfoInConversationRequestBody.create = function create(properties) {
      return new GetMessagesCheckInfoInConversationRequestBody(properties);
    };

    GetMessagesCheckInfoInConversationRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.cursor_reverse_begin != null && Object.hasOwnProperty.call(m, 'cursor_reverse_begin'))
        w.uint32(24).int64(m.cursor_reverse_begin);
      if (m.expect_msg_total_count != null && Object.hasOwnProperty.call(m, 'expect_msg_total_count'))
        w.uint32(32).int32(m.expect_msg_total_count);
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(42).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(48).int32(m.conversation_type);
      if (m.cursor_reverse_end != null && Object.hasOwnProperty.call(m, 'cursor_reverse_end'))
        w.uint32(56).int64(m.cursor_reverse_end);
      return w;
    };

    GetMessagesCheckInfoInConversationRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMessagesCheckInfoInConversationRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 5:
            m.conversation_id = r.string();
            break;
          case 6:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.cursor_reverse_begin = r.int64();
            break;
          case 7:
            m.cursor_reverse_end = r.int64();
            break;
          case 4:
            m.expect_msg_total_count = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetMessagesCheckInfoInConversationRequestBody;
  })();

  im_proto.MessagesCheckInfo = (function () {
    function MessagesCheckInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessagesCheckInfo.prototype.head_msg_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesCheckInfo.prototype.tail_msg_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessagesCheckInfo.prototype.msg_count = 0;
    MessagesCheckInfo.prototype.indexes_checksum = 0;

    MessagesCheckInfo.create = function create(properties) {
      return new MessagesCheckInfo(properties);
    };

    MessagesCheckInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.head_msg_index != null && Object.hasOwnProperty.call(m, 'head_msg_index'))
        w.uint32(8).int64(m.head_msg_index);
      if (m.tail_msg_index != null && Object.hasOwnProperty.call(m, 'tail_msg_index'))
        w.uint32(16).int64(m.tail_msg_index);
      if (m.msg_count != null && Object.hasOwnProperty.call(m, 'msg_count')) w.uint32(24).int32(m.msg_count);
      if (m.indexes_checksum != null && Object.hasOwnProperty.call(m, 'indexes_checksum'))
        w.uint32(32).uint32(m.indexes_checksum);
      return w;
    };

    MessagesCheckInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessagesCheckInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.head_msg_index = r.int64();
            break;
          case 2:
            m.tail_msg_index = r.int64();
            break;
          case 3:
            m.msg_count = r.int32();
            break;
          case 4:
            m.indexes_checksum = r.uint32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MessagesCheckInfo;
  })();

  im_proto.GetMessagesCheckInfoInConversationResponseBody = (function () {
    function GetMessagesCheckInfoInConversationResponseBody(p) {
      this.msgs_checkinfo_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMessagesCheckInfoInConversationResponseBody.prototype.msgs_checkinfo_list = $util.emptyArray;
    GetMessagesCheckInfoInConversationResponseBody.prototype.real_msg_total_count = 0;
    GetMessagesCheckInfoInConversationResponseBody.prototype.cursor_reverse_next = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    GetMessagesCheckInfoInConversationResponseBody.create = function create(properties) {
      return new GetMessagesCheckInfoInConversationResponseBody(properties);
    };

    GetMessagesCheckInfoInConversationResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.msgs_checkinfo_list != null && m.msgs_checkinfo_list.length) {
        for (var i = 0; i < m.msgs_checkinfo_list.length; ++i)
          $root.im_proto.MessagesCheckInfo.encode(m.msgs_checkinfo_list[i], w.uint32(10).fork()).ldelim();
      }
      if (m.real_msg_total_count != null && Object.hasOwnProperty.call(m, 'real_msg_total_count'))
        w.uint32(16).int32(m.real_msg_total_count);
      if (m.cursor_reverse_next != null && Object.hasOwnProperty.call(m, 'cursor_reverse_next'))
        w.uint32(32).int64(m.cursor_reverse_next);
      return w;
    };

    GetMessagesCheckInfoInConversationResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMessagesCheckInfoInConversationResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.msgs_checkinfo_list && m.msgs_checkinfo_list.length)) m.msgs_checkinfo_list = [];
            m.msgs_checkinfo_list.push($root.im_proto.MessagesCheckInfo.decode(r, r.uint32()));
            break;
          case 2:
            m.real_msg_total_count = r.int32();
            break;
          case 4:
            m.cursor_reverse_next = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetMessagesCheckInfoInConversationResponseBody;
  })();

  im_proto.GetMessagesCheckInfoV2RequestBody = (function () {
    function GetMessagesCheckInfoV2RequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMessagesCheckInfoV2RequestBody.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetMessagesCheckInfoV2RequestBody.prototype.conv_id = '';
    GetMessagesCheckInfoV2RequestBody.prototype.conv_type = 1;
    GetMessagesCheckInfoV2RequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetMessagesCheckInfoV2RequestBody.prototype.limit = 0;

    GetMessagesCheckInfoV2RequestBody.create = function create(properties) {
      return new GetMessagesCheckInfoV2RequestBody(properties);
    };

    GetMessagesCheckInfoV2RequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conv_short_id != null && Object.hasOwnProperty.call(m, 'conv_short_id')) w.uint32(8).int64(m.conv_short_id);
      if (m.conv_id != null && Object.hasOwnProperty.call(m, 'conv_id')) w.uint32(18).string(m.conv_id);
      if (m.conv_type != null && Object.hasOwnProperty.call(m, 'conv_type')) w.uint32(24).int32(m.conv_type);
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(32).int64(m.cursor);
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(40).int32(m.limit);
      return w;
    };

    GetMessagesCheckInfoV2RequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMessagesCheckInfoV2RequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conv_short_id = r.int64();
            break;
          case 2:
            m.conv_id = r.string();
            break;
          case 3:
            m.conv_type = r.int32();
            break;
          case 4:
            m.cursor = r.int64();
            break;
          case 5:
            m.limit = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetMessagesCheckInfoV2RequestBody;
  })();

  im_proto.MessageCheckInfoV2 = (function () {
    function MessageCheckInfoV2(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessageCheckInfoV2.prototype.msg_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessageCheckInfoV2.prototype.index_in_conv = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    MessageCheckInfoV2.create = function create(properties) {
      return new MessageCheckInfoV2(properties);
    };

    MessageCheckInfoV2.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.msg_id);
      w.uint32(16).int64(m.index_in_conv);
      return w;
    };

    MessageCheckInfoV2.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessageCheckInfoV2();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.msg_id = r.int64();
            break;
          case 2:
            m.index_in_conv = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('msg_id')) throw $util.ProtocolError("missing required 'msg_id'", { instance: m });
      if (!m.hasOwnProperty('index_in_conv'))
        throw $util.ProtocolError("missing required 'index_in_conv'", { instance: m });
      return m;
    };

    return MessageCheckInfoV2;
  })();

  im_proto.GetMessagesCheckInfoV2ResponseBody = (function () {
    function GetMessagesCheckInfoV2ResponseBody(p) {
      this.msg_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMessagesCheckInfoV2ResponseBody.prototype.msg_list = $util.emptyArray;
    GetMessagesCheckInfoV2ResponseBody.prototype.has_more = false;
    GetMessagesCheckInfoV2ResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetMessagesCheckInfoV2ResponseBody.prototype.is_demoted = false;

    GetMessagesCheckInfoV2ResponseBody.create = function create(properties) {
      return new GetMessagesCheckInfoV2ResponseBody(properties);
    };

    GetMessagesCheckInfoV2ResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.msg_list != null && m.msg_list.length) {
        for (var i = 0; i < m.msg_list.length; ++i)
          $root.im_proto.MessageCheckInfoV2.encode(m.msg_list[i], w.uint32(10).fork()).ldelim();
      }
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(16).bool(m.has_more);
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(24).int64(m.next_cursor);
      if (m.is_demoted != null && Object.hasOwnProperty.call(m, 'is_demoted')) w.uint32(32).bool(m.is_demoted);
      return w;
    };

    GetMessagesCheckInfoV2ResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMessagesCheckInfoV2ResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.msg_list && m.msg_list.length)) m.msg_list = [];
            m.msg_list.push($root.im_proto.MessageCheckInfoV2.decode(r, r.uint32()));
            break;
          case 2:
            m.has_more = r.bool();
            break;
          case 3:
            m.next_cursor = r.int64();
            break;
          case 4:
            m.is_demoted = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetMessagesCheckInfoV2ResponseBody;
  })();

  im_proto.CreateConversationRequestBody = (function () {
    function CreateConversationRequestBody(p) {
      this.participants = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    CreateConversationRequestBody.prototype.conversation_type = 0;
    CreateConversationRequestBody.prototype.participants = $util.emptyArray;

    CreateConversationRequestBody.create = function create(properties) {
      return new CreateConversationRequestBody(properties);
    };

    CreateConversationRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(8).int32(m.conversation_type);
      if (m.participants != null && m.participants.length) {
        for (var i = 0; i < m.participants.length; ++i) w.uint32(16).int64(m.participants[i]);
      }
      return w;
    };

    CreateConversationRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.CreateConversationRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_type = r.int32();
            break;
          case 2:
            if (!(m.participants && m.participants.length)) m.participants = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.participants.push(r.int64());
            } else m.participants.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return CreateConversationRequestBody;
  })();

  im_proto.CreateConversationResponseBody = (function () {
    function CreateConversationResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    CreateConversationResponseBody.prototype.conversation = null;
    CreateConversationResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CreateConversationResponseBody.prototype.check_message = '';
    CreateConversationResponseBody.prototype.extra_info = '';
    CreateConversationResponseBody.prototype.status = 0;

    CreateConversationResponseBody.create = function create(properties) {
      return new CreateConversationResponseBody(properties);
    };

    CreateConversationResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation != null && Object.hasOwnProperty.call(m, 'conversation'))
        $root.im_proto.ConversationInfo.encode(m.conversation, w.uint32(10).fork()).ldelim();
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(16).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(26).string(m.check_message);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(34).string(m.extra_info);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(40).int32(m.status);
      return w;
    };

    CreateConversationResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.CreateConversationResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation = $root.im_proto.ConversationInfo.decode(r, r.uint32());
            break;
          case 2:
            m.check_code = r.int64();
            break;
          case 3:
            m.check_message = r.string();
            break;
          case 4:
            m.extra_info = r.string();
            break;
          case 5:
            m.status = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return CreateConversationResponseBody;
  })();

  im_proto.CreateConversationV2RequestBody = (function () {
    function CreateConversationV2RequestBody(p) {
      this.participants = [];
      this.biz_ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    CreateConversationV2RequestBody.prototype.conversation_type = 0;
    CreateConversationV2RequestBody.prototype.participants = $util.emptyArray;
    CreateConversationV2RequestBody.prototype.persistent = false;
    CreateConversationV2RequestBody.prototype.idempotent_id = '';
    CreateConversationV2RequestBody.prototype.name = '';
    CreateConversationV2RequestBody.prototype.avatar_url = '';
    CreateConversationV2RequestBody.prototype.description = '';
    CreateConversationV2RequestBody.prototype.biz_ext = $util.emptyObject;
    CreateConversationV2RequestBody.prototype.biz = '';
    CreateConversationV2RequestBody.prototype.channel = '';

    CreateConversationV2RequestBody.create = function create(properties) {
      return new CreateConversationV2RequestBody(properties);
    };

    CreateConversationV2RequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(8).int32(m.conversation_type);
      if (m.participants != null && m.participants.length) {
        for (var i = 0; i < m.participants.length; ++i) w.uint32(16).int64(m.participants[i]);
      }
      if (m.persistent != null && Object.hasOwnProperty.call(m, 'persistent')) w.uint32(24).bool(m.persistent);
      if (m.idempotent_id != null && Object.hasOwnProperty.call(m, 'idempotent_id'))
        w.uint32(34).string(m.idempotent_id);
      if (m.name != null && Object.hasOwnProperty.call(m, 'name')) w.uint32(50).string(m.name);
      if (m.avatar_url != null && Object.hasOwnProperty.call(m, 'avatar_url')) w.uint32(58).string(m.avatar_url);
      if (m.description != null && Object.hasOwnProperty.call(m, 'description')) w.uint32(66).string(m.description);
      if (m.biz_ext != null && Object.hasOwnProperty.call(m, 'biz_ext')) {
        for (var ks = Object.keys(m.biz_ext), i = 0; i < ks.length; ++i) {
          w.uint32(90).fork().uint32(10).string(ks[i]).uint32(18).string(m.biz_ext[ks[i]]).ldelim();
        }
      }
      if (m.biz != null && Object.hasOwnProperty.call(m, 'biz')) w.uint32(98).string(m.biz);
      if (m.channel != null && Object.hasOwnProperty.call(m, 'channel')) w.uint32(106).string(m.channel);
      return w;
    };

    CreateConversationV2RequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.CreateConversationV2RequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_type = r.int32();
            break;
          case 2:
            if (!(m.participants && m.participants.length)) m.participants = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.participants.push(r.int64());
            } else m.participants.push(r.int64());
            break;
          case 3:
            m.persistent = r.bool();
            break;
          case 4:
            m.idempotent_id = r.string();
            break;
          case 6:
            m.name = r.string();
            break;
          case 7:
            m.avatar_url = r.string();
            break;
          case 8:
            m.description = r.string();
            break;
          case 11:
            if (m.biz_ext === $util.emptyObject) m.biz_ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.biz_ext[k] = value;
            break;
          case 12:
            m.biz = r.string();
            break;
          case 13:
            m.channel = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return CreateConversationV2RequestBody;
  })();

  im_proto.CreateConversationV2ResponseBody = (function () {
    function CreateConversationV2ResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    CreateConversationV2ResponseBody.prototype.conversation = null;
    CreateConversationV2ResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CreateConversationV2ResponseBody.prototype.check_message = '';
    CreateConversationV2ResponseBody.prototype.extra_info = '';
    CreateConversationV2ResponseBody.prototype.status = 0;

    CreateConversationV2ResponseBody.create = function create(properties) {
      return new CreateConversationV2ResponseBody(properties);
    };

    CreateConversationV2ResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation != null && Object.hasOwnProperty.call(m, 'conversation'))
        $root.im_proto.ConversationInfoV2.encode(m.conversation, w.uint32(10).fork()).ldelim();
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(16).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(26).string(m.check_message);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(34).string(m.extra_info);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(40).int32(m.status);
      return w;
    };

    CreateConversationV2ResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.CreateConversationV2ResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation = $root.im_proto.ConversationInfoV2.decode(r, r.uint32());
            break;
          case 2:
            m.check_code = r.int64();
            break;
          case 3:
            m.check_message = r.string();
            break;
          case 4:
            m.extra_info = r.string();
            break;
          case 5:
            m.status = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return CreateConversationV2ResponseBody;
  })();

  im_proto.SendUserActionRequestBody = (function () {
    function SendUserActionRequestBody(p) {
      this.extra = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SendUserActionRequestBody.prototype.conversation_id = '';
    SendUserActionRequestBody.prototype.conversation_type = 0;
    SendUserActionRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SendUserActionRequestBody.prototype.action_type = 1;
    SendUserActionRequestBody.prototype.extra = $util.emptyObject;

    SendUserActionRequestBody.create = function create(properties) {
      return new SendUserActionRequestBody(properties);
    };

    SendUserActionRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.action_type != null && Object.hasOwnProperty.call(m, 'action_type')) w.uint32(32).int32(m.action_type);
      if (m.extra != null && Object.hasOwnProperty.call(m, 'extra')) {
        for (var ks = Object.keys(m.extra), i = 0; i < ks.length; ++i) {
          w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.extra[ks[i]]).ldelim();
        }
      }
      return w;
    };

    SendUserActionRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SendUserActionRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.action_type = r.int32();
            break;
          case 5:
            if (m.extra === $util.emptyObject) m.extra = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.extra[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SendUserActionRequestBody;
  })();

  im_proto.SendUserActionResponseBody = (function () {
    function SendUserActionResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SendUserActionResponseBody.create = function create(properties) {
      return new SendUserActionResponseBody(properties);
    };

    SendUserActionResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    SendUserActionResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SendUserActionResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SendUserActionResponseBody;
  })();

  im_proto.SendInputStatusRequestBody = (function () {
    function SendInputStatusRequestBody(p) {
      this.extra = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SendInputStatusRequestBody.prototype.conversation_id = '';
    SendInputStatusRequestBody.prototype.conversation_type = 0;
    SendInputStatusRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SendInputStatusRequestBody.prototype.status = 3;
    SendInputStatusRequestBody.prototype.extra = $util.emptyObject;

    SendInputStatusRequestBody.create = function create(properties) {
      return new SendInputStatusRequestBody(properties);
    };

    SendInputStatusRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(32).int32(m.status);
      if (m.extra != null && Object.hasOwnProperty.call(m, 'extra')) {
        for (var ks = Object.keys(m.extra), i = 0; i < ks.length; ++i) {
          w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.extra[ks[i]]).ldelim();
        }
      }
      return w;
    };

    SendInputStatusRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SendInputStatusRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.status = r.int32();
            break;
          case 5:
            if (m.extra === $util.emptyObject) m.extra = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.extra[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SendInputStatusRequestBody;
  })();

  im_proto.SendInputStatusResponseBody = (function () {
    function SendInputStatusResponseBody(p) {
      this.extra = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SendInputStatusResponseBody.prototype.status = 1;
    SendInputStatusResponseBody.prototype.extra = $util.emptyObject;

    SendInputStatusResponseBody.create = function create(properties) {
      return new SendInputStatusResponseBody(properties);
    };

    SendInputStatusResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(8).int32(m.status);
      if (m.extra != null && Object.hasOwnProperty.call(m, 'extra')) {
        for (var ks = Object.keys(m.extra), i = 0; i < ks.length; ++i) {
          w.uint32(18).fork().uint32(10).string(ks[i]).uint32(18).string(m.extra[ks[i]]).ldelim();
        }
      }
      return w;
    };

    SendInputStatusResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SendInputStatusResponseBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.status = r.int32();
            break;
          case 2:
            if (m.extra === $util.emptyObject) m.extra = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.extra[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SendInputStatusResponseBody;
  })();

  im_proto.GetConfigsRequestBody = (function () {
    function GetConfigsRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConfigsRequestBody.create = function create(properties) {
      return new GetConfigsRequestBody(properties);
    };

    GetConfigsRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    GetConfigsRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConfigsRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConfigsRequestBody;
  })();

  im_proto.GetConfigsResponseBody = (function () {
    function GetConfigsResponseBody(p) {
      this.configs = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConfigsResponseBody.prototype.version = 0;
    GetConfigsResponseBody.prototype.configs = $util.emptyArray;

    GetConfigsResponseBody.create = function create(properties) {
      return new GetConfigsResponseBody(properties);
    };

    GetConfigsResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.version != null && Object.hasOwnProperty.call(m, 'version')) w.uint32(8).int32(m.version);
      if (m.configs != null && m.configs.length) {
        for (var i = 0; i < m.configs.length; ++i)
          $root.im_proto.Config.encode(m.configs[i], w.uint32(18).fork()).ldelim();
      }
      return w;
    };

    GetConfigsResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConfigsResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.version = r.int32();
            break;
          case 2:
            if (!(m.configs && m.configs.length)) m.configs = [];
            m.configs.push($root.im_proto.Config.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConfigsResponseBody;
  })();

  im_proto.Config = (function () {
    function Config(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    Config.prototype.conf_name = '';
    Config.prototype.conf_value = '';

    Config.create = function create(properties) {
      return new Config(properties);
    };

    Config.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conf_name != null && Object.hasOwnProperty.call(m, 'conf_name')) w.uint32(10).string(m.conf_name);
      if (m.conf_value != null && Object.hasOwnProperty.call(m, 'conf_value')) w.uint32(18).string(m.conf_value);
      return w;
    };

    Config.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.Config();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conf_name = r.string();
            break;
          case 2:
            m.conf_value = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Config;
  })();

  im_proto.ConvCountReport = (function () {
    function ConvCountReport(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConvCountReport.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConvCountReport.prototype.unread_count = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConvCountReport.prototype.conversation_type = 1;
    ConvCountReport.prototype.customed_conversation_type = 0;

    ConvCountReport.create = function create(properties) {
      return new ConvCountReport(properties);
    };

    ConvCountReport.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conv_short_id != null && Object.hasOwnProperty.call(m, 'conv_short_id')) w.uint32(8).int64(m.conv_short_id);
      if (m.unread_count != null && Object.hasOwnProperty.call(m, 'unread_count')) w.uint32(16).int64(m.unread_count);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.customed_conversation_type != null && Object.hasOwnProperty.call(m, 'customed_conversation_type'))
        w.uint32(32).int32(m.customed_conversation_type);
      return w;
    };

    ConvCountReport.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConvCountReport();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conv_short_id = r.int64();
            break;
          case 2:
            m.unread_count = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.customed_conversation_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConvCountReport;
  })();

  im_proto.UnReadCountReportRequestBody = (function () {
    function UnReadCountReportRequestBody(p) {
      this.conv_unread_count = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    UnReadCountReportRequestBody.prototype.total_unread_count = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    UnReadCountReportRequestBody.prototype.conv_unread_count = $util.emptyArray;

    UnReadCountReportRequestBody.create = function create(properties) {
      return new UnReadCountReportRequestBody(properties);
    };

    UnReadCountReportRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.total_unread_count != null && Object.hasOwnProperty.call(m, 'total_unread_count'))
        w.uint32(8).int64(m.total_unread_count);
      if (m.conv_unread_count != null && m.conv_unread_count.length) {
        for (var i = 0; i < m.conv_unread_count.length; ++i)
          $root.im_proto.ConvCountReport.encode(m.conv_unread_count[i], w.uint32(18).fork()).ldelim();
      }
      return w;
    };

    UnReadCountReportRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.UnReadCountReportRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.total_unread_count = r.int64();
            break;
          case 2:
            if (!(m.conv_unread_count && m.conv_unread_count.length)) m.conv_unread_count = [];
            m.conv_unread_count.push($root.im_proto.ConvCountReport.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UnReadCountReportRequestBody;
  })();

  im_proto.UnReadCountReportResponseBody = (function () {
    function UnReadCountReportResponseBody(p) {
      this.failed_conv_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    UnReadCountReportResponseBody.prototype.set_total_status = false;
    UnReadCountReportResponseBody.prototype.failed_conv_list = $util.emptyArray;

    UnReadCountReportResponseBody.create = function create(properties) {
      return new UnReadCountReportResponseBody(properties);
    };

    UnReadCountReportResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).bool(m.set_total_status);
      if (m.failed_conv_list != null && m.failed_conv_list.length) {
        for (var i = 0; i < m.failed_conv_list.length; ++i) w.uint32(16).int64(m.failed_conv_list[i]);
      }
      return w;
    };

    UnReadCountReportResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.UnReadCountReportResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.set_total_status = r.bool();
            break;
          case 2:
            if (!(m.failed_conv_list && m.failed_conv_list.length)) m.failed_conv_list = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.failed_conv_list.push(r.int64());
            } else m.failed_conv_list.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('set_total_status'))
        throw $util.ProtocolError("missing required 'set_total_status'", { instance: m });
      return m;
    };

    return UnReadCountReportResponseBody;
  })();

  im_proto.GetUnreadCountRequestBody = (function () {
    function GetUnreadCountRequestBody(p) {
      this.conv_short_id = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetUnreadCountRequestBody.prototype.get_total = false;
    GetUnreadCountRequestBody.prototype.conv_short_id = $util.emptyArray;

    GetUnreadCountRequestBody.create = function create(properties) {
      return new GetUnreadCountRequestBody(properties);
    };

    GetUnreadCountRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.get_total != null && Object.hasOwnProperty.call(m, 'get_total')) w.uint32(8).bool(m.get_total);
      if (m.conv_short_id != null && m.conv_short_id.length) {
        for (var i = 0; i < m.conv_short_id.length; ++i) w.uint32(16).int64(m.conv_short_id[i]);
      }
      return w;
    };

    GetUnreadCountRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetUnreadCountRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.get_total = r.bool();
            break;
          case 2:
            if (!(m.conv_short_id && m.conv_short_id.length)) m.conv_short_id = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.conv_short_id.push(r.int64());
            } else m.conv_short_id.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetUnreadCountRequestBody;
  })();

  im_proto.GetUnreadCountResponseBody = (function () {
    function GetUnreadCountResponseBody(p) {
      this.conv_unread_count = {};
      this.failed_conv_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetUnreadCountResponseBody.prototype.total_unread_count = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetUnreadCountResponseBody.prototype.conv_unread_count = $util.emptyObject;
    GetUnreadCountResponseBody.prototype.failed_conv_list = $util.emptyArray;

    GetUnreadCountResponseBody.create = function create(properties) {
      return new GetUnreadCountResponseBody(properties);
    };

    GetUnreadCountResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.total_unread_count != null && Object.hasOwnProperty.call(m, 'total_unread_count'))
        w.uint32(8).int64(m.total_unread_count);
      if (m.conv_unread_count != null && Object.hasOwnProperty.call(m, 'conv_unread_count')) {
        for (var ks = Object.keys(m.conv_unread_count), i = 0; i < ks.length; ++i) {
          w.uint32(18).fork().uint32(8).int64(ks[i]).uint32(16).int64(m.conv_unread_count[ks[i]]).ldelim();
        }
      }
      if (m.failed_conv_list != null && m.failed_conv_list.length) {
        for (var i = 0; i < m.failed_conv_list.length; ++i) w.uint32(24).int64(m.failed_conv_list[i]);
      }
      return w;
    };

    GetUnreadCountResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetUnreadCountResponseBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.total_unread_count = r.int64();
            break;
          case 2:
            if (m.conv_unread_count === $util.emptyObject) m.conv_unread_count = {};
            var c2 = r.uint32() + r.pos;
            k = 0;
            value = 0;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.int64();
                  break;
                case 2:
                  value = r.int64();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.conv_unread_count[typeof k === 'object' ? $util.longToHash(k) : k] = value;
            break;
          case 3:
            if (!(m.failed_conv_list && m.failed_conv_list.length)) m.failed_conv_list = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.failed_conv_list.push(r.int64());
            } else m.failed_conv_list.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetUnreadCountResponseBody;
  })();

  im_proto.GetBlockListRequestBody = (function () {
    function GetBlockListRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetBlockListRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetBlockListRequestBody.prototype.limit = 0;
    GetBlockListRequestBody.prototype.block_type = false;
    GetBlockListRequestBody.prototype.conv_type = 1;
    GetBlockListRequestBody.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetBlockListRequestBody.prototype.conv_id = '';
    GetBlockListRequestBody.prototype.customed_conv_type = 0;

    GetBlockListRequestBody.create = function create(properties) {
      return new GetBlockListRequestBody(properties);
    };

    GetBlockListRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(8).int64(m.cursor);
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(16).int32(m.limit);
      if (m.block_type != null && Object.hasOwnProperty.call(m, 'block_type')) w.uint32(24).bool(m.block_type);
      if (m.conv_type != null && Object.hasOwnProperty.call(m, 'conv_type')) w.uint32(32).int32(m.conv_type);
      if (m.conv_short_id != null && Object.hasOwnProperty.call(m, 'conv_short_id'))
        w.uint32(40).int64(m.conv_short_id);
      if (m.conv_id != null && Object.hasOwnProperty.call(m, 'conv_id')) w.uint32(50).string(m.conv_id);
      if (m.customed_conv_type != null && Object.hasOwnProperty.call(m, 'customed_conv_type'))
        w.uint32(56).int32(m.customed_conv_type);
      return w;
    };

    GetBlockListRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetBlockListRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cursor = r.int64();
            break;
          case 2:
            m.limit = r.int32();
            break;
          case 3:
            m.block_type = r.bool();
            break;
          case 4:
            m.conv_type = r.int32();
            break;
          case 5:
            m.conv_short_id = r.int64();
            break;
          case 6:
            m.conv_id = r.string();
            break;
          case 7:
            m.customed_conv_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetBlockListRequestBody;
  })();

  im_proto.BlockUserInfo = (function () {
    function BlockUserInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BlockUserInfo.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BlockUserInfo.prototype.create_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    BlockUserInfo.create = function create(properties) {
      return new BlockUserInfo(properties);
    };

    BlockUserInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(8).int64(m.user_id);
      if (m.create_time != null && Object.hasOwnProperty.call(m, 'create_time')) w.uint32(16).int64(m.create_time);
      return w;
    };

    BlockUserInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BlockUserInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.int64();
            break;
          case 2:
            m.create_time = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BlockUserInfo;
  })();

  im_proto.GetBlockListResponseBody = (function () {
    function GetBlockListResponseBody(p) {
      this.user_info = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetBlockListResponseBody.prototype.user_info = $util.emptyArray;
    GetBlockListResponseBody.prototype.has_more = false;
    GetBlockListResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    GetBlockListResponseBody.create = function create(properties) {
      return new GetBlockListResponseBody(properties);
    };

    GetBlockListResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_info != null && m.user_info.length) {
        for (var i = 0; i < m.user_info.length; ++i)
          $root.im_proto.BlockUserInfo.encode(m.user_info[i], w.uint32(10).fork()).ldelim();
      }
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(16).bool(m.has_more);
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(24).int64(m.next_cursor);
      return w;
    };

    GetBlockListResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetBlockListResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.user_info && m.user_info.length)) m.user_info = [];
            m.user_info.push($root.im_proto.BlockUserInfo.decode(r, r.uint32()));
            break;
          case 2:
            m.has_more = r.bool();
            break;
          case 3:
            m.next_cursor = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetBlockListResponseBody;
  })();

  im_proto.SetBlocklistRequestBody = (function () {
    function SetBlocklistRequestBody(p) {
      this.blocklist = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SetBlocklistRequestBody.prototype.set_block_list = false;
    SetBlocklistRequestBody.prototype.blocklist = $util.emptyArray;
    SetBlocklistRequestBody.prototype.block_type = false;
    SetBlocklistRequestBody.prototype.conv_type = 1;
    SetBlocklistRequestBody.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SetBlocklistRequestBody.prototype.conv_id = '';
    SetBlocklistRequestBody.prototype.customed_conv_type = 0;

    SetBlocklistRequestBody.create = function create(properties) {
      return new SetBlocklistRequestBody(properties);
    };

    SetBlocklistRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.set_block_list != null && Object.hasOwnProperty.call(m, 'set_block_list'))
        w.uint32(8).bool(m.set_block_list);
      if (m.blocklist != null && m.blocklist.length) {
        for (var i = 0; i < m.blocklist.length; ++i) w.uint32(16).int64(m.blocklist[i]);
      }
      if (m.block_type != null && Object.hasOwnProperty.call(m, 'block_type')) w.uint32(24).bool(m.block_type);
      if (m.conv_type != null && Object.hasOwnProperty.call(m, 'conv_type')) w.uint32(32).int32(m.conv_type);
      if (m.conv_short_id != null && Object.hasOwnProperty.call(m, 'conv_short_id'))
        w.uint32(40).int64(m.conv_short_id);
      if (m.conv_id != null && Object.hasOwnProperty.call(m, 'conv_id')) w.uint32(50).string(m.conv_id);
      if (m.customed_conv_type != null && Object.hasOwnProperty.call(m, 'customed_conv_type'))
        w.uint32(56).int32(m.customed_conv_type);
      return w;
    };

    SetBlocklistRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SetBlocklistRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.set_block_list = r.bool();
            break;
          case 2:
            if (!(m.blocklist && m.blocklist.length)) m.blocklist = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.blocklist.push(r.int64());
            } else m.blocklist.push(r.int64());
            break;
          case 3:
            m.block_type = r.bool();
            break;
          case 4:
            m.conv_type = r.int32();
            break;
          case 5:
            m.conv_short_id = r.int64();
            break;
          case 6:
            m.conv_id = r.string();
            break;
          case 7:
            m.customed_conv_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SetBlocklistRequestBody;
  })();

  im_proto.SetBlocklistResponseBody = (function () {
    function SetBlocklistResponseBody(p) {
      this.failed_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SetBlocklistResponseBody.prototype.failed_list = $util.emptyArray;

    SetBlocklistResponseBody.create = function create(properties) {
      return new SetBlocklistResponseBody(properties);
    };

    SetBlocklistResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.failed_list != null && m.failed_list.length) {
        for (var i = 0; i < m.failed_list.length; ++i) w.uint32(8).int64(m.failed_list[i]);
      }
      return w;
    };

    SetBlocklistResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SetBlocklistResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.failed_list && m.failed_list.length)) m.failed_list = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.failed_list.push(r.int64());
            } else m.failed_list.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SetBlocklistResponseBody;
  })();

  im_proto.CheckInBlockListRequestBody = (function () {
    function CheckInBlockListRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    CheckInBlockListRequestBody.prototype.user_to_check = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CheckInBlockListRequestBody.prototype.block_type = false;
    CheckInBlockListRequestBody.prototype.conv_type = 1;
    CheckInBlockListRequestBody.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CheckInBlockListRequestBody.prototype.conv_id = '';
    CheckInBlockListRequestBody.prototype.customed_conv_type = 0;

    CheckInBlockListRequestBody.create = function create(properties) {
      return new CheckInBlockListRequestBody(properties);
    };

    CheckInBlockListRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_to_check != null && Object.hasOwnProperty.call(m, 'user_to_check')) w.uint32(8).int64(m.user_to_check);
      if (m.block_type != null && Object.hasOwnProperty.call(m, 'block_type')) w.uint32(16).bool(m.block_type);
      if (m.conv_type != null && Object.hasOwnProperty.call(m, 'conv_type')) w.uint32(24).int32(m.conv_type);
      if (m.conv_short_id != null && Object.hasOwnProperty.call(m, 'conv_short_id'))
        w.uint32(32).int64(m.conv_short_id);
      if (m.conv_id != null && Object.hasOwnProperty.call(m, 'conv_id')) w.uint32(42).string(m.conv_id);
      if (m.customed_conv_type != null && Object.hasOwnProperty.call(m, 'customed_conv_type'))
        w.uint32(48).int32(m.customed_conv_type);
      return w;
    };

    CheckInBlockListRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.CheckInBlockListRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_to_check = r.int64();
            break;
          case 2:
            m.block_type = r.bool();
            break;
          case 3:
            m.conv_type = r.int32();
            break;
          case 4:
            m.conv_short_id = r.int64();
            break;
          case 5:
            m.conv_id = r.string();
            break;
          case 6:
            m.customed_conv_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return CheckInBlockListRequestBody;
  })();

  im_proto.CheckInBlockListResponseBody = (function () {
    function CheckInBlockListResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    CheckInBlockListResponseBody.prototype.in_blocklist = false;

    CheckInBlockListResponseBody.create = function create(properties) {
      return new CheckInBlockListResponseBody(properties);
    };

    CheckInBlockListResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.in_blocklist != null && Object.hasOwnProperty.call(m, 'in_blocklist')) w.uint32(8).bool(m.in_blocklist);
      return w;
    };

    CheckInBlockListResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.CheckInBlockListResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.in_blocklist = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return CheckInBlockListResponseBody;
  })();

  im_proto.BlockMembersRequestBody = (function () {
    function BlockMembersRequestBody(p) {
      this.block_time = {};
      this.biz_ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BlockMembersRequestBody.prototype.block_status = 0;
    BlockMembersRequestBody.prototype.block_time = $util.emptyObject;
    BlockMembersRequestBody.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BlockMembersRequestBody.prototype.conversation_type = 0;
    BlockMembersRequestBody.prototype.conversation_id = '';
    BlockMembersRequestBody.prototype.biz_ext = $util.emptyObject;

    BlockMembersRequestBody.create = function create(properties) {
      return new BlockMembersRequestBody(properties);
    };

    BlockMembersRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.block_status != null && Object.hasOwnProperty.call(m, 'block_status')) w.uint32(8).int32(m.block_status);
      if (m.block_time != null && Object.hasOwnProperty.call(m, 'block_time')) {
        for (var ks = Object.keys(m.block_time), i = 0; i < ks.length; ++i) {
          w.uint32(18).fork().uint32(8).int64(ks[i]).uint32(16).int64(m.block_time[ks[i]]).ldelim();
        }
      }
      if (m.conv_short_id != null && Object.hasOwnProperty.call(m, 'conv_short_id'))
        w.uint32(24).int64(m.conv_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(32).int32(m.conversation_type);
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(42).string(m.conversation_id);
      if (m.biz_ext != null && Object.hasOwnProperty.call(m, 'biz_ext')) {
        for (var ks = Object.keys(m.biz_ext), i = 0; i < ks.length; ++i) {
          w.uint32(90).fork().uint32(10).string(ks[i]).uint32(18).string(m.biz_ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    BlockMembersRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BlockMembersRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.block_status = r.int32();
            break;
          case 2:
            if (m.block_time === $util.emptyObject) m.block_time = {};
            var c2 = r.uint32() + r.pos;
            k = 0;
            value = 0;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.int64();
                  break;
                case 2:
                  value = r.int64();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.block_time[typeof k === 'object' ? $util.longToHash(k) : k] = value;
            break;
          case 3:
            m.conv_short_id = r.int64();
            break;
          case 4:
            m.conversation_type = r.int32();
            break;
          case 5:
            m.conversation_id = r.string();
            break;
          case 11:
            if (m.biz_ext === $util.emptyObject) m.biz_ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.biz_ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BlockMembersRequestBody;
  })();

  im_proto.BlockMembersResponseBody = (function () {
    function BlockMembersResponseBody(p) {
      this.failed_members = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BlockMembersResponseBody.prototype.failed_members = $util.emptyArray;

    BlockMembersResponseBody.create = function create(properties) {
      return new BlockMembersResponseBody(properties);
    };

    BlockMembersResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.failed_members != null && m.failed_members.length) {
        for (var i = 0; i < m.failed_members.length; ++i) w.uint32(8).int64(m.failed_members[i]);
      }
      return w;
    };

    BlockMembersResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BlockMembersResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.failed_members && m.failed_members.length)) m.failed_members = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.failed_members.push(r.int64());
            } else m.failed_members.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BlockMembersResponseBody;
  })();

  im_proto.BlockConversationRequestBody = (function () {
    function BlockConversationRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BlockConversationRequestBody.prototype.conversation_id = '';
    BlockConversationRequestBody.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BlockConversationRequestBody.prototype.conversation_type = 0;
    BlockConversationRequestBody.prototype.block_status = 0;
    BlockConversationRequestBody.prototype.block_normal_only = false;

    BlockConversationRequestBody.create = function create(properties) {
      return new BlockConversationRequestBody(properties);
    };

    BlockConversationRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conv_short_id != null && Object.hasOwnProperty.call(m, 'conv_short_id'))
        w.uint32(16).int64(m.conv_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.block_status != null && Object.hasOwnProperty.call(m, 'block_status')) w.uint32(32).int32(m.block_status);
      if (m.block_normal_only != null && Object.hasOwnProperty.call(m, 'block_normal_only'))
        w.uint32(40).bool(m.block_normal_only);
      return w;
    };

    BlockConversationRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BlockConversationRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conv_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.block_status = r.int32();
            break;
          case 5:
            m.block_normal_only = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BlockConversationRequestBody;
  })();

  im_proto.BlockConversationResponseBody = (function () {
    function BlockConversationResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BlockConversationResponseBody.create = function create(properties) {
      return new BlockConversationResponseBody(properties);
    };

    BlockConversationResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    BlockConversationResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BlockConversationResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BlockConversationResponseBody;
  })();

  im_proto.MarkMessageRequestBody = (function () {
    function MarkMessageRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MarkMessageRequestBody.prototype.conversation_id = '';
    MarkMessageRequestBody.prototype.conversation_type = 0;
    MarkMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarkMessageRequestBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarkMessageRequestBody.prototype.do_action = false;
    MarkMessageRequestBody.prototype.action_type = 0;
    MarkMessageRequestBody.prototype.sort_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarkMessageRequestBody.prototype.tag = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    MarkMessageRequestBody.create = function create(properties) {
      return new MarkMessageRequestBody(properties);
    };

    MarkMessageRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.server_message_id != null && Object.hasOwnProperty.call(m, 'server_message_id'))
        w.uint32(32).int64(m.server_message_id);
      if (m.do_action != null && Object.hasOwnProperty.call(m, 'do_action')) w.uint32(40).bool(m.do_action);
      if (m.action_type != null && Object.hasOwnProperty.call(m, 'action_type')) w.uint32(48).int32(m.action_type);
      if (m.sort_time != null && Object.hasOwnProperty.call(m, 'sort_time')) w.uint32(56).int64(m.sort_time);
      if (m.tag != null && Object.hasOwnProperty.call(m, 'tag')) w.uint32(64).int64(m.tag);
      return w;
    };

    MarkMessageRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MarkMessageRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.server_message_id = r.int64();
            break;
          case 5:
            m.do_action = r.bool();
            break;
          case 6:
            m.action_type = r.int32();
            break;
          case 7:
            m.sort_time = r.int64();
            break;
          case 8:
            m.tag = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MarkMessageRequestBody;
  })();

  im_proto.MarkMessageResponseBody = (function () {
    function MarkMessageResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MarkMessageResponseBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarkMessageResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarkMessageResponseBody.prototype.check_message = '';
    MarkMessageResponseBody.prototype.status = 0;

    MarkMessageResponseBody.create = function create(properties) {
      return new MarkMessageResponseBody(properties);
    };

    MarkMessageResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.server_message_id != null && Object.hasOwnProperty.call(m, 'server_message_id'))
        w.uint32(8).int64(m.server_message_id);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(16).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(26).string(m.check_message);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(32).int32(m.status);
      return w;
    };

    MarkMessageResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MarkMessageResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.server_message_id = r.int64();
            break;
          case 2:
            m.check_code = r.int64();
            break;
          case 3:
            m.check_message = r.string();
            break;
          case 4:
            m.status = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MarkMessageResponseBody;
  })();

  im_proto.BatchUnmarkMessageRequestBody = (function () {
    function BatchUnmarkMessageRequestBody(p) {
      this.server_message_ids = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BatchUnmarkMessageRequestBody.prototype.conversation_id = '';
    BatchUnmarkMessageRequestBody.prototype.conversation_type = 0;
    BatchUnmarkMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BatchUnmarkMessageRequestBody.prototype.server_message_ids = $util.emptyArray;
    BatchUnmarkMessageRequestBody.prototype.action_type = 0;
    BatchUnmarkMessageRequestBody.prototype.tag = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    BatchUnmarkMessageRequestBody.create = function create(properties) {
      return new BatchUnmarkMessageRequestBody(properties);
    };

    BatchUnmarkMessageRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.server_message_ids != null && m.server_message_ids.length) {
        for (var i = 0; i < m.server_message_ids.length; ++i) w.uint32(32).int64(m.server_message_ids[i]);
      }
      if (m.action_type != null && Object.hasOwnProperty.call(m, 'action_type')) w.uint32(40).int32(m.action_type);
      if (m.tag != null && Object.hasOwnProperty.call(m, 'tag')) w.uint32(48).int64(m.tag);
      return w;
    };

    BatchUnmarkMessageRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BatchUnmarkMessageRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            if (!(m.server_message_ids && m.server_message_ids.length)) m.server_message_ids = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.server_message_ids.push(r.int64());
            } else m.server_message_ids.push(r.int64());
            break;
          case 5:
            m.action_type = r.int32();
            break;
          case 6:
            m.tag = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BatchUnmarkMessageRequestBody;
  })();

  im_proto.BatchUnmarkMessageResponseBody = (function () {
    function BatchUnmarkMessageResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BatchUnmarkMessageResponseBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BatchUnmarkMessageResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BatchUnmarkMessageResponseBody.prototype.check_message = '';
    BatchUnmarkMessageResponseBody.prototype.status = 0;

    BatchUnmarkMessageResponseBody.create = function create(properties) {
      return new BatchUnmarkMessageResponseBody(properties);
    };

    BatchUnmarkMessageResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.server_message_id != null && Object.hasOwnProperty.call(m, 'server_message_id'))
        w.uint32(8).int64(m.server_message_id);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(16).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(26).string(m.check_message);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(32).int32(m.status);
      return w;
    };

    BatchUnmarkMessageResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BatchUnmarkMessageResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.server_message_id = r.int64();
            break;
          case 2:
            m.check_code = r.int64();
            break;
          case 3:
            m.check_message = r.string();
            break;
          case 4:
            m.status = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BatchUnmarkMessageResponseBody;
  })();

  im_proto.PullMarkMessageRequestBody = (function () {
    function PullMarkMessageRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    PullMarkMessageRequestBody.prototype.conversation_id = '';
    PullMarkMessageRequestBody.prototype.conversation_type = 0;
    PullMarkMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PullMarkMessageRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PullMarkMessageRequestBody.prototype.limit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PullMarkMessageRequestBody.prototype.asc = false;
    PullMarkMessageRequestBody.prototype.action_type = 0;
    PullMarkMessageRequestBody.prototype.tag = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    PullMarkMessageRequestBody.prototype.clear_unread_count = false;

    PullMarkMessageRequestBody.create = function create(properties) {
      return new PullMarkMessageRequestBody(properties);
    };

    PullMarkMessageRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(32).int64(m.cursor);
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(40).int64(m.limit);
      if (m.asc != null && Object.hasOwnProperty.call(m, 'asc')) w.uint32(48).bool(m.asc);
      if (m.action_type != null && Object.hasOwnProperty.call(m, 'action_type')) w.uint32(56).int32(m.action_type);
      if (m.tag != null && Object.hasOwnProperty.call(m, 'tag')) w.uint32(64).int64(m.tag);
      if (m.clear_unread_count != null && Object.hasOwnProperty.call(m, 'clear_unread_count'))
        w.uint32(72).bool(m.clear_unread_count);
      return w;
    };

    PullMarkMessageRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.PullMarkMessageRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.cursor = r.int64();
            break;
          case 5:
            m.limit = r.int64();
            break;
          case 6:
            m.asc = r.bool();
            break;
          case 7:
            m.action_type = r.int32();
            break;
          case 8:
            m.tag = r.int64();
            break;
          case 9:
            m.clear_unread_count = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PullMarkMessageRequestBody;
  })();

  im_proto.PullMarkMessageResponseBody = (function () {
    function PullMarkMessageResponseBody(p) {
      this.messages = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    PullMarkMessageResponseBody.prototype.messages = $util.emptyArray;
    PullMarkMessageResponseBody.prototype.has_more = false;
    PullMarkMessageResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    PullMarkMessageResponseBody.create = function create(properties) {
      return new PullMarkMessageResponseBody(properties);
    };

    PullMarkMessageResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(10).fork()).ldelim();
      }
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(16).bool(m.has_more);
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(24).int64(m.next_cursor);
      return w;
    };

    PullMarkMessageResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.PullMarkMessageResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          case 2:
            m.has_more = r.bool();
            break;
          case 3:
            m.next_cursor = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PullMarkMessageResponseBody;
  })();

  im_proto.MarkMsgUnreadCountReportRequestBody = (function () {
    function MarkMsgUnreadCountReportRequestBody(p) {
      this.tag_unread_count = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MarkMsgUnreadCountReportRequestBody.prototype.conversation_id = '';
    MarkMsgUnreadCountReportRequestBody.prototype.conversation_type = 0;
    MarkMsgUnreadCountReportRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    MarkMsgUnreadCountReportRequestBody.prototype.total_unread_count = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    MarkMsgUnreadCountReportRequestBody.prototype.tag_unread_count = $util.emptyObject;

    MarkMsgUnreadCountReportRequestBody.create = function create(properties) {
      return new MarkMsgUnreadCountReportRequestBody(properties);
    };

    MarkMsgUnreadCountReportRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.total_unread_count != null && Object.hasOwnProperty.call(m, 'total_unread_count'))
        w.uint32(32).int64(m.total_unread_count);
      if (m.tag_unread_count != null && Object.hasOwnProperty.call(m, 'tag_unread_count')) {
        for (var ks = Object.keys(m.tag_unread_count), i = 0; i < ks.length; ++i) {
          w.uint32(42).fork().uint32(8).int64(ks[i]).uint32(16).int64(m.tag_unread_count[ks[i]]).ldelim();
        }
      }
      return w;
    };

    MarkMsgUnreadCountReportRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MarkMsgUnreadCountReportRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.total_unread_count = r.int64();
            break;
          case 5:
            if (m.tag_unread_count === $util.emptyObject) m.tag_unread_count = {};
            var c2 = r.uint32() + r.pos;
            k = 0;
            value = 0;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.int64();
                  break;
                case 2:
                  value = r.int64();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.tag_unread_count[typeof k === 'object' ? $util.longToHash(k) : k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MarkMsgUnreadCountReportRequestBody;
  })();

  im_proto.MarkMsgUnreadCountReportResponseBody = (function () {
    function MarkMsgUnreadCountReportResponseBody(p) {
      this.failed_tag_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MarkMsgUnreadCountReportResponseBody.prototype.set_total_status = false;
    MarkMsgUnreadCountReportResponseBody.prototype.failed_tag_list = $util.emptyArray;

    MarkMsgUnreadCountReportResponseBody.create = function create(properties) {
      return new MarkMsgUnreadCountReportResponseBody(properties);
    };

    MarkMsgUnreadCountReportResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.set_total_status != null && Object.hasOwnProperty.call(m, 'set_total_status'))
        w.uint32(8).bool(m.set_total_status);
      if (m.failed_tag_list != null && m.failed_tag_list.length) {
        for (var i = 0; i < m.failed_tag_list.length; ++i) w.uint32(16).int64(m.failed_tag_list[i]);
      }
      return w;
    };

    MarkMsgUnreadCountReportResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MarkMsgUnreadCountReportResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.set_total_status = r.bool();
            break;
          case 2:
            if (!(m.failed_tag_list && m.failed_tag_list.length)) m.failed_tag_list = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.failed_tag_list.push(r.int64());
            } else m.failed_tag_list.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MarkMsgUnreadCountReportResponseBody;
  })();

  im_proto.MarkMsgGetUnreadCountRequestBody = (function () {
    function MarkMsgGetUnreadCountRequestBody(p) {
      this.tags = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MarkMsgGetUnreadCountRequestBody.prototype.conversation_id = '';
    MarkMsgGetUnreadCountRequestBody.prototype.conversation_type = 0;
    MarkMsgGetUnreadCountRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    MarkMsgGetUnreadCountRequestBody.prototype.get_total = false;
    MarkMsgGetUnreadCountRequestBody.prototype.tags = $util.emptyArray;

    MarkMsgGetUnreadCountRequestBody.create = function create(properties) {
      return new MarkMsgGetUnreadCountRequestBody(properties);
    };

    MarkMsgGetUnreadCountRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.get_total != null && Object.hasOwnProperty.call(m, 'get_total')) w.uint32(32).bool(m.get_total);
      if (m.tags != null && m.tags.length) {
        for (var i = 0; i < m.tags.length; ++i) w.uint32(40).int64(m.tags[i]);
      }
      return w;
    };

    MarkMsgGetUnreadCountRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MarkMsgGetUnreadCountRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.get_total = r.bool();
            break;
          case 5:
            if (!(m.tags && m.tags.length)) m.tags = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.tags.push(r.int64());
            } else m.tags.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MarkMsgGetUnreadCountRequestBody;
  })();

  im_proto.MarkMsgGetUnreadCountResponseBody = (function () {
    function MarkMsgGetUnreadCountResponseBody(p) {
      this.tag_unread_count = {};
      this.failed_tag_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MarkMsgGetUnreadCountResponseBody.prototype.total_count = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarkMsgGetUnreadCountResponseBody.prototype.tag_unread_count = $util.emptyObject;
    MarkMsgGetUnreadCountResponseBody.prototype.failed_tag_list = $util.emptyArray;

    MarkMsgGetUnreadCountResponseBody.create = function create(properties) {
      return new MarkMsgGetUnreadCountResponseBody(properties);
    };

    MarkMsgGetUnreadCountResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.total_count != null && Object.hasOwnProperty.call(m, 'total_count')) w.uint32(8).int64(m.total_count);
      if (m.tag_unread_count != null && Object.hasOwnProperty.call(m, 'tag_unread_count')) {
        for (var ks = Object.keys(m.tag_unread_count), i = 0; i < ks.length; ++i) {
          w.uint32(18).fork().uint32(8).int64(ks[i]).uint32(16).int64(m.tag_unread_count[ks[i]]).ldelim();
        }
      }
      if (m.failed_tag_list != null && m.failed_tag_list.length) {
        for (var i = 0; i < m.failed_tag_list.length; ++i) w.uint32(24).int64(m.failed_tag_list[i]);
      }
      return w;
    };

    MarkMsgGetUnreadCountResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MarkMsgGetUnreadCountResponseBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.total_count = r.int64();
            break;
          case 2:
            if (m.tag_unread_count === $util.emptyObject) m.tag_unread_count = {};
            var c2 = r.uint32() + r.pos;
            k = 0;
            value = 0;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.int64();
                  break;
                case 2:
                  value = r.int64();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.tag_unread_count[typeof k === 'object' ? $util.longToHash(k) : k] = value;
            break;
          case 3:
            if (!(m.failed_tag_list && m.failed_tag_list.length)) m.failed_tag_list = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.failed_tag_list.push(r.int64());
            } else m.failed_tag_list.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MarkMsgGetUnreadCountResponseBody;
  })();

  im_proto.SetConversationInfoRequestBody = (function () {
    function SetConversationInfoRequestBody(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SetConversationInfoRequestBody.prototype.conversation_id = '';
    SetConversationInfoRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SetConversationInfoRequestBody.prototype.conversation_type = 0;
    SetConversationInfoRequestBody.prototype.ext = $util.emptyObject;

    SetConversationInfoRequestBody.create = function create(properties) {
      return new SetConversationInfoRequestBody(properties);
    };

    SetConversationInfoRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    SetConversationInfoRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SetConversationInfoRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SetConversationInfoRequestBody;
  })();

  im_proto.SetConversationInfoResponseBody = (function () {
    function SetConversationInfoResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SetConversationInfoResponseBody.prototype.conversation = null;
    SetConversationInfoResponseBody.prototype.status = 0;
    SetConversationInfoResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SetConversationInfoResponseBody.prototype.check_message = '';
    SetConversationInfoResponseBody.prototype.extra_info = '';

    SetConversationInfoResponseBody.create = function create(properties) {
      return new SetConversationInfoResponseBody(properties);
    };

    SetConversationInfoResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation != null && Object.hasOwnProperty.call(m, 'conversation'))
        $root.im_proto.ConversationInfo.encode(m.conversation, w.uint32(10).fork()).ldelim();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(24).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(34).string(m.check_message);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(42).string(m.extra_info);
      return w;
    };

    SetConversationInfoResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SetConversationInfoResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation = $root.im_proto.ConversationInfo.decode(r, r.uint32());
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.check_code = r.int64();
            break;
          case 4:
            m.check_message = r.string();
            break;
          case 5:
            m.extra_info = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SetConversationInfoResponseBody;
  })();

  im_proto.DeleteConversationRequestBody = (function () {
    function DeleteConversationRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DeleteConversationRequestBody.prototype.conversation_id = '';
    DeleteConversationRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DeleteConversationRequestBody.prototype.conversation_type = 0;
    DeleteConversationRequestBody.prototype.last_message_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DeleteConversationRequestBody.prototype.last_message_index_v2 = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DeleteConversationRequestBody.prototype.badge_count = 0;

    DeleteConversationRequestBody.create = function create(properties) {
      return new DeleteConversationRequestBody(properties);
    };

    DeleteConversationRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.last_message_index != null && Object.hasOwnProperty.call(m, 'last_message_index'))
        w.uint32(32).int64(m.last_message_index);
      if (m.last_message_index_v2 != null && Object.hasOwnProperty.call(m, 'last_message_index_v2'))
        w.uint32(40).int64(m.last_message_index_v2);
      if (m.badge_count != null && Object.hasOwnProperty.call(m, 'badge_count')) w.uint32(48).int32(m.badge_count);
      return w;
    };

    DeleteConversationRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DeleteConversationRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.last_message_index = r.int64();
            break;
          case 5:
            m.last_message_index_v2 = r.int64();
            break;
          case 6:
            m.badge_count = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DeleteConversationRequestBody;
  })();

  im_proto.DissolveConversationRequestBody = (function () {
    function DissolveConversationRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DissolveConversationRequestBody.prototype.conversation_id = '';
    DissolveConversationRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DissolveConversationRequestBody.prototype.conversation_type = 0;

    DissolveConversationRequestBody.create = function create(properties) {
      return new DissolveConversationRequestBody(properties);
    };

    DissolveConversationRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      return w;
    };

    DissolveConversationRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DissolveConversationRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DissolveConversationRequestBody;
  })();

  im_proto.DeleteMessageRequestBody = (function () {
    function DeleteMessageRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DeleteMessageRequestBody.prototype.conversation_id = '';
    DeleteMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DeleteMessageRequestBody.prototype.conversation_type = 0;
    DeleteMessageRequestBody.prototype.message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    DeleteMessageRequestBody.create = function create(properties) {
      return new DeleteMessageRequestBody(properties);
    };

    DeleteMessageRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.message_id != null && Object.hasOwnProperty.call(m, 'message_id')) w.uint32(32).int64(m.message_id);
      return w;
    };

    DeleteMessageRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DeleteMessageRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.message_id = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DeleteMessageRequestBody;
  })();

  im_proto.MarkConversationReadRequestBody = (function () {
    function MarkConversationReadRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MarkConversationReadRequestBody.prototype.conversation_id = '';
    MarkConversationReadRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarkConversationReadRequestBody.prototype.conversation_type = 0;
    MarkConversationReadRequestBody.prototype.read_message_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarkConversationReadRequestBody.prototype.conv_unread_count = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarkConversationReadRequestBody.prototype.total_unread_count = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarkConversationReadRequestBody.prototype.read_message_index_v2 = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarkConversationReadRequestBody.prototype.read_badge_count = 0;
    MarkConversationReadRequestBody.prototype.ticket = '';
    MarkConversationReadRequestBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarkConversationReadRequestBody.prototype.read_badge_count_v2 = 0;

    MarkConversationReadRequestBody.create = function create(properties) {
      return new MarkConversationReadRequestBody(properties);
    };

    MarkConversationReadRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.read_message_index != null && Object.hasOwnProperty.call(m, 'read_message_index'))
        w.uint32(32).int64(m.read_message_index);
      if (m.conv_unread_count != null && Object.hasOwnProperty.call(m, 'conv_unread_count'))
        w.uint32(40).int64(m.conv_unread_count);
      if (m.total_unread_count != null && Object.hasOwnProperty.call(m, 'total_unread_count'))
        w.uint32(48).int64(m.total_unread_count);
      if (m.read_message_index_v2 != null && Object.hasOwnProperty.call(m, 'read_message_index_v2'))
        w.uint32(56).int64(m.read_message_index_v2);
      if (m.read_badge_count != null && Object.hasOwnProperty.call(m, 'read_badge_count'))
        w.uint32(64).int32(m.read_badge_count);
      if (m.ticket != null && Object.hasOwnProperty.call(m, 'ticket')) w.uint32(74).string(m.ticket);
      if (m.server_message_id != null && Object.hasOwnProperty.call(m, 'server_message_id'))
        w.uint32(80).int64(m.server_message_id);
      if (m.read_badge_count_v2 != null && Object.hasOwnProperty.call(m, 'read_badge_count_v2'))
        w.uint32(88).int32(m.read_badge_count_v2);
      return w;
    };

    MarkConversationReadRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MarkConversationReadRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.read_message_index = r.int64();
            break;
          case 5:
            m.conv_unread_count = r.int64();
            break;
          case 6:
            m.total_unread_count = r.int64();
            break;
          case 7:
            m.read_message_index_v2 = r.int64();
            break;
          case 8:
            m.read_badge_count = r.int32();
            break;
          case 9:
            m.ticket = r.string();
            break;
          case 10:
            m.server_message_id = r.int64();
            break;
          case 11:
            m.read_badge_count_v2 = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MarkConversationReadRequestBody;
  })();

  im_proto.GetConversationParticipantsReadIndexV3RequestBody = (function () {
    function GetConversationParticipantsReadIndexV3RequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationParticipantsReadIndexV3RequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    GetConversationParticipantsReadIndexV3RequestBody.prototype.conversation_type = 0;
    GetConversationParticipantsReadIndexV3RequestBody.prototype.conversation_id = '';

    GetConversationParticipantsReadIndexV3RequestBody.create = function create(properties) {
      return new GetConversationParticipantsReadIndexV3RequestBody(properties);
    };

    GetConversationParticipantsReadIndexV3RequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(8).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(26).string(m.conversation_id);
      return w;
    };

    GetConversationParticipantsReadIndexV3RequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationParticipantsReadIndexV3RequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_short_id = r.int64();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationParticipantsReadIndexV3RequestBody;
  })();

  im_proto.GetConversationParticipantsReadIndexV3ResponseBody = (function () {
    function GetConversationParticipantsReadIndexV3ResponseBody(p) {
      this.indexes = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationParticipantsReadIndexV3ResponseBody.prototype.indexes = $util.emptyArray;

    GetConversationParticipantsReadIndexV3ResponseBody.create = function create(properties) {
      return new GetConversationParticipantsReadIndexV3ResponseBody(properties);
    };

    GetConversationParticipantsReadIndexV3ResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.indexes != null && m.indexes.length) {
        for (var i = 0; i < m.indexes.length; ++i)
          $root.im_proto.ParticipantReadIndex.encode(m.indexes[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    GetConversationParticipantsReadIndexV3ResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationParticipantsReadIndexV3ResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.indexes && m.indexes.length)) m.indexes = [];
            m.indexes.push($root.im_proto.ParticipantReadIndex.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationParticipantsReadIndexV3ResponseBody;
  })();

  im_proto.BatchGetConversationParticipantsReadIndexRequestBody = (function () {
    function BatchGetConversationParticipantsReadIndexRequestBody(p) {
      this.conversation_id = [];
      this.conversation_short_id = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BatchGetConversationParticipantsReadIndexRequestBody.prototype.conversation_id = $util.emptyArray;
    BatchGetConversationParticipantsReadIndexRequestBody.prototype.conversation_short_id = $util.emptyArray;
    BatchGetConversationParticipantsReadIndexRequestBody.prototype.request_from = '';
    BatchGetConversationParticipantsReadIndexRequestBody.prototype.min_index_required = false;

    BatchGetConversationParticipantsReadIndexRequestBody.create = function create(properties) {
      return new BatchGetConversationParticipantsReadIndexRequestBody(properties);
    };

    BatchGetConversationParticipantsReadIndexRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && m.conversation_id.length) {
        for (var i = 0; i < m.conversation_id.length; ++i) w.uint32(10).string(m.conversation_id[i]);
      }
      if (m.conversation_short_id != null && m.conversation_short_id.length) {
        for (var i = 0; i < m.conversation_short_id.length; ++i) w.uint32(16).int64(m.conversation_short_id[i]);
      }
      if (m.request_from != null && Object.hasOwnProperty.call(m, 'request_from')) w.uint32(26).string(m.request_from);
      if (m.min_index_required != null && Object.hasOwnProperty.call(m, 'min_index_required'))
        w.uint32(32).bool(m.min_index_required);
      return w;
    };

    BatchGetConversationParticipantsReadIndexRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BatchGetConversationParticipantsReadIndexRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conversation_id && m.conversation_id.length)) m.conversation_id = [];
            m.conversation_id.push(r.string());
            break;
          case 2:
            if (!(m.conversation_short_id && m.conversation_short_id.length)) m.conversation_short_id = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.conversation_short_id.push(r.int64());
            } else m.conversation_short_id.push(r.int64());
            break;
          case 3:
            m.request_from = r.string();
            break;
          case 4:
            m.min_index_required = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BatchGetConversationParticipantsReadIndexRequestBody;
  })();

  im_proto.BatchGetConversationParticipantsReadIndexResponseBody = (function () {
    function BatchGetConversationParticipantsReadIndexResponseBody(p) {
      this.conversationParticipantsReadIndex = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BatchGetConversationParticipantsReadIndexResponseBody.prototype.conversationParticipantsReadIndex =
      $util.emptyArray;

    BatchGetConversationParticipantsReadIndexResponseBody.create = function create(properties) {
      return new BatchGetConversationParticipantsReadIndexResponseBody(properties);
    };

    BatchGetConversationParticipantsReadIndexResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversationParticipantsReadIndex != null && m.conversationParticipantsReadIndex.length) {
        for (var i = 0; i < m.conversationParticipantsReadIndex.length; ++i)
          $root.im_proto.ConversationParticipantReadIndex.encode(
            m.conversationParticipantsReadIndex[i],
            w.uint32(10).fork(),
          ).ldelim();
      }
      return w;
    };

    BatchGetConversationParticipantsReadIndexResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BatchGetConversationParticipantsReadIndexResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conversationParticipantsReadIndex && m.conversationParticipantsReadIndex.length))
              m.conversationParticipantsReadIndex = [];
            m.conversationParticipantsReadIndex.push(
              $root.im_proto.ConversationParticipantReadIndex.decode(r, r.uint32()),
            );
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BatchGetConversationParticipantsReadIndexResponseBody;
  })();

  im_proto.ConversationParticipantReadIndex = (function () {
    function ConversationParticipantReadIndex(p) {
      this.participantReadIndex = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationParticipantReadIndex.prototype.conversation_id = '';
    ConversationParticipantReadIndex.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    ConversationParticipantReadIndex.prototype.participantReadIndex = $util.emptyArray;

    ConversationParticipantReadIndex.create = function create(properties) {
      return new ConversationParticipantReadIndex(properties);
    };

    ConversationParticipantReadIndex.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.participantReadIndex != null && m.participantReadIndex.length) {
        for (var i = 0; i < m.participantReadIndex.length; ++i)
          $root.im_proto.ParticipantReadIndex.encode(m.participantReadIndex[i], w.uint32(26).fork()).ldelim();
      }
      return w;
    };

    ConversationParticipantReadIndex.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationParticipantReadIndex();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            if (!(m.participantReadIndex && m.participantReadIndex.length)) m.participantReadIndex = [];
            m.participantReadIndex.push($root.im_proto.ParticipantReadIndex.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationParticipantReadIndex;
  })();

  im_proto.ParticipantReadIndex = (function () {
    function ParticipantReadIndex(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ParticipantReadIndex.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ParticipantReadIndex.prototype.sec_uid = '';
    ParticipantReadIndex.prototype.index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ParticipantReadIndex.prototype.index_v2 = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ParticipantReadIndex.prototype.index_min = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    ParticipantReadIndex.create = function create(properties) {
      return new ParticipantReadIndex(properties);
    };

    ParticipantReadIndex.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(8).int64(m.user_id);
      if (m.sec_uid != null && Object.hasOwnProperty.call(m, 'sec_uid')) w.uint32(18).string(m.sec_uid);
      if (m.index != null && Object.hasOwnProperty.call(m, 'index')) w.uint32(24).int64(m.index);
      if (m.index_v2 != null && Object.hasOwnProperty.call(m, 'index_v2')) w.uint32(32).int64(m.index_v2);
      if (m.index_min != null && Object.hasOwnProperty.call(m, 'index_min')) w.uint32(40).int64(m.index_min);
      return w;
    };

    ParticipantReadIndex.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ParticipantReadIndex();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.int64();
            break;
          case 2:
            m.sec_uid = r.string();
            break;
          case 3:
            m.index = r.int64();
            break;
          case 4:
            m.index_v2 = r.int64();
            break;
          case 5:
            m.index_min = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ParticipantReadIndex;
  })();

  im_proto.GetConversationParticipantsMinIndexV3RequestBody = (function () {
    function GetConversationParticipantsMinIndexV3RequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationParticipantsMinIndexV3RequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    GetConversationParticipantsMinIndexV3RequestBody.prototype.conversation_type = 0;
    GetConversationParticipantsMinIndexV3RequestBody.prototype.conversation_id = '';

    GetConversationParticipantsMinIndexV3RequestBody.create = function create(properties) {
      return new GetConversationParticipantsMinIndexV3RequestBody(properties);
    };

    GetConversationParticipantsMinIndexV3RequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(8).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(26).string(m.conversation_id);
      return w;
    };

    GetConversationParticipantsMinIndexV3RequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationParticipantsMinIndexV3RequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_short_id = r.int64();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationParticipantsMinIndexV3RequestBody;
  })();

  im_proto.GetConversationParticipantsMinIndexV3ResponseBody = (function () {
    function GetConversationParticipantsMinIndexV3ResponseBody(p) {
      this.indexes = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationParticipantsMinIndexV3ResponseBody.prototype.indexes = $util.emptyArray;

    GetConversationParticipantsMinIndexV3ResponseBody.create = function create(properties) {
      return new GetConversationParticipantsMinIndexV3ResponseBody(properties);
    };

    GetConversationParticipantsMinIndexV3ResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.indexes != null && m.indexes.length) {
        for (var i = 0; i < m.indexes.length; ++i)
          $root.im_proto.ParticipantMinIndex.encode(m.indexes[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    GetConversationParticipantsMinIndexV3ResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationParticipantsMinIndexV3ResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.indexes && m.indexes.length)) m.indexes = [];
            m.indexes.push($root.im_proto.ParticipantMinIndex.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationParticipantsMinIndexV3ResponseBody;
  })();

  im_proto.ParticipantMinIndex = (function () {
    function ParticipantMinIndex(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ParticipantMinIndex.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ParticipantMinIndex.prototype.sec_uid = '';
    ParticipantMinIndex.prototype.index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ParticipantMinIndex.prototype.index_v2 = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    ParticipantMinIndex.create = function create(properties) {
      return new ParticipantMinIndex(properties);
    };

    ParticipantMinIndex.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(8).int64(m.user_id);
      if (m.sec_uid != null && Object.hasOwnProperty.call(m, 'sec_uid')) w.uint32(18).string(m.sec_uid);
      if (m.index != null && Object.hasOwnProperty.call(m, 'index')) w.uint32(24).int64(m.index);
      if (m.index_v2 != null && Object.hasOwnProperty.call(m, 'index_v2')) w.uint32(32).int64(m.index_v2);
      return w;
    };

    ParticipantMinIndex.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ParticipantMinIndex();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.int64();
            break;
          case 2:
            m.sec_uid = r.string();
            break;
          case 3:
            m.index = r.int64();
            break;
          case 4:
            m.index_v2 = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ParticipantMinIndex;
  })();

  im_proto.BatchMarkConversationReadRequestBody = (function () {
    function BatchMarkConversationReadRequestBody(p) {
      this.mark_read_requests = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BatchMarkConversationReadRequestBody.prototype.mark_read_requests = $util.emptyArray;

    BatchMarkConversationReadRequestBody.create = function create(properties) {
      return new BatchMarkConversationReadRequestBody(properties);
    };

    BatchMarkConversationReadRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.mark_read_requests != null && m.mark_read_requests.length) {
        for (var i = 0; i < m.mark_read_requests.length; ++i)
          $root.im_proto.MarkConversationReadRequestBody.encode(m.mark_read_requests[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    BatchMarkConversationReadRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BatchMarkConversationReadRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.mark_read_requests && m.mark_read_requests.length)) m.mark_read_requests = [];
            m.mark_read_requests.push($root.im_proto.MarkConversationReadRequestBody.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BatchMarkConversationReadRequestBody;
  })();

  im_proto.BatchMarkConversationReadResponseBody = (function () {
    function BatchMarkConversationReadResponseBody(p) {
      this.failed_requests = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BatchMarkConversationReadResponseBody.prototype.failed_requests = $util.emptyArray;

    BatchMarkConversationReadResponseBody.create = function create(properties) {
      return new BatchMarkConversationReadResponseBody(properties);
    };

    BatchMarkConversationReadResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.failed_requests != null && m.failed_requests.length) {
        for (var i = 0; i < m.failed_requests.length; ++i)
          $root.im_proto.MarkConversationReadRequestBody.encode(m.failed_requests[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    BatchMarkConversationReadResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BatchMarkConversationReadResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.failed_requests && m.failed_requests.length)) m.failed_requests = [];
            m.failed_requests.push($root.im_proto.MarkConversationReadRequestBody.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BatchMarkConversationReadResponseBody;
  })();

  im_proto.SendMessageP2PRequestBody = (function () {
    function SendMessageP2PRequestBody(p) {
      this.visible_user = [];
      this.invisible_user = [];
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SendMessageP2PRequestBody.prototype.send_type = 0;
    SendMessageP2PRequestBody.prototype.conversation_id = '';
    SendMessageP2PRequestBody.prototype.conversation_type = 0;
    SendMessageP2PRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SendMessageP2PRequestBody.prototype.visible_user = $util.emptyArray;
    SendMessageP2PRequestBody.prototype.invisible_user = $util.emptyArray;
    SendMessageP2PRequestBody.prototype.message_type = 0;
    SendMessageP2PRequestBody.prototype.content = '';
    SendMessageP2PRequestBody.prototype.ext = $util.emptyObject;
    SendMessageP2PRequestBody.prototype.client_message_id = '';

    SendMessageP2PRequestBody.create = function create(properties) {
      return new SendMessageP2PRequestBody(properties);
    };

    SendMessageP2PRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.send_type != null && Object.hasOwnProperty.call(m, 'send_type')) w.uint32(8).int32(m.send_type);
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(18).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(32).int64(m.conversation_short_id);
      if (m.visible_user != null && m.visible_user.length) {
        for (var i = 0; i < m.visible_user.length; ++i) w.uint32(40).int64(m.visible_user[i]);
      }
      if (m.invisible_user != null && m.invisible_user.length) {
        for (var i = 0; i < m.invisible_user.length; ++i) w.uint32(48).int64(m.invisible_user[i]);
      }
      if (m.message_type != null && Object.hasOwnProperty.call(m, 'message_type')) w.uint32(56).int32(m.message_type);
      if (m.content != null && Object.hasOwnProperty.call(m, 'content')) w.uint32(66).string(m.content);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(74).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      if (m.client_message_id != null && Object.hasOwnProperty.call(m, 'client_message_id'))
        w.uint32(82).string(m.client_message_id);
      return w;
    };

    SendMessageP2PRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SendMessageP2PRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.send_type = r.int32();
            break;
          case 2:
            m.conversation_id = r.string();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.conversation_short_id = r.int64();
            break;
          case 5:
            if (!(m.visible_user && m.visible_user.length)) m.visible_user = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.visible_user.push(r.int64());
            } else m.visible_user.push(r.int64());
            break;
          case 6:
            if (!(m.invisible_user && m.invisible_user.length)) m.invisible_user = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.invisible_user.push(r.int64());
            } else m.invisible_user.push(r.int64());
            break;
          case 7:
            m.message_type = r.int32();
            break;
          case 8:
            m.content = r.string();
            break;
          case 9:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          case 10:
            m.client_message_id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SendMessageP2PRequestBody;
  })();

  im_proto.SendMessageP2PResponseBody = (function () {
    function SendMessageP2PResponseBody(p) {
      this.failed_user = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SendMessageP2PResponseBody.prototype.failed_user = $util.emptyArray;

    SendMessageP2PResponseBody.create = function create(properties) {
      return new SendMessageP2PResponseBody(properties);
    };

    SendMessageP2PResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.failed_user != null && m.failed_user.length) {
        for (var i = 0; i < m.failed_user.length; ++i) w.uint32(8).int64(m.failed_user[i]);
      }
      return w;
    };

    SendMessageP2PResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SendMessageP2PResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.failed_user && m.failed_user.length)) m.failed_user = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.failed_user.push(r.int64());
            } else m.failed_user.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SendMessageP2PResponseBody;
  })();

  im_proto.SendMessageRequestBody = (function () {
    function SendMessageRequestBody(p) {
      this.ext = {};
      this.mentioned_users = [];
      this.client_ext = {};
      this.VisibleUsers = [];
      this.InvisibleUsers = [];
      this.send_media_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SendMessageRequestBody.prototype.conversation_id = '';
    SendMessageRequestBody.prototype.conversation_type = 0;
    SendMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SendMessageRequestBody.prototype.content = '';
    SendMessageRequestBody.prototype.ext = $util.emptyObject;
    SendMessageRequestBody.prototype.message_type = 0;
    SendMessageRequestBody.prototype.ticket = '';
    SendMessageRequestBody.prototype.client_message_id = '';
    SendMessageRequestBody.prototype.mentioned_users = $util.emptyArray;
    SendMessageRequestBody.prototype.ignore_badge_count = false;
    SendMessageRequestBody.prototype.ref_msg_info = null;
    SendMessageRequestBody.prototype.client_ext = $util.emptyObject;
    SendMessageRequestBody.prototype.content_pb = null;
    SendMessageRequestBody.prototype.scene = '';
    SendMessageRequestBody.prototype.VisibleUsers = $util.emptyArray;
    SendMessageRequestBody.prototype.InvisibleUsers = $util.emptyArray;
    SendMessageRequestBody.prototype.send_media_list = $util.emptyArray;

    SendMessageRequestBody.create = function create(properties) {
      return new SendMessageRequestBody(properties);
    };

    SendMessageRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.content != null && Object.hasOwnProperty.call(m, 'content')) w.uint32(34).string(m.content);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      if (m.message_type != null && Object.hasOwnProperty.call(m, 'message_type')) w.uint32(48).int32(m.message_type);
      if (m.ticket != null && Object.hasOwnProperty.call(m, 'ticket')) w.uint32(58).string(m.ticket);
      if (m.client_message_id != null && Object.hasOwnProperty.call(m, 'client_message_id'))
        w.uint32(66).string(m.client_message_id);
      if (m.mentioned_users != null && m.mentioned_users.length) {
        for (var i = 0; i < m.mentioned_users.length; ++i) w.uint32(72).int64(m.mentioned_users[i]);
      }
      if (m.ignore_badge_count != null && Object.hasOwnProperty.call(m, 'ignore_badge_count'))
        w.uint32(80).bool(m.ignore_badge_count);
      if (m.ref_msg_info != null && Object.hasOwnProperty.call(m, 'ref_msg_info'))
        $root.im_proto.ReferencedMessageInfo.encode(m.ref_msg_info, w.uint32(90).fork()).ldelim();
      if (m.client_ext != null && Object.hasOwnProperty.call(m, 'client_ext')) {
        for (var ks = Object.keys(m.client_ext), i = 0; i < ks.length; ++i) {
          w.uint32(98).fork().uint32(10).string(ks[i]).uint32(18).string(m.client_ext[ks[i]]).ldelim();
        }
      }
      if (m.content_pb != null && Object.hasOwnProperty.call(m, 'content_pb'))
        $root.im_proto.MessageContent.encode(m.content_pb, w.uint32(106).fork()).ldelim();
      if (m.scene != null && Object.hasOwnProperty.call(m, 'scene')) w.uint32(114).string(m.scene);
      if (m.VisibleUsers != null && m.VisibleUsers.length) {
        for (var i = 0; i < m.VisibleUsers.length; ++i) w.uint32(120).int64(m.VisibleUsers[i]);
      }
      if (m.InvisibleUsers != null && m.InvisibleUsers.length) {
        for (var i = 0; i < m.InvisibleUsers.length; ++i) w.uint32(128).int64(m.InvisibleUsers[i]);
      }
      if (m.send_media_list != null && m.send_media_list.length) {
        for (var i = 0; i < m.send_media_list.length; ++i)
          $root.im_proto.SendMediaRequest.encode(m.send_media_list[i], w.uint32(138).fork()).ldelim();
      }
      return w;
    };

    SendMessageRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SendMessageRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.content = r.string();
            break;
          case 5:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          case 6:
            m.message_type = r.int32();
            break;
          case 7:
            m.ticket = r.string();
            break;
          case 8:
            m.client_message_id = r.string();
            break;
          case 9:
            if (!(m.mentioned_users && m.mentioned_users.length)) m.mentioned_users = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.mentioned_users.push(r.int64());
            } else m.mentioned_users.push(r.int64());
            break;
          case 10:
            m.ignore_badge_count = r.bool();
            break;
          case 11:
            m.ref_msg_info = $root.im_proto.ReferencedMessageInfo.decode(r, r.uint32());
            break;
          case 12:
            if (m.client_ext === $util.emptyObject) m.client_ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.client_ext[k] = value;
            break;
          case 13:
            m.content_pb = $root.im_proto.MessageContent.decode(r, r.uint32());
            break;
          case 14:
            m.scene = r.string();
            break;
          case 15:
            if (!(m.VisibleUsers && m.VisibleUsers.length)) m.VisibleUsers = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.VisibleUsers.push(r.int64());
            } else m.VisibleUsers.push(r.int64());
            break;
          case 16:
            if (!(m.InvisibleUsers && m.InvisibleUsers.length)) m.InvisibleUsers = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.InvisibleUsers.push(r.int64());
            } else m.InvisibleUsers.push(r.int64());
            break;
          case 17:
            if (!(m.send_media_list && m.send_media_list.length)) m.send_media_list = [];
            m.send_media_list.push($root.im_proto.SendMediaRequest.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SendMessageRequestBody;
  })();

  im_proto.SendMediaRequest = (function () {
    function SendMediaRequest(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SendMediaRequest.prototype.type = 1;
    SendMediaRequest.prototype.id = '';
    SendMediaRequest.prototype.decrypt_key = '';
    SendMediaRequest.prototype.metadata = null;

    SendMediaRequest.create = function create(properties) {
      return new SendMediaRequest(properties);
    };

    SendMediaRequest.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.type != null && Object.hasOwnProperty.call(m, 'type')) w.uint32(8).int32(m.type);
      if (m.id != null && Object.hasOwnProperty.call(m, 'id')) w.uint32(18).string(m.id);
      if (m.decrypt_key != null && Object.hasOwnProperty.call(m, 'decrypt_key')) w.uint32(26).string(m.decrypt_key);
      if (m.metadata != null && Object.hasOwnProperty.call(m, 'metadata'))
        $root.im_proto.MediaMeta.encode(m.metadata, w.uint32(82).fork()).ldelim();
      return w;
    };

    SendMediaRequest.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SendMediaRequest();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.type = r.int32();
            break;
          case 2:
            m.id = r.string();
            break;
          case 3:
            m.decrypt_key = r.string();
            break;
          case 10:
            m.metadata = $root.im_proto.MediaMeta.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SendMediaRequest;
  })();

  im_proto.MediaMeta = (function () {
    function MediaMeta(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MediaMeta.prototype.width = 0;
    MediaMeta.prototype.height = 0;
    MediaMeta.prototype.duration = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MediaMeta.prototype.size = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MediaMeta.prototype.name = '';
    MediaMeta.prototype.codec = '';

    MediaMeta.create = function create(properties) {
      return new MediaMeta(properties);
    };

    MediaMeta.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.width != null && Object.hasOwnProperty.call(m, 'width')) w.uint32(8).int32(m.width);
      if (m.height != null && Object.hasOwnProperty.call(m, 'height')) w.uint32(16).int32(m.height);
      if (m.duration != null && Object.hasOwnProperty.call(m, 'duration')) w.uint32(24).int64(m.duration);
      if (m.size != null && Object.hasOwnProperty.call(m, 'size')) w.uint32(32).int64(m.size);
      if (m.name != null && Object.hasOwnProperty.call(m, 'name')) w.uint32(42).string(m.name);
      if (m.codec != null && Object.hasOwnProperty.call(m, 'codec')) w.uint32(50).string(m.codec);
      return w;
    };

    MediaMeta.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MediaMeta();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.width = r.int32();
            break;
          case 2:
            m.height = r.int32();
            break;
          case 3:
            m.duration = r.int64();
            break;
          case 4:
            m.size = r.int64();
            break;
          case 5:
            m.name = r.string();
            break;
          case 6:
            m.codec = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MediaMeta;
  })();

  im_proto.MediaInfo = (function () {
    function MediaInfo(p) {
      this.url_info_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MediaInfo.prototype.id = '';
    MediaInfo.prototype.type = 1;
    MediaInfo.prototype.decrypt_key = '';
    MediaInfo.prototype.url_info_list = $util.emptyArray;

    MediaInfo.create = function create(properties) {
      return new MediaInfo(properties);
    };

    MediaInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.id != null && Object.hasOwnProperty.call(m, 'id')) w.uint32(10).string(m.id);
      if (m.type != null && Object.hasOwnProperty.call(m, 'type')) w.uint32(16).int32(m.type);
      if (m.decrypt_key != null && Object.hasOwnProperty.call(m, 'decrypt_key')) w.uint32(26).string(m.decrypt_key);
      if (m.url_info_list != null && m.url_info_list.length) {
        for (var i = 0; i < m.url_info_list.length; ++i)
          $root.im_proto.MediaURLStruct.encode(m.url_info_list[i], w.uint32(162).fork()).ldelim();
      }
      return w;
    };

    MediaInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MediaInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.id = r.string();
            break;
          case 2:
            m.type = r.int32();
            break;
          case 3:
            m.decrypt_key = r.string();
            break;
          case 20:
            if (!(m.url_info_list && m.url_info_list.length)) m.url_info_list = [];
            m.url_info_list.push($root.im_proto.MediaURLStruct.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MediaInfo;
  })();

  im_proto.MediaURLStruct = (function () {
    function MediaURLStruct(p) {
      this.url_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MediaURLStruct.prototype.display_type = '';
    MediaURLStruct.prototype.url_list = $util.emptyArray;
    MediaURLStruct.prototype.video_model = '';
    MediaURLStruct.prototype.width = 0;
    MediaURLStruct.prototype.height = 0;
    MediaURLStruct.prototype.duration = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MediaURLStruct.prototype.size = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MediaURLStruct.prototype.name = '';
    MediaURLStruct.prototype.codec = '';

    MediaURLStruct.create = function create(properties) {
      return new MediaURLStruct(properties);
    };

    MediaURLStruct.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.display_type != null && Object.hasOwnProperty.call(m, 'display_type')) w.uint32(10).string(m.display_type);
      if (m.url_list != null && m.url_list.length) {
        for (var i = 0; i < m.url_list.length; ++i) w.uint32(18).string(m.url_list[i]);
      }
      if (m.video_model != null && Object.hasOwnProperty.call(m, 'video_model')) w.uint32(26).string(m.video_model);
      if (m.width != null && Object.hasOwnProperty.call(m, 'width')) w.uint32(160).int32(m.width);
      if (m.height != null && Object.hasOwnProperty.call(m, 'height')) w.uint32(168).int32(m.height);
      if (m.duration != null && Object.hasOwnProperty.call(m, 'duration')) w.uint32(176).int64(m.duration);
      if (m.size != null && Object.hasOwnProperty.call(m, 'size')) w.uint32(184).int64(m.size);
      if (m.name != null && Object.hasOwnProperty.call(m, 'name')) w.uint32(194).string(m.name);
      if (m.codec != null && Object.hasOwnProperty.call(m, 'codec')) w.uint32(202).string(m.codec);
      return w;
    };

    MediaURLStruct.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MediaURLStruct();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.display_type = r.string();
            break;
          case 2:
            if (!(m.url_list && m.url_list.length)) m.url_list = [];
            m.url_list.push(r.string());
            break;
          case 3:
            m.video_model = r.string();
            break;
          case 20:
            m.width = r.int32();
            break;
          case 21:
            m.height = r.int32();
            break;
          case 22:
            m.duration = r.int64();
            break;
          case 23:
            m.size = r.int64();
            break;
          case 24:
            m.name = r.string();
            break;
          case 25:
            m.codec = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MediaURLStruct;
  })();

  im_proto.ReferencedMessageInfo = (function () {
    function ReferencedMessageInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ReferencedMessageInfo.prototype.referenced_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ReferencedMessageInfo.prototype.hint = '';
    ReferencedMessageInfo.prototype.root_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ReferencedMessageInfo.prototype.root_message_conv_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    ReferencedMessageInfo.create = function create(properties) {
      return new ReferencedMessageInfo(properties);
    };

    ReferencedMessageInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.referenced_message_id);
      w.uint32(18).string(m.hint);
      if (m.root_message_id != null && Object.hasOwnProperty.call(m, 'root_message_id'))
        w.uint32(24).int64(m.root_message_id);
      if (m.root_message_conv_index != null && Object.hasOwnProperty.call(m, 'root_message_conv_index'))
        w.uint32(32).int64(m.root_message_conv_index);
      return w;
    };

    ReferencedMessageInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ReferencedMessageInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.referenced_message_id = r.int64();
            break;
          case 2:
            m.hint = r.string();
            break;
          case 3:
            m.root_message_id = r.int64();
            break;
          case 4:
            m.root_message_conv_index = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('referenced_message_id'))
        throw $util.ProtocolError("missing required 'referenced_message_id'", { instance: m });
      if (!m.hasOwnProperty('hint')) throw $util.ProtocolError("missing required 'hint'", { instance: m });
      return m;
    };

    return ReferencedMessageInfo;
  })();

  im_proto.SendMessageResponseBody = (function () {
    function SendMessageResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SendMessageResponseBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SendMessageResponseBody.prototype.extra_info = '';
    SendMessageResponseBody.prototype.status = 0;
    SendMessageResponseBody.prototype.client_message_id = '';
    SendMessageResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SendMessageResponseBody.prototype.check_message = '';
    SendMessageResponseBody.prototype.filtered_content = '';
    SendMessageResponseBody.prototype.is_async_send = false;
    SendMessageResponseBody.prototype.new_ticket = '';
    SendMessageResponseBody.prototype.conversation = null;
    SendMessageResponseBody.prototype.inboxPageCategory = 1;
    SendMessageResponseBody.prototype.filter_reason = 1;

    SendMessageResponseBody.create = function create(properties) {
      return new SendMessageResponseBody(properties);
    };

    SendMessageResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.server_message_id != null && Object.hasOwnProperty.call(m, 'server_message_id'))
        w.uint32(8).int64(m.server_message_id);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(18).string(m.extra_info);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(24).int32(m.status);
      if (m.client_message_id != null && Object.hasOwnProperty.call(m, 'client_message_id'))
        w.uint32(34).string(m.client_message_id);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(40).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(50).string(m.check_message);
      if (m.filtered_content != null && Object.hasOwnProperty.call(m, 'filtered_content'))
        w.uint32(58).string(m.filtered_content);
      if (m.is_async_send != null && Object.hasOwnProperty.call(m, 'is_async_send')) w.uint32(64).bool(m.is_async_send);
      if (m.new_ticket != null && Object.hasOwnProperty.call(m, 'new_ticket')) w.uint32(74).string(m.new_ticket);
      if (m.conversation != null && Object.hasOwnProperty.call(m, 'conversation'))
        $root.im_proto.ConversationInfoV2.encode(m.conversation, w.uint32(82).fork()).ldelim();
      if (m.inboxPageCategory != null && Object.hasOwnProperty.call(m, 'inboxPageCategory'))
        w.uint32(96).int32(m.inboxPageCategory);
      if (m.filter_reason != null && Object.hasOwnProperty.call(m, 'filter_reason'))
        w.uint32(104).int32(m.filter_reason);
      return w;
    };

    SendMessageResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SendMessageResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.server_message_id = r.int64();
            break;
          case 2:
            m.extra_info = r.string();
            break;
          case 3:
            m.status = r.int32();
            break;
          case 4:
            m.client_message_id = r.string();
            break;
          case 5:
            m.check_code = r.int64();
            break;
          case 6:
            m.check_message = r.string();
            break;
          case 7:
            m.filtered_content = r.string();
            break;
          case 8:
            m.is_async_send = r.bool();
            break;
          case 9:
            m.new_ticket = r.string();
            break;
          case 10:
            m.conversation = $root.im_proto.ConversationInfoV2.decode(r, r.uint32());
            break;
          case 12:
            m.inboxPageCategory = r.int32();
            break;
          case 13:
            m.filter_reason = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SendMessageResponseBody;
  })();

  im_proto.ModifyMessageRequestBody = (function () {
    function ModifyMessageRequestBody(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ModifyMessageRequestBody.prototype.conversation_id = '';
    ModifyMessageRequestBody.prototype.conversation_type = 0;
    ModifyMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ModifyMessageRequestBody.prototype.server_message_id = '';
    ModifyMessageRequestBody.prototype.ext = $util.emptyObject;
    ModifyMessageRequestBody.prototype.ticket = '';

    ModifyMessageRequestBody.create = function create(properties) {
      return new ModifyMessageRequestBody(properties);
    };

    ModifyMessageRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.server_message_id != null && Object.hasOwnProperty.call(m, 'server_message_id'))
        w.uint32(34).string(m.server_message_id);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      if (m.ticket != null && Object.hasOwnProperty.call(m, 'ticket')) w.uint32(50).string(m.ticket);
      return w;
    };

    ModifyMessageRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ModifyMessageRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.server_message_id = r.string();
            break;
          case 5:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          case 6:
            m.ticket = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ModifyMessageRequestBody;
  })();

  im_proto.ModifyMessageResponseBody = (function () {
    function ModifyMessageResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ModifyMessageResponseBody.create = function create(properties) {
      return new ModifyMessageResponseBody(properties);
    };

    ModifyMessageResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    ModifyMessageResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ModifyMessageResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ModifyMessageResponseBody;
  })();

  im_proto.MsgTrace = (function () {
    function MsgTrace(p) {
      this.metrics = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MsgTrace.prototype.metrics = $util.emptyObject;
    MsgTrace.prototype.path = 0;

    MsgTrace.create = function create(properties) {
      return new MsgTrace(properties);
    };

    MsgTrace.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.metrics != null && Object.hasOwnProperty.call(m, 'metrics')) {
        for (var ks = Object.keys(m.metrics), i = 0; i < ks.length; ++i) {
          w.uint32(10).fork().uint32(8).int32(ks[i]).uint32(16).int64(m.metrics[ks[i]]).ldelim();
        }
      }
      if (m.path != null && Object.hasOwnProperty.call(m, 'path')) w.uint32(16).int32(m.path);
      return w;
    };

    MsgTrace.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MsgTrace(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (m.metrics === $util.emptyObject) m.metrics = {};
            var c2 = r.uint32() + r.pos;
            k = 0;
            value = 0;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.int32();
                  break;
                case 2:
                  value = r.int64();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.metrics[k] = value;
            break;
          case 2:
            m.path = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MsgTrace;
  })();

  im_proto.MuteBadgeCountInfo = (function () {
    function MuteBadgeCountInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MuteBadgeCountInfo.prototype.message_type = 1;
    MuteBadgeCountInfo.prototype.badge_count = 0;

    MuteBadgeCountInfo.create = function create(properties) {
      return new MuteBadgeCountInfo(properties);
    };

    MuteBadgeCountInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int32(m.message_type);
      w.uint32(16).int32(m.badge_count);
      return w;
    };

    MuteBadgeCountInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MuteBadgeCountInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.message_type = r.int32();
            break;
          case 2:
            m.badge_count = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('message_type'))
        throw $util.ProtocolError("missing required 'message_type'", { instance: m });
      if (!m.hasOwnProperty('badge_count'))
        throw $util.ProtocolError("missing required 'badge_count'", { instance: m });
      return m;
    };

    return MuteBadgeCountInfo;
  })();

  im_proto.NewMessageNotify = (function () {
    function NewMessageNotify(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    NewMessageNotify.prototype.conversation_id = '';
    NewMessageNotify.prototype.conversation_type = 0;
    NewMessageNotify.prototype.notify_type = 1;
    NewMessageNotify.prototype.message = null;
    NewMessageNotify.prototype.previous_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NewMessageNotify.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NewMessageNotify.prototype.index_in_conversation = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NewMessageNotify.prototype.index_in_conversation_v2 = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NewMessageNotify.prototype.conversation_version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NewMessageNotify.prototype.previous_conversation_version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NewMessageNotify.prototype.cmd_message_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NewMessageNotify.prototype.badge_count = 0;
    NewMessageNotify.prototype.trace = null;
    NewMessageNotify.prototype.ref_msg_info = null;
    NewMessageNotify.prototype.previous_msg_index_in_conv = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NewMessageNotify.prototype.readconv_version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NewMessageNotify.prototype.pre_readconv_version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NewMessageNotify.prototype.mute_badge_count_info = null;
    NewMessageNotify.prototype.push_preview = '';
    NewMessageNotify.prototype.badge_count_v2 = 0;

    NewMessageNotify.create = function create(properties) {
      return new NewMessageNotify(properties);
    };

    NewMessageNotify.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(18).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.notify_type != null && Object.hasOwnProperty.call(m, 'notify_type')) w.uint32(32).int32(m.notify_type);
      if (m.message != null && Object.hasOwnProperty.call(m, 'message'))
        $root.im_proto.MessageBody.encode(m.message, w.uint32(42).fork()).ldelim();
      if (m.previous_cursor != null && Object.hasOwnProperty.call(m, 'previous_cursor'))
        w.uint32(48).int64(m.previous_cursor);
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(56).int64(m.next_cursor);
      if (m.index_in_conversation != null && Object.hasOwnProperty.call(m, 'index_in_conversation'))
        w.uint32(64).int64(m.index_in_conversation);
      if (m.index_in_conversation_v2 != null && Object.hasOwnProperty.call(m, 'index_in_conversation_v2'))
        w.uint32(72).int64(m.index_in_conversation_v2);
      if (m.conversation_version != null && Object.hasOwnProperty.call(m, 'conversation_version'))
        w.uint32(80).int64(m.conversation_version);
      if (m.previous_conversation_version != null && Object.hasOwnProperty.call(m, 'previous_conversation_version'))
        w.uint32(88).int64(m.previous_conversation_version);
      if (m.cmd_message_index != null && Object.hasOwnProperty.call(m, 'cmd_message_index'))
        w.uint32(96).int64(m.cmd_message_index);
      if (m.badge_count != null && Object.hasOwnProperty.call(m, 'badge_count')) w.uint32(104).int32(m.badge_count);
      if (m.trace != null && Object.hasOwnProperty.call(m, 'trace'))
        $root.im_proto.MsgTrace.encode(m.trace, w.uint32(114).fork()).ldelim();
      if (m.ref_msg_info != null && Object.hasOwnProperty.call(m, 'ref_msg_info'))
        $root.im_proto.ReferenceInfo.encode(m.ref_msg_info, w.uint32(122).fork()).ldelim();
      if (m.previous_msg_index_in_conv != null && Object.hasOwnProperty.call(m, 'previous_msg_index_in_conv'))
        w.uint32(128).int64(m.previous_msg_index_in_conv);
      if (m.readconv_version != null && Object.hasOwnProperty.call(m, 'readconv_version'))
        w.uint32(136).int64(m.readconv_version);
      if (m.pre_readconv_version != null && Object.hasOwnProperty.call(m, 'pre_readconv_version'))
        w.uint32(144).int64(m.pre_readconv_version);
      if (m.mute_badge_count_info != null && Object.hasOwnProperty.call(m, 'mute_badge_count_info'))
        $root.im_proto.MuteBadgeCountInfo.encode(m.mute_badge_count_info, w.uint32(154).fork()).ldelim();
      if (m.push_preview != null && Object.hasOwnProperty.call(m, 'push_preview')) w.uint32(162).string(m.push_preview);
      if (m.badge_count_v2 != null && Object.hasOwnProperty.call(m, 'badge_count_v2'))
        w.uint32(168).int32(m.badge_count_v2);
      return w;
    };

    NewMessageNotify.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.NewMessageNotify();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 2:
            m.conversation_id = r.string();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.notify_type = r.int32();
            break;
          case 5:
            m.message = $root.im_proto.MessageBody.decode(r, r.uint32());
            break;
          case 6:
            m.previous_cursor = r.int64();
            break;
          case 7:
            m.next_cursor = r.int64();
            break;
          case 8:
            m.index_in_conversation = r.int64();
            break;
          case 9:
            m.index_in_conversation_v2 = r.int64();
            break;
          case 10:
            m.conversation_version = r.int64();
            break;
          case 11:
            m.previous_conversation_version = r.int64();
            break;
          case 12:
            m.cmd_message_index = r.int64();
            break;
          case 13:
            m.badge_count = r.int32();
            break;
          case 14:
            m.trace = $root.im_proto.MsgTrace.decode(r, r.uint32());
            break;
          case 15:
            m.ref_msg_info = $root.im_proto.ReferenceInfo.decode(r, r.uint32());
            break;
          case 16:
            m.previous_msg_index_in_conv = r.int64();
            break;
          case 17:
            m.readconv_version = r.int64();
            break;
          case 18:
            m.pre_readconv_version = r.int64();
            break;
          case 19:
            m.mute_badge_count_info = $root.im_proto.MuteBadgeCountInfo.decode(r, r.uint32());
            break;
          case 20:
            m.push_preview = r.string();
            break;
          case 21:
            m.badge_count_v2 = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return NewMessageNotify;
  })();

  im_proto.NewDirectPushNotify = (function () {
    function NewDirectPushNotify(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    NewDirectPushNotify.prototype.send_type = 0;
    NewDirectPushNotify.prototype.sender = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NewDirectPushNotify.prototype.sec_sender = '';
    NewDirectPushNotify.prototype.conversation_id = '';
    NewDirectPushNotify.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NewDirectPushNotify.prototype.conversation_type = 0;
    NewDirectPushNotify.prototype.message_type = 0;
    NewDirectPushNotify.prototype.content = '';
    NewDirectPushNotify.prototype.ext = $util.emptyObject;
    NewDirectPushNotify.prototype.create_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    NewDirectPushNotify.create = function create(properties) {
      return new NewDirectPushNotify(properties);
    };

    NewDirectPushNotify.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.send_type != null && Object.hasOwnProperty.call(m, 'send_type')) w.uint32(8).int32(m.send_type);
      if (m.sender != null && Object.hasOwnProperty.call(m, 'sender')) w.uint32(16).int64(m.sender);
      if (m.sec_sender != null && Object.hasOwnProperty.call(m, 'sec_sender')) w.uint32(26).string(m.sec_sender);
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(34).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(40).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(48).int32(m.conversation_type);
      if (m.message_type != null && Object.hasOwnProperty.call(m, 'message_type')) w.uint32(56).int32(m.message_type);
      if (m.content != null && Object.hasOwnProperty.call(m, 'content')) w.uint32(66).string(m.content);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(74).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      if (m.create_time != null && Object.hasOwnProperty.call(m, 'create_time')) w.uint32(80).int64(m.create_time);
      return w;
    };

    NewDirectPushNotify.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.NewDirectPushNotify(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.send_type = r.int32();
            break;
          case 2:
            m.sender = r.int64();
            break;
          case 3:
            m.sec_sender = r.string();
            break;
          case 4:
            m.conversation_id = r.string();
            break;
          case 5:
            m.conversation_short_id = r.int64();
            break;
          case 6:
            m.conversation_type = r.int32();
            break;
          case 7:
            m.message_type = r.int32();
            break;
          case 8:
            m.content = r.string();
            break;
          case 9:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          case 10:
            m.create_time = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return NewDirectPushNotify;
  })();

  im_proto.BizNewDirectPushNotify = (function () {
    function BizNewDirectPushNotify(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BizNewDirectPushNotify.prototype.inbox_type = 0;
    BizNewDirectPushNotify.prototype.message_type = 0;
    BizNewDirectPushNotify.prototype.content = '';
    BizNewDirectPushNotify.prototype.ext = $util.emptyObject;
    BizNewDirectPushNotify.prototype.create_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    BizNewDirectPushNotify.create = function create(properties) {
      return new BizNewDirectPushNotify(properties);
    };

    BizNewDirectPushNotify.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.inbox_type != null && Object.hasOwnProperty.call(m, 'inbox_type')) w.uint32(8).int32(m.inbox_type);
      if (m.message_type != null && Object.hasOwnProperty.call(m, 'message_type')) w.uint32(16).int32(m.message_type);
      if (m.content != null && Object.hasOwnProperty.call(m, 'content')) w.uint32(26).string(m.content);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      if (m.create_time != null && Object.hasOwnProperty.call(m, 'create_time')) w.uint32(40).int64(m.create_time);
      return w;
    };

    BizNewDirectPushNotify.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BizNewDirectPushNotify(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.inbox_type = r.int32();
            break;
          case 2:
            m.message_type = r.int32();
            break;
          case 3:
            m.content = r.string();
            break;
          case 4:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          case 5:
            m.create_time = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BizNewDirectPushNotify;
  })();

  im_proto.NewFriendMessageNotify = (function () {
    function NewFriendMessageNotify(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    NewFriendMessageNotify.prototype.message_type = 1;
    NewFriendMessageNotify.prototype.from_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NewFriendMessageNotify.prototype.to_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    NewFriendMessageNotify.prototype.content = '';
    NewFriendMessageNotify.prototype.ext = $util.emptyObject;

    NewFriendMessageNotify.create = function create(properties) {
      return new NewFriendMessageNotify(properties);
    };

    NewFriendMessageNotify.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.message_type != null && Object.hasOwnProperty.call(m, 'message_type')) w.uint32(8).int32(m.message_type);
      if (m.from_id != null && Object.hasOwnProperty.call(m, 'from_id')) w.uint32(16).int64(m.from_id);
      if (m.to_id != null && Object.hasOwnProperty.call(m, 'to_id')) w.uint32(24).int64(m.to_id);
      if (m.content != null && Object.hasOwnProperty.call(m, 'content')) w.uint32(34).string(m.content);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    NewFriendMessageNotify.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.NewFriendMessageNotify(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.message_type = r.int32();
            break;
          case 2:
            m.from_id = r.int64();
            break;
          case 3:
            m.to_id = r.int64();
            break;
          case 4:
            m.content = r.string();
            break;
          case 5:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return NewFriendMessageNotify;
  })();

  im_proto.MarkConversationReadNotify = (function () {
    function MarkConversationReadNotify(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MarkConversationReadNotify.prototype.conversation_id = '';
    MarkConversationReadNotify.prototype.conversation_type = 0;
    MarkConversationReadNotify.prototype.read_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarkConversationReadNotify.prototype.read_index_v2 = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarkConversationReadNotify.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MarkConversationReadNotify.prototype.message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    MarkConversationReadNotify.create = function create(properties) {
      return new MarkConversationReadNotify(properties);
    };

    MarkConversationReadNotify.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.read_index != null && Object.hasOwnProperty.call(m, 'read_index')) w.uint32(24).int64(m.read_index);
      if (m.read_index_v2 != null && Object.hasOwnProperty.call(m, 'read_index_v2'))
        w.uint32(32).int64(m.read_index_v2);
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(40).int64(m.user_id);
      if (m.message_id != null && Object.hasOwnProperty.call(m, 'message_id')) w.uint32(48).int64(m.message_id);
      return w;
    };

    MarkConversationReadNotify.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MarkConversationReadNotify();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.read_index = r.int64();
            break;
          case 4:
            m.read_index_v2 = r.int64();
            break;
          case 5:
            m.user_id = r.int64();
            break;
          case 6:
            m.message_id = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MarkConversationReadNotify;
  })();

  im_proto.InputStatusNotify = (function () {
    function InputStatusNotify(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    InputStatusNotify.prototype.sender = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    InputStatusNotify.prototype.conversation_id = '';
    InputStatusNotify.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    InputStatusNotify.prototype.conversation_type = 1;
    InputStatusNotify.prototype.input_status = 3;
    InputStatusNotify.prototype.create_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    InputStatusNotify.create = function create(properties) {
      return new InputStatusNotify(properties);
    };

    InputStatusNotify.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.sender != null && Object.hasOwnProperty.call(m, 'sender')) w.uint32(8).int64(m.sender);
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(18).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(32).int32(m.conversation_type);
      w.uint32(40).int32(m.input_status);
      w.uint32(80).int64(m.create_time);
      return w;
    };

    InputStatusNotify.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.InputStatusNotify();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.sender = r.int64();
            break;
          case 2:
            m.conversation_id = r.string();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.conversation_type = r.int32();
            break;
          case 5:
            m.input_status = r.int32();
            break;
          case 10:
            m.create_time = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('input_status'))
        throw $util.ProtocolError("missing required 'input_status'", { instance: m });
      if (!m.hasOwnProperty('create_time'))
        throw $util.ProtocolError("missing required 'create_time'", { instance: m });
      return m;
    };

    return InputStatusNotify;
  })();

  im_proto.ConversationInfoUpdatedNotify = (function () {
    function ConversationInfoUpdatedNotify(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationInfoUpdatedNotify.prototype.conversation = null;

    ConversationInfoUpdatedNotify.create = function create(properties) {
      return new ConversationInfoUpdatedNotify(properties);
    };

    ConversationInfoUpdatedNotify.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation != null && Object.hasOwnProperty.call(m, 'conversation'))
        $root.im_proto.ConversationInfo.encode(m.conversation, w.uint32(10).fork()).ldelim();
      return w;
    };

    ConversationInfoUpdatedNotify.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationInfoUpdatedNotify();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation = $root.im_proto.ConversationInfo.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationInfoUpdatedNotify;
  })();

  im_proto.GetConversationInfoRequestBody = (function () {
    function GetConversationInfoRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationInfoRequestBody.prototype.conversation_id = '';
    GetConversationInfoRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetConversationInfoRequestBody.prototype.conversation_type = 0;

    GetConversationInfoRequestBody.create = function create(properties) {
      return new GetConversationInfoRequestBody(properties);
    };

    GetConversationInfoRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      return w;
    };

    GetConversationInfoRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationInfoRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationInfoRequestBody;
  })();

  im_proto.GetConversationInfoResponseBody = (function () {
    function GetConversationInfoResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationInfoResponseBody.prototype.conversation_info = null;

    GetConversationInfoResponseBody.create = function create(properties) {
      return new GetConversationInfoResponseBody(properties);
    };

    GetConversationInfoResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_info != null && Object.hasOwnProperty.call(m, 'conversation_info'))
        $root.im_proto.ConversationInfo.encode(m.conversation_info, w.uint32(10).fork()).ldelim();
      return w;
    };

    GetConversationInfoResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationInfoResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_info = $root.im_proto.ConversationInfo.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationInfoResponseBody;
  })();

  im_proto.ConversationsPerUserByFavoriteV2RequestBody = (function () {
    function ConversationsPerUserByFavoriteV2RequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationsPerUserByFavoriteV2RequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationsPerUserByFavoriteV2RequestBody.prototype.limit = 500;

    ConversationsPerUserByFavoriteV2RequestBody.create = function create(properties) {
      return new ConversationsPerUserByFavoriteV2RequestBody(properties);
    };

    ConversationsPerUserByFavoriteV2RequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(8).int64(m.cursor);
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(16).int32(m.limit);
      return w;
    };

    ConversationsPerUserByFavoriteV2RequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationsPerUserByFavoriteV2RequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cursor = r.int64();
            break;
          case 2:
            m.limit = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationsPerUserByFavoriteV2RequestBody;
  })();

  im_proto.ConversationsPerUserByTopV2RequestBody = (function () {
    function ConversationsPerUserByTopV2RequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationsPerUserByTopV2RequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationsPerUserByTopV2RequestBody.prototype.limit = 500;

    ConversationsPerUserByTopV2RequestBody.create = function create(properties) {
      return new ConversationsPerUserByTopV2RequestBody(properties);
    };

    ConversationsPerUserByTopV2RequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(8).int64(m.cursor);
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(16).int32(m.limit);
      return w;
    };

    ConversationsPerUserByTopV2RequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationsPerUserByTopV2RequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cursor = r.int64();
            break;
          case 2:
            m.limit = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationsPerUserByTopV2RequestBody;
  })();

  im_proto.GetConversationInfoV2RequestBody = (function () {
    function GetConversationInfoV2RequestBody(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationInfoV2RequestBody.prototype.conversation_id = '';
    GetConversationInfoV2RequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    GetConversationInfoV2RequestBody.prototype.conversation_type = 0;
    GetConversationInfoV2RequestBody.prototype.ext = $util.emptyObject;

    GetConversationInfoV2RequestBody.create = function create(properties) {
      return new GetConversationInfoV2RequestBody(properties);
    };

    GetConversationInfoV2RequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    GetConversationInfoV2RequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationInfoV2RequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationInfoV2RequestBody;
  })();

  im_proto.GetConversationInfoV2ResponseBody = (function () {
    function GetConversationInfoV2ResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationInfoV2ResponseBody.prototype.conversation_info = null;

    GetConversationInfoV2ResponseBody.create = function create(properties) {
      return new GetConversationInfoV2ResponseBody(properties);
    };

    GetConversationInfoV2ResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_info != null && Object.hasOwnProperty.call(m, 'conversation_info'))
        $root.im_proto.ConversationInfoV2.encode(m.conversation_info, w.uint32(10).fork()).ldelim();
      return w;
    };

    GetConversationInfoV2ResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationInfoV2ResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_info = $root.im_proto.ConversationInfoV2.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationInfoV2ResponseBody;
  })();

  im_proto.GetConversationInfoListRequestBody = (function () {
    function GetConversationInfoListRequestBody(p) {
      this.conversation_info_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationInfoListRequestBody.prototype.conversation_info_list = $util.emptyArray;

    GetConversationInfoListRequestBody.create = function create(properties) {
      return new GetConversationInfoListRequestBody(properties);
    };

    GetConversationInfoListRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_info_list != null && m.conversation_info_list.length) {
        for (var i = 0; i < m.conversation_info_list.length; ++i)
          $root.im_proto.GetConversationInfoRequestBody.encode(
            m.conversation_info_list[i],
            w.uint32(10).fork(),
          ).ldelim();
      }
      return w;
    };

    GetConversationInfoListRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationInfoListRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conversation_info_list && m.conversation_info_list.length)) m.conversation_info_list = [];
            m.conversation_info_list.push($root.im_proto.GetConversationInfoRequestBody.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationInfoListRequestBody;
  })();

  im_proto.GetConversationInfoListResponseBody = (function () {
    function GetConversationInfoListResponseBody(p) {
      this.conversation_info_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationInfoListResponseBody.prototype.conversation_info_list = $util.emptyArray;

    GetConversationInfoListResponseBody.create = function create(properties) {
      return new GetConversationInfoListResponseBody(properties);
    };

    GetConversationInfoListResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_info_list != null && m.conversation_info_list.length) {
        for (var i = 0; i < m.conversation_info_list.length; ++i)
          $root.im_proto.ConversationInfo.encode(m.conversation_info_list[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    GetConversationInfoListResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationInfoListResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conversation_info_list && m.conversation_info_list.length)) m.conversation_info_list = [];
            m.conversation_info_list.push($root.im_proto.ConversationInfo.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationInfoListResponseBody;
  })();

  im_proto.GetConversationInfoListV2RequestBody = (function () {
    function GetConversationInfoListV2RequestBody(p) {
      this.conversation_info_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationInfoListV2RequestBody.prototype.conversation_info_list = $util.emptyArray;

    GetConversationInfoListV2RequestBody.create = function create(properties) {
      return new GetConversationInfoListV2RequestBody(properties);
    };

    GetConversationInfoListV2RequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_info_list != null && m.conversation_info_list.length) {
        for (var i = 0; i < m.conversation_info_list.length; ++i)
          $root.im_proto.GetConversationInfoV2RequestBody.encode(
            m.conversation_info_list[i],
            w.uint32(10).fork(),
          ).ldelim();
      }
      return w;
    };

    GetConversationInfoListV2RequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationInfoListV2RequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conversation_info_list && m.conversation_info_list.length)) m.conversation_info_list = [];
            m.conversation_info_list.push($root.im_proto.GetConversationInfoV2RequestBody.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationInfoListV2RequestBody;
  })();

  im_proto.GetConversationInfoListV2ResponseBody = (function () {
    function GetConversationInfoListV2ResponseBody(p) {
      this.conversation_info_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationInfoListV2ResponseBody.prototype.conversation_info_list = $util.emptyArray;

    GetConversationInfoListV2ResponseBody.create = function create(properties) {
      return new GetConversationInfoListV2ResponseBody(properties);
    };

    GetConversationInfoListV2ResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_info_list != null && m.conversation_info_list.length) {
        for (var i = 0; i < m.conversation_info_list.length; ++i)
          $root.im_proto.ConversationInfoV2.encode(m.conversation_info_list[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    GetConversationInfoListV2ResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationInfoListV2ResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conversation_info_list && m.conversation_info_list.length)) m.conversation_info_list = [];
            m.conversation_info_list.push($root.im_proto.ConversationInfoV2.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationInfoListV2ResponseBody;
  })();

  im_proto.PreviewerGetConversationInfoListRequestBody = (function () {
    function PreviewerGetConversationInfoListRequestBody(p) {
      this.conversation_info_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    PreviewerGetConversationInfoListRequestBody.prototype.conversation_info_list = $util.emptyArray;

    PreviewerGetConversationInfoListRequestBody.create = function create(properties) {
      return new PreviewerGetConversationInfoListRequestBody(properties);
    };

    PreviewerGetConversationInfoListRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_info_list != null && m.conversation_info_list.length) {
        for (var i = 0; i < m.conversation_info_list.length; ++i)
          $root.im_proto.GetConversationInfoV2RequestBody.encode(
            m.conversation_info_list[i],
            w.uint32(10).fork(),
          ).ldelim();
      }
      return w;
    };

    PreviewerGetConversationInfoListRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.PreviewerGetConversationInfoListRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conversation_info_list && m.conversation_info_list.length)) m.conversation_info_list = [];
            m.conversation_info_list.push($root.im_proto.GetConversationInfoV2RequestBody.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PreviewerGetConversationInfoListRequestBody;
  })();

  im_proto.PreviewerGetConversationInfoListResponseBody = (function () {
    function PreviewerGetConversationInfoListResponseBody(p) {
      this.conversation_info_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    PreviewerGetConversationInfoListResponseBody.prototype.conversation_info_list = $util.emptyArray;
    PreviewerGetConversationInfoListResponseBody.prototype.status = 0;
    PreviewerGetConversationInfoListResponseBody.prototype.check_code = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    PreviewerGetConversationInfoListResponseBody.prototype.check_message = '';

    PreviewerGetConversationInfoListResponseBody.create = function create(properties) {
      return new PreviewerGetConversationInfoListResponseBody(properties);
    };

    PreviewerGetConversationInfoListResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_info_list != null && m.conversation_info_list.length) {
        for (var i = 0; i < m.conversation_info_list.length; ++i)
          $root.im_proto.ConversationInfoV2.encode(m.conversation_info_list[i], w.uint32(10).fork()).ldelim();
      }
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(24).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(34).string(m.check_message);
      return w;
    };

    PreviewerGetConversationInfoListResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.PreviewerGetConversationInfoListResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conversation_info_list && m.conversation_info_list.length)) m.conversation_info_list = [];
            m.conversation_info_list.push($root.im_proto.ConversationInfoV2.decode(r, r.uint32()));
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.check_code = r.int64();
            break;
          case 4:
            m.check_message = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PreviewerGetConversationInfoListResponseBody;
  })();

  im_proto.GetConversationInfoListByFavoriteV2ResponseBody = (function () {
    function GetConversationInfoListByFavoriteV2ResponseBody(p) {
      this.conversation_info_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationInfoListByFavoriteV2ResponseBody.prototype.conversation_info_list = $util.emptyArray;
    GetConversationInfoListByFavoriteV2ResponseBody.prototype.has_more = false;
    GetConversationInfoListByFavoriteV2ResponseBody.prototype.next_cursor = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    GetConversationInfoListByFavoriteV2ResponseBody.create = function create(properties) {
      return new GetConversationInfoListByFavoriteV2ResponseBody(properties);
    };

    GetConversationInfoListByFavoriteV2ResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_info_list != null && m.conversation_info_list.length) {
        for (var i = 0; i < m.conversation_info_list.length; ++i)
          $root.im_proto.ConversationInfoV2.encode(m.conversation_info_list[i], w.uint32(10).fork()).ldelim();
      }
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(16).bool(m.has_more);
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(24).int64(m.next_cursor);
      return w;
    };

    GetConversationInfoListByFavoriteV2ResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationInfoListByFavoriteV2ResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conversation_info_list && m.conversation_info_list.length)) m.conversation_info_list = [];
            m.conversation_info_list.push($root.im_proto.ConversationInfoV2.decode(r, r.uint32()));
            break;
          case 2:
            m.has_more = r.bool();
            break;
          case 3:
            m.next_cursor = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationInfoListByFavoriteV2ResponseBody;
  })();

  im_proto.GetConversationInfoListByTopV2ResponseBody = (function () {
    function GetConversationInfoListByTopV2ResponseBody(p) {
      this.conversation_info_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationInfoListByTopV2ResponseBody.prototype.conversation_info_list = $util.emptyArray;
    GetConversationInfoListByTopV2ResponseBody.prototype.has_more = false;
    GetConversationInfoListByTopV2ResponseBody.prototype.next_cursor = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    GetConversationInfoListByTopV2ResponseBody.create = function create(properties) {
      return new GetConversationInfoListByTopV2ResponseBody(properties);
    };

    GetConversationInfoListByTopV2ResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_info_list != null && m.conversation_info_list.length) {
        for (var i = 0; i < m.conversation_info_list.length; ++i)
          $root.im_proto.ConversationInfoV2.encode(m.conversation_info_list[i], w.uint32(10).fork()).ldelim();
      }
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(16).bool(m.has_more);
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(24).int64(m.next_cursor);
      return w;
    };

    GetConversationInfoListByTopV2ResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationInfoListByTopV2ResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conversation_info_list && m.conversation_info_list.length)) m.conversation_info_list = [];
            m.conversation_info_list.push($root.im_proto.ConversationInfoV2.decode(r, r.uint32()));
            break;
          case 2:
            m.has_more = r.bool();
            break;
          case 3:
            m.next_cursor = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationInfoListByTopV2ResponseBody;
  })();

  im_proto.GetConversationsCheckInfoRequestBody = (function () {
    function GetConversationsCheckInfoRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationsCheckInfoRequestBody.create = function create(properties) {
      return new GetConversationsCheckInfoRequestBody(properties);
    };

    GetConversationsCheckInfoRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    GetConversationsCheckInfoRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationsCheckInfoRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationsCheckInfoRequestBody;
  })();

  im_proto.ConversationCheckInfo = (function () {
    function ConversationCheckInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationCheckInfo.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationCheckInfo.prototype.conversation_id = '';
    ConversationCheckInfo.prototype.conversation_type = 0;

    ConversationCheckInfo.create = function create(properties) {
      return new ConversationCheckInfo(properties);
    };

    ConversationCheckInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(8).int64(m.conversation_short_id);
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(18).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      return w;
    };

    ConversationCheckInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationCheckInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_short_id = r.int64();
            break;
          case 2:
            m.conversation_id = r.string();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationCheckInfo;
  })();

  im_proto.GetConversationsCheckInfoResponseBody = (function () {
    function GetConversationsCheckInfoResponseBody(p) {
      this.conversation_checkinfo_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationsCheckInfoResponseBody.prototype.conversation_checkinfo_list = $util.emptyArray;

    GetConversationsCheckInfoResponseBody.create = function create(properties) {
      return new GetConversationsCheckInfoResponseBody(properties);
    };

    GetConversationsCheckInfoResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_checkinfo_list != null && m.conversation_checkinfo_list.length) {
        for (var i = 0; i < m.conversation_checkinfo_list.length; ++i)
          $root.im_proto.ConversationCheckInfo.encode(m.conversation_checkinfo_list[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    GetConversationsCheckInfoResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationsCheckInfoResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conversation_checkinfo_list && m.conversation_checkinfo_list.length))
              m.conversation_checkinfo_list = [];
            m.conversation_checkinfo_list.push($root.im_proto.ConversationCheckInfo.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationsCheckInfoResponseBody;
  })();

  im_proto.GetConversationsCheckInfoV2RequestBody = (function () {
    function GetConversationsCheckInfoV2RequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationsCheckInfoV2RequestBody.prototype.limit = 0;

    GetConversationsCheckInfoV2RequestBody.create = function create(properties) {
      return new GetConversationsCheckInfoV2RequestBody(properties);
    };

    GetConversationsCheckInfoV2RequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(8).int32(m.limit);
      return w;
    };

    GetConversationsCheckInfoV2RequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationsCheckInfoV2RequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.limit = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationsCheckInfoV2RequestBody;
  })();

  im_proto.ConversationCheckInfoV2 = (function () {
    function ConversationCheckInfoV2(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationCheckInfoV2.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationCheckInfoV2.prototype.conv_id = '';
    ConversationCheckInfoV2.prototype.conv_type = 1;
    ConversationCheckInfoV2.prototype.is_pinned = false;

    ConversationCheckInfoV2.create = function create(properties) {
      return new ConversationCheckInfoV2(properties);
    };

    ConversationCheckInfoV2.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.conv_short_id);
      if (m.conv_id != null && Object.hasOwnProperty.call(m, 'conv_id')) w.uint32(18).string(m.conv_id);
      w.uint32(24).int32(m.conv_type);
      if (m.is_pinned != null && Object.hasOwnProperty.call(m, 'is_pinned')) w.uint32(32).bool(m.is_pinned);
      return w;
    };

    ConversationCheckInfoV2.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationCheckInfoV2();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conv_short_id = r.int64();
            break;
          case 2:
            m.conv_id = r.string();
            break;
          case 3:
            m.conv_type = r.int32();
            break;
          case 4:
            m.is_pinned = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('conv_short_id'))
        throw $util.ProtocolError("missing required 'conv_short_id'", { instance: m });
      if (!m.hasOwnProperty('conv_type')) throw $util.ProtocolError("missing required 'conv_type'", { instance: m });
      return m;
    };

    return ConversationCheckInfoV2;
  })();

  im_proto.GetConversationsCheckInfoV2ResponseBody = (function () {
    function GetConversationsCheckInfoV2ResponseBody(p) {
      this.conv_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationsCheckInfoV2ResponseBody.prototype.conv_list = $util.emptyArray;
    GetConversationsCheckInfoV2ResponseBody.prototype.is_demoted = false;
    GetConversationsCheckInfoV2ResponseBody.prototype.is_pinned_included = false;

    GetConversationsCheckInfoV2ResponseBody.create = function create(properties) {
      return new GetConversationsCheckInfoV2ResponseBody(properties);
    };

    GetConversationsCheckInfoV2ResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conv_list != null && m.conv_list.length) {
        for (var i = 0; i < m.conv_list.length; ++i)
          $root.im_proto.ConversationCheckInfoV2.encode(m.conv_list[i], w.uint32(10).fork()).ldelim();
      }
      if (m.is_demoted != null && Object.hasOwnProperty.call(m, 'is_demoted')) w.uint32(16).bool(m.is_demoted);
      if (m.is_pinned_included != null && Object.hasOwnProperty.call(m, 'is_pinned_included'))
        w.uint32(24).bool(m.is_pinned_included);
      return w;
    };

    GetConversationsCheckInfoV2ResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationsCheckInfoV2ResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conv_list && m.conv_list.length)) m.conv_list = [];
            m.conv_list.push($root.im_proto.ConversationCheckInfoV2.decode(r, r.uint32()));
            break;
          case 2:
            m.is_demoted = r.bool();
            break;
          case 3:
            m.is_pinned_included = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationsCheckInfoV2ResponseBody;
  })();

  im_proto.RecallMessageRequestBody = (function () {
    function RecallMessageRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    RecallMessageRequestBody.prototype.conversation_id = '';
    RecallMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    RecallMessageRequestBody.prototype.conversation_type = 0;
    RecallMessageRequestBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    RecallMessageRequestBody.create = function create(properties) {
      return new RecallMessageRequestBody(properties);
    };

    RecallMessageRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.server_message_id != null && Object.hasOwnProperty.call(m, 'server_message_id'))
        w.uint32(32).int64(m.server_message_id);
      return w;
    };

    RecallMessageRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.RecallMessageRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.server_message_id = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return RecallMessageRequestBody;
  })();

  im_proto.ConversationAddParticipantsRequestBody = (function () {
    function ConversationAddParticipantsRequestBody(p) {
      this.participants = [];
      this.biz_ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationAddParticipantsRequestBody.prototype.conversation_id = '';
    ConversationAddParticipantsRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    ConversationAddParticipantsRequestBody.prototype.conversation_type = 0;
    ConversationAddParticipantsRequestBody.prototype.participants = $util.emptyArray;
    ConversationAddParticipantsRequestBody.prototype.biz_ext = $util.emptyObject;

    ConversationAddParticipantsRequestBody.create = function create(properties) {
      return new ConversationAddParticipantsRequestBody(properties);
    };

    ConversationAddParticipantsRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.participants != null && m.participants.length) {
        for (var i = 0; i < m.participants.length; ++i) w.uint32(32).int64(m.participants[i]);
      }
      if (m.biz_ext != null && Object.hasOwnProperty.call(m, 'biz_ext')) {
        for (var ks = Object.keys(m.biz_ext), i = 0; i < ks.length; ++i) {
          w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.biz_ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    ConversationAddParticipantsRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationAddParticipantsRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            if (!(m.participants && m.participants.length)) m.participants = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.participants.push(r.int64());
            } else m.participants.push(r.int64());
            break;
          case 5:
            if (m.biz_ext === $util.emptyObject) m.biz_ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.biz_ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationAddParticipantsRequestBody;
  })();

  im_proto.SecUidPair = (function () {
    function SecUidPair(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SecUidPair.prototype.uid = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SecUidPair.prototype.sec_uid = '';

    SecUidPair.create = function create(properties) {
      return new SecUidPair(properties);
    };

    SecUidPair.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.uid != null && Object.hasOwnProperty.call(m, 'uid')) w.uint32(8).int64(m.uid);
      if (m.sec_uid != null && Object.hasOwnProperty.call(m, 'sec_uid')) w.uint32(18).string(m.sec_uid);
      return w;
    };

    SecUidPair.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SecUidPair();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.uid = r.int64();
            break;
          case 2:
            m.sec_uid = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SecUidPair;
  })();

  im_proto.ConversationAddParticipantsResponseBody = (function () {
    function ConversationAddParticipantsResponseBody(p) {
      this.success_participants = [];
      this.failed_participants = [];
      this.sec_success_participants = [];
      this.sec_failed_participants = [];
      this.biz_ext = {};
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationAddParticipantsResponseBody.prototype.success_participants = $util.emptyArray;
    ConversationAddParticipantsResponseBody.prototype.failed_participants = $util.emptyArray;
    ConversationAddParticipantsResponseBody.prototype.status = 0;
    ConversationAddParticipantsResponseBody.prototype.extra_info = '';
    ConversationAddParticipantsResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationAddParticipantsResponseBody.prototype.check_message = '';
    ConversationAddParticipantsResponseBody.prototype.sec_success_participants = $util.emptyArray;
    ConversationAddParticipantsResponseBody.prototype.sec_failed_participants = $util.emptyArray;
    ConversationAddParticipantsResponseBody.prototype.biz_ext = $util.emptyObject;
    ConversationAddParticipantsResponseBody.prototype.ext = $util.emptyObject;

    ConversationAddParticipantsResponseBody.create = function create(properties) {
      return new ConversationAddParticipantsResponseBody(properties);
    };

    ConversationAddParticipantsResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.success_participants != null && m.success_participants.length) {
        for (var i = 0; i < m.success_participants.length; ++i) w.uint32(8).int64(m.success_participants[i]);
      }
      if (m.failed_participants != null && m.failed_participants.length) {
        for (var i = 0; i < m.failed_participants.length; ++i) w.uint32(16).int64(m.failed_participants[i]);
      }
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(24).int32(m.status);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(34).string(m.extra_info);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(40).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(50).string(m.check_message);
      if (m.sec_success_participants != null && m.sec_success_participants.length) {
        for (var i = 0; i < m.sec_success_participants.length; ++i)
          $root.im_proto.SecUidPair.encode(m.sec_success_participants[i], w.uint32(58).fork()).ldelim();
      }
      if (m.sec_failed_participants != null && m.sec_failed_participants.length) {
        for (var i = 0; i < m.sec_failed_participants.length; ++i)
          $root.im_proto.SecUidPair.encode(m.sec_failed_participants[i], w.uint32(66).fork()).ldelim();
      }
      if (m.biz_ext != null && Object.hasOwnProperty.call(m, 'biz_ext')) {
        for (var ks = Object.keys(m.biz_ext), i = 0; i < ks.length; ++i) {
          w.uint32(74).fork().uint32(10).string(ks[i]).uint32(18).string(m.biz_ext[ks[i]]).ldelim();
        }
      }
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(82).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    ConversationAddParticipantsResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationAddParticipantsResponseBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.success_participants && m.success_participants.length)) m.success_participants = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.success_participants.push(r.int64());
            } else m.success_participants.push(r.int64());
            break;
          case 2:
            if (!(m.failed_participants && m.failed_participants.length)) m.failed_participants = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.failed_participants.push(r.int64());
            } else m.failed_participants.push(r.int64());
            break;
          case 3:
            m.status = r.int32();
            break;
          case 4:
            m.extra_info = r.string();
            break;
          case 5:
            m.check_code = r.int64();
            break;
          case 6:
            m.check_message = r.string();
            break;
          case 7:
            if (!(m.sec_success_participants && m.sec_success_participants.length)) m.sec_success_participants = [];
            m.sec_success_participants.push($root.im_proto.SecUidPair.decode(r, r.uint32()));
            break;
          case 8:
            if (!(m.sec_failed_participants && m.sec_failed_participants.length)) m.sec_failed_participants = [];
            m.sec_failed_participants.push($root.im_proto.SecUidPair.decode(r, r.uint32()));
            break;
          case 9:
            if (m.biz_ext === $util.emptyObject) m.biz_ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.biz_ext[k] = value;
            break;
          case 10:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationAddParticipantsResponseBody;
  })();

  im_proto.ConversationRemoveParticipantsRequestBody = (function () {
    function ConversationRemoveParticipantsRequestBody(p) {
      this.participants = [];
      this.biz_ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationRemoveParticipantsRequestBody.prototype.conversation_id = '';
    ConversationRemoveParticipantsRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    ConversationRemoveParticipantsRequestBody.prototype.conversation_type = 0;
    ConversationRemoveParticipantsRequestBody.prototype.participants = $util.emptyArray;
    ConversationRemoveParticipantsRequestBody.prototype.biz_ext = $util.emptyObject;

    ConversationRemoveParticipantsRequestBody.create = function create(properties) {
      return new ConversationRemoveParticipantsRequestBody(properties);
    };

    ConversationRemoveParticipantsRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.participants != null && m.participants.length) {
        for (var i = 0; i < m.participants.length; ++i) w.uint32(32).int64(m.participants[i]);
      }
      if (m.biz_ext != null && Object.hasOwnProperty.call(m, 'biz_ext')) {
        for (var ks = Object.keys(m.biz_ext), i = 0; i < ks.length; ++i) {
          w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.biz_ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    ConversationRemoveParticipantsRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationRemoveParticipantsRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            if (!(m.participants && m.participants.length)) m.participants = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.participants.push(r.int64());
            } else m.participants.push(r.int64());
            break;
          case 5:
            if (m.biz_ext === $util.emptyObject) m.biz_ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.biz_ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationRemoveParticipantsRequestBody;
  })();

  im_proto.ConversationRemoveParticipantsResponseBody = (function () {
    function ConversationRemoveParticipantsResponseBody(p) {
      this.failed_participants = [];
      this.failed_sec_participants = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationRemoveParticipantsResponseBody.prototype.failed_participants = $util.emptyArray;
    ConversationRemoveParticipantsResponseBody.prototype.status = 0;
    ConversationRemoveParticipantsResponseBody.prototype.extra_info = '';
    ConversationRemoveParticipantsResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationRemoveParticipantsResponseBody.prototype.check_message = '';
    ConversationRemoveParticipantsResponseBody.prototype.failed_sec_participants = $util.emptyArray;

    ConversationRemoveParticipantsResponseBody.create = function create(properties) {
      return new ConversationRemoveParticipantsResponseBody(properties);
    };

    ConversationRemoveParticipantsResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.failed_participants != null && m.failed_participants.length) {
        for (var i = 0; i < m.failed_participants.length; ++i) w.uint32(8).int64(m.failed_participants[i]);
      }
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(26).string(m.extra_info);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(32).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(42).string(m.check_message);
      if (m.failed_sec_participants != null && m.failed_sec_participants.length) {
        for (var i = 0; i < m.failed_sec_participants.length; ++i)
          $root.im_proto.SecUidPair.encode(m.failed_sec_participants[i], w.uint32(50).fork()).ldelim();
      }
      return w;
    };

    ConversationRemoveParticipantsResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationRemoveParticipantsResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.failed_participants && m.failed_participants.length)) m.failed_participants = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.failed_participants.push(r.int64());
            } else m.failed_participants.push(r.int64());
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.extra_info = r.string();
            break;
          case 4:
            m.check_code = r.int64();
            break;
          case 5:
            m.check_message = r.string();
            break;
          case 6:
            if (!(m.failed_sec_participants && m.failed_sec_participants.length)) m.failed_sec_participants = [];
            m.failed_sec_participants.push($root.im_proto.SecUidPair.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationRemoveParticipantsResponseBody;
  })();

  im_proto.ConversationLeaveRequestBody = (function () {
    function ConversationLeaveRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationLeaveRequestBody.prototype.conversation_id = '';
    ConversationLeaveRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationLeaveRequestBody.prototype.conversation_type = 0;

    ConversationLeaveRequestBody.create = function create(properties) {
      return new ConversationLeaveRequestBody(properties);
    };

    ConversationLeaveRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      return w;
    };

    ConversationLeaveRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationLeaveRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationLeaveRequestBody;
  })();

  im_proto.ConversationSetRoleRequestBody = (function () {
    function ConversationSetRoleRequestBody(p) {
      this.roles = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationSetRoleRequestBody.prototype.conversation_id = '';
    ConversationSetRoleRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationSetRoleRequestBody.prototype.conversation_type = 0;
    ConversationSetRoleRequestBody.prototype.roles = $util.emptyObject;

    ConversationSetRoleRequestBody.create = function create(properties) {
      return new ConversationSetRoleRequestBody(properties);
    };

    ConversationSetRoleRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.roles != null && Object.hasOwnProperty.call(m, 'roles')) {
        for (var ks = Object.keys(m.roles), i = 0; i < ks.length; ++i) {
          w.uint32(34).fork().uint32(8).int64(ks[i]).uint32(16).int32(m.roles[ks[i]]).ldelim();
        }
      }
      return w;
    };

    ConversationSetRoleRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationSetRoleRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            if (m.roles === $util.emptyObject) m.roles = {};
            var c2 = r.uint32() + r.pos;
            k = 0;
            value = 0;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.int64();
                  break;
                case 2:
                  value = r.int32();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.roles[typeof k === 'object' ? $util.longToHash(k) : k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationSetRoleRequestBody;
  })();

  im_proto.ConversationSetRoleResponseBody = (function () {
    function ConversationSetRoleResponseBody(p) {
      this.success_participants = [];
      this.failed_participants = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationSetRoleResponseBody.prototype.success_participants = $util.emptyArray;
    ConversationSetRoleResponseBody.prototype.failed_participants = $util.emptyArray;
    ConversationSetRoleResponseBody.prototype.status = 0;
    ConversationSetRoleResponseBody.prototype.extra_info = '';
    ConversationSetRoleResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationSetRoleResponseBody.prototype.check_message = '';

    ConversationSetRoleResponseBody.create = function create(properties) {
      return new ConversationSetRoleResponseBody(properties);
    };

    ConversationSetRoleResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.success_participants != null && m.success_participants.length) {
        for (var i = 0; i < m.success_participants.length; ++i) w.uint32(8).int64(m.success_participants[i]);
      }
      if (m.failed_participants != null && m.failed_participants.length) {
        for (var i = 0; i < m.failed_participants.length; ++i) w.uint32(16).int64(m.failed_participants[i]);
      }
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(24).int32(m.status);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(34).string(m.extra_info);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(40).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(50).string(m.check_message);
      return w;
    };

    ConversationSetRoleResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationSetRoleResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.success_participants && m.success_participants.length)) m.success_participants = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.success_participants.push(r.int64());
            } else m.success_participants.push(r.int64());
            break;
          case 2:
            if (!(m.failed_participants && m.failed_participants.length)) m.failed_participants = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.failed_participants.push(r.int64());
            } else m.failed_participants.push(r.int64());
            break;
          case 3:
            m.status = r.int32();
            break;
          case 4:
            m.extra_info = r.string();
            break;
          case 5:
            m.check_code = r.int64();
            break;
          case 6:
            m.check_message = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationSetRoleResponseBody;
  })();

  im_proto.ConversationParticipantsListRequestBody = (function () {
    function ConversationParticipantsListRequestBody(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationParticipantsListRequestBody.prototype.conversation_id = '';
    ConversationParticipantsListRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    ConversationParticipantsListRequestBody.prototype.conversation_type = 0;
    ConversationParticipantsListRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationParticipantsListRequestBody.prototype.limit = 100;
    ConversationParticipantsListRequestBody.prototype.ext = $util.emptyObject;

    ConversationParticipantsListRequestBody.create = function create(properties) {
      return new ConversationParticipantsListRequestBody(properties);
    };

    ConversationParticipantsListRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(32).int64(m.cursor);
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(40).int32(m.limit);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(50).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    ConversationParticipantsListRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationParticipantsListRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.cursor = r.int64();
            break;
          case 5:
            m.limit = r.int32();
            break;
          case 6:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationParticipantsListRequestBody;
  })();

  im_proto.ConversationParticipantsListResponseBody = (function () {
    function ConversationParticipantsListResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationParticipantsListResponseBody.prototype.participants_page = null;

    ConversationParticipantsListResponseBody.create = function create(properties) {
      return new ConversationParticipantsListResponseBody(properties);
    };

    ConversationParticipantsListResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.participants_page != null && Object.hasOwnProperty.call(m, 'participants_page'))
        $root.im_proto.ParticipantsPage.encode(m.participants_page, w.uint32(10).fork()).ldelim();
      return w;
    };

    ConversationParticipantsListResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationParticipantsListResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.participants_page = $root.im_proto.ParticipantsPage.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationParticipantsListResponseBody;
  })();

  im_proto.MgetConversationParticipantsRequestBody = (function () {
    function MgetConversationParticipantsRequestBody(p) {
      this.participants = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MgetConversationParticipantsRequestBody.prototype.conversation_id = '';
    MgetConversationParticipantsRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    MgetConversationParticipantsRequestBody.prototype.conversation_type = 0;
    MgetConversationParticipantsRequestBody.prototype.participants = $util.emptyArray;

    MgetConversationParticipantsRequestBody.create = function create(properties) {
      return new MgetConversationParticipantsRequestBody(properties);
    };

    MgetConversationParticipantsRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.participants != null && m.participants.length) {
        for (var i = 0; i < m.participants.length; ++i) w.uint32(32).int64(m.participants[i]);
      }
      return w;
    };

    MgetConversationParticipantsRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MgetConversationParticipantsRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            if (!(m.participants && m.participants.length)) m.participants = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.participants.push(r.int64());
            } else m.participants.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MgetConversationParticipantsRequestBody;
  })();

  im_proto.MgetConversationParticipantsResponseBody = (function () {
    function MgetConversationParticipantsResponseBody(p) {
      this.participants = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MgetConversationParticipantsResponseBody.prototype.participants = $util.emptyArray;

    MgetConversationParticipantsResponseBody.create = function create(properties) {
      return new MgetConversationParticipantsResponseBody(properties);
    };

    MgetConversationParticipantsResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.participants != null && m.participants.length) {
        for (var i = 0; i < m.participants.length; ++i)
          $root.im_proto.Participant.encode(m.participants[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    MgetConversationParticipantsResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MgetConversationParticipantsResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.participants && m.participants.length)) m.participants = [];
            m.participants.push($root.im_proto.Participant.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MgetConversationParticipantsResponseBody;
  })();

  im_proto.UpdateConversationParticipantRequestBody = (function () {
    function UpdateConversationParticipantRequestBody(p) {
      this.biz_ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    UpdateConversationParticipantRequestBody.prototype.conversation_id = '';
    UpdateConversationParticipantRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    UpdateConversationParticipantRequestBody.prototype.conversation_type = 0;
    UpdateConversationParticipantRequestBody.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    UpdateConversationParticipantRequestBody.prototype.role = 0;
    UpdateConversationParticipantRequestBody.prototype.alias = '';
    UpdateConversationParticipantRequestBody.prototype.is_alias_set = false;
    UpdateConversationParticipantRequestBody.prototype.biz_ext = $util.emptyObject;

    UpdateConversationParticipantRequestBody.create = function create(properties) {
      return new UpdateConversationParticipantRequestBody(properties);
    };

    UpdateConversationParticipantRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(32).int64(m.user_id);
      if (m.role != null && Object.hasOwnProperty.call(m, 'role')) w.uint32(40).int32(m.role);
      if (m.alias != null && Object.hasOwnProperty.call(m, 'alias')) w.uint32(50).string(m.alias);
      if (m.is_alias_set != null && Object.hasOwnProperty.call(m, 'is_alias_set')) w.uint32(56).bool(m.is_alias_set);
      if (m.biz_ext != null && Object.hasOwnProperty.call(m, 'biz_ext')) {
        for (var ks = Object.keys(m.biz_ext), i = 0; i < ks.length; ++i) {
          w.uint32(90).fork().uint32(10).string(ks[i]).uint32(18).string(m.biz_ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    UpdateConversationParticipantRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.UpdateConversationParticipantRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.user_id = r.int64();
            break;
          case 5:
            m.role = r.int32();
            break;
          case 6:
            m.alias = r.string();
            break;
          case 7:
            m.is_alias_set = r.bool();
            break;
          case 11:
            if (m.biz_ext === $util.emptyObject) m.biz_ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.biz_ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UpdateConversationParticipantRequestBody;
  })();

  im_proto.UpdateConversationParticipantResponseBody = (function () {
    function UpdateConversationParticipantResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    UpdateConversationParticipantResponseBody.prototype.participant = null;
    UpdateConversationParticipantResponseBody.prototype.status = 0;
    UpdateConversationParticipantResponseBody.prototype.extra_info = '';
    UpdateConversationParticipantResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    UpdateConversationParticipantResponseBody.prototype.check_message = '';

    UpdateConversationParticipantResponseBody.create = function create(properties) {
      return new UpdateConversationParticipantResponseBody(properties);
    };

    UpdateConversationParticipantResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.participant != null && Object.hasOwnProperty.call(m, 'participant'))
        $root.im_proto.Participant.encode(m.participant, w.uint32(10).fork()).ldelim();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(26).string(m.extra_info);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(32).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(42).string(m.check_message);
      return w;
    };

    UpdateConversationParticipantResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.UpdateConversationParticipantResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.participant = $root.im_proto.Participant.decode(r, r.uint32());
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.extra_info = r.string();
            break;
          case 4:
            m.check_code = r.int64();
            break;
          case 5:
            m.check_message = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UpdateConversationParticipantResponseBody;
  })();

  im_proto.BatchUpdateConversationParticipantRequestBody = (function () {
    function BatchUpdateConversationParticipantRequestBody(p) {
      this.participants = [];
      this.biz_ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BatchUpdateConversationParticipantRequestBody.prototype.conversation_id = '';
    BatchUpdateConversationParticipantRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    BatchUpdateConversationParticipantRequestBody.prototype.conversation_type = 0;
    BatchUpdateConversationParticipantRequestBody.prototype.participants = $util.emptyArray;
    BatchUpdateConversationParticipantRequestBody.prototype.role = 0;
    BatchUpdateConversationParticipantRequestBody.prototype.biz_ext = $util.emptyObject;

    BatchUpdateConversationParticipantRequestBody.create = function create(properties) {
      return new BatchUpdateConversationParticipantRequestBody(properties);
    };

    BatchUpdateConversationParticipantRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.participants != null && m.participants.length) {
        for (var i = 0; i < m.participants.length; ++i) w.uint32(32).int64(m.participants[i]);
      }
      if (m.role != null && Object.hasOwnProperty.call(m, 'role')) w.uint32(40).int32(m.role);
      if (m.biz_ext != null && Object.hasOwnProperty.call(m, 'biz_ext')) {
        for (var ks = Object.keys(m.biz_ext), i = 0; i < ks.length; ++i) {
          w.uint32(50).fork().uint32(10).string(ks[i]).uint32(18).string(m.biz_ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    BatchUpdateConversationParticipantRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BatchUpdateConversationParticipantRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            if (!(m.participants && m.participants.length)) m.participants = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.participants.push(r.int64());
            } else m.participants.push(r.int64());
            break;
          case 5:
            m.role = r.int32();
            break;
          case 6:
            if (m.biz_ext === $util.emptyObject) m.biz_ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.biz_ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BatchUpdateConversationParticipantRequestBody;
  })();

  im_proto.UpdateConversationParticipantResult = (function () {
    function UpdateConversationParticipantResult(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    UpdateConversationParticipantResult.prototype.participant = null;
    UpdateConversationParticipantResult.prototype.status = 0;
    UpdateConversationParticipantResult.prototype.extra_info = '';
    UpdateConversationParticipantResult.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    UpdateConversationParticipantResult.prototype.check_message = '';

    UpdateConversationParticipantResult.create = function create(properties) {
      return new UpdateConversationParticipantResult(properties);
    };

    UpdateConversationParticipantResult.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.participant != null && Object.hasOwnProperty.call(m, 'participant'))
        $root.im_proto.Participant.encode(m.participant, w.uint32(10).fork()).ldelim();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(26).string(m.extra_info);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(32).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(42).string(m.check_message);
      return w;
    };

    UpdateConversationParticipantResult.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.UpdateConversationParticipantResult();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.participant = $root.im_proto.Participant.decode(r, r.uint32());
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.extra_info = r.string();
            break;
          case 4:
            m.check_code = r.int64();
            break;
          case 5:
            m.check_message = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UpdateConversationParticipantResult;
  })();

  im_proto.BatchUpdateConversationParticipantResponseBody = (function () {
    function BatchUpdateConversationParticipantResponseBody(p) {
      this.success_participants = [];
      this.callback_failed_participants = [];
      this.failed_participants = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BatchUpdateConversationParticipantResponseBody.prototype.success_participants = $util.emptyArray;
    BatchUpdateConversationParticipantResponseBody.prototype.callback_failed_participants = $util.emptyArray;
    BatchUpdateConversationParticipantResponseBody.prototype.failed_participants = $util.emptyArray;

    BatchUpdateConversationParticipantResponseBody.create = function create(properties) {
      return new BatchUpdateConversationParticipantResponseBody(properties);
    };

    BatchUpdateConversationParticipantResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.success_participants != null && m.success_participants.length) {
        for (var i = 0; i < m.success_participants.length; ++i)
          $root.im_proto.UpdateConversationParticipantResult.encode(
            m.success_participants[i],
            w.uint32(10).fork(),
          ).ldelim();
      }
      if (m.callback_failed_participants != null && m.callback_failed_participants.length) {
        for (var i = 0; i < m.callback_failed_participants.length; ++i)
          $root.im_proto.UpdateConversationParticipantResult.encode(
            m.callback_failed_participants[i],
            w.uint32(18).fork(),
          ).ldelim();
      }
      if (m.failed_participants != null && m.failed_participants.length) {
        for (var i = 0; i < m.failed_participants.length; ++i) w.uint32(24).int64(m.failed_participants[i]);
      }
      return w;
    };

    BatchUpdateConversationParticipantResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BatchUpdateConversationParticipantResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.success_participants && m.success_participants.length)) m.success_participants = [];
            m.success_participants.push($root.im_proto.UpdateConversationParticipantResult.decode(r, r.uint32()));
            break;
          case 2:
            if (!(m.callback_failed_participants && m.callback_failed_participants.length))
              m.callback_failed_participants = [];
            m.callback_failed_participants.push(
              $root.im_proto.UpdateConversationParticipantResult.decode(r, r.uint32()),
            );
            break;
          case 3:
            if (!(m.failed_participants && m.failed_participants.length)) m.failed_participants = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.failed_participants.push(r.int64());
            } else m.failed_participants.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BatchUpdateConversationParticipantResponseBody;
  })();

  im_proto.GetGroupInfoRequestBody = (function () {
    function GetGroupInfoRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetGroupInfoRequestBody.prototype.conversation_id = '';
    GetGroupInfoRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetGroupInfoRequestBody.prototype.conversation_type = 0;

    GetGroupInfoRequestBody.create = function create(properties) {
      return new GetGroupInfoRequestBody(properties);
    };

    GetGroupInfoRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      return w;
    };

    GetGroupInfoRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetGroupInfoRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetGroupInfoRequestBody;
  })();

  im_proto.GetGroupInfoResponseBody = (function () {
    function GetGroupInfoResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetGroupInfoResponseBody.prototype.group_info = null;

    GetGroupInfoResponseBody.create = function create(properties) {
      return new GetGroupInfoResponseBody(properties);
    };

    GetGroupInfoResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.group_info != null && Object.hasOwnProperty.call(m, 'group_info'))
        $root.im_proto.GroupInfo.encode(m.group_info, w.uint32(10).fork()).ldelim();
      return w;
    };

    GetGroupInfoResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetGroupInfoResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.group_info = $root.im_proto.GroupInfo.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetGroupInfoResponseBody;
  })();

  im_proto.GetGroupInfoListRequestBody = (function () {
    function GetGroupInfoListRequestBody(p) {
      this.group_info_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetGroupInfoListRequestBody.prototype.group_info_list = $util.emptyArray;

    GetGroupInfoListRequestBody.create = function create(properties) {
      return new GetGroupInfoListRequestBody(properties);
    };

    GetGroupInfoListRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.group_info_list != null && m.group_info_list.length) {
        for (var i = 0; i < m.group_info_list.length; ++i)
          $root.im_proto.GetGroupInfoRequestBody.encode(m.group_info_list[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    GetGroupInfoListRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetGroupInfoListRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.group_info_list && m.group_info_list.length)) m.group_info_list = [];
            m.group_info_list.push($root.im_proto.GetGroupInfoRequestBody.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetGroupInfoListRequestBody;
  })();

  im_proto.GetGroupInfoListResponseBody = (function () {
    function GetGroupInfoListResponseBody(p) {
      this.group_info_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetGroupInfoListResponseBody.prototype.group_info_list = $util.emptyArray;

    GetGroupInfoListResponseBody.create = function create(properties) {
      return new GetGroupInfoListResponseBody(properties);
    };

    GetGroupInfoListResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.group_info_list != null && m.group_info_list.length) {
        for (var i = 0; i < m.group_info_list.length; ++i)
          $root.im_proto.GroupInfo.encode(m.group_info_list[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    GetGroupInfoListResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetGroupInfoListResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.group_info_list && m.group_info_list.length)) m.group_info_list = [];
            m.group_info_list.push($root.im_proto.GroupInfo.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetGroupInfoListResponseBody;
  })();

  im_proto.SetGroupInfoRequestBody = (function () {
    function SetGroupInfoRequestBody(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SetGroupInfoRequestBody.prototype.conversation_id = '';
    SetGroupInfoRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SetGroupInfoRequestBody.prototype.conversation_type = 0;
    SetGroupInfoRequestBody.prototype.group_name = '';
    SetGroupInfoRequestBody.prototype.group_desc = '';
    SetGroupInfoRequestBody.prototype.group_icon = '';
    SetGroupInfoRequestBody.prototype.ext = $util.emptyObject;

    SetGroupInfoRequestBody.create = function create(properties) {
      return new SetGroupInfoRequestBody(properties);
    };

    SetGroupInfoRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.group_name != null && Object.hasOwnProperty.call(m, 'group_name')) w.uint32(42).string(m.group_name);
      if (m.group_desc != null && Object.hasOwnProperty.call(m, 'group_desc')) w.uint32(50).string(m.group_desc);
      if (m.group_icon != null && Object.hasOwnProperty.call(m, 'group_icon')) w.uint32(58).string(m.group_icon);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(66).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    SetGroupInfoRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SetGroupInfoRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 5:
            m.group_name = r.string();
            break;
          case 6:
            m.group_desc = r.string();
            break;
          case 7:
            m.group_icon = r.string();
            break;
          case 8:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SetGroupInfoRequestBody;
  })();

  im_proto.SetGroupInfoResponseBody = (function () {
    function SetGroupInfoResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SetGroupInfoResponseBody.prototype.group_info = null;
    SetGroupInfoResponseBody.prototype.status = 0;
    SetGroupInfoResponseBody.prototype.extra_info = '';
    SetGroupInfoResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SetGroupInfoResponseBody.prototype.check_message = '';

    SetGroupInfoResponseBody.create = function create(properties) {
      return new SetGroupInfoResponseBody(properties);
    };

    SetGroupInfoResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.group_info != null && Object.hasOwnProperty.call(m, 'group_info'))
        $root.im_proto.GroupInfo.encode(m.group_info, w.uint32(10).fork()).ldelim();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(26).string(m.extra_info);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(32).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(42).string(m.check_message);
      return w;
    };

    SetGroupInfoResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SetGroupInfoResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.group_info = $root.im_proto.GroupInfo.decode(r, r.uint32());
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.extra_info = r.string();
            break;
          case 4:
            m.check_code = r.int64();
            break;
          case 5:
            m.check_message = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SetGroupInfoResponseBody;
  })();

  im_proto.GetConversationCoreInfoRequestBody = (function () {
    function GetConversationCoreInfoRequestBody(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationCoreInfoRequestBody.prototype.conversation_id = '';
    GetConversationCoreInfoRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    GetConversationCoreInfoRequestBody.prototype.conversation_type = 0;
    GetConversationCoreInfoRequestBody.prototype.ext = $util.emptyObject;

    GetConversationCoreInfoRequestBody.create = function create(properties) {
      return new GetConversationCoreInfoRequestBody(properties);
    };

    GetConversationCoreInfoRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    GetConversationCoreInfoRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationCoreInfoRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationCoreInfoRequestBody;
  })();

  im_proto.GetConversationCoreInfoResponseBody = (function () {
    function GetConversationCoreInfoResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationCoreInfoResponseBody.prototype.conversation_core_info = null;

    GetConversationCoreInfoResponseBody.create = function create(properties) {
      return new GetConversationCoreInfoResponseBody(properties);
    };

    GetConversationCoreInfoResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_core_info != null && Object.hasOwnProperty.call(m, 'conversation_core_info'))
        $root.im_proto.ConversationCoreInfo.encode(m.conversation_core_info, w.uint32(10).fork()).ldelim();
      return w;
    };

    GetConversationCoreInfoResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationCoreInfoResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_core_info = $root.im_proto.ConversationCoreInfo.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationCoreInfoResponseBody;
  })();

  im_proto.GetConversationCoreInfoListRequestBody = (function () {
    function GetConversationCoreInfoListRequestBody(p) {
      this.conversation_core_info_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationCoreInfoListRequestBody.prototype.conversation_core_info_list = $util.emptyArray;

    GetConversationCoreInfoListRequestBody.create = function create(properties) {
      return new GetConversationCoreInfoListRequestBody(properties);
    };

    GetConversationCoreInfoListRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_core_info_list != null && m.conversation_core_info_list.length) {
        for (var i = 0; i < m.conversation_core_info_list.length; ++i)
          $root.im_proto.GetConversationCoreInfoRequestBody.encode(
            m.conversation_core_info_list[i],
            w.uint32(10).fork(),
          ).ldelim();
      }
      return w;
    };

    GetConversationCoreInfoListRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationCoreInfoListRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conversation_core_info_list && m.conversation_core_info_list.length))
              m.conversation_core_info_list = [];
            m.conversation_core_info_list.push($root.im_proto.GetConversationCoreInfoRequestBody.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationCoreInfoListRequestBody;
  })();

  im_proto.GetConversationCoreInfoListResponseBody = (function () {
    function GetConversationCoreInfoListResponseBody(p) {
      this.conversation_core_info_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationCoreInfoListResponseBody.prototype.conversation_core_info_list = $util.emptyArray;

    GetConversationCoreInfoListResponseBody.create = function create(properties) {
      return new GetConversationCoreInfoListResponseBody(properties);
    };

    GetConversationCoreInfoListResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_core_info_list != null && m.conversation_core_info_list.length) {
        for (var i = 0; i < m.conversation_core_info_list.length; ++i)
          $root.im_proto.ConversationCoreInfo.encode(m.conversation_core_info_list[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    GetConversationCoreInfoListResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationCoreInfoListResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conversation_core_info_list && m.conversation_core_info_list.length))
              m.conversation_core_info_list = [];
            m.conversation_core_info_list.push($root.im_proto.ConversationCoreInfo.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationCoreInfoListResponseBody;
  })();

  im_proto.SetConversationCoreInfoRequestBody = (function () {
    function SetConversationCoreInfoRequestBody(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SetConversationCoreInfoRequestBody.prototype.conversation_id = '';
    SetConversationCoreInfoRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    SetConversationCoreInfoRequestBody.prototype.conversation_type = 0;
    SetConversationCoreInfoRequestBody.prototype.name = '';
    SetConversationCoreInfoRequestBody.prototype.desc = '';
    SetConversationCoreInfoRequestBody.prototype.icon = '';
    SetConversationCoreInfoRequestBody.prototype.notice = '';
    SetConversationCoreInfoRequestBody.prototype.is_name_set = false;
    SetConversationCoreInfoRequestBody.prototype.is_desc_set = false;
    SetConversationCoreInfoRequestBody.prototype.is_icon_set = false;
    SetConversationCoreInfoRequestBody.prototype.is_notice_set = false;
    SetConversationCoreInfoRequestBody.prototype.ext = $util.emptyObject;

    SetConversationCoreInfoRequestBody.create = function create(properties) {
      return new SetConversationCoreInfoRequestBody(properties);
    };

    SetConversationCoreInfoRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.name != null && Object.hasOwnProperty.call(m, 'name')) w.uint32(34).string(m.name);
      if (m.desc != null && Object.hasOwnProperty.call(m, 'desc')) w.uint32(42).string(m.desc);
      if (m.icon != null && Object.hasOwnProperty.call(m, 'icon')) w.uint32(50).string(m.icon);
      if (m.notice != null && Object.hasOwnProperty.call(m, 'notice')) w.uint32(58).string(m.notice);
      if (m.is_name_set != null && Object.hasOwnProperty.call(m, 'is_name_set')) w.uint32(64).bool(m.is_name_set);
      if (m.is_desc_set != null && Object.hasOwnProperty.call(m, 'is_desc_set')) w.uint32(72).bool(m.is_desc_set);
      if (m.is_icon_set != null && Object.hasOwnProperty.call(m, 'is_icon_set')) w.uint32(80).bool(m.is_icon_set);
      if (m.is_notice_set != null && Object.hasOwnProperty.call(m, 'is_notice_set')) w.uint32(88).bool(m.is_notice_set);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(98).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    SetConversationCoreInfoRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SetConversationCoreInfoRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.name = r.string();
            break;
          case 5:
            m.desc = r.string();
            break;
          case 6:
            m.icon = r.string();
            break;
          case 7:
            m.notice = r.string();
            break;
          case 8:
            m.is_name_set = r.bool();
            break;
          case 9:
            m.is_desc_set = r.bool();
            break;
          case 10:
            m.is_icon_set = r.bool();
            break;
          case 11:
            m.is_notice_set = r.bool();
            break;
          case 12:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SetConversationCoreInfoRequestBody;
  })();

  im_proto.SetConversationCoreInfoResponseBody = (function () {
    function SetConversationCoreInfoResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SetConversationCoreInfoResponseBody.prototype.conversation_core_info = null;
    SetConversationCoreInfoResponseBody.prototype.status = 0;
    SetConversationCoreInfoResponseBody.prototype.extra_info = '';
    SetConversationCoreInfoResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SetConversationCoreInfoResponseBody.prototype.check_message = '';

    SetConversationCoreInfoResponseBody.create = function create(properties) {
      return new SetConversationCoreInfoResponseBody(properties);
    };

    SetConversationCoreInfoResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_core_info != null && Object.hasOwnProperty.call(m, 'conversation_core_info'))
        $root.im_proto.ConversationCoreInfo.encode(m.conversation_core_info, w.uint32(10).fork()).ldelim();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(26).string(m.extra_info);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(32).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(42).string(m.check_message);
      return w;
    };

    SetConversationCoreInfoResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SetConversationCoreInfoResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_core_info = $root.im_proto.ConversationCoreInfo.decode(r, r.uint32());
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.extra_info = r.string();
            break;
          case 4:
            m.check_code = r.int64();
            break;
          case 5:
            m.check_message = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SetConversationCoreInfoResponseBody;
  })();

  im_proto.UpsertConversationCoreExtInfoRequestBody = (function () {
    function UpsertConversationCoreExtInfoRequestBody(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    UpsertConversationCoreExtInfoRequestBody.prototype.conversation_id = '';
    UpsertConversationCoreExtInfoRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    UpsertConversationCoreExtInfoRequestBody.prototype.conversation_type = 0;
    UpsertConversationCoreExtInfoRequestBody.prototype.ext = $util.emptyObject;

    UpsertConversationCoreExtInfoRequestBody.create = function create(properties) {
      return new UpsertConversationCoreExtInfoRequestBody(properties);
    };

    UpsertConversationCoreExtInfoRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    UpsertConversationCoreExtInfoRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.UpsertConversationCoreExtInfoRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UpsertConversationCoreExtInfoRequestBody;
  })();

  im_proto.UpsertConversationCoreExtInfoResponseBody = (function () {
    function UpsertConversationCoreExtInfoResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    UpsertConversationCoreExtInfoResponseBody.prototype.core_info = null;
    UpsertConversationCoreExtInfoResponseBody.prototype.status = 0;
    UpsertConversationCoreExtInfoResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    UpsertConversationCoreExtInfoResponseBody.prototype.check_message = '';
    UpsertConversationCoreExtInfoResponseBody.prototype.extra_info = '';

    UpsertConversationCoreExtInfoResponseBody.create = function create(properties) {
      return new UpsertConversationCoreExtInfoResponseBody(properties);
    };

    UpsertConversationCoreExtInfoResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.core_info != null && Object.hasOwnProperty.call(m, 'core_info'))
        $root.im_proto.ConversationCoreInfo.encode(m.core_info, w.uint32(10).fork()).ldelim();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(24).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(34).string(m.check_message);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(42).string(m.extra_info);
      return w;
    };

    UpsertConversationCoreExtInfoResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.UpsertConversationCoreExtInfoResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.core_info = $root.im_proto.ConversationCoreInfo.decode(r, r.uint32());
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.check_code = r.int64();
            break;
          case 4:
            m.check_message = r.string();
            break;
          case 5:
            m.extra_info = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UpsertConversationCoreExtInfoResponseBody;
  })();

  im_proto.DeleteConversationCoreExtInfoRequestBody = (function () {
    function DeleteConversationCoreExtInfoRequestBody(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DeleteConversationCoreExtInfoRequestBody.prototype.conversation_id = '';
    DeleteConversationCoreExtInfoRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    DeleteConversationCoreExtInfoRequestBody.prototype.ext = $util.emptyObject;

    DeleteConversationCoreExtInfoRequestBody.create = function create(properties) {
      return new DeleteConversationCoreExtInfoRequestBody(properties);
    };

    DeleteConversationCoreExtInfoRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(26).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    DeleteConversationCoreExtInfoRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DeleteConversationCoreExtInfoRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DeleteConversationCoreExtInfoRequestBody;
  })();

  im_proto.DeleteConversationCoreExtInfoResponseBody = (function () {
    function DeleteConversationCoreExtInfoResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DeleteConversationCoreExtInfoResponseBody.prototype.core_info = null;
    DeleteConversationCoreExtInfoResponseBody.prototype.status = 0;
    DeleteConversationCoreExtInfoResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DeleteConversationCoreExtInfoResponseBody.prototype.check_message = '';
    DeleteConversationCoreExtInfoResponseBody.prototype.extra_info = '';

    DeleteConversationCoreExtInfoResponseBody.create = function create(properties) {
      return new DeleteConversationCoreExtInfoResponseBody(properties);
    };

    DeleteConversationCoreExtInfoResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.core_info != null && Object.hasOwnProperty.call(m, 'core_info'))
        $root.im_proto.ConversationCoreInfo.encode(m.core_info, w.uint32(10).fork()).ldelim();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(24).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(34).string(m.check_message);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(42).string(m.extra_info);
      return w;
    };

    DeleteConversationCoreExtInfoResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DeleteConversationCoreExtInfoResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.core_info = $root.im_proto.ConversationCoreInfo.decode(r, r.uint32());
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.check_code = r.int64();
            break;
          case 4:
            m.check_message = r.string();
            break;
          case 5:
            m.extra_info = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DeleteConversationCoreExtInfoResponseBody;
  })();

  im_proto.SetConversationSettingInfoRequestBody = (function () {
    function SetConversationSettingInfoRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SetConversationSettingInfoRequestBody.prototype.conversation_id = '';
    SetConversationSettingInfoRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    SetConversationSettingInfoRequestBody.prototype.conversation_type = 0;
    SetConversationSettingInfoRequestBody.prototype.set_stick_on_top = false;
    SetConversationSettingInfoRequestBody.prototype.set_mute = false;
    SetConversationSettingInfoRequestBody.prototype.set_favorite = false;

    SetConversationSettingInfoRequestBody.create = function create(properties) {
      return new SetConversationSettingInfoRequestBody(properties);
    };

    SetConversationSettingInfoRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.set_stick_on_top != null && Object.hasOwnProperty.call(m, 'set_stick_on_top'))
        w.uint32(32).bool(m.set_stick_on_top);
      if (m.set_mute != null && Object.hasOwnProperty.call(m, 'set_mute')) w.uint32(40).bool(m.set_mute);
      if (m.set_favorite != null && Object.hasOwnProperty.call(m, 'set_favorite')) w.uint32(48).bool(m.set_favorite);
      return w;
    };

    SetConversationSettingInfoRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SetConversationSettingInfoRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.set_stick_on_top = r.bool();
            break;
          case 5:
            m.set_mute = r.bool();
            break;
          case 6:
            m.set_favorite = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SetConversationSettingInfoRequestBody;
  })();

  im_proto.SetConversationSettingInfoResponseBody = (function () {
    function SetConversationSettingInfoResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SetConversationSettingInfoResponseBody.prototype.setting_info = null;
    SetConversationSettingInfoResponseBody.prototype.status = 0;
    SetConversationSettingInfoResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SetConversationSettingInfoResponseBody.prototype.check_message = '';
    SetConversationSettingInfoResponseBody.prototype.extra_info = '';

    SetConversationSettingInfoResponseBody.create = function create(properties) {
      return new SetConversationSettingInfoResponseBody(properties);
    };

    SetConversationSettingInfoResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.setting_info != null && Object.hasOwnProperty.call(m, 'setting_info'))
        $root.im_proto.ConversationSettingInfo.encode(m.setting_info, w.uint32(10).fork()).ldelim();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(24).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(34).string(m.check_message);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(42).string(m.extra_info);
      return w;
    };

    SetConversationSettingInfoResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SetConversationSettingInfoResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.setting_info = $root.im_proto.ConversationSettingInfo.decode(r, r.uint32());
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.check_code = r.int64();
            break;
          case 4:
            m.check_message = r.string();
            break;
          case 5:
            m.extra_info = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SetConversationSettingInfoResponseBody;
  })();

  im_proto.UpsertConversationSettingExtInfoRequestBody = (function () {
    function UpsertConversationSettingExtInfoRequestBody(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    UpsertConversationSettingExtInfoRequestBody.prototype.conversation_id = '';
    UpsertConversationSettingExtInfoRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    UpsertConversationSettingExtInfoRequestBody.prototype.conversation_type = 0;
    UpsertConversationSettingExtInfoRequestBody.prototype.ext = $util.emptyObject;

    UpsertConversationSettingExtInfoRequestBody.create = function create(properties) {
      return new UpsertConversationSettingExtInfoRequestBody(properties);
    };

    UpsertConversationSettingExtInfoRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    UpsertConversationSettingExtInfoRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.UpsertConversationSettingExtInfoRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UpsertConversationSettingExtInfoRequestBody;
  })();

  im_proto.UpsertConversationSettingExtInfoResponseBody = (function () {
    function UpsertConversationSettingExtInfoResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    UpsertConversationSettingExtInfoResponseBody.prototype.setting_info = null;
    UpsertConversationSettingExtInfoResponseBody.prototype.status = 0;
    UpsertConversationSettingExtInfoResponseBody.prototype.check_code = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    UpsertConversationSettingExtInfoResponseBody.prototype.check_message = '';
    UpsertConversationSettingExtInfoResponseBody.prototype.extra_info = '';

    UpsertConversationSettingExtInfoResponseBody.create = function create(properties) {
      return new UpsertConversationSettingExtInfoResponseBody(properties);
    };

    UpsertConversationSettingExtInfoResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.setting_info != null && Object.hasOwnProperty.call(m, 'setting_info'))
        $root.im_proto.ConversationSettingInfo.encode(m.setting_info, w.uint32(10).fork()).ldelim();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(24).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(34).string(m.check_message);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(42).string(m.extra_info);
      return w;
    };

    UpsertConversationSettingExtInfoResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.UpsertConversationSettingExtInfoResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.setting_info = $root.im_proto.ConversationSettingInfo.decode(r, r.uint32());
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.check_code = r.int64();
            break;
          case 4:
            m.check_message = r.string();
            break;
          case 5:
            m.extra_info = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UpsertConversationSettingExtInfoResponseBody;
  })();

  im_proto.DeleteConversationSettingExtInfoRequestBody = (function () {
    function DeleteConversationSettingExtInfoRequestBody(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DeleteConversationSettingExtInfoRequestBody.prototype.conversation_id = '';
    DeleteConversationSettingExtInfoRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    DeleteConversationSettingExtInfoRequestBody.prototype.ext = $util.emptyObject;

    DeleteConversationSettingExtInfoRequestBody.create = function create(properties) {
      return new DeleteConversationSettingExtInfoRequestBody(properties);
    };

    DeleteConversationSettingExtInfoRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(26).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    DeleteConversationSettingExtInfoRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DeleteConversationSettingExtInfoRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DeleteConversationSettingExtInfoRequestBody;
  })();

  im_proto.DeleteConversationSettingExtInfoResponseBody = (function () {
    function DeleteConversationSettingExtInfoResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DeleteConversationSettingExtInfoResponseBody.prototype.setting_info = null;
    DeleteConversationSettingExtInfoResponseBody.prototype.status = 0;
    DeleteConversationSettingExtInfoResponseBody.prototype.check_code = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    DeleteConversationSettingExtInfoResponseBody.prototype.check_message = '';
    DeleteConversationSettingExtInfoResponseBody.prototype.extra_info = '';

    DeleteConversationSettingExtInfoResponseBody.create = function create(properties) {
      return new DeleteConversationSettingExtInfoResponseBody(properties);
    };

    DeleteConversationSettingExtInfoResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.setting_info != null && Object.hasOwnProperty.call(m, 'setting_info'))
        $root.im_proto.ConversationSettingInfo.encode(m.setting_info, w.uint32(10).fork()).ldelim();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(24).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(34).string(m.check_message);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(42).string(m.extra_info);
      return w;
    };

    DeleteConversationSettingExtInfoResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DeleteConversationSettingExtInfoResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.setting_info = $root.im_proto.ConversationSettingInfo.decode(r, r.uint32());
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.check_code = r.int64();
            break;
          case 4:
            m.check_message = r.string();
            break;
          case 5:
            m.extra_info = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DeleteConversationSettingExtInfoResponseBody;
  })();

  im_proto.GetConversationSettingInfoRequestBody = (function () {
    function GetConversationSettingInfoRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationSettingInfoRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    GetConversationSettingInfoRequestBody.create = function create(properties) {
      return new GetConversationSettingInfoRequestBody(properties);
    };

    GetConversationSettingInfoRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      return w;
    };

    GetConversationSettingInfoRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationSettingInfoRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 2:
            m.conversation_short_id = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationSettingInfoRequestBody;
  })();

  im_proto.GetConversationSettingInfoResponseBody = (function () {
    function GetConversationSettingInfoResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationSettingInfoResponseBody.prototype.conversation_setting_info = null;
    GetConversationSettingInfoResponseBody.prototype.status = 0;
    GetConversationSettingInfoResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetConversationSettingInfoResponseBody.prototype.check_message = '';
    GetConversationSettingInfoResponseBody.prototype.extra_info = '';

    GetConversationSettingInfoResponseBody.create = function create(properties) {
      return new GetConversationSettingInfoResponseBody(properties);
    };

    GetConversationSettingInfoResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_setting_info != null && Object.hasOwnProperty.call(m, 'conversation_setting_info'))
        $root.im_proto.ConversationSettingInfo.encode(m.conversation_setting_info, w.uint32(10).fork()).ldelim();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(24).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(34).string(m.check_message);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(42).string(m.extra_info);
      return w;
    };

    GetConversationSettingInfoResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationSettingInfoResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_setting_info = $root.im_proto.ConversationSettingInfo.decode(r, r.uint32());
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.check_code = r.int64();
            break;
          case 4:
            m.check_message = r.string();
            break;
          case 5:
            m.extra_info = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationSettingInfoResponseBody;
  })();

  im_proto.StrangerConversation = (function () {
    function StrangerConversation(p) {
      this.participants = [];
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    StrangerConversation.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    StrangerConversation.prototype.unread = 0;
    StrangerConversation.prototype.last_message = null;
    StrangerConversation.prototype.conversation_id = '';
    StrangerConversation.prototype.participants = $util.emptyArray;
    StrangerConversation.prototype.badge_count = 0;
    StrangerConversation.prototype.ext = $util.emptyObject;

    StrangerConversation.create = function create(properties) {
      return new StrangerConversation(properties);
    };

    StrangerConversation.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(8).int64(m.conversation_short_id);
      if (m.unread != null && Object.hasOwnProperty.call(m, 'unread')) w.uint32(16).int32(m.unread);
      if (m.last_message != null && Object.hasOwnProperty.call(m, 'last_message'))
        $root.im_proto.MessageBody.encode(m.last_message, w.uint32(26).fork()).ldelim();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(34).string(m.conversation_id);
      if (m.participants != null && m.participants.length) {
        for (var i = 0; i < m.participants.length; ++i)
          $root.im_proto.Participant.encode(m.participants[i], w.uint32(42).fork()).ldelim();
      }
      if (m.badge_count != null && Object.hasOwnProperty.call(m, 'badge_count')) w.uint32(48).int32(m.badge_count);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(58).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    StrangerConversation.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.StrangerConversation(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_short_id = r.int64();
            break;
          case 2:
            m.unread = r.int32();
            break;
          case 3:
            m.last_message = $root.im_proto.MessageBody.decode(r, r.uint32());
            break;
          case 4:
            m.conversation_id = r.string();
            break;
          case 5:
            if (!(m.participants && m.participants.length)) m.participants = [];
            m.participants.push($root.im_proto.Participant.decode(r, r.uint32()));
            break;
          case 6:
            m.badge_count = r.int32();
            break;
          case 7:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return StrangerConversation;
  })();

  im_proto.StrangerNewMessageNotify = (function () {
    function StrangerNewMessageNotify(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    StrangerNewMessageNotify.prototype.message = null;

    StrangerNewMessageNotify.create = function create(properties) {
      return new StrangerNewMessageNotify(properties);
    };

    StrangerNewMessageNotify.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.message != null && Object.hasOwnProperty.call(m, 'message'))
        $root.im_proto.MessageBody.encode(m.message, w.uint32(18).fork()).ldelim();
      return w;
    };

    StrangerNewMessageNotify.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.StrangerNewMessageNotify();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 2:
            m.message = $root.im_proto.MessageBody.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return StrangerNewMessageNotify;
  })();

  im_proto.GetStrangerConversationListRequestBody = (function () {
    function GetStrangerConversationListRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetStrangerConversationListRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetStrangerConversationListRequestBody.prototype.count = $util.Long ? $util.Long.fromBits(50, 0, false) : 50;
    GetStrangerConversationListRequestBody.prototype.show_total_unread = false;
    GetStrangerConversationListRequestBody.prototype.biz_info = '';

    GetStrangerConversationListRequestBody.create = function create(properties) {
      return new GetStrangerConversationListRequestBody(properties);
    };

    GetStrangerConversationListRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(8).int64(m.cursor);
      if (m.count != null && Object.hasOwnProperty.call(m, 'count')) w.uint32(16).int64(m.count);
      if (m.show_total_unread != null && Object.hasOwnProperty.call(m, 'show_total_unread'))
        w.uint32(24).bool(m.show_total_unread);
      if (m.biz_info != null && Object.hasOwnProperty.call(m, 'biz_info')) w.uint32(34).string(m.biz_info);
      return w;
    };

    GetStrangerConversationListRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetStrangerConversationListRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cursor = r.int64();
            break;
          case 2:
            m.count = r.int64();
            break;
          case 3:
            m.show_total_unread = r.bool();
            break;
          case 4:
            m.biz_info = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetStrangerConversationListRequestBody;
  })();

  im_proto.GetStrangerConversationListResponseBody = (function () {
    function GetStrangerConversationListResponseBody(p) {
      this.conversation_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetStrangerConversationListResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetStrangerConversationListResponseBody.prototype.has_more = false;
    GetStrangerConversationListResponseBody.prototype.total_unread = 0;
    GetStrangerConversationListResponseBody.prototype.conversation_list = $util.emptyArray;

    GetStrangerConversationListResponseBody.create = function create(properties) {
      return new GetStrangerConversationListResponseBody(properties);
    };

    GetStrangerConversationListResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(8).int64(m.next_cursor);
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(16).bool(m.has_more);
      if (m.total_unread != null && Object.hasOwnProperty.call(m, 'total_unread')) w.uint32(24).int32(m.total_unread);
      if (m.conversation_list != null && m.conversation_list.length) {
        for (var i = 0; i < m.conversation_list.length; ++i)
          $root.im_proto.StrangerConversation.encode(m.conversation_list[i], w.uint32(34).fork()).ldelim();
      }
      return w;
    };

    GetStrangerConversationListResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetStrangerConversationListResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.next_cursor = r.int64();
            break;
          case 2:
            m.has_more = r.bool();
            break;
          case 3:
            m.total_unread = r.int32();
            break;
          case 4:
            if (!(m.conversation_list && m.conversation_list.length)) m.conversation_list = [];
            m.conversation_list.push($root.im_proto.StrangerConversation.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetStrangerConversationListResponseBody;
  })();

  im_proto.GetStrangerMessagesRequestBody = (function () {
    function GetStrangerMessagesRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetStrangerMessagesRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetStrangerMessagesRequestBody.prototype.reset_unread_count = false;

    GetStrangerMessagesRequestBody.create = function create(properties) {
      return new GetStrangerMessagesRequestBody(properties);
    };

    GetStrangerMessagesRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(8).int64(m.conversation_short_id);
      if (m.reset_unread_count != null && Object.hasOwnProperty.call(m, 'reset_unread_count'))
        w.uint32(16).bool(m.reset_unread_count);
      return w;
    };

    GetStrangerMessagesRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetStrangerMessagesRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_short_id = r.int64();
            break;
          case 2:
            m.reset_unread_count = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetStrangerMessagesRequestBody;
  })();

  im_proto.GetStrangerMessagesResponseBody = (function () {
    function GetStrangerMessagesResponseBody(p) {
      this.messages = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetStrangerMessagesResponseBody.prototype.messages = $util.emptyArray;

    GetStrangerMessagesResponseBody.create = function create(properties) {
      return new GetStrangerMessagesResponseBody(properties);
    };

    GetStrangerMessagesResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(26).fork()).ldelim();
      }
      return w;
    };

    GetStrangerMessagesResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetStrangerMessagesResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 3:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetStrangerMessagesResponseBody;
  })();

  im_proto.DeleteStrangerMessageRequestBody = (function () {
    function DeleteStrangerMessageRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DeleteStrangerMessageRequestBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    DeleteStrangerMessageRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    DeleteStrangerMessageRequestBody.create = function create(properties) {
      return new DeleteStrangerMessageRequestBody(properties);
    };

    DeleteStrangerMessageRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.server_message_id != null && Object.hasOwnProperty.call(m, 'server_message_id'))
        w.uint32(8).int64(m.server_message_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      return w;
    };

    DeleteStrangerMessageRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DeleteStrangerMessageRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.server_message_id = r.int64();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DeleteStrangerMessageRequestBody;
  })();

  im_proto.DeleteStrangerMessageResponseBody = (function () {
    function DeleteStrangerMessageResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DeleteStrangerMessageResponseBody.create = function create(properties) {
      return new DeleteStrangerMessageResponseBody(properties);
    };

    DeleteStrangerMessageResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    DeleteStrangerMessageResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DeleteStrangerMessageResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DeleteStrangerMessageResponseBody;
  })();

  im_proto.DeleteStrangerConversationRequestBody = (function () {
    function DeleteStrangerConversationRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DeleteStrangerConversationRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    DeleteStrangerConversationRequestBody.create = function create(properties) {
      return new DeleteStrangerConversationRequestBody(properties);
    };

    DeleteStrangerConversationRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(8).int64(m.conversation_short_id);
      return w;
    };

    DeleteStrangerConversationRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DeleteStrangerConversationRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_short_id = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DeleteStrangerConversationRequestBody;
  })();

  im_proto.DeleteStrangerConversationResponseBody = (function () {
    function DeleteStrangerConversationResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DeleteStrangerConversationResponseBody.create = function create(properties) {
      return new DeleteStrangerConversationResponseBody(properties);
    };

    DeleteStrangerConversationResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    DeleteStrangerConversationResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DeleteStrangerConversationResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DeleteStrangerConversationResponseBody;
  })();

  im_proto.DeleteStrangerAllConversationRequestBody = (function () {
    function DeleteStrangerAllConversationRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DeleteStrangerAllConversationRequestBody.create = function create(properties) {
      return new DeleteStrangerAllConversationRequestBody(properties);
    };

    DeleteStrangerAllConversationRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    DeleteStrangerAllConversationRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DeleteStrangerAllConversationRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DeleteStrangerAllConversationRequestBody;
  })();

  im_proto.DeleteStrangerAllConversationResponseBody = (function () {
    function DeleteStrangerAllConversationResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DeleteStrangerAllConversationResponseBody.create = function create(properties) {
      return new DeleteStrangerAllConversationResponseBody(properties);
    };

    DeleteStrangerAllConversationResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    DeleteStrangerAllConversationResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DeleteStrangerAllConversationResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DeleteStrangerAllConversationResponseBody;
  })();

  im_proto.MarkStrangerConversationReadRequestBody = (function () {
    function MarkStrangerConversationReadRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MarkStrangerConversationReadRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    MarkStrangerConversationReadRequestBody.create = function create(properties) {
      return new MarkStrangerConversationReadRequestBody(properties);
    };

    MarkStrangerConversationReadRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(8).int64(m.conversation_short_id);
      return w;
    };

    MarkStrangerConversationReadRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MarkStrangerConversationReadRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_short_id = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MarkStrangerConversationReadRequestBody;
  })();

  im_proto.MarkStrangerConversationReadResponseBody = (function () {
    function MarkStrangerConversationReadResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MarkStrangerConversationReadResponseBody.create = function create(properties) {
      return new MarkStrangerConversationReadResponseBody(properties);
    };

    MarkStrangerConversationReadResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    MarkStrangerConversationReadResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MarkStrangerConversationReadResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MarkStrangerConversationReadResponseBody;
  })();

  im_proto.MarkStrangerAllConversationReadRequestBody = (function () {
    function MarkStrangerAllConversationReadRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MarkStrangerAllConversationReadRequestBody.create = function create(properties) {
      return new MarkStrangerAllConversationReadRequestBody(properties);
    };

    MarkStrangerAllConversationReadRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    MarkStrangerAllConversationReadRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MarkStrangerAllConversationReadRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MarkStrangerAllConversationReadRequestBody;
  })();

  im_proto.MarkStrangerAllConversationReadResponseBody = (function () {
    function MarkStrangerAllConversationReadResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MarkStrangerAllConversationReadResponseBody.create = function create(properties) {
      return new MarkStrangerAllConversationReadResponseBody(properties);
    };

    MarkStrangerAllConversationReadResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    MarkStrangerAllConversationReadResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MarkStrangerAllConversationReadResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MarkStrangerAllConversationReadResponseBody;
  })();

  im_proto.GetStrangerUnreadCountRequestBody = (function () {
    function GetStrangerUnreadCountRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetStrangerUnreadCountRequestBody.prototype.reset_unread_count = false;

    GetStrangerUnreadCountRequestBody.create = function create(properties) {
      return new GetStrangerUnreadCountRequestBody(properties);
    };

    GetStrangerUnreadCountRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.reset_unread_count != null && Object.hasOwnProperty.call(m, 'reset_unread_count'))
        w.uint32(8).bool(m.reset_unread_count);
      return w;
    };

    GetStrangerUnreadCountRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetStrangerUnreadCountRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.reset_unread_count = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetStrangerUnreadCountRequestBody;
  })();

  im_proto.GetStrangerUnreadCountResponseBody = (function () {
    function GetStrangerUnreadCountResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetStrangerUnreadCountResponseBody.prototype.user_unread_count = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    GetStrangerUnreadCountResponseBody.create = function create(properties) {
      return new GetStrangerUnreadCountResponseBody(properties);
    };

    GetStrangerUnreadCountResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.user_unread_count);
      return w;
    };

    GetStrangerUnreadCountResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetStrangerUnreadCountResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_unread_count = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('user_unread_count'))
        throw $util.ProtocolError("missing required 'user_unread_count'", { instance: m });
      return m;
    };

    return GetStrangerUnreadCountResponseBody;
  })();

  im_proto.MessagePropertyContent = (function () {
    function MessagePropertyContent(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessagePropertyContent.prototype.type = 0;
    MessagePropertyContent.prototype.sync_content = null;
    MessagePropertyContent.prototype.reaction_content = null;
    MessagePropertyContent.prototype.index_in_message = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    MessagePropertyContent.create = function create(properties) {
      return new MessagePropertyContent(properties);
    };

    MessagePropertyContent.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.type != null && Object.hasOwnProperty.call(m, 'type')) w.uint32(8).int32(m.type);
      if (m.sync_content != null && Object.hasOwnProperty.call(m, 'sync_content'))
        $root.im_proto.SyncContent.encode(m.sync_content, w.uint32(18).fork()).ldelim();
      if (m.reaction_content != null && Object.hasOwnProperty.call(m, 'reaction_content'))
        $root.im_proto.ReactionContent.encode(m.reaction_content, w.uint32(26).fork()).ldelim();
      if (m.index_in_message != null && Object.hasOwnProperty.call(m, 'index_in_message'))
        w.uint32(32).int64(m.index_in_message);
      return w;
    };

    MessagePropertyContent.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessagePropertyContent();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.type = r.int32();
            break;
          case 2:
            m.sync_content = $root.im_proto.SyncContent.decode(r, r.uint32());
            break;
          case 3:
            m.reaction_content = $root.im_proto.ReactionContent.decode(r, r.uint32());
            break;
          case 4:
            m.index_in_message = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MessagePropertyContent;
  })();

  im_proto.ReactionContent = (function () {
    function ReactionContent(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ReactionContent.prototype.id = 0;
    ReactionContent.prototype.name = '';
    ReactionContent.prototype.status = 0;
    ReactionContent.prototype.target_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ReactionContent.prototype.target_client_message_id = '';

    ReactionContent.create = function create(properties) {
      return new ReactionContent(properties);
    };

    ReactionContent.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.id != null && Object.hasOwnProperty.call(m, 'id')) w.uint32(8).int32(m.id);
      if (m.name != null && Object.hasOwnProperty.call(m, 'name')) w.uint32(18).string(m.name);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(24).int32(m.status);
      if (m.target_message_id != null && Object.hasOwnProperty.call(m, 'target_message_id'))
        w.uint32(32).int64(m.target_message_id);
      if (m.target_client_message_id != null && Object.hasOwnProperty.call(m, 'target_client_message_id'))
        w.uint32(42).string(m.target_client_message_id);
      return w;
    };

    ReactionContent.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ReactionContent();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.id = r.int32();
            break;
          case 2:
            m.name = r.string();
            break;
          case 3:
            m.status = r.int32();
            break;
          case 4:
            m.target_message_id = r.int64();
            break;
          case 5:
            m.target_client_message_id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ReactionContent;
  })();

  im_proto.ReactionMessageRequestBody = (function () {
    function ReactionMessageRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ReactionMessageRequestBody.prototype.conversation_id = '';
    ReactionMessageRequestBody.prototype.conversation_type = 0;
    ReactionMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ReactionMessageRequestBody.prototype.reaction_content = null;
    ReactionMessageRequestBody.prototype.message_type = 0;
    ReactionMessageRequestBody.prototype.ticket = '';
    ReactionMessageRequestBody.prototype.client_message_id = '';

    ReactionMessageRequestBody.create = function create(properties) {
      return new ReactionMessageRequestBody(properties);
    };

    ReactionMessageRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.reaction_content != null && Object.hasOwnProperty.call(m, 'reaction_content'))
        $root.im_proto.ReactionContent.encode(m.reaction_content, w.uint32(34).fork()).ldelim();
      if (m.message_type != null && Object.hasOwnProperty.call(m, 'message_type')) w.uint32(48).int32(m.message_type);
      if (m.ticket != null && Object.hasOwnProperty.call(m, 'ticket')) w.uint32(58).string(m.ticket);
      if (m.client_message_id != null && Object.hasOwnProperty.call(m, 'client_message_id'))
        w.uint32(66).string(m.client_message_id);
      return w;
    };

    ReactionMessageRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ReactionMessageRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.reaction_content = $root.im_proto.ReactionContent.decode(r, r.uint32());
            break;
          case 6:
            m.message_type = r.int32();
            break;
          case 7:
            m.ticket = r.string();
            break;
          case 8:
            m.client_message_id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ReactionMessageRequestBody;
  })();

  im_proto.ReactionMessageResponseBody = (function () {
    function ReactionMessageResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ReactionMessageResponseBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ReactionMessageResponseBody.prototype.client_message_id = '';
    ReactionMessageResponseBody.prototype.status = 0;

    ReactionMessageResponseBody.create = function create(properties) {
      return new ReactionMessageResponseBody(properties);
    };

    ReactionMessageResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.server_message_id != null && Object.hasOwnProperty.call(m, 'server_message_id'))
        w.uint32(8).int64(m.server_message_id);
      if (m.client_message_id != null && Object.hasOwnProperty.call(m, 'client_message_id'))
        w.uint32(18).string(m.client_message_id);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(24).int32(m.status);
      return w;
    };

    ReactionMessageResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ReactionMessageResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.server_message_id = r.int64();
            break;
          case 2:
            m.client_message_id = r.string();
            break;
          case 3:
            m.status = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ReactionMessageResponseBody;
  })();

  im_proto.SyncContent = (function () {
    function SyncContent(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SyncContent.prototype.status = 0;
    SyncContent.prototype.target_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SyncContent.prototype.target_client_message_id = '';

    SyncContent.create = function create(properties) {
      return new SyncContent(properties);
    };

    SyncContent.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(8).int32(m.status);
      if (m.target_message_id != null && Object.hasOwnProperty.call(m, 'target_message_id'))
        w.uint32(16).int64(m.target_message_id);
      if (m.target_client_message_id != null && Object.hasOwnProperty.call(m, 'target_client_message_id'))
        w.uint32(26).string(m.target_client_message_id);
      return w;
    };

    SyncContent.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SyncContent();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.status = r.int32();
            break;
          case 2:
            m.target_message_id = r.int64();
            break;
          case 3:
            m.target_client_message_id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SyncContent;
  })();

  im_proto.SyncMessageRequestBody = (function () {
    function SyncMessageRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SyncMessageRequestBody.prototype.conversation_id = '';
    SyncMessageRequestBody.prototype.conversation_type = 0;
    SyncMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SyncMessageRequestBody.prototype.sync_content = null;
    SyncMessageRequestBody.prototype.message_type = 0;
    SyncMessageRequestBody.prototype.ticket = '';
    SyncMessageRequestBody.prototype.client_message_id = '';
    SyncMessageRequestBody.prototype.target_message_sender = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    SyncMessageRequestBody.create = function create(properties) {
      return new SyncMessageRequestBody(properties);
    };

    SyncMessageRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.sync_content != null && Object.hasOwnProperty.call(m, 'sync_content'))
        $root.im_proto.SyncContent.encode(m.sync_content, w.uint32(34).fork()).ldelim();
      if (m.message_type != null && Object.hasOwnProperty.call(m, 'message_type')) w.uint32(48).int32(m.message_type);
      if (m.ticket != null && Object.hasOwnProperty.call(m, 'ticket')) w.uint32(58).string(m.ticket);
      if (m.client_message_id != null && Object.hasOwnProperty.call(m, 'client_message_id'))
        w.uint32(66).string(m.client_message_id);
      if (m.target_message_sender != null && Object.hasOwnProperty.call(m, 'target_message_sender'))
        w.uint32(72).int64(m.target_message_sender);
      return w;
    };

    SyncMessageRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SyncMessageRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.sync_content = $root.im_proto.SyncContent.decode(r, r.uint32());
            break;
          case 6:
            m.message_type = r.int32();
            break;
          case 7:
            m.ticket = r.string();
            break;
          case 8:
            m.client_message_id = r.string();
            break;
          case 9:
            m.target_message_sender = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SyncMessageRequestBody;
  })();

  im_proto.SyncMessageResponseBody = (function () {
    function SyncMessageResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SyncMessageResponseBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SyncMessageResponseBody.prototype.client_message_id = '';
    SyncMessageResponseBody.prototype.status = 0;

    SyncMessageResponseBody.create = function create(properties) {
      return new SyncMessageResponseBody(properties);
    };

    SyncMessageResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.server_message_id != null && Object.hasOwnProperty.call(m, 'server_message_id'))
        w.uint32(8).int64(m.server_message_id);
      if (m.client_message_id != null && Object.hasOwnProperty.call(m, 'client_message_id'))
        w.uint32(18).string(m.client_message_id);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(24).int32(m.status);
      return w;
    };

    SyncMessageResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SyncMessageResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.server_message_id = r.int64();
            break;
          case 2:
            m.client_message_id = r.string();
            break;
          case 3:
            m.status = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SyncMessageResponseBody;
  })();

  im_proto.ModifyPropertyContent = (function () {
    function ModifyPropertyContent(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ModifyPropertyContent.prototype.operation = 0;
    ModifyPropertyContent.prototype.key = '';
    ModifyPropertyContent.prototype.value = '';
    ModifyPropertyContent.prototype.idempotent_id = '';

    ModifyPropertyContent.create = function create(properties) {
      return new ModifyPropertyContent(properties);
    };

    ModifyPropertyContent.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.operation != null && Object.hasOwnProperty.call(m, 'operation')) w.uint32(8).int32(m.operation);
      if (m.key != null && Object.hasOwnProperty.call(m, 'key')) w.uint32(18).string(m.key);
      if (m.value != null && Object.hasOwnProperty.call(m, 'value')) w.uint32(26).string(m.value);
      if (m.idempotent_id != null && Object.hasOwnProperty.call(m, 'idempotent_id'))
        w.uint32(34).string(m.idempotent_id);
      return w;
    };

    ModifyPropertyContent.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ModifyPropertyContent();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.operation = r.int32();
            break;
          case 2:
            m.key = r.string();
            break;
          case 3:
            m.value = r.string();
            break;
          case 4:
            m.idempotent_id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ModifyPropertyContent;
  })();

  im_proto.ModifyPropertyBody = (function () {
    function ModifyPropertyBody(p) {
      this.modify_property_content = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ModifyPropertyBody.prototype.conversation_id = '';
    ModifyPropertyBody.prototype.conversation_type = 0;
    ModifyPropertyBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ModifyPropertyBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ModifyPropertyBody.prototype.client_message_id = '';
    ModifyPropertyBody.prototype.modify_property_content = $util.emptyArray;

    ModifyPropertyBody.create = function create(properties) {
      return new ModifyPropertyBody(properties);
    };

    ModifyPropertyBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.server_message_id != null && Object.hasOwnProperty.call(m, 'server_message_id'))
        w.uint32(32).int64(m.server_message_id);
      if (m.client_message_id != null && Object.hasOwnProperty.call(m, 'client_message_id'))
        w.uint32(42).string(m.client_message_id);
      if (m.modify_property_content != null && m.modify_property_content.length) {
        for (var i = 0; i < m.modify_property_content.length; ++i)
          $root.im_proto.ModifyPropertyContent.encode(m.modify_property_content[i], w.uint32(50).fork()).ldelim();
      }
      return w;
    };

    ModifyPropertyBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ModifyPropertyBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.server_message_id = r.int64();
            break;
          case 5:
            m.client_message_id = r.string();
            break;
          case 6:
            if (!(m.modify_property_content && m.modify_property_content.length)) m.modify_property_content = [];
            m.modify_property_content.push($root.im_proto.ModifyPropertyContent.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ModifyPropertyBody;
  })();

  im_proto.ModifyMessagePropertyRequestBody = (function () {
    function ModifyMessagePropertyRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ModifyMessagePropertyRequestBody.prototype.property_list = null;
    ModifyMessagePropertyRequestBody.prototype.ticket = '';

    ModifyMessagePropertyRequestBody.create = function create(properties) {
      return new ModifyMessagePropertyRequestBody(properties);
    };

    ModifyMessagePropertyRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.property_list != null && Object.hasOwnProperty.call(m, 'property_list'))
        $root.im_proto.ModifyPropertyBody.encode(m.property_list, w.uint32(10).fork()).ldelim();
      if (m.ticket != null && Object.hasOwnProperty.call(m, 'ticket')) w.uint32(18).string(m.ticket);
      return w;
    };

    ModifyMessagePropertyRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ModifyMessagePropertyRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.property_list = $root.im_proto.ModifyPropertyBody.decode(r, r.uint32());
            break;
          case 2:
            m.ticket = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ModifyMessagePropertyRequestBody;
  })();

  im_proto.ModifyMessagePropertyResponseBody = (function () {
    function ModifyMessagePropertyResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ModifyMessagePropertyResponseBody.prototype.status = 0;
    ModifyMessagePropertyResponseBody.prototype.version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    ModifyMessagePropertyResponseBody.create = function create(properties) {
      return new ModifyMessagePropertyResponseBody(properties);
    };

    ModifyMessagePropertyResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(8).int32(m.status);
      if (m.version != null && Object.hasOwnProperty.call(m, 'version')) w.uint32(16).int64(m.version);
      return w;
    };

    ModifyMessagePropertyResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ModifyMessagePropertyResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.status = r.int32();
            break;
          case 2:
            m.version = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ModifyMessagePropertyResponseBody;
  })();

  im_proto.AckMessageRequestBody = (function () {
    function AckMessageRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    AckMessageRequestBody.prototype.start_timestamp = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AckMessageRequestBody.prototype.id = '';
    AckMessageRequestBody.prototype.conv_type = 1;
    AckMessageRequestBody.prototype.msg_type = 1;
    AckMessageRequestBody.prototype.push_type = 1;
    AckMessageRequestBody.prototype.cmd = 0;

    AckMessageRequestBody.create = function create(properties) {
      return new AckMessageRequestBody(properties);
    };

    AckMessageRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.start_timestamp);
      w.uint32(18).string(m.id);
      if (m.conv_type != null && Object.hasOwnProperty.call(m, 'conv_type')) w.uint32(24).int32(m.conv_type);
      if (m.msg_type != null && Object.hasOwnProperty.call(m, 'msg_type')) w.uint32(32).int32(m.msg_type);
      if (m.push_type != null && Object.hasOwnProperty.call(m, 'push_type')) w.uint32(40).int32(m.push_type);
      if (m.cmd != null && Object.hasOwnProperty.call(m, 'cmd')) w.uint32(48).int32(m.cmd);
      return w;
    };

    AckMessageRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.AckMessageRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.start_timestamp = r.int64();
            break;
          case 2:
            m.id = r.string();
            break;
          case 3:
            m.conv_type = r.int32();
            break;
          case 4:
            m.msg_type = r.int32();
            break;
          case 5:
            m.push_type = r.int32();
            break;
          case 6:
            m.cmd = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('start_timestamp'))
        throw $util.ProtocolError("missing required 'start_timestamp'", { instance: m });
      if (!m.hasOwnProperty('id')) throw $util.ProtocolError("missing required 'id'", { instance: m });
      return m;
    };

    return AckMessageRequestBody;
  })();

  im_proto.AckMessageResponseBody = (function () {
    function AckMessageResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    AckMessageResponseBody.prototype.backend_e2e_latency = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    AckMessageResponseBody.create = function create(properties) {
      return new AckMessageResponseBody(properties);
    };

    AckMessageResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.backend_e2e_latency != null && Object.hasOwnProperty.call(m, 'backend_e2e_latency'))
        w.uint32(8).int64(m.backend_e2e_latency);
      return w;
    };

    AckMessageResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.AckMessageResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.backend_e2e_latency = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return AckMessageResponseBody;
  })();

  im_proto.GetUploadTokenRequestBody = (function () {
    function GetUploadTokenRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetUploadTokenRequestBody.prototype.vsdk_version = '';
    GetUploadTokenRequestBody.prototype.token_type = 1;

    GetUploadTokenRequestBody.create = function create(properties) {
      return new GetUploadTokenRequestBody(properties);
    };

    GetUploadTokenRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.vsdk_version != null && Object.hasOwnProperty.call(m, 'vsdk_version')) w.uint32(10).string(m.vsdk_version);
      if (m.token_type != null && Object.hasOwnProperty.call(m, 'token_type')) w.uint32(16).int32(m.token_type);
      return w;
    };

    GetUploadTokenRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetUploadTokenRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.vsdk_version = r.string();
            break;
          case 2:
            m.token_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetUploadTokenRequestBody;
  })();

  im_proto.GetUploadTokenResponseBody = (function () {
    function GetUploadTokenResponseBody(p) {
      this.hosts = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetUploadTokenResponseBody.prototype.access_key = '';
    GetUploadTokenResponseBody.prototype.hosts = $util.emptyArray;
    GetUploadTokenResponseBody.prototype.token = '';
    GetUploadTokenResponseBody.prototype.token_type = 1;
    GetUploadTokenResponseBody.prototype.secret_access_key = '';
    GetUploadTokenResponseBody.prototype.space_name = '';
    GetUploadTokenResponseBody.prototype.service_id = '';
    GetUploadTokenResponseBody.prototype.expire_time = '';
    GetUploadTokenResponseBody.prototype.current_time = '';

    GetUploadTokenResponseBody.create = function create(properties) {
      return new GetUploadTokenResponseBody(properties);
    };

    GetUploadTokenResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.access_key != null && Object.hasOwnProperty.call(m, 'access_key')) w.uint32(10).string(m.access_key);
      if (m.hosts != null && m.hosts.length) {
        for (var i = 0; i < m.hosts.length; ++i) w.uint32(18).string(m.hosts[i]);
      }
      if (m.token != null && Object.hasOwnProperty.call(m, 'token')) w.uint32(26).string(m.token);
      if (m.token_type != null && Object.hasOwnProperty.call(m, 'token_type')) w.uint32(32).int32(m.token_type);
      if (m.secret_access_key != null && Object.hasOwnProperty.call(m, 'secret_access_key'))
        w.uint32(42).string(m.secret_access_key);
      if (m.space_name != null && Object.hasOwnProperty.call(m, 'space_name')) w.uint32(50).string(m.space_name);
      if (m.service_id != null && Object.hasOwnProperty.call(m, 'service_id')) w.uint32(58).string(m.service_id);
      if (m.expire_time != null && Object.hasOwnProperty.call(m, 'expire_time')) w.uint32(66).string(m.expire_time);
      if (m.current_time != null && Object.hasOwnProperty.call(m, 'current_time')) w.uint32(74).string(m.current_time);
      return w;
    };

    GetUploadTokenResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetUploadTokenResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.access_key = r.string();
            break;
          case 2:
            if (!(m.hosts && m.hosts.length)) m.hosts = [];
            m.hosts.push(r.string());
            break;
          case 3:
            m.token = r.string();
            break;
          case 4:
            m.token_type = r.int32();
            break;
          case 5:
            m.secret_access_key = r.string();
            break;
          case 6:
            m.space_name = r.string();
            break;
          case 7:
            m.service_id = r.string();
            break;
          case 8:
            m.expire_time = r.string();
            break;
          case 9:
            m.current_time = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetUploadTokenResponseBody;
  })();

  im_proto.ImgOption = (function () {
    function ImgOption(p) {
      this.params = [];
      this.urls = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ImgOption.prototype.tplv = '';
    ImgOption.prototype.params = $util.emptyArray;
    ImgOption.prototype.format = '';
    ImgOption.prototype.urls = $util.emptyArray;

    ImgOption.create = function create(properties) {
      return new ImgOption(properties);
    };

    ImgOption.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.tplv != null && Object.hasOwnProperty.call(m, 'tplv')) w.uint32(10).string(m.tplv);
      if (m.params != null && m.params.length) {
        for (var i = 0; i < m.params.length; ++i) w.uint32(18).string(m.params[i]);
      }
      if (m.format != null && Object.hasOwnProperty.call(m, 'format')) w.uint32(26).string(m.format);
      if (m.urls != null && m.urls.length) {
        for (var i = 0; i < m.urls.length; ++i) w.uint32(802).string(m.urls[i]);
      }
      return w;
    };

    ImgOption.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ImgOption();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.tplv = r.string();
            break;
          case 2:
            if (!(m.params && m.params.length)) m.params = [];
            m.params.push(r.string());
            break;
          case 3:
            m.format = r.string();
            break;
          case 100:
            if (!(m.urls && m.urls.length)) m.urls = [];
            m.urls.push(r.string());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ImgOption;
  })();

  im_proto.VideoOption = (function () {
    function VideoOption(p) {
      this.urls = [];
      this.cover_urls = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    VideoOption.prototype.vid = '';
    VideoOption.prototype.cover_uri = '';
    VideoOption.prototype.urls = $util.emptyArray;
    VideoOption.prototype.cover_urls = $util.emptyArray;

    VideoOption.create = function create(properties) {
      return new VideoOption(properties);
    };

    VideoOption.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.vid != null && Object.hasOwnProperty.call(m, 'vid')) w.uint32(10).string(m.vid);
      if (m.cover_uri != null && Object.hasOwnProperty.call(m, 'cover_uri')) w.uint32(18).string(m.cover_uri);
      if (m.urls != null && m.urls.length) {
        for (var i = 0; i < m.urls.length; ++i) w.uint32(802).string(m.urls[i]);
      }
      if (m.cover_urls != null && m.cover_urls.length) {
        for (var i = 0; i < m.cover_urls.length; ++i) w.uint32(810).string(m.cover_urls[i]);
      }
      return w;
    };

    VideoOption.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.VideoOption();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.vid = r.string();
            break;
          case 2:
            m.cover_uri = r.string();
            break;
          case 100:
            if (!(m.urls && m.urls.length)) m.urls = [];
            m.urls.push(r.string());
            break;
          case 101:
            if (!(m.cover_urls && m.cover_urls.length)) m.cover_urls = [];
            m.cover_urls.push(r.string());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return VideoOption;
  })();

  im_proto.AudioOption = (function () {
    function AudioOption(p) {
      this.urls = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    AudioOption.prototype.vid = '';
    AudioOption.prototype.urls = $util.emptyArray;

    AudioOption.create = function create(properties) {
      return new AudioOption(properties);
    };

    AudioOption.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.vid != null && Object.hasOwnProperty.call(m, 'vid')) w.uint32(10).string(m.vid);
      if (m.urls != null && m.urls.length) {
        for (var i = 0; i < m.urls.length; ++i) w.uint32(802).string(m.urls[i]);
      }
      return w;
    };

    AudioOption.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.AudioOption();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.vid = r.string();
            break;
          case 100:
            if (!(m.urls && m.urls.length)) m.urls = [];
            m.urls.push(r.string());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return AudioOption;
  })();

  im_proto.FileOption = (function () {
    function FileOption(p) {
      this.urls = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    FileOption.prototype.urls = $util.emptyArray;

    FileOption.create = function create(properties) {
      return new FileOption(properties);
    };

    FileOption.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.urls != null && m.urls.length) {
        for (var i = 0; i < m.urls.length; ++i) w.uint32(802).string(m.urls[i]);
      }
      return w;
    };

    FileOption.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.FileOption();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 100:
            if (!(m.urls && m.urls.length)) m.urls = [];
            m.urls.push(r.string());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return FileOption;
  })();

  im_proto.GetMediaUrlsRequestBody = (function () {
    function GetMediaUrlsRequestBody(p) {
      this.img_options = [];
      this.video_options = [];
      this.audio_options = [];
      this.file_options = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMediaUrlsRequestBody.prototype.source_appid = 0;
    GetMediaUrlsRequestBody.prototype.uri = '';
    GetMediaUrlsRequestBody.prototype.media_type = 0;
    GetMediaUrlsRequestBody.prototype.encrypted = false;
    GetMediaUrlsRequestBody.prototype.img_options = $util.emptyArray;
    GetMediaUrlsRequestBody.prototype.video_options = $util.emptyArray;
    GetMediaUrlsRequestBody.prototype.audio_options = $util.emptyArray;
    GetMediaUrlsRequestBody.prototype.file_options = $util.emptyArray;
    GetMediaUrlsRequestBody.prototype.encrypted_uri = '';
    GetMediaUrlsRequestBody.prototype.read_url_from = 1;

    GetMediaUrlsRequestBody.create = function create(properties) {
      return new GetMediaUrlsRequestBody(properties);
    };

    GetMediaUrlsRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.source_appid != null && Object.hasOwnProperty.call(m, 'source_appid')) w.uint32(8).int32(m.source_appid);
      if (m.uri != null && Object.hasOwnProperty.call(m, 'uri')) w.uint32(18).string(m.uri);
      if (m.media_type != null && Object.hasOwnProperty.call(m, 'media_type')) w.uint32(24).int32(m.media_type);
      if (m.encrypted != null && Object.hasOwnProperty.call(m, 'encrypted')) w.uint32(32).bool(m.encrypted);
      if (m.img_options != null && m.img_options.length) {
        for (var i = 0; i < m.img_options.length; ++i)
          $root.im_proto.ImgOption.encode(m.img_options[i], w.uint32(42).fork()).ldelim();
      }
      if (m.video_options != null && m.video_options.length) {
        for (var i = 0; i < m.video_options.length; ++i)
          $root.im_proto.VideoOption.encode(m.video_options[i], w.uint32(50).fork()).ldelim();
      }
      if (m.audio_options != null && m.audio_options.length) {
        for (var i = 0; i < m.audio_options.length; ++i)
          $root.im_proto.AudioOption.encode(m.audio_options[i], w.uint32(58).fork()).ldelim();
      }
      if (m.file_options != null && m.file_options.length) {
        for (var i = 0; i < m.file_options.length; ++i)
          $root.im_proto.FileOption.encode(m.file_options[i], w.uint32(66).fork()).ldelim();
      }
      if (m.encrypted_uri != null && Object.hasOwnProperty.call(m, 'encrypted_uri'))
        w.uint32(74).string(m.encrypted_uri);
      if (m.read_url_from != null && Object.hasOwnProperty.call(m, 'read_url_from'))
        w.uint32(80).int32(m.read_url_from);
      return w;
    };

    GetMediaUrlsRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMediaUrlsRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.source_appid = r.int32();
            break;
          case 2:
            m.uri = r.string();
            break;
          case 3:
            m.media_type = r.int32();
            break;
          case 4:
            m.encrypted = r.bool();
            break;
          case 5:
            if (!(m.img_options && m.img_options.length)) m.img_options = [];
            m.img_options.push($root.im_proto.ImgOption.decode(r, r.uint32()));
            break;
          case 6:
            if (!(m.video_options && m.video_options.length)) m.video_options = [];
            m.video_options.push($root.im_proto.VideoOption.decode(r, r.uint32()));
            break;
          case 7:
            if (!(m.audio_options && m.audio_options.length)) m.audio_options = [];
            m.audio_options.push($root.im_proto.AudioOption.decode(r, r.uint32()));
            break;
          case 8:
            if (!(m.file_options && m.file_options.length)) m.file_options = [];
            m.file_options.push($root.im_proto.FileOption.decode(r, r.uint32()));
            break;
          case 9:
            m.encrypted_uri = r.string();
            break;
          case 10:
            m.read_url_from = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetMediaUrlsRequestBody;
  })();

  im_proto.GetMediaUrlsResponseBody = (function () {
    function GetMediaUrlsResponseBody(p) {
      this.img_options = [];
      this.video_options = [];
      this.audio_options = [];
      this.file_options = [];
      this.encrypted_urls = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMediaUrlsResponseBody.prototype.uri = '';
    GetMediaUrlsResponseBody.prototype.media_type = 0;
    GetMediaUrlsResponseBody.prototype.img_options = $util.emptyArray;
    GetMediaUrlsResponseBody.prototype.video_options = $util.emptyArray;
    GetMediaUrlsResponseBody.prototype.audio_options = $util.emptyArray;
    GetMediaUrlsResponseBody.prototype.file_options = $util.emptyArray;
    GetMediaUrlsResponseBody.prototype.encrypted_urls = $util.emptyArray;

    GetMediaUrlsResponseBody.create = function create(properties) {
      return new GetMediaUrlsResponseBody(properties);
    };

    GetMediaUrlsResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.uri != null && Object.hasOwnProperty.call(m, 'uri')) w.uint32(10).string(m.uri);
      if (m.media_type != null && Object.hasOwnProperty.call(m, 'media_type')) w.uint32(16).int32(m.media_type);
      if (m.img_options != null && m.img_options.length) {
        for (var i = 0; i < m.img_options.length; ++i)
          $root.im_proto.ImgOption.encode(m.img_options[i], w.uint32(26).fork()).ldelim();
      }
      if (m.video_options != null && m.video_options.length) {
        for (var i = 0; i < m.video_options.length; ++i)
          $root.im_proto.VideoOption.encode(m.video_options[i], w.uint32(34).fork()).ldelim();
      }
      if (m.audio_options != null && m.audio_options.length) {
        for (var i = 0; i < m.audio_options.length; ++i)
          $root.im_proto.AudioOption.encode(m.audio_options[i], w.uint32(42).fork()).ldelim();
      }
      if (m.file_options != null && m.file_options.length) {
        for (var i = 0; i < m.file_options.length; ++i)
          $root.im_proto.FileOption.encode(m.file_options[i], w.uint32(50).fork()).ldelim();
      }
      if (m.encrypted_urls != null && m.encrypted_urls.length) {
        for (var i = 0; i < m.encrypted_urls.length; ++i) w.uint32(58).string(m.encrypted_urls[i]);
      }
      return w;
    };

    GetMediaUrlsResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMediaUrlsResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.uri = r.string();
            break;
          case 2:
            m.media_type = r.int32();
            break;
          case 3:
            if (!(m.img_options && m.img_options.length)) m.img_options = [];
            m.img_options.push($root.im_proto.ImgOption.decode(r, r.uint32()));
            break;
          case 4:
            if (!(m.video_options && m.video_options.length)) m.video_options = [];
            m.video_options.push($root.im_proto.VideoOption.decode(r, r.uint32()));
            break;
          case 5:
            if (!(m.audio_options && m.audio_options.length)) m.audio_options = [];
            m.audio_options.push($root.im_proto.AudioOption.decode(r, r.uint32()));
            break;
          case 6:
            if (!(m.file_options && m.file_options.length)) m.file_options = [];
            m.file_options.push($root.im_proto.FileOption.decode(r, r.uint32()));
            break;
          case 7:
            if (!(m.encrypted_urls && m.encrypted_urls.length)) m.encrypted_urls = [];
            m.encrypted_urls.push(r.string());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetMediaUrlsResponseBody;
  })();

  im_proto.VcdConversation = (function () {
    function VcdConversation(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    VcdConversation.prototype.conversation_id = '';
    VcdConversation.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    VcdConversation.prototype.conversation_type = 0;
    VcdConversation.prototype.vcd_version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    VcdConversation.create = function create(properties) {
      return new VcdConversation(properties);
    };

    VcdConversation.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(16).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.vcd_version != null && Object.hasOwnProperty.call(m, 'vcd_version')) w.uint32(32).int64(m.vcd_version);
      return w;
    };

    VcdConversation.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.VcdConversation();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.vcd_version = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return VcdConversation;
  })();

  im_proto.VcdCleanRequestBody = (function () {
    function VcdCleanRequestBody(p) {
      this.local_conversations = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    VcdCleanRequestBody.prototype.local_conversations = $util.emptyArray;

    VcdCleanRequestBody.create = function create(properties) {
      return new VcdCleanRequestBody(properties);
    };

    VcdCleanRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.local_conversations != null && m.local_conversations.length) {
        for (var i = 0; i < m.local_conversations.length; ++i)
          $root.im_proto.VcdConversation.encode(m.local_conversations[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    VcdCleanRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.VcdCleanRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.local_conversations && m.local_conversations.length)) m.local_conversations = [];
            m.local_conversations.push($root.im_proto.VcdConversation.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return VcdCleanRequestBody;
  })();

  im_proto.VcdCleanResponseBody = (function () {
    function VcdCleanResponseBody(p) {
      this.server_conversations = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    VcdCleanResponseBody.prototype.server_conversations = $util.emptyArray;

    VcdCleanResponseBody.create = function create(properties) {
      return new VcdCleanResponseBody(properties);
    };

    VcdCleanResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.server_conversations != null && m.server_conversations.length) {
        for (var i = 0; i < m.server_conversations.length; ++i)
          $root.im_proto.VcdConversation.encode(m.server_conversations[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    VcdCleanResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.VcdCleanResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.server_conversations && m.server_conversations.length)) m.server_conversations = [];
            m.server_conversations.push($root.im_proto.VcdConversation.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return VcdCleanResponseBody;
  })();

  im_proto.GetTicketRequestBody = (function () {
    function GetTicketRequestBody(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetTicketRequestBody.prototype.ticket_type = 1;
    GetTicketRequestBody.prototype.conversation_type = 1;
    GetTicketRequestBody.prototype.to_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetTicketRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetTicketRequestBody.prototype.ext = $util.emptyObject;
    GetTicketRequestBody.prototype.customed_conversation_type = 0;

    GetTicketRequestBody.create = function create(properties) {
      return new GetTicketRequestBody(properties);
    };

    GetTicketRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.ticket_type != null && Object.hasOwnProperty.call(m, 'ticket_type')) w.uint32(8).int32(m.ticket_type);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.to_id != null && Object.hasOwnProperty.call(m, 'to_id')) w.uint32(32).int64(m.to_id);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(40).int64(m.conversation_short_id);
      if (m.customed_conversation_type != null && Object.hasOwnProperty.call(m, 'customed_conversation_type'))
        w.uint32(48).int32(m.customed_conversation_type);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(82).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    GetTicketRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetTicketRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.ticket_type = r.int32();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.to_id = r.int64();
            break;
          case 5:
            m.conversation_short_id = r.int64();
            break;
          case 10:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          case 6:
            m.customed_conversation_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetTicketRequestBody;
  })();

  im_proto.GetTicketResponseBody = (function () {
    function GetTicketResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetTicketResponseBody.prototype.ticket = '';

    GetTicketResponseBody.create = function create(properties) {
      return new GetTicketResponseBody(properties);
    };

    GetTicketResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.ticket != null && Object.hasOwnProperty.call(m, 'ticket')) w.uint32(10).string(m.ticket);
      return w;
    };

    GetTicketResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetTicketResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.ticket = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetTicketResponseBody;
  })();

  im_proto.GetUserConversationListRequestBody = (function () {
    function GetUserConversationListRequestBody(p) {
      this.include_multiple_roles = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetUserConversationListRequestBody.prototype.sort_type = 1;
    GetUserConversationListRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetUserConversationListRequestBody.prototype.con_type = 1;
    GetUserConversationListRequestBody.prototype.limit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetUserConversationListRequestBody.prototype.include_role = 0;
    GetUserConversationListRequestBody.prototype.exclude_role = 0;
    GetUserConversationListRequestBody.prototype.include_removed_group = false;
    GetUserConversationListRequestBody.prototype.with_cold = false;
    GetUserConversationListRequestBody.prototype.customed_con_type = 0;
    GetUserConversationListRequestBody.prototype.include_multiple_roles = $util.emptyArray;

    GetUserConversationListRequestBody.create = function create(properties) {
      return new GetUserConversationListRequestBody(properties);
    };

    GetUserConversationListRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.sort_type != null && Object.hasOwnProperty.call(m, 'sort_type')) w.uint32(8).int32(m.sort_type);
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(16).int64(m.cursor);
      if (m.con_type != null && Object.hasOwnProperty.call(m, 'con_type')) w.uint32(24).int32(m.con_type);
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(32).int64(m.limit);
      if (m.include_role != null && Object.hasOwnProperty.call(m, 'include_role')) w.uint32(40).int32(m.include_role);
      if (m.exclude_role != null && Object.hasOwnProperty.call(m, 'exclude_role')) w.uint32(48).int32(m.exclude_role);
      if (m.include_removed_group != null && Object.hasOwnProperty.call(m, 'include_removed_group'))
        w.uint32(56).bool(m.include_removed_group);
      if (m.with_cold != null && Object.hasOwnProperty.call(m, 'with_cold')) w.uint32(64).bool(m.with_cold);
      if (m.customed_con_type != null && Object.hasOwnProperty.call(m, 'customed_con_type'))
        w.uint32(72).int32(m.customed_con_type);
      if (m.include_multiple_roles != null && m.include_multiple_roles.length) {
        for (var i = 0; i < m.include_multiple_roles.length; ++i) w.uint32(80).int32(m.include_multiple_roles[i]);
      }
      return w;
    };

    GetUserConversationListRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetUserConversationListRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.sort_type = r.int32();
            break;
          case 2:
            m.cursor = r.int64();
            break;
          case 3:
            m.con_type = r.int32();
            break;
          case 4:
            m.limit = r.int64();
            break;
          case 5:
            m.include_role = r.int32();
            break;
          case 6:
            m.exclude_role = r.int32();
            break;
          case 7:
            m.include_removed_group = r.bool();
            break;
          case 8:
            m.with_cold = r.bool();
            break;
          case 9:
            m.customed_con_type = r.int32();
            break;
          case 10:
            if (!(m.include_multiple_roles && m.include_multiple_roles.length)) m.include_multiple_roles = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.include_multiple_roles.push(r.int32());
            } else m.include_multiple_roles.push(r.int32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetUserConversationListRequestBody;
  })();

  im_proto.GetUserConversationListResponseBody = (function () {
    function GetUserConversationListResponseBody(p) {
      this.list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetUserConversationListResponseBody.prototype.list = $util.emptyArray;
    GetUserConversationListResponseBody.prototype.has_more = false;
    GetUserConversationListResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    GetUserConversationListResponseBody.create = function create(properties) {
      return new GetUserConversationListResponseBody(properties);
    };

    GetUserConversationListResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.list != null && m.list.length) {
        for (var i = 0; i < m.list.length; ++i)
          $root.im_proto.ConversationInfoV2.encode(m.list[i], w.uint32(10).fork()).ldelim();
      }
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(16).bool(m.has_more);
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(24).int64(m.next_cursor);
      return w;
    };

    GetUserConversationListResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetUserConversationListResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.list && m.list.length)) m.list = [];
            m.list.push($root.im_proto.ConversationInfoV2.decode(r, r.uint32()));
            break;
          case 2:
            m.has_more = r.bool();
            break;
          case 3:
            m.next_cursor = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetUserConversationListResponseBody;
  })();

  im_proto.BroadcastSendMessageRequestBody = (function () {
    function BroadcastSendMessageRequestBody(p) {
      this.ext = {};
      this.mentioned_users = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BroadcastSendMessageRequestBody.prototype.conversation_id = '';
    BroadcastSendMessageRequestBody.prototype.conversation_type = 0;
    BroadcastSendMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BroadcastSendMessageRequestBody.prototype.content = '';
    BroadcastSendMessageRequestBody.prototype.ext = $util.emptyObject;
    BroadcastSendMessageRequestBody.prototype.message_type = 0;
    BroadcastSendMessageRequestBody.prototype.ticket = '';
    BroadcastSendMessageRequestBody.prototype.client_message_id = '';
    BroadcastSendMessageRequestBody.prototype.mentioned_users = $util.emptyArray;

    BroadcastSendMessageRequestBody.create = function create(properties) {
      return new BroadcastSendMessageRequestBody(properties);
    };

    BroadcastSendMessageRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.content != null && Object.hasOwnProperty.call(m, 'content')) w.uint32(34).string(m.content);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      if (m.message_type != null && Object.hasOwnProperty.call(m, 'message_type')) w.uint32(48).int32(m.message_type);
      if (m.ticket != null && Object.hasOwnProperty.call(m, 'ticket')) w.uint32(58).string(m.ticket);
      if (m.client_message_id != null && Object.hasOwnProperty.call(m, 'client_message_id'))
        w.uint32(66).string(m.client_message_id);
      if (m.mentioned_users != null && m.mentioned_users.length) {
        for (var i = 0; i < m.mentioned_users.length; ++i) w.uint32(72).int64(m.mentioned_users[i]);
      }
      return w;
    };

    BroadcastSendMessageRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BroadcastSendMessageRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.content = r.string();
            break;
          case 5:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          case 6:
            m.message_type = r.int32();
            break;
          case 7:
            m.ticket = r.string();
            break;
          case 8:
            m.client_message_id = r.string();
            break;
          case 9:
            if (!(m.mentioned_users && m.mentioned_users.length)) m.mentioned_users = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.mentioned_users.push(r.int64());
            } else m.mentioned_users.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BroadcastSendMessageRequestBody;
  })();

  im_proto.BroadcastSendMessageResponseBody = (function () {
    function BroadcastSendMessageResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BroadcastSendMessageResponseBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BroadcastSendMessageResponseBody.prototype.extra_info = '';
    BroadcastSendMessageResponseBody.prototype.status = 0;
    BroadcastSendMessageResponseBody.prototype.client_message_id = '';
    BroadcastSendMessageResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BroadcastSendMessageResponseBody.prototype.check_message = '';
    BroadcastSendMessageResponseBody.prototype.filtered_content = '';

    BroadcastSendMessageResponseBody.create = function create(properties) {
      return new BroadcastSendMessageResponseBody(properties);
    };

    BroadcastSendMessageResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.server_message_id != null && Object.hasOwnProperty.call(m, 'server_message_id'))
        w.uint32(8).int64(m.server_message_id);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(18).string(m.extra_info);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(24).int32(m.status);
      if (m.client_message_id != null && Object.hasOwnProperty.call(m, 'client_message_id'))
        w.uint32(34).string(m.client_message_id);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(40).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(50).string(m.check_message);
      if (m.filtered_content != null && Object.hasOwnProperty.call(m, 'filtered_content'))
        w.uint32(58).string(m.filtered_content);
      return w;
    };

    BroadcastSendMessageResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BroadcastSendMessageResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.server_message_id = r.int64();
            break;
          case 2:
            m.extra_info = r.string();
            break;
          case 3:
            m.status = r.int32();
            break;
          case 4:
            m.client_message_id = r.string();
            break;
          case 5:
            m.check_code = r.int64();
            break;
          case 6:
            m.check_message = r.string();
            break;
          case 7:
            m.filtered_content = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BroadcastSendMessageResponseBody;
  })();

  im_proto.BroadcastRecvMessageRequestBody = (function () {
    function BroadcastRecvMessageRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BroadcastRecvMessageRequestBody.prototype.conversation_id = '';
    BroadcastRecvMessageRequestBody.prototype.conversation_type = 0;
    BroadcastRecvMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BroadcastRecvMessageRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BroadcastRecvMessageRequestBody.prototype.limit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BroadcastRecvMessageRequestBody.prototype.reverse = false;
    BroadcastRecvMessageRequestBody.prototype.pull_type = 0;

    BroadcastRecvMessageRequestBody.create = function create(properties) {
      return new BroadcastRecvMessageRequestBody(properties);
    };

    BroadcastRecvMessageRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(32).int64(m.cursor);
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(40).int64(m.limit);
      if (m.reverse != null && Object.hasOwnProperty.call(m, 'reverse')) w.uint32(48).bool(m.reverse);
      if (m.pull_type != null && Object.hasOwnProperty.call(m, 'pull_type')) w.uint32(56).int32(m.pull_type);
      return w;
    };

    BroadcastRecvMessageRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BroadcastRecvMessageRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.cursor = r.int64();
            break;
          case 5:
            m.limit = r.int64();
            break;
          case 6:
            m.reverse = r.bool();
            break;
          case 7:
            m.pull_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BroadcastRecvMessageRequestBody;
  })();

  im_proto.BroadcastRecvMessageResponseBody = (function () {
    function BroadcastRecvMessageResponseBody(p) {
      this.messages = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BroadcastRecvMessageResponseBody.prototype.messages = $util.emptyArray;
    BroadcastRecvMessageResponseBody.prototype.has_more = false;
    BroadcastRecvMessageResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    BroadcastRecvMessageResponseBody.create = function create(properties) {
      return new BroadcastRecvMessageResponseBody(properties);
    };

    BroadcastRecvMessageResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(10).fork()).ldelim();
      }
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(16).bool(m.has_more);
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(24).int64(m.next_cursor);
      return w;
    };

    BroadcastRecvMessageResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BroadcastRecvMessageResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          case 2:
            m.has_more = r.bool();
            break;
          case 3:
            m.next_cursor = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BroadcastRecvMessageResponseBody;
  })();

  im_proto.ConversationRequest = (function () {
    function ConversationRequest(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationRequest.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationRequest.prototype.conversation_type = 0;

    ConversationRequest.create = function create(properties) {
      return new ConversationRequest(properties);
    };

    ConversationRequest.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(8).int64(m.conversation_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      return w;
    };

    ConversationRequest.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationRequest();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_short_id = r.int64();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationRequest;
  })();

  im_proto.BroadcastUserCounterRequestBody = (function () {
    function BroadcastUserCounterRequestBody(p) {
      this.conversations = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BroadcastUserCounterRequestBody.prototype.conversations = $util.emptyArray;

    BroadcastUserCounterRequestBody.create = function create(properties) {
      return new BroadcastUserCounterRequestBody(properties);
    };

    BroadcastUserCounterRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversations != null && m.conversations.length) {
        for (var i = 0; i < m.conversations.length; ++i)
          $root.im_proto.ConversationRequest.encode(m.conversations[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    BroadcastUserCounterRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BroadcastUserCounterRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conversations && m.conversations.length)) m.conversations = [];
            m.conversations.push($root.im_proto.ConversationRequest.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BroadcastUserCounterRequestBody;
  })();

  im_proto.BroadcastUserInfo = (function () {
    function BroadcastUserInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BroadcastUserInfo.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BroadcastUserInfo.prototype.counter = 0;
    BroadcastUserInfo.prototype.conversation_type = 0;

    BroadcastUserInfo.create = function create(properties) {
      return new BroadcastUserInfo(properties);
    };

    BroadcastUserInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(8).int64(m.conversation_short_id);
      if (m.counter != null && Object.hasOwnProperty.call(m, 'counter')) w.uint32(16).int32(m.counter);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      return w;
    };

    BroadcastUserInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BroadcastUserInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_short_id = r.int64();
            break;
          case 2:
            m.counter = r.int32();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BroadcastUserInfo;
  })();

  im_proto.BroadcastUserCounterResponseBody = (function () {
    function BroadcastUserCounterResponseBody(p) {
      this.infos = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BroadcastUserCounterResponseBody.prototype.infos = $util.emptyArray;

    BroadcastUserCounterResponseBody.create = function create(properties) {
      return new BroadcastUserCounterResponseBody(properties);
    };

    BroadcastUserCounterResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.infos != null && m.infos.length) {
        for (var i = 0; i < m.infos.length; ++i)
          $root.im_proto.BroadcastUserInfo.encode(m.infos[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    BroadcastUserCounterResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BroadcastUserCounterResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.infos && m.infos.length)) m.infos = [];
            m.infos.push($root.im_proto.BroadcastUserInfo.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BroadcastUserCounterResponseBody;
  })();

  im_proto.ClientACKRequestBody = (function () {
    function ClientACKRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ClientACKRequestBody.prototype.start_time_stamp = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ClientACKRequestBody.prototype.cmd = 0;
    ClientACKRequestBody.prototype.network_type = 0;
    ClientACKRequestBody.prototype.logid = '';
    ClientACKRequestBody.prototype.client_time_stamp = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ClientACKRequestBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ClientACKRequestBody.prototype.type = 0;

    ClientACKRequestBody.create = function create(properties) {
      return new ClientACKRequestBody(properties);
    };

    ClientACKRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.start_time_stamp);
      w.uint32(16).int32(m.cmd);
      if (m.network_type != null && Object.hasOwnProperty.call(m, 'network_type')) w.uint32(24).int32(m.network_type);
      if (m.logid != null && Object.hasOwnProperty.call(m, 'logid')) w.uint32(34).string(m.logid);
      if (m.client_time_stamp != null && Object.hasOwnProperty.call(m, 'client_time_stamp'))
        w.uint32(40).int64(m.client_time_stamp);
      if (m.server_message_id != null && Object.hasOwnProperty.call(m, 'server_message_id'))
        w.uint32(48).int64(m.server_message_id);
      w.uint32(56).int32(m.type);
      return w;
    };

    ClientACKRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ClientACKRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.start_time_stamp = r.int64();
            break;
          case 2:
            m.cmd = r.int32();
            break;
          case 3:
            m.network_type = r.int32();
            break;
          case 4:
            m.logid = r.string();
            break;
          case 5:
            m.client_time_stamp = r.int64();
            break;
          case 6:
            m.server_message_id = r.int64();
            break;
          case 7:
            m.type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('start_time_stamp'))
        throw $util.ProtocolError("missing required 'start_time_stamp'", { instance: m });
      if (!m.hasOwnProperty('cmd')) throw $util.ProtocolError("missing required 'cmd'", { instance: m });
      if (!m.hasOwnProperty('type')) throw $util.ProtocolError("missing required 'type'", { instance: m });
      return m;
    };

    return ClientACKRequestBody;
  })();

  im_proto.ClientBatchACKRequestBody = (function () {
    function ClientBatchACKRequestBody(p) {
      this.ack_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ClientBatchACKRequestBody.prototype.ack_list = $util.emptyArray;

    ClientBatchACKRequestBody.create = function create(properties) {
      return new ClientBatchACKRequestBody(properties);
    };

    ClientBatchACKRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.ack_list != null && m.ack_list.length) {
        for (var i = 0; i < m.ack_list.length; ++i)
          $root.im_proto.ClientACKRequestBody.encode(m.ack_list[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    ClientBatchACKRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ClientBatchACKRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.ack_list && m.ack_list.length)) m.ack_list = [];
            m.ack_list.push($root.im_proto.ClientACKRequestBody.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ClientBatchACKRequestBody;
  })();

  im_proto.ClientACKResponseBody = (function () {
    function ClientACKResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ClientACKResponseBody.create = function create(properties) {
      return new ClientACKResponseBody(properties);
    };

    ClientACKResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    ClientACKResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ClientACKResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ClientACKResponseBody;
  })();

  im_proto.ClientBatchACKResponseBody = (function () {
    function ClientBatchACKResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ClientBatchACKResponseBody.create = function create(properties) {
      return new ClientBatchACKResponseBody(properties);
    };

    ClientBatchACKResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    ClientBatchACKResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ClientBatchACKResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ClientBatchACKResponseBody;
  })();

  im_proto.VoipInfo = (function () {
    function VoipInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    VoipInfo.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    VoipInfo.prototype.device_id = '';
    VoipInfo.prototype.channel_id = '';
    VoipInfo.prototype.token = '';
    VoipInfo.prototype.status = 0;
    VoipInfo.prototype.caller_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    VoipInfo.prototype.created_time_ms = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    VoipInfo.prototype.updated_time_ms = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    VoipInfo.prototype.con_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    VoipInfo.prototype.v_type = 0;
    VoipInfo.prototype.srv_msg_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    VoipInfo.create = function create(properties) {
      return new VoipInfo(properties);
    };

    VoipInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(8).int64(m.user_id);
      if (m.device_id != null && Object.hasOwnProperty.call(m, 'device_id')) w.uint32(18).string(m.device_id);
      if (m.channel_id != null && Object.hasOwnProperty.call(m, 'channel_id')) w.uint32(26).string(m.channel_id);
      if (m.token != null && Object.hasOwnProperty.call(m, 'token')) w.uint32(34).string(m.token);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(40).int32(m.status);
      if (m.caller_id != null && Object.hasOwnProperty.call(m, 'caller_id')) w.uint32(48).int64(m.caller_id);
      if (m.created_time_ms != null && Object.hasOwnProperty.call(m, 'created_time_ms'))
        w.uint32(56).int64(m.created_time_ms);
      if (m.updated_time_ms != null && Object.hasOwnProperty.call(m, 'updated_time_ms'))
        w.uint32(64).int64(m.updated_time_ms);
      if (m.con_short_id != null && Object.hasOwnProperty.call(m, 'con_short_id')) w.uint32(72).int64(m.con_short_id);
      if (m.v_type != null && Object.hasOwnProperty.call(m, 'v_type')) w.uint32(80).int32(m.v_type);
      if (m.srv_msg_id != null && Object.hasOwnProperty.call(m, 'srv_msg_id')) w.uint32(88).int64(m.srv_msg_id);
      return w;
    };

    VoipInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.VoipInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.int64();
            break;
          case 2:
            m.device_id = r.string();
            break;
          case 3:
            m.channel_id = r.string();
            break;
          case 4:
            m.token = r.string();
            break;
          case 5:
            m.status = r.int32();
            break;
          case 6:
            m.caller_id = r.int64();
            break;
          case 7:
            m.created_time_ms = r.int64();
            break;
          case 8:
            m.updated_time_ms = r.int64();
            break;
          case 9:
            m.con_short_id = r.int64();
            break;
          case 10:
            m.v_type = r.int32();
            break;
          case 11:
            m.srv_msg_id = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return VoipInfo;
  })();

  im_proto.CreateVoipRequestBody = (function () {
    function CreateVoipRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    CreateVoipRequestBody.prototype.idempotent_id = '';
    CreateVoipRequestBody.prototype.v_type = 0;
    CreateVoipRequestBody.prototype.con_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CreateVoipRequestBody.prototype.srv_msg_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CreateVoipRequestBody.prototype.ref_channel_id = '';
    CreateVoipRequestBody.prototype.voip_mode = 0;

    CreateVoipRequestBody.create = function create(properties) {
      return new CreateVoipRequestBody(properties);
    };

    CreateVoipRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.idempotent_id != null && Object.hasOwnProperty.call(m, 'idempotent_id'))
        w.uint32(10).string(m.idempotent_id);
      if (m.v_type != null && Object.hasOwnProperty.call(m, 'v_type')) w.uint32(16).int32(m.v_type);
      if (m.con_short_id != null && Object.hasOwnProperty.call(m, 'con_short_id')) w.uint32(24).int64(m.con_short_id);
      if (m.srv_msg_id != null && Object.hasOwnProperty.call(m, 'srv_msg_id')) w.uint32(32).int64(m.srv_msg_id);
      if (m.ref_channel_id != null && Object.hasOwnProperty.call(m, 'ref_channel_id'))
        w.uint32(42).string(m.ref_channel_id);
      if (m.voip_mode != null && Object.hasOwnProperty.call(m, 'voip_mode')) w.uint32(48).int32(m.voip_mode);
      return w;
    };

    CreateVoipRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.CreateVoipRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.idempotent_id = r.string();
            break;
          case 2:
            m.v_type = r.int32();
            break;
          case 3:
            m.con_short_id = r.int64();
            break;
          case 4:
            m.srv_msg_id = r.int64();
            break;
          case 5:
            m.ref_channel_id = r.string();
            break;
          case 6:
            m.voip_mode = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return CreateVoipRequestBody;
  })();

  im_proto.CreateVoipResponseBody = (function () {
    function CreateVoipResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    CreateVoipResponseBody.prototype.info = null;
    CreateVoipResponseBody.prototype.status_code = 0;
    CreateVoipResponseBody.prototype.voip_mode = 0;

    CreateVoipResponseBody.create = function create(properties) {
      return new CreateVoipResponseBody(properties);
    };

    CreateVoipResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.info != null && Object.hasOwnProperty.call(m, 'info'))
        $root.im_proto.VoipInfo.encode(m.info, w.uint32(10).fork()).ldelim();
      if (m.status_code != null && Object.hasOwnProperty.call(m, 'status_code')) w.uint32(16).int32(m.status_code);
      if (m.voip_mode != null && Object.hasOwnProperty.call(m, 'voip_mode')) w.uint32(24).int32(m.voip_mode);
      return w;
    };

    CreateVoipResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.CreateVoipResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.info = $root.im_proto.VoipInfo.decode(r, r.uint32());
            break;
          case 2:
            m.status_code = r.int32();
            break;
          case 3:
            m.voip_mode = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return CreateVoipResponseBody;
  })();

  im_proto.CallVoipRequestBody = (function () {
    function CallVoipRequestBody(p) {
      this.callee_ids = [];
      this.ext = {};
      this.ref_channel_users = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    CallVoipRequestBody.prototype.callee_ids = $util.emptyArray;
    CallVoipRequestBody.prototype.channel_id = '';
    CallVoipRequestBody.prototype.v_type = 0;
    CallVoipRequestBody.prototype.ext = $util.emptyObject;
    CallVoipRequestBody.prototype.ref_channel_users = $util.emptyArray;
    CallVoipRequestBody.prototype.con_id = '';

    CallVoipRequestBody.create = function create(properties) {
      return new CallVoipRequestBody(properties);
    };

    CallVoipRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.callee_ids != null && m.callee_ids.length) {
        for (var i = 0; i < m.callee_ids.length; ++i) w.uint32(8).int64(m.callee_ids[i]);
      }
      if (m.channel_id != null && Object.hasOwnProperty.call(m, 'channel_id')) w.uint32(18).string(m.channel_id);
      if (m.v_type != null && Object.hasOwnProperty.call(m, 'v_type')) w.uint32(24).int32(m.v_type);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      if (m.ref_channel_users != null && m.ref_channel_users.length) {
        for (var i = 0; i < m.ref_channel_users.length; ++i) w.uint32(40).int64(m.ref_channel_users[i]);
      }
      if (m.con_id != null && Object.hasOwnProperty.call(m, 'con_id')) w.uint32(50).string(m.con_id);
      return w;
    };

    CallVoipRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.CallVoipRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.callee_ids && m.callee_ids.length)) m.callee_ids = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.callee_ids.push(r.int64());
            } else m.callee_ids.push(r.int64());
            break;
          case 2:
            m.channel_id = r.string();
            break;
          case 3:
            m.v_type = r.int32();
            break;
          case 4:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          case 5:
            if (!(m.ref_channel_users && m.ref_channel_users.length)) m.ref_channel_users = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.ref_channel_users.push(r.int64());
            } else m.ref_channel_users.push(r.int64());
            break;
          case 6:
            m.con_id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return CallVoipRequestBody;
  })();

  im_proto.CallVoipResponseBody = (function () {
    function CallVoipResponseBody(p) {
      this.callee_ids = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    CallVoipResponseBody.prototype.info = null;
    CallVoipResponseBody.prototype.callee_ids = $util.emptyArray;
    CallVoipResponseBody.prototype.status = 0;
    CallVoipResponseBody.prototype.extra_info = '';
    CallVoipResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    CallVoipResponseBody.prototype.check_message = '';
    CallVoipResponseBody.prototype.ref_channel_id = '';
    CallVoipResponseBody.prototype.voip_mode = 0;

    CallVoipResponseBody.create = function create(properties) {
      return new CallVoipResponseBody(properties);
    };

    CallVoipResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.info != null && Object.hasOwnProperty.call(m, 'info'))
        $root.im_proto.VoipInfo.encode(m.info, w.uint32(10).fork()).ldelim();
      if (m.callee_ids != null && m.callee_ids.length) {
        for (var i = 0; i < m.callee_ids.length; ++i) w.uint32(16).int64(m.callee_ids[i]);
      }
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(24).int32(m.status);
      if (m.extra_info != null && Object.hasOwnProperty.call(m, 'extra_info')) w.uint32(34).string(m.extra_info);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(40).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(50).string(m.check_message);
      if (m.ref_channel_id != null && Object.hasOwnProperty.call(m, 'ref_channel_id'))
        w.uint32(58).string(m.ref_channel_id);
      if (m.voip_mode != null && Object.hasOwnProperty.call(m, 'voip_mode')) w.uint32(64).int32(m.voip_mode);
      return w;
    };

    CallVoipResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.CallVoipResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.info = $root.im_proto.VoipInfo.decode(r, r.uint32());
            break;
          case 2:
            if (!(m.callee_ids && m.callee_ids.length)) m.callee_ids = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.callee_ids.push(r.int64());
            } else m.callee_ids.push(r.int64());
            break;
          case 3:
            m.status = r.int32();
            break;
          case 4:
            m.extra_info = r.string();
            break;
          case 5:
            m.check_code = r.int64();
            break;
          case 6:
            m.check_message = r.string();
            break;
          case 7:
            m.ref_channel_id = r.string();
            break;
          case 8:
            m.voip_mode = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return CallVoipResponseBody;
  })();

  im_proto.UpdateVoipRequestBody = (function () {
    function UpdateVoipRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    UpdateVoipRequestBody.prototype.channel_id = '';
    UpdateVoipRequestBody.prototype.status = 0;
    UpdateVoipRequestBody.prototype.v_type = 0;

    UpdateVoipRequestBody.create = function create(properties) {
      return new UpdateVoipRequestBody(properties);
    };

    UpdateVoipRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.channel_id != null && Object.hasOwnProperty.call(m, 'channel_id')) w.uint32(10).string(m.channel_id);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.v_type != null && Object.hasOwnProperty.call(m, 'v_type')) w.uint32(24).int32(m.v_type);
      return w;
    };

    UpdateVoipRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.UpdateVoipRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.channel_id = r.string();
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.v_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UpdateVoipRequestBody;
  })();

  im_proto.UpdateVoipResponseBody = (function () {
    function UpdateVoipResponseBody(p) {
      this.callees = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    UpdateVoipResponseBody.prototype.info = null;
    UpdateVoipResponseBody.prototype.status_code = 0;
    UpdateVoipResponseBody.prototype.voip_mode = 0;
    UpdateVoipResponseBody.prototype.callees = $util.emptyArray;

    UpdateVoipResponseBody.create = function create(properties) {
      return new UpdateVoipResponseBody(properties);
    };

    UpdateVoipResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.info != null && Object.hasOwnProperty.call(m, 'info'))
        $root.im_proto.VoipInfo.encode(m.info, w.uint32(10).fork()).ldelim();
      if (m.status_code != null && Object.hasOwnProperty.call(m, 'status_code')) w.uint32(16).int32(m.status_code);
      if (m.voip_mode != null && Object.hasOwnProperty.call(m, 'voip_mode')) w.uint32(24).int32(m.voip_mode);
      if (m.callees != null && m.callees.length) {
        for (var i = 0; i < m.callees.length; ++i) w.uint32(32).int64(m.callees[i]);
      }
      return w;
    };

    UpdateVoipResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.UpdateVoipResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.info = $root.im_proto.VoipInfo.decode(r, r.uint32());
            break;
          case 2:
            m.status_code = r.int32();
            break;
          case 3:
            m.voip_mode = r.int32();
            break;
          case 4:
            if (!(m.callees && m.callees.length)) m.callees = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.callees.push(r.int64());
            } else m.callees.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UpdateVoipResponseBody;
  })();

  im_proto.JoinVoipRequestBody = (function () {
    function JoinVoipRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    JoinVoipRequestBody.prototype.con_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    JoinVoipRequestBody.prototype.channel_id = '';

    JoinVoipRequestBody.create = function create(properties) {
      return new JoinVoipRequestBody(properties);
    };

    JoinVoipRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.con_short_id != null && Object.hasOwnProperty.call(m, 'con_short_id')) w.uint32(8).int64(m.con_short_id);
      if (m.channel_id != null && Object.hasOwnProperty.call(m, 'channel_id')) w.uint32(18).string(m.channel_id);
      return w;
    };

    JoinVoipRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.JoinVoipRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.con_short_id = r.int64();
            break;
          case 2:
            m.channel_id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return JoinVoipRequestBody;
  })();

  im_proto.JoinVoipResponseBody = (function () {
    function JoinVoipResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    JoinVoipResponseBody.prototype.info = null;
    JoinVoipResponseBody.prototype.status = 0;
    JoinVoipResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    JoinVoipResponseBody.prototype.check_message = '';

    JoinVoipResponseBody.create = function create(properties) {
      return new JoinVoipResponseBody(properties);
    };

    JoinVoipResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.info != null && Object.hasOwnProperty.call(m, 'info'))
        $root.im_proto.VoipInfo.encode(m.info, w.uint32(10).fork()).ldelim();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(24).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(34).string(m.check_message);
      return w;
    };

    JoinVoipResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.JoinVoipResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.info = $root.im_proto.VoipInfo.decode(r, r.uint32());
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.check_code = r.int64();
            break;
          case 4:
            m.check_message = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return JoinVoipResponseBody;
  })();

  im_proto.ChannelHeartBeatRequestBody = (function () {
    function ChannelHeartBeatRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ChannelHeartBeatRequestBody.prototype.channel_id = '';

    ChannelHeartBeatRequestBody.create = function create(properties) {
      return new ChannelHeartBeatRequestBody(properties);
    };

    ChannelHeartBeatRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.channel_id != null && Object.hasOwnProperty.call(m, 'channel_id')) w.uint32(10).string(m.channel_id);
      return w;
    };

    ChannelHeartBeatRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ChannelHeartBeatRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.channel_id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ChannelHeartBeatRequestBody;
  })();

  im_proto.ChannelHeartBeatResponseBody = (function () {
    function ChannelHeartBeatResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ChannelHeartBeatResponseBody.create = function create(properties) {
      return new ChannelHeartBeatResponseBody(properties);
    };

    ChannelHeartBeatResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    ChannelHeartBeatResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ChannelHeartBeatResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ChannelHeartBeatResponseBody;
  })();

  im_proto.Profile = (function () {
    function Profile(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    Profile.prototype.nick_name = '';
    Profile.prototype.protrait = '';
    Profile.prototype.basic_ext_info = '';
    Profile.prototype.detail_ext_info = '';
    Profile.prototype.uid = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    Profile.create = function create(properties) {
      return new Profile(properties);
    };

    Profile.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.nick_name != null && Object.hasOwnProperty.call(m, 'nick_name')) w.uint32(10).string(m.nick_name);
      if (m.protrait != null && Object.hasOwnProperty.call(m, 'protrait')) w.uint32(18).string(m.protrait);
      if (m.basic_ext_info != null && Object.hasOwnProperty.call(m, 'basic_ext_info'))
        w.uint32(26).string(m.basic_ext_info);
      if (m.detail_ext_info != null && Object.hasOwnProperty.call(m, 'detail_ext_info'))
        w.uint32(34).string(m.detail_ext_info);
      if (m.uid != null && Object.hasOwnProperty.call(m, 'uid')) w.uint32(40).int64(m.uid);
      return w;
    };

    Profile.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.Profile();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.nick_name = r.string();
            break;
          case 2:
            m.protrait = r.string();
            break;
          case 3:
            m.basic_ext_info = r.string();
            break;
          case 4:
            m.detail_ext_info = r.string();
            break;
          case 5:
            m.uid = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Profile;
  })();

  im_proto.ProfileGetInfoRequestBody = (function () {
    function ProfileGetInfoRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ProfileGetInfoRequestBody.prototype.userid = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ProfileGetInfoRequestBody.prototype.from_source = false;

    ProfileGetInfoRequestBody.create = function create(properties) {
      return new ProfileGetInfoRequestBody(properties);
    };

    ProfileGetInfoRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.userid);
      if (m.from_source != null && Object.hasOwnProperty.call(m, 'from_source')) w.uint32(16).bool(m.from_source);
      return w;
    };

    ProfileGetInfoRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ProfileGetInfoRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.userid = r.int64();
            break;
          case 2:
            m.from_source = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('userid')) throw $util.ProtocolError("missing required 'userid'", { instance: m });
      return m;
    };

    return ProfileGetInfoRequestBody;
  })();

  im_proto.ProfileGetInfoResponseBody = (function () {
    function ProfileGetInfoResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ProfileGetInfoResponseBody.prototype.profile = null;

    ProfileGetInfoResponseBody.create = function create(properties) {
      return new ProfileGetInfoResponseBody(properties);
    };

    ProfileGetInfoResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.profile != null && Object.hasOwnProperty.call(m, 'profile'))
        $root.im_proto.Profile.encode(m.profile, w.uint32(10).fork()).ldelim();
      return w;
    };

    ProfileGetInfoResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ProfileGetInfoResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.profile = $root.im_proto.Profile.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ProfileGetInfoResponseBody;
  })();

  im_proto.ClientMetric = (function () {
    function ClientMetric(p) {
      this.tags = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ClientMetric.prototype.metric_type = 0;
    ClientMetric.prototype.k = '';
    ClientMetric.prototype.v = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ClientMetric.prototype.tags = $util.emptyObject;

    ClientMetric.create = function create(properties) {
      return new ClientMetric(properties);
    };

    ClientMetric.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.metric_type != null && Object.hasOwnProperty.call(m, 'metric_type')) w.uint32(8).int32(m.metric_type);
      if (m.k != null && Object.hasOwnProperty.call(m, 'k')) w.uint32(18).string(m.k);
      if (m.v != null && Object.hasOwnProperty.call(m, 'v')) w.uint32(24).int64(m.v);
      if (m.tags != null && Object.hasOwnProperty.call(m, 'tags')) {
        for (var ks = Object.keys(m.tags), i = 0; i < ks.length; ++i) {
          w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.tags[ks[i]]).ldelim();
        }
      }
      return w;
    };

    ClientMetric.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ClientMetric(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.metric_type = r.int32();
            break;
          case 2:
            m.k = r.string();
            break;
          case 3:
            m.v = r.int64();
            break;
          case 4:
            if (m.tags === $util.emptyObject) m.tags = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.tags[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ClientMetric;
  })();

  im_proto.ReportClientMetricsRequestBody = (function () {
    function ReportClientMetricsRequestBody(p) {
      this.report_metrics_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ReportClientMetricsRequestBody.prototype.report_metrics_list = $util.emptyArray;

    ReportClientMetricsRequestBody.create = function create(properties) {
      return new ReportClientMetricsRequestBody(properties);
    };

    ReportClientMetricsRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.report_metrics_list != null && m.report_metrics_list.length) {
        for (var i = 0; i < m.report_metrics_list.length; ++i)
          $root.im_proto.ClientMetric.encode(m.report_metrics_list[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    ReportClientMetricsRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ReportClientMetricsRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.report_metrics_list && m.report_metrics_list.length)) m.report_metrics_list = [];
            m.report_metrics_list.push($root.im_proto.ClientMetric.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ReportClientMetricsRequestBody;
  })();

  im_proto.ReportClientMetricsResponseBody = (function () {
    function ReportClientMetricsResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ReportClientMetricsResponseBody.create = function create(properties) {
      return new ReportClientMetricsResponseBody(properties);
    };

    ReportClientMetricsResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    ReportClientMetricsResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ReportClientMetricsResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ReportClientMetricsResponseBody;
  })();

  im_proto.ModifyMessageExtRequestBody = (function () {
    function ModifyMessageExtRequestBody(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ModifyMessageExtRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ModifyMessageExtRequestBody.prototype.message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ModifyMessageExtRequestBody.prototype.ticket = '';
    ModifyMessageExtRequestBody.prototype.ext = $util.emptyObject;

    ModifyMessageExtRequestBody.create = function create(properties) {
      return new ModifyMessageExtRequestBody(properties);
    };

    ModifyMessageExtRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.conversation_short_id);
      w.uint32(16).int64(m.message_id);
      w.uint32(26).string(m.ticket);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    ModifyMessageExtRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ModifyMessageExtRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_short_id = r.int64();
            break;
          case 2:
            m.message_id = r.int64();
            break;
          case 3:
            m.ticket = r.string();
            break;
          case 4:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('conversation_short_id'))
        throw $util.ProtocolError("missing required 'conversation_short_id'", { instance: m });
      if (!m.hasOwnProperty('message_id')) throw $util.ProtocolError("missing required 'message_id'", { instance: m });
      if (!m.hasOwnProperty('ticket')) throw $util.ProtocolError("missing required 'ticket'", { instance: m });
      return m;
    };

    return ModifyMessageExtRequestBody;
  })();

  im_proto.ModifyMessageExtResponseBody = (function () {
    function ModifyMessageExtResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ModifyMessageExtResponseBody.create = function create(properties) {
      return new ModifyMessageExtResponseBody(properties);
    };

    ModifyMessageExtResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    ModifyMessageExtResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ModifyMessageExtResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ModifyMessageExtResponseBody;
  })();

  im_proto.ConversationApplyInfo = (function () {
    function ConversationApplyInfo(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationApplyInfo.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationApplyInfo.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationApplyInfo.prototype.conversation_type = 0;
    ConversationApplyInfo.prototype.apply_status = 1;
    ConversationApplyInfo.prototype.apply_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationApplyInfo.prototype.create_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationApplyInfo.prototype.modify_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationApplyInfo.prototype.modify_user = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationApplyInfo.prototype.sec_uid = '';
    ConversationApplyInfo.prototype.invite_user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationApplyInfo.prototype.sec_invite_uid = '';
    ConversationApplyInfo.prototype.ext = $util.emptyObject;
    ConversationApplyInfo.prototype.apply_reason = '';

    ConversationApplyInfo.create = function create(properties) {
      return new ConversationApplyInfo(properties);
    };

    ConversationApplyInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(8).int64(m.user_id);
      if (m.conv_short_id != null && Object.hasOwnProperty.call(m, 'conv_short_id'))
        w.uint32(16).int64(m.conv_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      if (m.apply_status != null && Object.hasOwnProperty.call(m, 'apply_status')) w.uint32(32).int32(m.apply_status);
      if (m.apply_id != null && Object.hasOwnProperty.call(m, 'apply_id')) w.uint32(40).int64(m.apply_id);
      if (m.create_time != null && Object.hasOwnProperty.call(m, 'create_time')) w.uint32(48).int64(m.create_time);
      if (m.modify_time != null && Object.hasOwnProperty.call(m, 'modify_time')) w.uint32(56).int64(m.modify_time);
      if (m.modify_user != null && Object.hasOwnProperty.call(m, 'modify_user')) w.uint32(64).int64(m.modify_user);
      if (m.sec_uid != null && Object.hasOwnProperty.call(m, 'sec_uid')) w.uint32(74).string(m.sec_uid);
      if (m.invite_user_id != null && Object.hasOwnProperty.call(m, 'invite_user_id'))
        w.uint32(80).int64(m.invite_user_id);
      if (m.sec_invite_uid != null && Object.hasOwnProperty.call(m, 'sec_invite_uid'))
        w.uint32(90).string(m.sec_invite_uid);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(98).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      if (m.apply_reason != null && Object.hasOwnProperty.call(m, 'apply_reason')) w.uint32(106).string(m.apply_reason);
      return w;
    };

    ConversationApplyInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationApplyInfo(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.int64();
            break;
          case 2:
            m.conv_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          case 4:
            m.apply_status = r.int32();
            break;
          case 5:
            m.apply_id = r.int64();
            break;
          case 6:
            m.create_time = r.int64();
            break;
          case 7:
            m.modify_time = r.int64();
            break;
          case 8:
            m.modify_user = r.int64();
            break;
          case 9:
            m.sec_uid = r.string();
            break;
          case 10:
            m.invite_user_id = r.int64();
            break;
          case 11:
            m.sec_invite_uid = r.string();
            break;
          case 12:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          case 13:
            m.apply_reason = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationApplyInfo;
  })();

  im_proto.GetConversationAuditSwitchRequestBody = (function () {
    function GetConversationAuditSwitchRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationAuditSwitchRequestBody.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetConversationAuditSwitchRequestBody.prototype.conversation_type = 0;

    GetConversationAuditSwitchRequestBody.create = function create(properties) {
      return new GetConversationAuditSwitchRequestBody(properties);
    };

    GetConversationAuditSwitchRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conv_short_id != null && Object.hasOwnProperty.call(m, 'conv_short_id')) w.uint32(8).int64(m.conv_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      return w;
    };

    GetConversationAuditSwitchRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationAuditSwitchRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conv_short_id = r.int64();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationAuditSwitchRequestBody;
  })();

  im_proto.GetConversationAuditSwitchResponseBody = (function () {
    function GetConversationAuditSwitchResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationAuditSwitchResponseBody.prototype.switch_status = false;

    GetConversationAuditSwitchResponseBody.create = function create(properties) {
      return new GetConversationAuditSwitchResponseBody(properties);
    };

    GetConversationAuditSwitchResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.switch_status != null && Object.hasOwnProperty.call(m, 'switch_status')) w.uint32(8).bool(m.switch_status);
      return w;
    };

    GetConversationAuditSwitchResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationAuditSwitchResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.switch_status = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationAuditSwitchResponseBody;
  })();

  im_proto.UpdateConversationAuditSwitchRequestBody = (function () {
    function UpdateConversationAuditSwitchRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    UpdateConversationAuditSwitchRequestBody.prototype.conv_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    UpdateConversationAuditSwitchRequestBody.prototype.conversation_type = 0;
    UpdateConversationAuditSwitchRequestBody.prototype.switch_status = false;

    UpdateConversationAuditSwitchRequestBody.create = function create(properties) {
      return new UpdateConversationAuditSwitchRequestBody(properties);
    };

    UpdateConversationAuditSwitchRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conv_short_id != null && Object.hasOwnProperty.call(m, 'conv_short_id')) w.uint32(8).int64(m.conv_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.switch_status != null && Object.hasOwnProperty.call(m, 'switch_status')) w.uint32(24).bool(m.switch_status);
      return w;
    };

    UpdateConversationAuditSwitchRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.UpdateConversationAuditSwitchRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conv_short_id = r.int64();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.switch_status = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UpdateConversationAuditSwitchRequestBody;
  })();

  im_proto.UpdateConversationAuditSwitchResponseBody = (function () {
    function UpdateConversationAuditSwitchResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    UpdateConversationAuditSwitchResponseBody.prototype.switch_status = false;
    UpdateConversationAuditSwitchResponseBody.prototype.status = 0;
    UpdateConversationAuditSwitchResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    UpdateConversationAuditSwitchResponseBody.prototype.check_message = '';

    UpdateConversationAuditSwitchResponseBody.create = function create(properties) {
      return new UpdateConversationAuditSwitchResponseBody(properties);
    };

    UpdateConversationAuditSwitchResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.switch_status != null && Object.hasOwnProperty.call(m, 'switch_status')) w.uint32(8).bool(m.switch_status);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(24).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(34).string(m.check_message);
      return w;
    };

    UpdateConversationAuditSwitchResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.UpdateConversationAuditSwitchResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.switch_status = r.bool();
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.check_code = r.int64();
            break;
          case 4:
            m.check_message = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UpdateConversationAuditSwitchResponseBody;
  })();

  im_proto.SendConversationApplyRequestBody = (function () {
    function SendConversationApplyRequestBody(p) {
      this.bizExt = {};
      this.invited_user_ids = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SendConversationApplyRequestBody.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SendConversationApplyRequestBody.prototype.conversation_type = 0;
    SendConversationApplyRequestBody.prototype.bizExt = $util.emptyObject;
    SendConversationApplyRequestBody.prototype.invite_user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SendConversationApplyRequestBody.prototype.invited_user_ids = $util.emptyArray;
    SendConversationApplyRequestBody.prototype.apply_reason = '';

    SendConversationApplyRequestBody.create = function create(properties) {
      return new SendConversationApplyRequestBody(properties);
    };

    SendConversationApplyRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conv_short_id != null && Object.hasOwnProperty.call(m, 'conv_short_id')) w.uint32(8).int64(m.conv_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.bizExt != null && Object.hasOwnProperty.call(m, 'bizExt')) {
        for (var ks = Object.keys(m.bizExt), i = 0; i < ks.length; ++i) {
          w.uint32(26).fork().uint32(10).string(ks[i]).uint32(18).string(m.bizExt[ks[i]]).ldelim();
        }
      }
      if (m.invite_user_id != null && Object.hasOwnProperty.call(m, 'invite_user_id'))
        w.uint32(32).int64(m.invite_user_id);
      if (m.invited_user_ids != null && m.invited_user_ids.length) {
        for (var i = 0; i < m.invited_user_ids.length; ++i) w.uint32(40).int64(m.invited_user_ids[i]);
      }
      if (m.apply_reason != null && Object.hasOwnProperty.call(m, 'apply_reason')) w.uint32(50).string(m.apply_reason);
      return w;
    };

    SendConversationApplyRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SendConversationApplyRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conv_short_id = r.int64();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            if (m.bizExt === $util.emptyObject) m.bizExt = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.bizExt[k] = value;
            break;
          case 4:
            m.invite_user_id = r.int64();
            break;
          case 5:
            if (!(m.invited_user_ids && m.invited_user_ids.length)) m.invited_user_ids = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.invited_user_ids.push(r.int64());
            } else m.invited_user_ids.push(r.int64());
            break;
          case 6:
            m.apply_reason = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SendConversationApplyRequestBody;
  })();

  im_proto.SendConversationApplyResponseBody = (function () {
    function SendConversationApplyResponseBody(p) {
      this.success_users = [];
      this.failed_users = [];
      this.exist_users = [];
      this.biz_ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SendConversationApplyResponseBody.prototype.status = 0;
    SendConversationApplyResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SendConversationApplyResponseBody.prototype.check_message = '';
    SendConversationApplyResponseBody.prototype.success_users = $util.emptyArray;
    SendConversationApplyResponseBody.prototype.failed_users = $util.emptyArray;
    SendConversationApplyResponseBody.prototype.exist_users = $util.emptyArray;
    SendConversationApplyResponseBody.prototype.biz_ext = $util.emptyObject;

    SendConversationApplyResponseBody.create = function create(properties) {
      return new SendConversationApplyResponseBody(properties);
    };

    SendConversationApplyResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(8).int32(m.status);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(16).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(26).string(m.check_message);
      if (m.success_users != null && m.success_users.length) {
        for (var i = 0; i < m.success_users.length; ++i) w.uint32(32).int64(m.success_users[i]);
      }
      if (m.failed_users != null && m.failed_users.length) {
        for (var i = 0; i < m.failed_users.length; ++i) w.uint32(40).int64(m.failed_users[i]);
      }
      if (m.exist_users != null && m.exist_users.length) {
        for (var i = 0; i < m.exist_users.length; ++i) w.uint32(48).int64(m.exist_users[i]);
      }
      if (m.biz_ext != null && Object.hasOwnProperty.call(m, 'biz_ext')) {
        for (var ks = Object.keys(m.biz_ext), i = 0; i < ks.length; ++i) {
          w.uint32(58).fork().uint32(10).string(ks[i]).uint32(18).string(m.biz_ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    SendConversationApplyResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SendConversationApplyResponseBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.status = r.int32();
            break;
          case 2:
            m.check_code = r.int64();
            break;
          case 3:
            m.check_message = r.string();
            break;
          case 4:
            if (!(m.success_users && m.success_users.length)) m.success_users = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.success_users.push(r.int64());
            } else m.success_users.push(r.int64());
            break;
          case 5:
            if (!(m.failed_users && m.failed_users.length)) m.failed_users = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.failed_users.push(r.int64());
            } else m.failed_users.push(r.int64());
            break;
          case 6:
            if (!(m.exist_users && m.exist_users.length)) m.exist_users = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.exist_users.push(r.int64());
            } else m.exist_users.push(r.int64());
            break;
          case 7:
            if (m.biz_ext === $util.emptyObject) m.biz_ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.biz_ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SendConversationApplyResponseBody;
  })();

  im_proto.AckConversationApplyRequestBody = (function () {
    function AckConversationApplyRequestBody(p) {
      this.bizExt = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    AckConversationApplyRequestBody.prototype.apply_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AckConversationApplyRequestBody.prototype.apply_status = 1;
    AckConversationApplyRequestBody.prototype.bizExt = $util.emptyObject;

    AckConversationApplyRequestBody.create = function create(properties) {
      return new AckConversationApplyRequestBody(properties);
    };

    AckConversationApplyRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.apply_id != null && Object.hasOwnProperty.call(m, 'apply_id')) w.uint32(8).int64(m.apply_id);
      if (m.apply_status != null && Object.hasOwnProperty.call(m, 'apply_status')) w.uint32(16).int32(m.apply_status);
      if (m.bizExt != null && Object.hasOwnProperty.call(m, 'bizExt')) {
        for (var ks = Object.keys(m.bizExt), i = 0; i < ks.length; ++i) {
          w.uint32(26).fork().uint32(10).string(ks[i]).uint32(18).string(m.bizExt[ks[i]]).ldelim();
        }
      }
      return w;
    };

    AckConversationApplyRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.AckConversationApplyRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.apply_id = r.int64();
            break;
          case 2:
            m.apply_status = r.int32();
            break;
          case 3:
            if (m.bizExt === $util.emptyObject) m.bizExt = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.bizExt[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return AckConversationApplyRequestBody;
  })();

  im_proto.AckConversationApplyResponseBody = (function () {
    function AckConversationApplyResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    AckConversationApplyResponseBody.prototype.apply_info = null;
    AckConversationApplyResponseBody.prototype.status = 0;
    AckConversationApplyResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    AckConversationApplyResponseBody.prototype.check_message = '';

    AckConversationApplyResponseBody.create = function create(properties) {
      return new AckConversationApplyResponseBody(properties);
    };

    AckConversationApplyResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.apply_info != null && Object.hasOwnProperty.call(m, 'apply_info'))
        $root.im_proto.ConversationApplyInfo.encode(m.apply_info, w.uint32(10).fork()).ldelim();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(16).int32(m.status);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(24).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(34).string(m.check_message);
      return w;
    };

    AckConversationApplyResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.AckConversationApplyResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.apply_info = $root.im_proto.ConversationApplyInfo.decode(r, r.uint32());
            break;
          case 2:
            m.status = r.int32();
            break;
          case 3:
            m.check_code = r.int64();
            break;
          case 4:
            m.check_message = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return AckConversationApplyResponseBody;
  })();

  im_proto.GetConversationApplyRequestBody = (function () {
    function GetConversationApplyRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationApplyRequestBody.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetConversationApplyRequestBody.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetConversationApplyRequestBody.prototype.conversation_type = 0;

    GetConversationApplyRequestBody.create = function create(properties) {
      return new GetConversationApplyRequestBody(properties);
    };

    GetConversationApplyRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(8).int64(m.user_id);
      if (m.conv_short_id != null && Object.hasOwnProperty.call(m, 'conv_short_id'))
        w.uint32(16).int64(m.conv_short_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(24).int32(m.conversation_type);
      return w;
    };

    GetConversationApplyRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationApplyRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.int64();
            break;
          case 2:
            m.conv_short_id = r.int64();
            break;
          case 3:
            m.conversation_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationApplyRequestBody;
  })();

  im_proto.GetConversationApplyResponseBody = (function () {
    function GetConversationApplyResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationApplyResponseBody.prototype.apply_info = null;

    GetConversationApplyResponseBody.create = function create(properties) {
      return new GetConversationApplyResponseBody(properties);
    };

    GetConversationApplyResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.apply_info != null && Object.hasOwnProperty.call(m, 'apply_info'))
        $root.im_proto.ConversationApplyInfo.encode(m.apply_info, w.uint32(10).fork()).ldelim();
      return w;
    };

    GetConversationApplyResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationApplyResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.apply_info = $root.im_proto.ConversationApplyInfo.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationApplyResponseBody;
  })();

  im_proto.GetConversationAuditListRequestBody = (function () {
    function GetConversationAuditListRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationAuditListRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetConversationAuditListRequestBody.prototype.limit = 0;
    GetConversationAuditListRequestBody.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetConversationAuditListRequestBody.prototype.no_clear_unread = false;

    GetConversationAuditListRequestBody.create = function create(properties) {
      return new GetConversationAuditListRequestBody(properties);
    };

    GetConversationAuditListRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(8).int64(m.cursor);
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(16).int32(m.limit);
      if (m.conv_short_id != null && Object.hasOwnProperty.call(m, 'conv_short_id'))
        w.uint32(24).int64(m.conv_short_id);
      if (m.no_clear_unread != null && Object.hasOwnProperty.call(m, 'no_clear_unread'))
        w.uint32(32).bool(m.no_clear_unread);
      return w;
    };

    GetConversationAuditListRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationAuditListRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cursor = r.int64();
            break;
          case 2:
            m.limit = r.int32();
            break;
          case 3:
            m.conv_short_id = r.int64();
            break;
          case 4:
            m.no_clear_unread = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationAuditListRequestBody;
  })();

  im_proto.GetConversationAuditListResponseBody = (function () {
    function GetConversationAuditListResponseBody(p) {
      this.apply_info_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationAuditListResponseBody.prototype.apply_info_list = $util.emptyArray;
    GetConversationAuditListResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetConversationAuditListResponseBody.prototype.has_more = false;

    GetConversationAuditListResponseBody.create = function create(properties) {
      return new GetConversationAuditListResponseBody(properties);
    };

    GetConversationAuditListResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.apply_info_list != null && m.apply_info_list.length) {
        for (var i = 0; i < m.apply_info_list.length; ++i)
          $root.im_proto.ConversationApplyInfo.encode(m.apply_info_list[i], w.uint32(10).fork()).ldelim();
      }
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(16).int64(m.next_cursor);
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(24).bool(m.has_more);
      return w;
    };

    GetConversationAuditListResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationAuditListResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.apply_info_list && m.apply_info_list.length)) m.apply_info_list = [];
            m.apply_info_list.push($root.im_proto.ConversationApplyInfo.decode(r, r.uint32()));
            break;
          case 2:
            m.next_cursor = r.int64();
            break;
          case 3:
            m.has_more = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationAuditListResponseBody;
  })();

  im_proto.GetConversationAuditUnreadRequestBody = (function () {
    function GetConversationAuditUnreadRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationAuditUnreadRequestBody.create = function create(properties) {
      return new GetConversationAuditUnreadRequestBody(properties);
    };

    GetConversationAuditUnreadRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    GetConversationAuditUnreadRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationAuditUnreadRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationAuditUnreadRequestBody;
  })();

  im_proto.GetConversationAuditUnreadResponseBody = (function () {
    function GetConversationAuditUnreadResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationAuditUnreadResponseBody.prototype.unread_count = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetConversationAuditUnreadResponseBody.prototype.last_apply_info = null;

    GetConversationAuditUnreadResponseBody.create = function create(properties) {
      return new GetConversationAuditUnreadResponseBody(properties);
    };

    GetConversationAuditUnreadResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.unread_count != null && Object.hasOwnProperty.call(m, 'unread_count')) w.uint32(8).int64(m.unread_count);
      if (m.last_apply_info != null && Object.hasOwnProperty.call(m, 'last_apply_info'))
        $root.im_proto.ConversationApplyInfo.encode(m.last_apply_info, w.uint32(18).fork()).ldelim();
      return w;
    };

    GetConversationAuditUnreadResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationAuditUnreadResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.unread_count = r.int64();
            break;
          case 2:
            m.last_apply_info = $root.im_proto.ConversationApplyInfo.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationAuditUnreadResponseBody;
  })();

  im_proto.BatchGetConversationAuditUnreadRequestBody = (function () {
    function BatchGetConversationAuditUnreadRequestBody(p) {
      this.conv_short_id = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BatchGetConversationAuditUnreadRequestBody.prototype.conv_short_id = $util.emptyArray;

    BatchGetConversationAuditUnreadRequestBody.create = function create(properties) {
      return new BatchGetConversationAuditUnreadRequestBody(properties);
    };

    BatchGetConversationAuditUnreadRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conv_short_id != null && m.conv_short_id.length) {
        for (var i = 0; i < m.conv_short_id.length; ++i) w.uint32(8).int64(m.conv_short_id[i]);
      }
      return w;
    };

    BatchGetConversationAuditUnreadRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BatchGetConversationAuditUnreadRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conv_short_id && m.conv_short_id.length)) m.conv_short_id = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.conv_short_id.push(r.int64());
            } else m.conv_short_id.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BatchGetConversationAuditUnreadRequestBody;
  })();

  im_proto.BatchGetConversationAuditUnreadResponseBody = (function () {
    function BatchGetConversationAuditUnreadResponseBody(p) {
      this.unread_count = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BatchGetConversationAuditUnreadResponseBody.prototype.unread_count = $util.emptyObject;

    BatchGetConversationAuditUnreadResponseBody.create = function create(properties) {
      return new BatchGetConversationAuditUnreadResponseBody(properties);
    };

    BatchGetConversationAuditUnreadResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.unread_count != null && Object.hasOwnProperty.call(m, 'unread_count')) {
        for (var ks = Object.keys(m.unread_count), i = 0; i < ks.length; ++i) {
          w.uint32(10).fork().uint32(8).int64(ks[i]).uint32(16).int64(m.unread_count[ks[i]]).ldelim();
        }
      }
      return w;
    };

    BatchGetConversationAuditUnreadResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BatchGetConversationAuditUnreadResponseBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (m.unread_count === $util.emptyObject) m.unread_count = {};
            var c2 = r.uint32() + r.pos;
            k = 0;
            value = 0;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.int64();
                  break;
                case 2:
                  value = r.int64();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.unread_count[typeof k === 'object' ? $util.longToHash(k) : k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BatchGetConversationAuditUnreadResponseBody;
  })();

  im_proto.ClearConversationAuditUnreadRequestBody = (function () {
    function ClearConversationAuditUnreadRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ClearConversationAuditUnreadRequestBody.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    ClearConversationAuditUnreadRequestBody.create = function create(properties) {
      return new ClearConversationAuditUnreadRequestBody(properties);
    };

    ClearConversationAuditUnreadRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conv_short_id != null && Object.hasOwnProperty.call(m, 'conv_short_id')) w.uint32(8).int64(m.conv_short_id);
      return w;
    };

    ClearConversationAuditUnreadRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ClearConversationAuditUnreadRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conv_short_id = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ClearConversationAuditUnreadRequestBody;
  })();

  im_proto.ClearConversationAuditUnreadResponseBody = (function () {
    function ClearConversationAuditUnreadResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ClearConversationAuditUnreadResponseBody.create = function create(properties) {
      return new ClearConversationAuditUnreadResponseBody(properties);
    };

    ClearConversationAuditUnreadResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    ClearConversationAuditUnreadResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ClearConversationAuditUnreadResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ClearConversationAuditUnreadResponseBody;
  })();

  im_proto.MessageInfo = (function () {
    function MessageInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessageInfo.prototype.status = 0;
    MessageInfo.prototype.body = null;

    MessageInfo.create = function create(properties) {
      return new MessageInfo(properties);
    };

    MessageInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(8).int32(m.status);
      if (m.body != null && Object.hasOwnProperty.call(m, 'body'))
        $root.im_proto.MessageBody.encode(m.body, w.uint32(18).fork()).ldelim();
      return w;
    };

    MessageInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessageInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.status = r.int32();
            break;
          case 2:
            m.body = $root.im_proto.MessageBody.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MessageInfo;
  })();

  im_proto.GetMessageInfoByIndexV2RequestBody = (function () {
    function GetMessageInfoByIndexV2RequestBody(p) {
      this.index_in_conversation_v2 = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMessageInfoByIndexV2RequestBody.prototype.conversation_id = '';
    GetMessageInfoByIndexV2RequestBody.prototype.conversation_type = 0;
    GetMessageInfoByIndexV2RequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    GetMessageInfoByIndexV2RequestBody.prototype.index_in_conversation_v2 = $util.emptyArray;

    GetMessageInfoByIndexV2RequestBody.create = function create(properties) {
      return new GetMessageInfoByIndexV2RequestBody(properties);
    };

    GetMessageInfoByIndexV2RequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.index_in_conversation_v2 != null && m.index_in_conversation_v2.length) {
        for (var i = 0; i < m.index_in_conversation_v2.length; ++i) w.uint32(32).int64(m.index_in_conversation_v2[i]);
      }
      return w;
    };

    GetMessageInfoByIndexV2RequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMessageInfoByIndexV2RequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            if (!(m.index_in_conversation_v2 && m.index_in_conversation_v2.length)) m.index_in_conversation_v2 = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.index_in_conversation_v2.push(r.int64());
            } else m.index_in_conversation_v2.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetMessageInfoByIndexV2RequestBody;
  })();

  im_proto.GetMessageInfoByIndexV2ResponseBody = (function () {
    function GetMessageInfoByIndexV2ResponseBody(p) {
      this.infos = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMessageInfoByIndexV2ResponseBody.prototype.infos = $util.emptyObject;

    GetMessageInfoByIndexV2ResponseBody.create = function create(properties) {
      return new GetMessageInfoByIndexV2ResponseBody(properties);
    };

    GetMessageInfoByIndexV2ResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.infos != null && Object.hasOwnProperty.call(m, 'infos')) {
        for (var ks = Object.keys(m.infos), i = 0; i < ks.length; ++i) {
          w.uint32(10).fork().uint32(8).int64(ks[i]);
          $root.im_proto.MessageInfo.encode(m.infos[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
        }
      }
      return w;
    };

    GetMessageInfoByIndexV2ResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMessageInfoByIndexV2ResponseBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (m.infos === $util.emptyObject) m.infos = {};
            var c2 = r.uint32() + r.pos;
            k = 0;
            value = null;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.int64();
                  break;
                case 2:
                  value = $root.im_proto.MessageInfo.decode(r, r.uint32());
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.infos[typeof k === 'object' ? $util.longToHash(k) : k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetMessageInfoByIndexV2ResponseBody;
  })();

  im_proto.GetMessageByIdRequestBody = (function () {
    function GetMessageByIdRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMessageByIdRequestBody.prototype.conversation_id = '';
    GetMessageByIdRequestBody.prototype.conversation_type = 0;
    GetMessageByIdRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetMessageByIdRequestBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    GetMessageByIdRequestBody.create = function create(properties) {
      return new GetMessageByIdRequestBody(properties);
    };

    GetMessageByIdRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.server_message_id != null && Object.hasOwnProperty.call(m, 'server_message_id'))
        w.uint32(32).int64(m.server_message_id);
      return w;
    };

    GetMessageByIdRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMessageByIdRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.server_message_id = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetMessageByIdRequestBody;
  })();

  im_proto.GetMessageByIdResponseBody = (function () {
    function GetMessageByIdResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMessageByIdResponseBody.prototype.msg_info = null;

    GetMessageByIdResponseBody.create = function create(properties) {
      return new GetMessageByIdResponseBody(properties);
    };

    GetMessageByIdResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.msg_info != null && Object.hasOwnProperty.call(m, 'msg_info'))
        $root.im_proto.MessageInfo.encode(m.msg_info, w.uint32(10).fork()).ldelim();
      return w;
    };

    GetMessageByIdResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMessageByIdResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.msg_info = $root.im_proto.MessageInfo.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetMessageByIdResponseBody;
  })();

  im_proto.PreviewerMessagesInConversationRequestBody = (function () {
    function PreviewerMessagesInConversationRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    PreviewerMessagesInConversationRequestBody.prototype.conversation_id = '';
    PreviewerMessagesInConversationRequestBody.prototype.conversation_type = 0;
    PreviewerMessagesInConversationRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    PreviewerMessagesInConversationRequestBody.prototype.direction = 1;
    PreviewerMessagesInConversationRequestBody.prototype.anchor_index = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    PreviewerMessagesInConversationRequestBody.prototype.limit = 50;

    PreviewerMessagesInConversationRequestBody.create = function create(properties) {
      return new PreviewerMessagesInConversationRequestBody(properties);
    };

    PreviewerMessagesInConversationRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      if (m.direction != null && Object.hasOwnProperty.call(m, 'direction')) w.uint32(32).int32(m.direction);
      if (m.anchor_index != null && Object.hasOwnProperty.call(m, 'anchor_index')) w.uint32(40).int64(m.anchor_index);
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(48).int32(m.limit);
      return w;
    };

    PreviewerMessagesInConversationRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.PreviewerMessagesInConversationRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.direction = r.int32();
            break;
          case 5:
            m.anchor_index = r.int64();
            break;
          case 6:
            m.limit = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PreviewerMessagesInConversationRequestBody;
  })();

  im_proto.PreviewerMessagesInConversationResponseBody = (function () {
    function PreviewerMessagesInConversationResponseBody(p) {
      this.messages = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    PreviewerMessagesInConversationResponseBody.prototype.messages = $util.emptyArray;
    PreviewerMessagesInConversationResponseBody.prototype.next_cursor = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    PreviewerMessagesInConversationResponseBody.prototype.has_more = false;
    PreviewerMessagesInConversationResponseBody.prototype.status = 0;
    PreviewerMessagesInConversationResponseBody.prototype.check_code = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    PreviewerMessagesInConversationResponseBody.prototype.check_message = '';

    PreviewerMessagesInConversationResponseBody.create = function create(properties) {
      return new PreviewerMessagesInConversationResponseBody(properties);
    };

    PreviewerMessagesInConversationResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(10).fork()).ldelim();
      }
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(16).int64(m.next_cursor);
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(24).bool(m.has_more);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(32).int32(m.status);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(40).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(50).string(m.check_message);
      return w;
    };

    PreviewerMessagesInConversationResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.PreviewerMessagesInConversationResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          case 2:
            m.next_cursor = r.int64();
            break;
          case 3:
            m.has_more = r.bool();
            break;
          case 4:
            m.status = r.int32();
            break;
          case 5:
            m.check_code = r.int64();
            break;
          case 6:
            m.check_message = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PreviewerMessagesInConversationResponseBody;
  })();

  im_proto.ConversationRecentMessage = (function () {
    function ConversationRecentMessage(p) {
      this.messages = [];
      this.ext_messages = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationRecentMessage.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationRecentMessage.prototype.messages = $util.emptyArray;
    ConversationRecentMessage.prototype.version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationRecentMessage.prototype.badge_count = 0;
    ConversationRecentMessage.prototype.conversation_id = '';
    ConversationRecentMessage.prototype.ext_messages = $util.emptyArray;

    ConversationRecentMessage.create = function create(properties) {
      return new ConversationRecentMessage(properties);
    };

    ConversationRecentMessage.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.conversation_short_id);
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(18).fork()).ldelim();
      }
      w.uint32(24).int64(m.version);
      if (m.badge_count != null && Object.hasOwnProperty.call(m, 'badge_count')) w.uint32(32).int32(m.badge_count);
      w.uint32(42).string(m.conversation_id);
      if (m.ext_messages != null && m.ext_messages.length) {
        for (var i = 0; i < m.ext_messages.length; ++i)
          $root.im_proto.MessageBody.encode(m.ext_messages[i], w.uint32(50).fork()).ldelim();
      }
      return w;
    };

    ConversationRecentMessage.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationRecentMessage();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_short_id = r.int64();
            break;
          case 2:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          case 3:
            m.version = r.int64();
            break;
          case 4:
            m.badge_count = r.int32();
            break;
          case 5:
            m.conversation_id = r.string();
            break;
          case 6:
            if (!(m.ext_messages && m.ext_messages.length)) m.ext_messages = [];
            m.ext_messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('conversation_short_id'))
        throw $util.ProtocolError("missing required 'conversation_short_id'", { instance: m });
      if (!m.hasOwnProperty('version')) throw $util.ProtocolError("missing required 'version'", { instance: m });
      if (!m.hasOwnProperty('conversation_id'))
        throw $util.ProtocolError("missing required 'conversation_id'", { instance: m });
      return m;
    };

    return ConversationRecentMessage;
  })();

  im_proto.GetRecentMessageReqBody = (function () {
    function GetRecentMessageReqBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetRecentMessageReqBody.prototype.conversation_version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetRecentMessageReqBody.prototype.source = '';
    GetRecentMessageReqBody.prototype.new_user = 0;

    GetRecentMessageReqBody.create = function create(properties) {
      return new GetRecentMessageReqBody(properties);
    };

    GetRecentMessageReqBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.conversation_version);
      w.uint32(18).string(m.source);
      if (m.new_user != null && Object.hasOwnProperty.call(m, 'new_user')) w.uint32(24).int32(m.new_user);
      return w;
    };

    GetRecentMessageReqBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetRecentMessageReqBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_version = r.int64();
            break;
          case 2:
            m.source = r.string();
            break;
          case 3:
            m.new_user = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('conversation_version'))
        throw $util.ProtocolError("missing required 'conversation_version'", { instance: m });
      if (!m.hasOwnProperty('source')) throw $util.ProtocolError("missing required 'source'", { instance: m });
      return m;
    };

    return GetRecentMessageReqBody;
  })();

  im_proto.GetCmdMessageReqBody = (function () {
    function GetCmdMessageReqBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetCmdMessageReqBody.prototype.cmd_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetCmdMessageReqBody.prototype.source = '';
    GetCmdMessageReqBody.prototype.new_user = 0;

    GetCmdMessageReqBody.create = function create(properties) {
      return new GetCmdMessageReqBody(properties);
    };

    GetCmdMessageReqBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.cmd_index);
      w.uint32(18).string(m.source);
      if (m.new_user != null && Object.hasOwnProperty.call(m, 'new_user')) w.uint32(24).int32(m.new_user);
      return w;
    };

    GetCmdMessageReqBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetCmdMessageReqBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cmd_index = r.int64();
            break;
          case 2:
            m.source = r.string();
            break;
          case 3:
            m.new_user = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('cmd_index')) throw $util.ProtocolError("missing required 'cmd_index'", { instance: m });
      if (!m.hasOwnProperty('source')) throw $util.ProtocolError("missing required 'source'", { instance: m });
      return m;
    };

    return GetCmdMessageReqBody;
  })();

  im_proto.GetRecentMessageRespBody = (function () {
    function GetRecentMessageRespBody(p) {
      this.messages = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetRecentMessageRespBody.prototype.next_conversation_version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetRecentMessageRespBody.prototype.messages = $util.emptyArray;
    GetRecentMessageRespBody.prototype.has_more = false;

    GetRecentMessageRespBody.create = function create(properties) {
      return new GetRecentMessageRespBody(properties);
    };

    GetRecentMessageRespBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.next_conversation_version);
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.ConversationRecentMessage.encode(m.messages[i], w.uint32(18).fork()).ldelim();
      }
      w.uint32(24).bool(m.has_more);
      return w;
    };

    GetRecentMessageRespBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetRecentMessageRespBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.next_conversation_version = r.int64();
            break;
          case 2:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.ConversationRecentMessage.decode(r, r.uint32()));
            break;
          case 3:
            m.has_more = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('next_conversation_version'))
        throw $util.ProtocolError("missing required 'next_conversation_version'", { instance: m });
      if (!m.hasOwnProperty('has_more')) throw $util.ProtocolError("missing required 'has_more'", { instance: m });
      return m;
    };

    return GetRecentMessageRespBody;
  })();

  im_proto.GetCmdMessageRespBody = (function () {
    function GetCmdMessageRespBody(p) {
      this.messages = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetCmdMessageRespBody.prototype.messages = $util.emptyArray;
    GetCmdMessageRespBody.prototype.has_more = false;
    GetCmdMessageRespBody.prototype.next_cmd_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetCmdMessageRespBody.prototype.next_user_message_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    GetCmdMessageRespBody.create = function create(properties) {
      return new GetCmdMessageRespBody(properties);
    };

    GetCmdMessageRespBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(10).fork()).ldelim();
      }
      w.uint32(16).bool(m.has_more);
      if (m.next_cmd_index != null && Object.hasOwnProperty.call(m, 'next_cmd_index'))
        w.uint32(24).int64(m.next_cmd_index);
      if (m.next_user_message_cursor != null && Object.hasOwnProperty.call(m, 'next_user_message_cursor'))
        w.uint32(32).int64(m.next_user_message_cursor);
      return w;
    };

    GetCmdMessageRespBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetCmdMessageRespBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          case 2:
            m.has_more = r.bool();
            break;
          case 3:
            m.next_cmd_index = r.int64();
            break;
          case 4:
            m.next_user_message_cursor = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('has_more')) throw $util.ProtocolError("missing required 'has_more'", { instance: m });
      return m;
    };

    return GetCmdMessageRespBody;
  })();

  im_proto.GetMessageInfoByIndexV2RangeRequestBody = (function () {
    function GetMessageInfoByIndexV2RangeRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMessageInfoByIndexV2RangeRequestBody.prototype.conversation_id = '';
    GetMessageInfoByIndexV2RangeRequestBody.prototype.conversation_type = 0;
    GetMessageInfoByIndexV2RangeRequestBody.prototype.conversation_short_id = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    GetMessageInfoByIndexV2RangeRequestBody.prototype.min_index_in_conversation_v2 = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    GetMessageInfoByIndexV2RangeRequestBody.prototype.max_index_in_conversation_v2 = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    GetMessageInfoByIndexV2RangeRequestBody.prototype.direction = 1;

    GetMessageInfoByIndexV2RangeRequestBody.create = function create(properties) {
      return new GetMessageInfoByIndexV2RangeRequestBody(properties);
    };

    GetMessageInfoByIndexV2RangeRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_id != null && Object.hasOwnProperty.call(m, 'conversation_id'))
        w.uint32(10).string(m.conversation_id);
      if (m.conversation_type != null && Object.hasOwnProperty.call(m, 'conversation_type'))
        w.uint32(16).int32(m.conversation_type);
      if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, 'conversation_short_id'))
        w.uint32(24).int64(m.conversation_short_id);
      w.uint32(32).int64(m.min_index_in_conversation_v2);
      w.uint32(40).int64(m.max_index_in_conversation_v2);
      if (m.direction != null && Object.hasOwnProperty.call(m, 'direction')) w.uint32(48).int32(m.direction);
      return w;
    };

    GetMessageInfoByIndexV2RangeRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMessageInfoByIndexV2RangeRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_id = r.string();
            break;
          case 2:
            m.conversation_type = r.int32();
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.min_index_in_conversation_v2 = r.int64();
            break;
          case 5:
            m.max_index_in_conversation_v2 = r.int64();
            break;
          case 6:
            m.direction = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('min_index_in_conversation_v2'))
        throw $util.ProtocolError("missing required 'min_index_in_conversation_v2'", { instance: m });
      if (!m.hasOwnProperty('max_index_in_conversation_v2'))
        throw $util.ProtocolError("missing required 'max_index_in_conversation_v2'", { instance: m });
      return m;
    };

    return GetMessageInfoByIndexV2RangeRequestBody;
  })();

  im_proto.GetMessageInfoByIndexV2RangeResponseBody = (function () {
    function GetMessageInfoByIndexV2RangeResponseBody(p) {
      this.infos = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMessageInfoByIndexV2RangeResponseBody.prototype.infos = $util.emptyArray;
    GetMessageInfoByIndexV2RangeResponseBody.prototype.next_index_in_conversation_v2 = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    GetMessageInfoByIndexV2RangeResponseBody.prototype.has_more = false;

    GetMessageInfoByIndexV2RangeResponseBody.create = function create(properties) {
      return new GetMessageInfoByIndexV2RangeResponseBody(properties);
    };

    GetMessageInfoByIndexV2RangeResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.infos != null && m.infos.length) {
        for (var i = 0; i < m.infos.length; ++i)
          $root.im_proto.MessageInfo.encode(m.infos[i], w.uint32(10).fork()).ldelim();
      }
      if (m.next_index_in_conversation_v2 != null && Object.hasOwnProperty.call(m, 'next_index_in_conversation_v2'))
        w.uint32(16).int64(m.next_index_in_conversation_v2);
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(24).bool(m.has_more);
      return w;
    };

    GetMessageInfoByIndexV2RangeResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMessageInfoByIndexV2RangeResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.infos && m.infos.length)) m.infos = [];
            m.infos.push($root.im_proto.MessageInfo.decode(r, r.uint32()));
            break;
          case 2:
            m.next_index_in_conversation_v2 = r.int64();
            break;
          case 3:
            m.has_more = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetMessageInfoByIndexV2RangeResponseBody;
  })();

  im_proto.MessageByInitRequestBody = (function () {
    function MessageByInitRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessageByInitRequestBody.prototype.version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    MessageByInitRequestBody.create = function create(properties) {
      return new MessageByInitRequestBody(properties);
    };

    MessageByInitRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.version != null && Object.hasOwnProperty.call(m, 'version')) w.uint32(8).int64(m.version);
      return w;
    };

    MessageByInitRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessageByInitRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.version = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MessageByInitRequestBody;
  })();

  im_proto.MessageByInitResponseBody = (function () {
    function MessageByInitResponseBody(p) {
      this.messages = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessageByInitResponseBody.prototype.messages = $util.emptyArray;
    MessageByInitResponseBody.prototype.has_more = false;
    MessageByInitResponseBody.prototype.next_init_version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessageByInitResponseBody.prototype.version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessageByInitResponseBody.prototype.user_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MessageByInitResponseBody.prototype.cmd_index = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    MessageByInitResponseBody.create = function create(properties) {
      return new MessageByInitResponseBody(properties);
    };

    MessageByInitResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.ConversationMessage.encode(m.messages[i], w.uint32(10).fork()).ldelim();
      }
      w.uint32(16).bool(m.has_more);
      w.uint32(24).int64(m.next_init_version);
      if (m.version != null && Object.hasOwnProperty.call(m, 'version')) w.uint32(32).int64(m.version);
      if (m.user_cursor != null && Object.hasOwnProperty.call(m, 'user_cursor')) w.uint32(40).int64(m.user_cursor);
      if (m.cmd_index != null && Object.hasOwnProperty.call(m, 'cmd_index')) w.uint32(48).int64(m.cmd_index);
      return w;
    };

    MessageByInitResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessageByInitResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.ConversationMessage.decode(r, r.uint32()));
            break;
          case 2:
            m.has_more = r.bool();
            break;
          case 3:
            m.next_init_version = r.int64();
            break;
          case 4:
            m.version = r.int64();
            break;
          case 5:
            m.user_cursor = r.int64();
            break;
          case 6:
            m.cmd_index = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('has_more')) throw $util.ProtocolError("missing required 'has_more'", { instance: m });
      if (!m.hasOwnProperty('next_init_version'))
        throw $util.ProtocolError("missing required 'next_init_version'", { instance: m });
      return m;
    };

    return MessageByInitResponseBody;
  })();

  im_proto.ConversationMessage = (function () {
    function ConversationMessage(p) {
      this.messages = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationMessage.prototype.conversations = null;
    ConversationMessage.prototype.messages = $util.emptyArray;

    ConversationMessage.create = function create(properties) {
      return new ConversationMessage(properties);
    };

    ConversationMessage.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      $root.im_proto.ConversationInfoV2.encode(m.conversations, w.uint32(10).fork()).ldelim();
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(18).fork()).ldelim();
      }
      return w;
    };

    ConversationMessage.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationMessage();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversations = $root.im_proto.ConversationInfoV2.decode(r, r.uint32());
            break;
          case 2:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('conversations'))
        throw $util.ProtocolError("missing required 'conversations'", { instance: m });
      return m;
    };

    return ConversationMessage;
  })();

  im_proto.SendFriendApplyRequestBody = (function () {
    function SendFriendApplyRequestBody(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SendFriendApplyRequestBody.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SendFriendApplyRequestBody.prototype.ext = $util.emptyObject;

    SendFriendApplyRequestBody.create = function create(properties) {
      return new SendFriendApplyRequestBody(properties);
    };

    SendFriendApplyRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.user_id);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(18).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    SendFriendApplyRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SendFriendApplyRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.int64();
            break;
          case 2:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('user_id')) throw $util.ProtocolError("missing required 'user_id'", { instance: m });
      return m;
    };

    return SendFriendApplyRequestBody;
  })();

  im_proto.SendFriendApplyResponseBody = (function () {
    function SendFriendApplyResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SendFriendApplyResponseBody.prototype.status = 0;
    SendFriendApplyResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SendFriendApplyResponseBody.prototype.check_message = '';

    SendFriendApplyResponseBody.create = function create(properties) {
      return new SendFriendApplyResponseBody(properties);
    };

    SendFriendApplyResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(8).int32(m.status);
      if (m.check_code != null && Object.hasOwnProperty.call(m, 'check_code')) w.uint32(16).int64(m.check_code);
      if (m.check_message != null && Object.hasOwnProperty.call(m, 'check_message'))
        w.uint32(26).string(m.check_message);
      return w;
    };

    SendFriendApplyResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SendFriendApplyResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.status = r.int32();
            break;
          case 2:
            m.check_code = r.int64();
            break;
          case 3:
            m.check_message = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return SendFriendApplyResponseBody;
  })();

  im_proto.GetFriendApplyListRequestBody = (function () {
    function GetFriendApplyListRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetFriendApplyListRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetFriendApplyListRequestBody.prototype.limit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetFriendApplyListRequestBody.prototype.get_total_count = false;
    GetFriendApplyListRequestBody.prototype.status = 0;

    GetFriendApplyListRequestBody.create = function create(properties) {
      return new GetFriendApplyListRequestBody(properties);
    };

    GetFriendApplyListRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(8).int64(m.cursor);
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(16).int64(m.limit);
      if (m.get_total_count != null && Object.hasOwnProperty.call(m, 'get_total_count'))
        w.uint32(24).bool(m.get_total_count);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(32).int32(m.status);
      return w;
    };

    GetFriendApplyListRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetFriendApplyListRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cursor = r.int64();
            break;
          case 2:
            m.limit = r.int64();
            break;
          case 3:
            m.get_total_count = r.bool();
            break;
          case 4:
            m.status = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetFriendApplyListRequestBody;
  })();

  im_proto.ApplyUserInfo = (function () {
    function ApplyUserInfo(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ApplyUserInfo.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ApplyUserInfo.prototype.apply_time_second = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ApplyUserInfo.prototype.ext = $util.emptyObject;
    ApplyUserInfo.prototype.status = 0;
    ApplyUserInfo.prototype.profile = null;

    ApplyUserInfo.create = function create(properties) {
      return new ApplyUserInfo(properties);
    };

    ApplyUserInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(8).int64(m.user_id);
      if (m.apply_time_second != null && Object.hasOwnProperty.call(m, 'apply_time_second'))
        w.uint32(16).int64(m.apply_time_second);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(26).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(32).int32(m.status);
      if (m.profile != null && Object.hasOwnProperty.call(m, 'profile'))
        $root.im_proto.Profile.encode(m.profile, w.uint32(42).fork()).ldelim();
      return w;
    };

    ApplyUserInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ApplyUserInfo(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.int64();
            break;
          case 2:
            m.apply_time_second = r.int64();
            break;
          case 3:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          case 4:
            m.status = r.int32();
            break;
          case 5:
            m.profile = $root.im_proto.Profile.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ApplyUserInfo;
  })();

  im_proto.GetFriendApplyListResponseBody = (function () {
    function GetFriendApplyListResponseBody(p) {
      this.user_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetFriendApplyListResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetFriendApplyListResponseBody.prototype.has_more = false;
    GetFriendApplyListResponseBody.prototype.user_list = $util.emptyArray;
    GetFriendApplyListResponseBody.prototype.total_count = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    GetFriendApplyListResponseBody.create = function create(properties) {
      return new GetFriendApplyListResponseBody(properties);
    };

    GetFriendApplyListResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(8).int64(m.next_cursor);
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(16).bool(m.has_more);
      if (m.user_list != null && m.user_list.length) {
        for (var i = 0; i < m.user_list.length; ++i)
          $root.im_proto.ApplyUserInfo.encode(m.user_list[i], w.uint32(26).fork()).ldelim();
      }
      if (m.total_count != null && Object.hasOwnProperty.call(m, 'total_count')) w.uint32(32).int64(m.total_count);
      return w;
    };

    GetFriendApplyListResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetFriendApplyListResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.next_cursor = r.int64();
            break;
          case 2:
            m.has_more = r.bool();
            break;
          case 3:
            if (!(m.user_list && m.user_list.length)) m.user_list = [];
            m.user_list.push($root.im_proto.ApplyUserInfo.decode(r, r.uint32()));
            break;
          case 4:
            m.total_count = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetFriendApplyListResponseBody;
  })();

  im_proto.GetFriendReceiveApplyListRequestBody = (function () {
    function GetFriendReceiveApplyListRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetFriendReceiveApplyListRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetFriendReceiveApplyListRequestBody.prototype.limit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetFriendReceiveApplyListRequestBody.prototype.get_total_count = false;
    GetFriendReceiveApplyListRequestBody.prototype.status = 0;

    GetFriendReceiveApplyListRequestBody.create = function create(properties) {
      return new GetFriendReceiveApplyListRequestBody(properties);
    };

    GetFriendReceiveApplyListRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(8).int64(m.cursor);
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(16).int64(m.limit);
      if (m.get_total_count != null && Object.hasOwnProperty.call(m, 'get_total_count'))
        w.uint32(24).bool(m.get_total_count);
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(32).int32(m.status);
      return w;
    };

    GetFriendReceiveApplyListRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetFriendReceiveApplyListRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cursor = r.int64();
            break;
          case 2:
            m.limit = r.int64();
            break;
          case 3:
            m.get_total_count = r.bool();
            break;
          case 4:
            m.status = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetFriendReceiveApplyListRequestBody;
  })();

  im_proto.GetFriendReceiveApplyListResponseBody = (function () {
    function GetFriendReceiveApplyListResponseBody(p) {
      this.user_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetFriendReceiveApplyListResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetFriendReceiveApplyListResponseBody.prototype.has_more = false;
    GetFriendReceiveApplyListResponseBody.prototype.user_list = $util.emptyArray;
    GetFriendReceiveApplyListResponseBody.prototype.total_count = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    GetFriendReceiveApplyListResponseBody.create = function create(properties) {
      return new GetFriendReceiveApplyListResponseBody(properties);
    };

    GetFriendReceiveApplyListResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(8).int64(m.next_cursor);
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(16).bool(m.has_more);
      if (m.user_list != null && m.user_list.length) {
        for (var i = 0; i < m.user_list.length; ++i)
          $root.im_proto.ApplyUserInfo.encode(m.user_list[i], w.uint32(26).fork()).ldelim();
      }
      if (m.total_count != null && Object.hasOwnProperty.call(m, 'total_count')) w.uint32(32).int64(m.total_count);
      return w;
    };

    GetFriendReceiveApplyListResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetFriendReceiveApplyListResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.next_cursor = r.int64();
            break;
          case 2:
            m.has_more = r.bool();
            break;
          case 3:
            if (!(m.user_list && m.user_list.length)) m.user_list = [];
            m.user_list.push($root.im_proto.ApplyUserInfo.decode(r, r.uint32()));
            break;
          case 4:
            m.total_count = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetFriendReceiveApplyListResponseBody;
  })();

  im_proto.ReplyFriendApplyRequestBody = (function () {
    function ReplyFriendApplyRequestBody(p) {
      this.user_id = [];
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ReplyFriendApplyRequestBody.prototype.user_id = $util.emptyArray;
    ReplyFriendApplyRequestBody.prototype.attitude = 0;
    ReplyFriendApplyRequestBody.prototype.ext = $util.emptyObject;

    ReplyFriendApplyRequestBody.create = function create(properties) {
      return new ReplyFriendApplyRequestBody(properties);
    };

    ReplyFriendApplyRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_id != null && m.user_id.length) {
        for (var i = 0; i < m.user_id.length; ++i) w.uint32(8).int64(m.user_id[i]);
      }
      if (m.attitude != null && Object.hasOwnProperty.call(m, 'attitude')) w.uint32(16).int32(m.attitude);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(26).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    ReplyFriendApplyRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ReplyFriendApplyRequestBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.user_id && m.user_id.length)) m.user_id = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.user_id.push(r.int64());
            } else m.user_id.push(r.int64());
            break;
          case 2:
            m.attitude = r.int32();
            break;
          case 3:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ReplyFriendApplyRequestBody;
  })();

  im_proto.ReplyFriendApplyResponseBody = (function () {
    function ReplyFriendApplyResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ReplyFriendApplyResponseBody.create = function create(properties) {
      return new ReplyFriendApplyResponseBody(properties);
    };

    ReplyFriendApplyResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    ReplyFriendApplyResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ReplyFriendApplyResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ReplyFriendApplyResponseBody;
  })();

  im_proto.FriendUserInfo = (function () {
    function FriendUserInfo(p) {
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    FriendUserInfo.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    FriendUserInfo.prototype.apply_time_second = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    FriendUserInfo.prototype.ext = $util.emptyObject;
    FriendUserInfo.prototype.profile = null;

    FriendUserInfo.create = function create(properties) {
      return new FriendUserInfo(properties);
    };

    FriendUserInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(8).int64(m.user_id);
      if (m.apply_time_second != null && Object.hasOwnProperty.call(m, 'apply_time_second'))
        w.uint32(16).int64(m.apply_time_second);
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(26).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      if (m.profile != null && Object.hasOwnProperty.call(m, 'profile'))
        $root.im_proto.Profile.encode(m.profile, w.uint32(34).fork()).ldelim();
      return w;
    };

    FriendUserInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.FriendUserInfo(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.int64();
            break;
          case 2:
            m.apply_time_second = r.int64();
            break;
          case 3:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          case 4:
            m.profile = $root.im_proto.Profile.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return FriendUserInfo;
  })();

  im_proto.GetFriendListRequestBody = (function () {
    function GetFriendListRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetFriendListRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetFriendListRequestBody.prototype.limit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetFriendListRequestBody.prototype.get_total_count = false;

    GetFriendListRequestBody.create = function create(properties) {
      return new GetFriendListRequestBody(properties);
    };

    GetFriendListRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(8).int64(m.cursor);
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(16).int64(m.limit);
      if (m.get_total_count != null && Object.hasOwnProperty.call(m, 'get_total_count'))
        w.uint32(24).bool(m.get_total_count);
      return w;
    };

    GetFriendListRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetFriendListRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cursor = r.int64();
            break;
          case 2:
            m.limit = r.int64();
            break;
          case 3:
            m.get_total_count = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetFriendListRequestBody;
  })();

  im_proto.GetFriendListResponseBody = (function () {
    function GetFriendListResponseBody(p) {
      this.user_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetFriendListResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GetFriendListResponseBody.prototype.has_more = false;
    GetFriendListResponseBody.prototype.user_list = $util.emptyArray;
    GetFriendListResponseBody.prototype.total_count = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    GetFriendListResponseBody.create = function create(properties) {
      return new GetFriendListResponseBody(properties);
    };

    GetFriendListResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.next_cursor != null && Object.hasOwnProperty.call(m, 'next_cursor')) w.uint32(8).int64(m.next_cursor);
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(16).bool(m.has_more);
      if (m.user_list != null && m.user_list.length) {
        for (var i = 0; i < m.user_list.length; ++i)
          $root.im_proto.FriendUserInfo.encode(m.user_list[i], w.uint32(26).fork()).ldelim();
      }
      if (m.total_count != null && Object.hasOwnProperty.call(m, 'total_count')) w.uint32(32).int64(m.total_count);
      return w;
    };

    GetFriendListResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetFriendListResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.next_cursor = r.int64();
            break;
          case 2:
            m.has_more = r.bool();
            break;
          case 3:
            if (!(m.user_list && m.user_list.length)) m.user_list = [];
            m.user_list.push($root.im_proto.FriendUserInfo.decode(r, r.uint32()));
            break;
          case 4:
            m.total_count = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetFriendListResponseBody;
  })();

  im_proto.DeleteFriendRequestBody = (function () {
    function DeleteFriendRequestBody(p) {
      this.user_id = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DeleteFriendRequestBody.prototype.user_id = $util.emptyArray;

    DeleteFriendRequestBody.create = function create(properties) {
      return new DeleteFriendRequestBody(properties);
    };

    DeleteFriendRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_id != null && m.user_id.length) {
        for (var i = 0; i < m.user_id.length; ++i) w.uint32(8).int64(m.user_id[i]);
      }
      return w;
    };

    DeleteFriendRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DeleteFriendRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.user_id && m.user_id.length)) m.user_id = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.user_id.push(r.int64());
            } else m.user_id.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DeleteFriendRequestBody;
  })();

  im_proto.DeleteFriendResponseBody = (function () {
    function DeleteFriendResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DeleteFriendResponseBody.create = function create(properties) {
      return new DeleteFriendResponseBody(properties);
    };

    DeleteFriendResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    DeleteFriendResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DeleteFriendResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DeleteFriendResponseBody;
  })();

  im_proto.ProfileBatchGetInfoRequestBody = (function () {
    function ProfileBatchGetInfoRequestBody(p) {
      this.userids = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ProfileBatchGetInfoRequestBody.prototype.userids = $util.emptyArray;

    ProfileBatchGetInfoRequestBody.create = function create(properties) {
      return new ProfileBatchGetInfoRequestBody(properties);
    };

    ProfileBatchGetInfoRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.userids != null && m.userids.length) {
        for (var i = 0; i < m.userids.length; ++i) w.uint32(8).int64(m.userids[i]);
      }
      return w;
    };

    ProfileBatchGetInfoRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ProfileBatchGetInfoRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.userids && m.userids.length)) m.userids = [];
            if ((t & 7) === 2) {
              var c2 = r.uint32() + r.pos;
              while (r.pos < c2) m.userids.push(r.int64());
            } else m.userids.push(r.int64());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ProfileBatchGetInfoRequestBody;
  })();

  im_proto.ProfileBatchGetInfoResponseBody = (function () {
    function ProfileBatchGetInfoResponseBody(p) {
      this.profiles = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ProfileBatchGetInfoResponseBody.prototype.profiles = $util.emptyArray;

    ProfileBatchGetInfoResponseBody.create = function create(properties) {
      return new ProfileBatchGetInfoResponseBody(properties);
    };

    ProfileBatchGetInfoResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.profiles != null && m.profiles.length) {
        for (var i = 0; i < m.profiles.length; ++i)
          $root.im_proto.Profile.encode(m.profiles[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    ProfileBatchGetInfoResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ProfileBatchGetInfoResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.profiles && m.profiles.length)) m.profiles = [];
            m.profiles.push($root.im_proto.Profile.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ProfileBatchGetInfoResponseBody;
  })();

  im_proto.ProfileSearchInfoRequestBody = (function () {
    function ProfileSearchInfoRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ProfileSearchInfoRequestBody.prototype.search_key = '';

    ProfileSearchInfoRequestBody.create = function create(properties) {
      return new ProfileSearchInfoRequestBody(properties);
    };

    ProfileSearchInfoRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(10).string(m.search_key);
      return w;
    };

    ProfileSearchInfoRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ProfileSearchInfoRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.search_key = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('search_key')) throw $util.ProtocolError("missing required 'search_key'", { instance: m });
      return m;
    };

    return ProfileSearchInfoRequestBody;
  })();

  im_proto.ProfileSearchInfoResponseBody = (function () {
    function ProfileSearchInfoResponseBody(p) {
      this.profile = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ProfileSearchInfoResponseBody.prototype.profile = $util.emptyArray;

    ProfileSearchInfoResponseBody.create = function create(properties) {
      return new ProfileSearchInfoResponseBody(properties);
    };

    ProfileSearchInfoResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.profile != null && m.profile.length) {
        for (var i = 0; i < m.profile.length; ++i)
          $root.im_proto.Profile.encode(m.profile[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    ProfileSearchInfoResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ProfileSearchInfoResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.profile && m.profile.length)) m.profile = [];
            m.profile.push($root.im_proto.Profile.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ProfileSearchInfoResponseBody;
  })();

  im_proto.GlobalMessageSearchRequestBody = (function () {
    function GlobalMessageSearchRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GlobalMessageSearchRequestBody.prototype.search_query = '';
    GlobalMessageSearchRequestBody.prototype.start_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GlobalMessageSearchRequestBody.prototype.end_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GlobalMessageSearchRequestBody.prototype.frag_size = 0;
    GlobalMessageSearchRequestBody.prototype.scroll_id = '';

    GlobalMessageSearchRequestBody.create = function create(properties) {
      return new GlobalMessageSearchRequestBody(properties);
    };

    GlobalMessageSearchRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(10).string(m.search_query);
      if (m.start_time != null && Object.hasOwnProperty.call(m, 'start_time')) w.uint32(16).int64(m.start_time);
      if (m.end_time != null && Object.hasOwnProperty.call(m, 'end_time')) w.uint32(24).int64(m.end_time);
      if (m.frag_size != null && Object.hasOwnProperty.call(m, 'frag_size')) w.uint32(32).int32(m.frag_size);
      if (m.scroll_id != null && Object.hasOwnProperty.call(m, 'scroll_id')) w.uint32(42).string(m.scroll_id);
      return w;
    };

    GlobalMessageSearchRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GlobalMessageSearchRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.search_query = r.string();
            break;
          case 2:
            m.start_time = r.int64();
            break;
          case 3:
            m.end_time = r.int64();
            break;
          case 4:
            m.frag_size = r.int32();
            break;
          case 5:
            m.scroll_id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('search_query'))
        throw $util.ProtocolError("missing required 'search_query'", { instance: m });
      return m;
    };

    return GlobalMessageSearchRequestBody;
  })();

  im_proto.GlobalMessageSearchResponseBody = (function () {
    function GlobalMessageSearchResponseBody(p) {
      this.conv_result = [];
      this.message_result = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GlobalMessageSearchResponseBody.prototype.conv_result = $util.emptyArray;
    GlobalMessageSearchResponseBody.prototype.message_result = $util.emptyArray;
    GlobalMessageSearchResponseBody.prototype.has_more = false;
    GlobalMessageSearchResponseBody.prototype.scroll_id = '';

    GlobalMessageSearchResponseBody.create = function create(properties) {
      return new GlobalMessageSearchResponseBody(properties);
    };

    GlobalMessageSearchResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conv_result != null && m.conv_result.length) {
        for (var i = 0; i < m.conv_result.length; ++i)
          $root.im_proto.ConversationCoreInfo.encode(m.conv_result[i], w.uint32(10).fork()).ldelim();
      }
      if (m.message_result != null && m.message_result.length) {
        for (var i = 0; i < m.message_result.length; ++i)
          $root.im_proto.MessageBody.encode(m.message_result[i], w.uint32(18).fork()).ldelim();
      }
      w.uint32(24).bool(m.has_more);
      w.uint32(34).string(m.scroll_id);
      return w;
    };

    GlobalMessageSearchResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GlobalMessageSearchResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conv_result && m.conv_result.length)) m.conv_result = [];
            m.conv_result.push($root.im_proto.ConversationCoreInfo.decode(r, r.uint32()));
            break;
          case 2:
            if (!(m.message_result && m.message_result.length)) m.message_result = [];
            m.message_result.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          case 3:
            m.has_more = r.bool();
            break;
          case 4:
            m.scroll_id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('has_more')) throw $util.ProtocolError("missing required 'has_more'", { instance: m });
      if (!m.hasOwnProperty('scroll_id')) throw $util.ProtocolError("missing required 'scroll_id'", { instance: m });
      return m;
    };

    return GlobalMessageSearchResponseBody;
  })();

  im_proto.ConversationCoreSearchQuery = (function () {
    function ConversationCoreSearchQuery(p) {
      this.ext_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationCoreSearchQuery.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationCoreSearchQuery.prototype.conv_name = '';
    ConversationCoreSearchQuery.prototype.conv_status = '';
    ConversationCoreSearchQuery.prototype.creat_start_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationCoreSearchQuery.prototype.creat_end_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationCoreSearchQuery.prototype.owner_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationCoreSearchQuery.prototype.ext_list = $util.emptyArray;

    ConversationCoreSearchQuery.create = function create(properties) {
      return new ConversationCoreSearchQuery(properties);
    };

    ConversationCoreSearchQuery.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conv_short_id != null && Object.hasOwnProperty.call(m, 'conv_short_id')) w.uint32(8).int64(m.conv_short_id);
      if (m.conv_name != null && Object.hasOwnProperty.call(m, 'conv_name')) w.uint32(18).string(m.conv_name);
      if (m.conv_status != null && Object.hasOwnProperty.call(m, 'conv_status')) w.uint32(26).string(m.conv_status);
      if (m.creat_start_time != null && Object.hasOwnProperty.call(m, 'creat_start_time'))
        w.uint32(32).int64(m.creat_start_time);
      if (m.creat_end_time != null && Object.hasOwnProperty.call(m, 'creat_end_time'))
        w.uint32(40).int64(m.creat_end_time);
      if (m.owner_id != null && Object.hasOwnProperty.call(m, 'owner_id')) w.uint32(48).int64(m.owner_id);
      if (m.ext_list != null && m.ext_list.length) {
        for (var i = 0; i < m.ext_list.length; ++i) w.uint32(58).string(m.ext_list[i]);
      }
      return w;
    };

    ConversationCoreSearchQuery.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationCoreSearchQuery();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conv_short_id = r.int64();
            break;
          case 2:
            m.conv_name = r.string();
            break;
          case 3:
            m.conv_status = r.string();
            break;
          case 4:
            m.creat_start_time = r.int64();
            break;
          case 5:
            m.creat_end_time = r.int64();
            break;
          case 6:
            m.owner_id = r.int64();
            break;
          case 7:
            if (!(m.ext_list && m.ext_list.length)) m.ext_list = [];
            m.ext_list.push(r.string());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationCoreSearchQuery;
  })();

  im_proto.ConversationCoreSearchRequestBody = (function () {
    function ConversationCoreSearchRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationCoreSearchRequestBody.prototype.search_query = null;
    ConversationCoreSearchRequestBody.prototype.frag_size = 0;
    ConversationCoreSearchRequestBody.prototype.scroll_id = '';

    ConversationCoreSearchRequestBody.create = function create(properties) {
      return new ConversationCoreSearchRequestBody(properties);
    };

    ConversationCoreSearchRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      $root.im_proto.ConversationCoreSearchQuery.encode(m.search_query, w.uint32(10).fork()).ldelim();
      if (m.frag_size != null && Object.hasOwnProperty.call(m, 'frag_size')) w.uint32(16).int32(m.frag_size);
      if (m.scroll_id != null && Object.hasOwnProperty.call(m, 'scroll_id')) w.uint32(26).string(m.scroll_id);
      return w;
    };

    ConversationCoreSearchRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationCoreSearchRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.search_query = $root.im_proto.ConversationCoreSearchQuery.decode(r, r.uint32());
            break;
          case 2:
            m.frag_size = r.int32();
            break;
          case 3:
            m.scroll_id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('search_query'))
        throw $util.ProtocolError("missing required 'search_query'", { instance: m });
      return m;
    };

    return ConversationCoreSearchRequestBody;
  })();

  im_proto.ConversationCoreSearchResponseBody = (function () {
    function ConversationCoreSearchResponseBody(p) {
      this.conversations = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationCoreSearchResponseBody.prototype.conversations = $util.emptyArray;
    ConversationCoreSearchResponseBody.prototype.has_more = false;
    ConversationCoreSearchResponseBody.prototype.scroll_id = '';
    ConversationCoreSearchResponseBody.prototype.total_count = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    ConversationCoreSearchResponseBody.create = function create(properties) {
      return new ConversationCoreSearchResponseBody(properties);
    };

    ConversationCoreSearchResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversations != null && m.conversations.length) {
        for (var i = 0; i < m.conversations.length; ++i)
          $root.im_proto.ConversationCoreInfo.encode(m.conversations[i], w.uint32(10).fork()).ldelim();
      }
      w.uint32(16).bool(m.has_more);
      w.uint32(26).string(m.scroll_id);
      if (m.total_count != null && Object.hasOwnProperty.call(m, 'total_count')) w.uint32(32).int64(m.total_count);
      return w;
    };

    ConversationCoreSearchResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationCoreSearchResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.conversations && m.conversations.length)) m.conversations = [];
            m.conversations.push($root.im_proto.ConversationCoreInfo.decode(r, r.uint32()));
            break;
          case 2:
            m.has_more = r.bool();
            break;
          case 3:
            m.scroll_id = r.string();
            break;
          case 4:
            m.total_count = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('has_more')) throw $util.ProtocolError("missing required 'has_more'", { instance: m });
      if (!m.hasOwnProperty('scroll_id')) throw $util.ProtocolError("missing required 'scroll_id'", { instance: m });
      return m;
    };

    return ConversationCoreSearchResponseBody;
  })();

  im_proto.ConversationMessageSearchRequestBody = (function () {
    function ConversationMessageSearchRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationMessageSearchRequestBody.prototype.search_query = '';
    ConversationMessageSearchRequestBody.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationMessageSearchRequestBody.prototype.start_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationMessageSearchRequestBody.prototype.end_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationMessageSearchRequestBody.prototype.frag_size = 0;
    ConversationMessageSearchRequestBody.prototype.scroll_id = '';

    ConversationMessageSearchRequestBody.create = function create(properties) {
      return new ConversationMessageSearchRequestBody(properties);
    };

    ConversationMessageSearchRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(10).string(m.search_query);
      w.uint32(16).int64(m.conv_short_id);
      if (m.start_time != null && Object.hasOwnProperty.call(m, 'start_time')) w.uint32(24).int64(m.start_time);
      if (m.end_time != null && Object.hasOwnProperty.call(m, 'end_time')) w.uint32(32).int64(m.end_time);
      if (m.frag_size != null && Object.hasOwnProperty.call(m, 'frag_size')) w.uint32(40).int32(m.frag_size);
      if (m.scroll_id != null && Object.hasOwnProperty.call(m, 'scroll_id')) w.uint32(50).string(m.scroll_id);
      return w;
    };

    ConversationMessageSearchRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationMessageSearchRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.search_query = r.string();
            break;
          case 2:
            m.conv_short_id = r.int64();
            break;
          case 3:
            m.start_time = r.int64();
            break;
          case 4:
            m.end_time = r.int64();
            break;
          case 5:
            m.frag_size = r.int32();
            break;
          case 6:
            m.scroll_id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('search_query'))
        throw $util.ProtocolError("missing required 'search_query'", { instance: m });
      if (!m.hasOwnProperty('conv_short_id'))
        throw $util.ProtocolError("missing required 'conv_short_id'", { instance: m });
      return m;
    };

    return ConversationMessageSearchRequestBody;
  })();

  im_proto.ConversationMessageSearchResponseBody = (function () {
    function ConversationMessageSearchResponseBody(p) {
      this.message_result = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationMessageSearchResponseBody.prototype.message_result = $util.emptyArray;
    ConversationMessageSearchResponseBody.prototype.has_more = false;
    ConversationMessageSearchResponseBody.prototype.scroll_id = '';

    ConversationMessageSearchResponseBody.create = function create(properties) {
      return new ConversationMessageSearchResponseBody(properties);
    };

    ConversationMessageSearchResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.message_result != null && m.message_result.length) {
        for (var i = 0; i < m.message_result.length; ++i)
          $root.im_proto.MessageBody.encode(m.message_result[i], w.uint32(10).fork()).ldelim();
      }
      w.uint32(16).bool(m.has_more);
      w.uint32(26).string(m.scroll_id);
      return w;
    };

    ConversationMessageSearchResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationMessageSearchResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.message_result && m.message_result.length)) m.message_result = [];
            m.message_result.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          case 2:
            m.has_more = r.bool();
            break;
          case 3:
            m.scroll_id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('has_more')) throw $util.ProtocolError("missing required 'has_more'", { instance: m });
      if (!m.hasOwnProperty('scroll_id')) throw $util.ProtocolError("missing required 'scroll_id'", { instance: m });
      return m;
    };

    return ConversationMessageSearchResponseBody;
  })();

  im_proto.ConversationMessagePreViewRequestBody = (function () {
    function ConversationMessagePreViewRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationMessagePreViewRequestBody.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationMessagePreViewRequestBody.prototype.message_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationMessagePreViewRequestBody.prototype.conversation_index = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;
    ConversationMessagePreViewRequestBody.prototype.inbox_type = 0;

    ConversationMessagePreViewRequestBody.create = function create(properties) {
      return new ConversationMessagePreViewRequestBody(properties);
    };

    ConversationMessagePreViewRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.conv_short_id);
      w.uint32(16).int64(m.message_id);
      w.uint32(24).int64(m.conversation_index);
      w.uint32(32).int32(m.inbox_type);
      return w;
    };

    ConversationMessagePreViewRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationMessagePreViewRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conv_short_id = r.int64();
            break;
          case 2:
            m.message_id = r.int64();
            break;
          case 3:
            m.conversation_index = r.int64();
            break;
          case 4:
            m.inbox_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('conv_short_id'))
        throw $util.ProtocolError("missing required 'conv_short_id'", { instance: m });
      if (!m.hasOwnProperty('message_id')) throw $util.ProtocolError("missing required 'message_id'", { instance: m });
      if (!m.hasOwnProperty('conversation_index'))
        throw $util.ProtocolError("missing required 'conversation_index'", { instance: m });
      if (!m.hasOwnProperty('inbox_type')) throw $util.ProtocolError("missing required 'inbox_type'", { instance: m });
      return m;
    };

    return ConversationMessagePreViewRequestBody;
  })();

  im_proto.ConversationMessagePreViewResponseBody = (function () {
    function ConversationMessagePreViewResponseBody(p) {
      this.message_result = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationMessagePreViewResponseBody.prototype.message_result = $util.emptyArray;

    ConversationMessagePreViewResponseBody.create = function create(properties) {
      return new ConversationMessagePreViewResponseBody(properties);
    };

    ConversationMessagePreViewResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.message_result != null && m.message_result.length) {
        for (var i = 0; i < m.message_result.length; ++i)
          $root.im_proto.MessageBody.encode(m.message_result[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    ConversationMessagePreViewResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationMessagePreViewResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.message_result && m.message_result.length)) m.message_result = [];
            m.message_result.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationMessagePreViewResponseBody;
  })();

  im_proto.GetMediaUploadConfigRequestBody = (function () {
    function GetMediaUploadConfigRequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMediaUploadConfigRequestBody.create = function create(properties) {
      return new GetMediaUploadConfigRequestBody(properties);
    };

    GetMediaUploadConfigRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      return w;
    };

    GetMediaUploadConfigRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMediaUploadConfigRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetMediaUploadConfigRequestBody;
  })();

  im_proto.GetMediaUploadConfigResponseBody = (function () {
    function GetMediaUploadConfigResponseBody(p) {
      this.configs = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMediaUploadConfigResponseBody.prototype.configs = $util.emptyArray;

    GetMediaUploadConfigResponseBody.create = function create(properties) {
      return new GetMediaUploadConfigResponseBody(properties);
    };

    GetMediaUploadConfigResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.configs != null && m.configs.length) {
        for (var i = 0; i < m.configs.length; ++i)
          $root.im_proto.MediaUploadConfig.encode(m.configs[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    GetMediaUploadConfigResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMediaUploadConfigResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.configs && m.configs.length)) m.configs = [];
            m.configs.push($root.im_proto.MediaUploadConfig.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetMediaUploadConfigResponseBody;
  })();

  im_proto.MediaUploadConfig = (function () {
    function MediaUploadConfig(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MediaUploadConfig.prototype.type = 1;
    MediaUploadConfig.prototype.resource_space = '';
    MediaUploadConfig.prototype.host = '';
    MediaUploadConfig.prototype.expiry_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MediaUploadConfig.prototype.current_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    MediaUploadConfig.prototype.access_key = '';
    MediaUploadConfig.prototype.session_token = '';
    MediaUploadConfig.prototype.secret_access_key = '';

    MediaUploadConfig.create = function create(properties) {
      return new MediaUploadConfig(properties);
    };

    MediaUploadConfig.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.type != null && Object.hasOwnProperty.call(m, 'type')) w.uint32(8).int32(m.type);
      if (m.resource_space != null && Object.hasOwnProperty.call(m, 'resource_space'))
        w.uint32(18).string(m.resource_space);
      if (m.host != null && Object.hasOwnProperty.call(m, 'host')) w.uint32(26).string(m.host);
      if (m.expiry_time != null && Object.hasOwnProperty.call(m, 'expiry_time')) w.uint32(32).int64(m.expiry_time);
      if (m.current_time != null && Object.hasOwnProperty.call(m, 'current_time')) w.uint32(40).int64(m.current_time);
      if (m.access_key != null && Object.hasOwnProperty.call(m, 'access_key')) w.uint32(50).string(m.access_key);
      if (m.session_token != null && Object.hasOwnProperty.call(m, 'session_token'))
        w.uint32(58).string(m.session_token);
      if (m.secret_access_key != null && Object.hasOwnProperty.call(m, 'secret_access_key'))
        w.uint32(66).string(m.secret_access_key);
      return w;
    };

    MediaUploadConfig.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MediaUploadConfig();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.type = r.int32();
            break;
          case 2:
            m.resource_space = r.string();
            break;
          case 3:
            m.host = r.string();
            break;
          case 4:
            m.expiry_time = r.int64();
            break;
          case 5:
            m.current_time = r.int64();
            break;
          case 6:
            m.access_key = r.string();
            break;
          case 7:
            m.session_token = r.string();
            break;
          case 8:
            m.secret_access_key = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MediaUploadConfig;
  })();

  im_proto.GetMediaStatusRequestBody = (function () {
    function GetMediaStatusRequestBody(p) {
      this.media_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMediaStatusRequestBody.prototype.media_list = $util.emptyArray;

    GetMediaStatusRequestBody.create = function create(properties) {
      return new GetMediaStatusRequestBody(properties);
    };

    GetMediaStatusRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.media_list != null && m.media_list.length) {
        for (var i = 0; i < m.media_list.length; ++i)
          $root.im_proto.GetMediaStatusRequestBody.MediaKey.encode(m.media_list[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    GetMediaStatusRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMediaStatusRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.media_list && m.media_list.length)) m.media_list = [];
            m.media_list.push($root.im_proto.GetMediaStatusRequestBody.MediaKey.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    GetMediaStatusRequestBody.MediaKey = (function () {
      function MediaKey(p) {
        if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      MediaKey.prototype.type = 1;
      MediaKey.prototype.id = '';

      MediaKey.create = function create(properties) {
        return new MediaKey(properties);
      };

      MediaKey.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.type != null && Object.hasOwnProperty.call(m, 'type')) w.uint32(8).int32(m.type);
        if (m.id != null && Object.hasOwnProperty.call(m, 'id')) w.uint32(18).string(m.id);
        return w;
      };

      MediaKey.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.im_proto.GetMediaStatusRequestBody.MediaKey();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.type = r.int32();
              break;
            case 2:
              m.id = r.string();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return MediaKey;
    })();

    return GetMediaStatusRequestBody;
  })();

  im_proto.GetMediaStatusResponseBody = (function () {
    function GetMediaStatusResponseBody(p) {
      this.results = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetMediaStatusResponseBody.prototype.results = $util.emptyObject;

    GetMediaStatusResponseBody.create = function create(properties) {
      return new GetMediaStatusResponseBody(properties);
    };

    GetMediaStatusResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.results != null && Object.hasOwnProperty.call(m, 'results')) {
        for (var ks = Object.keys(m.results), i = 0; i < ks.length; ++i) {
          w.uint32(10).fork().uint32(10).string(ks[i]);
          $root.im_proto.GetMediaStatusResponseBody.MediaStatusInfo.encode(m.results[ks[i]], w.uint32(18).fork())
            .ldelim()
            .ldelim();
        }
      }
      return w;
    };

    GetMediaStatusResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetMediaStatusResponseBody(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (m.results === $util.emptyObject) m.results = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = null;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = $root.im_proto.GetMediaStatusResponseBody.MediaStatusInfo.decode(r, r.uint32());
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.results[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    GetMediaStatusResponseBody.MediaStatusInfo = (function () {
      function MediaStatusInfo(p) {
        if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      MediaStatusInfo.prototype.type = 1;
      MediaStatusInfo.prototype.id = '';

      MediaStatusInfo.create = function create(properties) {
        return new MediaStatusInfo(properties);
      };

      MediaStatusInfo.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.type != null && Object.hasOwnProperty.call(m, 'type')) w.uint32(8).int32(m.type);
        if (m.id != null && Object.hasOwnProperty.call(m, 'id')) w.uint32(18).string(m.id);
        return w;
      };

      MediaStatusInfo.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.im_proto.GetMediaStatusResponseBody.MediaStatusInfo();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.type = r.int32();
              break;
            case 2:
              m.id = r.string();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return MediaStatusInfo;
    })();

    return GetMediaStatusResponseBody;
  })();

  im_proto.RequestBody = (function () {
    function RequestBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    RequestBody.prototype.send_message_body = null;
    RequestBody.prototype.messages_per_user_body = null;
    RequestBody.prototype.messages_per_user_init_body = null;
    RequestBody.prototype.messages_per_user_init_v2_body = null;
    RequestBody.prototype.messages_per_conversation_search_body = null;
    RequestBody.prototype.check_messages_per_user_body = null;
    RequestBody.prototype.get_message_by_id_body = null;
    RequestBody.prototype.conversations_list_body = null;
    RequestBody.prototype.messages_in_conversation_body = null;
    RequestBody.prototype.get_messages_checkinfo_in_conversation_body = null;
    RequestBody.prototype.get_messages_check_info_v2_body = null;
    RequestBody.prototype.send_user_action_body = null;
    RequestBody.prototype.send_input_status_body = null;
    RequestBody.prototype.get_conversation_info_body = null;
    RequestBody.prototype.set_conversation_info_body = null;
    RequestBody.prototype.create_conversation_body = null;
    RequestBody.prototype.delete_conversation_body = null;
    RequestBody.prototype.mark_conversation_read_body = null;
    RequestBody.prototype.conversation_participants_body = null;
    RequestBody.prototype.get_conversation_info_list_body = null;
    RequestBody.prototype.report_conversation_cursor_body = null;
    RequestBody.prototype.get_conversation_info_v2_body = null;
    RequestBody.prototype.create_conversation_v2_body = null;
    RequestBody.prototype.get_conversation_info_list_v2_body = null;
    RequestBody.prototype.get_conversation_info_list_by_favorite_v2_body = null;
    RequestBody.prototype.get_conversation_info_list_by_top_v2_body = null;
    RequestBody.prototype.batch_mark_read_body = null;
    RequestBody.prototype.dissolve_conversation_body = null;
    RequestBody.prototype.get_conversations_checkinfo_body = null;
    RequestBody.prototype.get_conversation_check_info_v2_body = null;
    RequestBody.prototype.conversation_add_participants_body = null;
    RequestBody.prototype.conversation_remove_participants_body = null;
    RequestBody.prototype.leave_conversation_body = null;
    RequestBody.prototype.conversation_set_role_body = null;
    RequestBody.prototype.mget_conversation_participants_body = null;
    RequestBody.prototype.update_conversation_participant_body = null;
    RequestBody.prototype.batch_update_conversation_participant_body = null;
    RequestBody.prototype.get_conversation_group_list_body = null;
    RequestBody.prototype.delete_message_body = null;
    RequestBody.prototype.recall_message_body = null;
    RequestBody.prototype.reaction_message_body = null;
    RequestBody.prototype.sync_message_body = null;
    RequestBody.prototype.modify_message_property_body = null;
    RequestBody.prototype.ack_message_body = null;
    RequestBody.prototype.get_group_info_body = null;
    RequestBody.prototype.set_group_info_body = null;
    RequestBody.prototype.get_group_info_list_body = null;
    RequestBody.prototype.get_conversation_core_info_body = null;
    RequestBody.prototype.set_conversation_core_info_body = null;
    RequestBody.prototype.get_conversation_core_info_list_body = null;
    RequestBody.prototype.upsert_conversation_core_ext_info_body = null;
    RequestBody.prototype.delete_conversation_core_ext_info_body = null;
    RequestBody.prototype.get_conversation_setting_info_body = null;
    RequestBody.prototype.set_conversation_setting_info_body = null;
    RequestBody.prototype.upsert_conversation_setting_ext_info_body = null;
    RequestBody.prototype.delete_conversation_setting_ext_info_body = null;
    RequestBody.prototype.get_stranger_conversation_body = null;
    RequestBody.prototype.get_stranger_messages_body = null;
    RequestBody.prototype.delete_stranger_message_body = null;
    RequestBody.prototype.delete_stranger_conversation_body = null;
    RequestBody.prototype.delete_stranger_all_conversation_body = null;
    RequestBody.prototype.mark_stranger_conversation_read_body = null;
    RequestBody.prototype.mark_stranger_all_conversation_read_body = null;
    RequestBody.prototype.get_stranger_unread_count_body = null;
    RequestBody.prototype.participants_read_index_body = null;
    RequestBody.prototype.participants_min_index_body = null;
    RequestBody.prototype.get_upload_token_body = null;
    RequestBody.prototype.get_media_urls_body = null;
    RequestBody.prototype.get_ticket_body = null;
    RequestBody.prototype.vcd_clean_body = null;
    RequestBody.prototype.get_conversation_list_body = null;
    RequestBody.prototype.broadcast_send_message_body = null;
    RequestBody.prototype.broadcast_recv_message_body = null;
    RequestBody.prototype.broadcast_user_counter_body = null;
    RequestBody.prototype.client_ack_body = null;
    RequestBody.prototype.create_voip_body = null;
    RequestBody.prototype.call_voip_body = null;
    RequestBody.prototype.update_voip_body = null;
    RequestBody.prototype.channel_heartbeat_body = null;
    RequestBody.prototype.profile_get_info = null;
    RequestBody.prototype.report_client_metrics_body = null;
    RequestBody.prototype.get_configs_body = null;
    RequestBody.prototype.unread_count_report_body = null;
    RequestBody.prototype.block_members_body = null;
    RequestBody.prototype.block_conversation_body = null;
    RequestBody.prototype.modify_message_ext_body = null;
    RequestBody.prototype.get_conversation_audit_switch_body = null;
    RequestBody.prototype.update_conversation_audit_switch_body = null;
    RequestBody.prototype.send_conversation_apply_body = null;
    RequestBody.prototype.ack_conversation_apply_body = null;
    RequestBody.prototype.get_conversation_apply_body = null;
    RequestBody.prototype.get_conversation_audit_list_body = null;
    RequestBody.prototype.get_conversation_audit_unread_body = null;
    RequestBody.prototype.clear_conversation_audit_unread_body = null;
    RequestBody.prototype.get_unread_count_body = null;
    RequestBody.prototype.send_message_p2p_body = null;
    RequestBody.prototype.get_blocklist_body = null;
    RequestBody.prototype.set_blocklist_body = null;
    RequestBody.prototype.check_in_blocklist_body = null;
    RequestBody.prototype.get_message_info_by_index_v2_body = null;
    RequestBody.prototype.batch_get_conversation_audit_unread = null;
    RequestBody.prototype.mark_message_body = null;
    RequestBody.prototype.pull_mark_message_body = null;
    RequestBody.prototype.batch_get_conversation_participants_readindex = null;
    RequestBody.prototype.get_recent_message_body = null;
    RequestBody.prototype.get_cmd_message_body = null;
    RequestBody.prototype.get_message_info_by_index_v2_range_body = null;
    RequestBody.prototype.message_by_init = null;
    RequestBody.prototype.previewer_messages_in_conversation_body = null;
    RequestBody.prototype.previewer_get_conversation_info_list_body = null;
    RequestBody.prototype.send_friend_apply_body = null;
    RequestBody.prototype.get_friend_apply_list_body = null;
    RequestBody.prototype.get_friend_receive_apply_list_body = null;
    RequestBody.prototype.reply_friend_apply_body = null;
    RequestBody.prototype.get_friend_list_body = null;
    RequestBody.prototype.delete_friend_body = null;
    RequestBody.prototype.profile_batch_get_info_body = null;
    RequestBody.prototype.profile_search_info_body = null;
    RequestBody.prototype.mark_msg_unread_count_report = null;
    RequestBody.prototype.mark_msg_get_unread_count = null;
    RequestBody.prototype.batch_unmark_message = null;
    RequestBody.prototype.client_batch_ack_body = null;
    RequestBody.prototype.media_upload_config_request_body = null;
    RequestBody.prototype.media_status_request_body = null;
    RequestBody.prototype.global_message_search_body = null;
    RequestBody.prototype.conversation_core_search_body = null;
    RequestBody.prototype.conversation_message_search_body = null;
    RequestBody.prototype.conversation_message_pre_view_body = null;
    RequestBody.prototype.get_messages_body = null;

    RequestBody.create = function create(properties) {
      return new RequestBody(properties);
    };

    RequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.send_message_body != null && Object.hasOwnProperty.call(m, 'send_message_body'))
        $root.im_proto.SendMessageRequestBody.encode(m.send_message_body, w.uint32(802).fork()).ldelim();
      if (m.messages_per_user_body != null && Object.hasOwnProperty.call(m, 'messages_per_user_body'))
        $root.im_proto.MessagesPerUserRequestBody.encode(m.messages_per_user_body, w.uint32(1602).fork()).ldelim();
      if (m.messages_per_user_init_body != null && Object.hasOwnProperty.call(m, 'messages_per_user_init_body'))
        $root.im_proto.MessagesPerUserInitRequestBody.encode(
          m.messages_per_user_init_body,
          w.uint32(1610).fork(),
        ).ldelim();
      if (m.messages_per_user_init_v2_body != null && Object.hasOwnProperty.call(m, 'messages_per_user_init_v2_body'))
        $root.im_proto.MessagesPerUserInitV2RequestBody.encode(
          m.messages_per_user_init_v2_body,
          w.uint32(1626).fork(),
        ).ldelim();
      if (
        m.messages_per_conversation_search_body != null &&
        Object.hasOwnProperty.call(m, 'messages_per_conversation_search_body')
      )
        $root.im_proto.MessagesPerConversationSearchRequestBody.encode(
          m.messages_per_conversation_search_body,
          w.uint32(1650).fork(),
        ).ldelim();
      if (m.check_messages_per_user_body != null && Object.hasOwnProperty.call(m, 'check_messages_per_user_body'))
        $root.im_proto.CheckMessagePerUserRequestBody.encode(
          m.check_messages_per_user_body,
          w.uint32(1682).fork(),
        ).ldelim();
      if (m.get_message_by_id_body != null && Object.hasOwnProperty.call(m, 'get_message_by_id_body'))
        $root.im_proto.GetMessageByIdRequestBody.encode(m.get_message_by_id_body, w.uint32(1690).fork()).ldelim();
      if (m.conversations_list_body != null && Object.hasOwnProperty.call(m, 'conversations_list_body'))
        $root.im_proto.ConversationsListRequestBody.encode(m.conversations_list_body, w.uint32(2402).fork()).ldelim();
      if (m.messages_in_conversation_body != null && Object.hasOwnProperty.call(m, 'messages_in_conversation_body'))
        $root.im_proto.MessagesInConversationRequestBody.encode(
          m.messages_in_conversation_body,
          w.uint32(2410).fork(),
        ).ldelim();
      if (
        m.get_messages_checkinfo_in_conversation_body != null &&
        Object.hasOwnProperty.call(m, 'get_messages_checkinfo_in_conversation_body')
      )
        $root.im_proto.GetMessagesCheckInfoInConversationRequestBody.encode(
          m.get_messages_checkinfo_in_conversation_body,
          w.uint32(2418).fork(),
        ).ldelim();
      if (m.get_messages_check_info_v2_body != null && Object.hasOwnProperty.call(m, 'get_messages_check_info_v2_body'))
        $root.im_proto.GetMessagesCheckInfoV2RequestBody.encode(
          m.get_messages_check_info_v2_body,
          w.uint32(2426).fork(),
        ).ldelim();
      if (m.send_user_action_body != null && Object.hasOwnProperty.call(m, 'send_user_action_body'))
        $root.im_proto.SendUserActionRequestBody.encode(m.send_user_action_body, w.uint32(3282).fork()).ldelim();
      if (m.send_input_status_body != null && Object.hasOwnProperty.call(m, 'send_input_status_body'))
        $root.im_proto.SendInputStatusRequestBody.encode(m.send_input_status_body, w.uint32(3290).fork()).ldelim();
      if (m.get_conversation_info_body != null && Object.hasOwnProperty.call(m, 'get_conversation_info_body'))
        $root.im_proto.GetConversationInfoRequestBody.encode(
          m.get_conversation_info_body,
          w.uint32(4802).fork(),
        ).ldelim();
      if (m.set_conversation_info_body != null && Object.hasOwnProperty.call(m, 'set_conversation_info_body'))
        $root.im_proto.SetConversationInfoRequestBody.encode(
          m.set_conversation_info_body,
          w.uint32(4810).fork(),
        ).ldelim();
      if (m.create_conversation_body != null && Object.hasOwnProperty.call(m, 'create_conversation_body'))
        $root.im_proto.CreateConversationRequestBody.encode(m.create_conversation_body, w.uint32(4818).fork()).ldelim();
      if (m.delete_conversation_body != null && Object.hasOwnProperty.call(m, 'delete_conversation_body'))
        $root.im_proto.DeleteConversationRequestBody.encode(m.delete_conversation_body, w.uint32(4826).fork()).ldelim();
      if (m.mark_conversation_read_body != null && Object.hasOwnProperty.call(m, 'mark_conversation_read_body'))
        $root.im_proto.MarkConversationReadRequestBody.encode(
          m.mark_conversation_read_body,
          w.uint32(4834).fork(),
        ).ldelim();
      if (m.conversation_participants_body != null && Object.hasOwnProperty.call(m, 'conversation_participants_body'))
        $root.im_proto.ConversationParticipantsListRequestBody.encode(
          m.conversation_participants_body,
          w.uint32(4842).fork(),
        ).ldelim();
      if (m.report_conversation_cursor_body != null && Object.hasOwnProperty.call(m, 'report_conversation_cursor_body'))
        $root.im_proto.ReportGetMessagesCursorRequestBody.encode(
          m.report_conversation_cursor_body,
          w.uint32(4850).fork(),
        ).ldelim();
      if (m.get_conversation_info_list_body != null && Object.hasOwnProperty.call(m, 'get_conversation_info_list_body'))
        $root.im_proto.GetConversationInfoListRequestBody.encode(
          m.get_conversation_info_list_body,
          w.uint32(4858).fork(),
        ).ldelim();
      if (m.get_conversation_info_v2_body != null && Object.hasOwnProperty.call(m, 'get_conversation_info_v2_body'))
        $root.im_proto.GetConversationInfoV2RequestBody.encode(
          m.get_conversation_info_v2_body,
          w.uint32(4866).fork(),
        ).ldelim();
      if (m.create_conversation_v2_body != null && Object.hasOwnProperty.call(m, 'create_conversation_v2_body'))
        $root.im_proto.CreateConversationV2RequestBody.encode(
          m.create_conversation_v2_body,
          w.uint32(4874).fork(),
        ).ldelim();
      if (
        m.get_conversation_info_list_v2_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_info_list_v2_body')
      )
        $root.im_proto.GetConversationInfoListV2RequestBody.encode(
          m.get_conversation_info_list_v2_body,
          w.uint32(4882).fork(),
        ).ldelim();
      if (
        m.get_conversation_info_list_by_favorite_v2_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_info_list_by_favorite_v2_body')
      )
        $root.im_proto.ConversationsPerUserByFavoriteV2RequestBody.encode(
          m.get_conversation_info_list_by_favorite_v2_body,
          w.uint32(4890).fork(),
        ).ldelim();
      if (
        m.get_conversation_info_list_by_top_v2_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_info_list_by_top_v2_body')
      )
        $root.im_proto.ConversationsPerUserByTopV2RequestBody.encode(
          m.get_conversation_info_list_by_top_v2_body,
          w.uint32(4898).fork(),
        ).ldelim();
      if (m.batch_mark_read_body != null && Object.hasOwnProperty.call(m, 'batch_mark_read_body'))
        $root.im_proto.BatchMarkConversationReadRequestBody.encode(
          m.batch_mark_read_body,
          w.uint32(4906).fork(),
        ).ldelim();
      if (m.dissolve_conversation_body != null && Object.hasOwnProperty.call(m, 'dissolve_conversation_body'))
        $root.im_proto.DissolveConversationRequestBody.encode(
          m.dissolve_conversation_body,
          w.uint32(4914).fork(),
        ).ldelim();
      if (
        m.get_conversations_checkinfo_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversations_checkinfo_body')
      )
        $root.im_proto.GetConversationsCheckInfoRequestBody.encode(
          m.get_conversations_checkinfo_body,
          w.uint32(4922).fork(),
        ).ldelim();
      if (
        m.get_conversation_check_info_v2_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_check_info_v2_body')
      )
        $root.im_proto.GetConversationsCheckInfoV2RequestBody.encode(
          m.get_conversation_check_info_v2_body,
          w.uint32(4930).fork(),
        ).ldelim();
      if (
        m.conversation_add_participants_body != null &&
        Object.hasOwnProperty.call(m, 'conversation_add_participants_body')
      )
        $root.im_proto.ConversationAddParticipantsRequestBody.encode(
          m.conversation_add_participants_body,
          w.uint32(5202).fork(),
        ).ldelim();
      if (
        m.conversation_remove_participants_body != null &&
        Object.hasOwnProperty.call(m, 'conversation_remove_participants_body')
      )
        $root.im_proto.ConversationRemoveParticipantsRequestBody.encode(
          m.conversation_remove_participants_body,
          w.uint32(5210).fork(),
        ).ldelim();
      if (m.leave_conversation_body != null && Object.hasOwnProperty.call(m, 'leave_conversation_body'))
        $root.im_proto.ConversationLeaveRequestBody.encode(m.leave_conversation_body, w.uint32(5218).fork()).ldelim();
      if (m.conversation_set_role_body != null && Object.hasOwnProperty.call(m, 'conversation_set_role_body'))
        $root.im_proto.ConversationSetRoleRequestBody.encode(
          m.conversation_set_role_body,
          w.uint32(5226).fork(),
        ).ldelim();
      if (
        m.mget_conversation_participants_body != null &&
        Object.hasOwnProperty.call(m, 'mget_conversation_participants_body')
      )
        $root.im_proto.MgetConversationParticipantsRequestBody.encode(
          m.mget_conversation_participants_body,
          w.uint32(5234).fork(),
        ).ldelim();
      if (
        m.update_conversation_participant_body != null &&
        Object.hasOwnProperty.call(m, 'update_conversation_participant_body')
      )
        $root.im_proto.UpdateConversationParticipantRequestBody.encode(
          m.update_conversation_participant_body,
          w.uint32(5242).fork(),
        ).ldelim();
      if (
        m.batch_update_conversation_participant_body != null &&
        Object.hasOwnProperty.call(m, 'batch_update_conversation_participant_body')
      )
        $root.im_proto.BatchUpdateConversationParticipantRequestBody.encode(
          m.batch_update_conversation_participant_body,
          w.uint32(5250).fork(),
        ).ldelim();
      if (
        m.get_conversation_group_list_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_group_list_body')
      )
        $root.im_proto.GetConversationGroupListRequestBody.encode(
          m.get_conversation_group_list_body,
          w.uint32(5522).fork(),
        ).ldelim();
      if (m.delete_message_body != null && Object.hasOwnProperty.call(m, 'delete_message_body'))
        $root.im_proto.DeleteMessageRequestBody.encode(m.delete_message_body, w.uint32(5610).fork()).ldelim();
      if (m.recall_message_body != null && Object.hasOwnProperty.call(m, 'recall_message_body'))
        $root.im_proto.RecallMessageRequestBody.encode(m.recall_message_body, w.uint32(5618).fork()).ldelim();
      if (m.reaction_message_body != null && Object.hasOwnProperty.call(m, 'reaction_message_body'))
        $root.im_proto.ReactionMessageRequestBody.encode(m.reaction_message_body, w.uint32(5626).fork()).ldelim();
      if (m.sync_message_body != null && Object.hasOwnProperty.call(m, 'sync_message_body'))
        $root.im_proto.SyncMessageRequestBody.encode(m.sync_message_body, w.uint32(5634).fork()).ldelim();
      if (m.modify_message_property_body != null && Object.hasOwnProperty.call(m, 'modify_message_property_body'))
        $root.im_proto.ModifyMessagePropertyRequestBody.encode(
          m.modify_message_property_body,
          w.uint32(5642).fork(),
        ).ldelim();
      if (m.ack_message_body != null && Object.hasOwnProperty.call(m, 'ack_message_body'))
        $root.im_proto.AckMessageRequestBody.encode(m.ack_message_body, w.uint32(5650).fork()).ldelim();
      if (m.get_group_info_body != null && Object.hasOwnProperty.call(m, 'get_group_info_body'))
        $root.im_proto.GetGroupInfoRequestBody.encode(m.get_group_info_body, w.uint32(6410).fork()).ldelim();
      if (m.set_group_info_body != null && Object.hasOwnProperty.call(m, 'set_group_info_body'))
        $root.im_proto.SetGroupInfoRequestBody.encode(m.set_group_info_body, w.uint32(6418).fork()).ldelim();
      if (m.get_group_info_list_body != null && Object.hasOwnProperty.call(m, 'get_group_info_list_body'))
        $root.im_proto.GetGroupInfoListRequestBody.encode(m.get_group_info_list_body, w.uint32(6426).fork()).ldelim();
      if (m.get_conversation_core_info_body != null && Object.hasOwnProperty.call(m, 'get_conversation_core_info_body'))
        $root.im_proto.GetConversationCoreInfoRequestBody.encode(
          m.get_conversation_core_info_body,
          w.uint32(7210).fork(),
        ).ldelim();
      if (m.set_conversation_core_info_body != null && Object.hasOwnProperty.call(m, 'set_conversation_core_info_body'))
        $root.im_proto.SetConversationCoreInfoRequestBody.encode(
          m.set_conversation_core_info_body,
          w.uint32(7218).fork(),
        ).ldelim();
      if (
        m.get_conversation_core_info_list_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_core_info_list_body')
      )
        $root.im_proto.GetConversationCoreInfoListRequestBody.encode(
          m.get_conversation_core_info_list_body,
          w.uint32(7226).fork(),
        ).ldelim();
      if (
        m.upsert_conversation_core_ext_info_body != null &&
        Object.hasOwnProperty.call(m, 'upsert_conversation_core_ext_info_body')
      )
        $root.im_proto.UpsertConversationCoreExtInfoRequestBody.encode(
          m.upsert_conversation_core_ext_info_body,
          w.uint32(7234).fork(),
        ).ldelim();
      if (
        m.delete_conversation_core_ext_info_body != null &&
        Object.hasOwnProperty.call(m, 'delete_conversation_core_ext_info_body')
      )
        $root.im_proto.DeleteConversationCoreExtInfoRequestBody.encode(
          m.delete_conversation_core_ext_info_body,
          w.uint32(7242).fork(),
        ).ldelim();
      if (
        m.get_conversation_setting_info_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_setting_info_body')
      )
        $root.im_proto.GetConversationSettingInfoRequestBody.encode(
          m.get_conversation_setting_info_body,
          w.uint32(7362).fork(),
        ).ldelim();
      if (
        m.set_conversation_setting_info_body != null &&
        Object.hasOwnProperty.call(m, 'set_conversation_setting_info_body')
      )
        $root.im_proto.SetConversationSettingInfoRequestBody.encode(
          m.set_conversation_setting_info_body,
          w.uint32(7370).fork(),
        ).ldelim();
      if (
        m.upsert_conversation_setting_ext_info_body != null &&
        Object.hasOwnProperty.call(m, 'upsert_conversation_setting_ext_info_body')
      )
        $root.im_proto.UpsertConversationSettingExtInfoRequestBody.encode(
          m.upsert_conversation_setting_ext_info_body,
          w.uint32(7378).fork(),
        ).ldelim();
      if (
        m.delete_conversation_setting_ext_info_body != null &&
        Object.hasOwnProperty.call(m, 'delete_conversation_setting_ext_info_body')
      )
        $root.im_proto.DeleteConversationSettingExtInfoRequestBody.encode(
          m.delete_conversation_setting_ext_info_body,
          w.uint32(7386).fork(),
        ).ldelim();
      if (m.get_stranger_conversation_body != null && Object.hasOwnProperty.call(m, 'get_stranger_conversation_body'))
        $root.im_proto.GetStrangerConversationListRequestBody.encode(
          m.get_stranger_conversation_body,
          w.uint32(8002).fork(),
        ).ldelim();
      if (m.get_stranger_messages_body != null && Object.hasOwnProperty.call(m, 'get_stranger_messages_body'))
        $root.im_proto.GetStrangerMessagesRequestBody.encode(
          m.get_stranger_messages_body,
          w.uint32(8010).fork(),
        ).ldelim();
      if (m.delete_stranger_message_body != null && Object.hasOwnProperty.call(m, 'delete_stranger_message_body'))
        $root.im_proto.DeleteStrangerMessageRequestBody.encode(
          m.delete_stranger_message_body,
          w.uint32(8018).fork(),
        ).ldelim();
      if (
        m.delete_stranger_conversation_body != null &&
        Object.hasOwnProperty.call(m, 'delete_stranger_conversation_body')
      )
        $root.im_proto.DeleteStrangerConversationRequestBody.encode(
          m.delete_stranger_conversation_body,
          w.uint32(8026).fork(),
        ).ldelim();
      if (
        m.delete_stranger_all_conversation_body != null &&
        Object.hasOwnProperty.call(m, 'delete_stranger_all_conversation_body')
      )
        $root.im_proto.DeleteStrangerAllConversationRequestBody.encode(
          m.delete_stranger_all_conversation_body,
          w.uint32(8034).fork(),
        ).ldelim();
      if (
        m.mark_stranger_conversation_read_body != null &&
        Object.hasOwnProperty.call(m, 'mark_stranger_conversation_read_body')
      )
        $root.im_proto.MarkStrangerConversationReadRequestBody.encode(
          m.mark_stranger_conversation_read_body,
          w.uint32(8042).fork(),
        ).ldelim();
      if (
        m.mark_stranger_all_conversation_read_body != null &&
        Object.hasOwnProperty.call(m, 'mark_stranger_all_conversation_read_body')
      )
        $root.im_proto.MarkStrangerAllConversationReadRequestBody.encode(
          m.mark_stranger_all_conversation_read_body,
          w.uint32(8050).fork(),
        ).ldelim();
      if (m.get_stranger_unread_count_body != null && Object.hasOwnProperty.call(m, 'get_stranger_unread_count_body'))
        $root.im_proto.GetStrangerUnreadCountRequestBody.encode(
          m.get_stranger_unread_count_body,
          w.uint32(8058).fork(),
        ).ldelim();
      if (m.participants_read_index_body != null && Object.hasOwnProperty.call(m, 'participants_read_index_body'))
        $root.im_proto.GetConversationParticipantsReadIndexV3RequestBody.encode(
          m.participants_read_index_body,
          w.uint32(16002).fork(),
        ).ldelim();
      if (m.participants_min_index_body != null && Object.hasOwnProperty.call(m, 'participants_min_index_body'))
        $root.im_proto.GetConversationParticipantsMinIndexV3RequestBody.encode(
          m.participants_min_index_body,
          w.uint32(16010).fork(),
        ).ldelim();
      if (m.get_upload_token_body != null && Object.hasOwnProperty.call(m, 'get_upload_token_body'))
        $root.im_proto.GetUploadTokenRequestBody.encode(m.get_upload_token_body, w.uint32(16026).fork()).ldelim();
      if (m.get_media_urls_body != null && Object.hasOwnProperty.call(m, 'get_media_urls_body'))
        $root.im_proto.GetMediaUrlsRequestBody.encode(m.get_media_urls_body, w.uint32(16034).fork()).ldelim();
      if (m.get_ticket_body != null && Object.hasOwnProperty.call(m, 'get_ticket_body'))
        $root.im_proto.GetTicketRequestBody.encode(m.get_ticket_body, w.uint32(16042).fork()).ldelim();
      if (m.get_conversation_list_body != null && Object.hasOwnProperty.call(m, 'get_conversation_list_body'))
        $root.im_proto.GetUserConversationListRequestBody.encode(
          m.get_conversation_list_body,
          w.uint32(16050).fork(),
        ).ldelim();
      if (m.broadcast_send_message_body != null && Object.hasOwnProperty.call(m, 'broadcast_send_message_body'))
        $root.im_proto.BroadcastSendMessageRequestBody.encode(
          m.broadcast_send_message_body,
          w.uint32(16058).fork(),
        ).ldelim();
      if (m.broadcast_recv_message_body != null && Object.hasOwnProperty.call(m, 'broadcast_recv_message_body'))
        $root.im_proto.BroadcastRecvMessageRequestBody.encode(
          m.broadcast_recv_message_body,
          w.uint32(16066).fork(),
        ).ldelim();
      if (m.broadcast_user_counter_body != null && Object.hasOwnProperty.call(m, 'broadcast_user_counter_body'))
        $root.im_proto.BroadcastUserCounterRequestBody.encode(
          m.broadcast_user_counter_body,
          w.uint32(16074).fork(),
        ).ldelim();
      if (m.client_ack_body != null && Object.hasOwnProperty.call(m, 'client_ack_body'))
        $root.im_proto.ClientACKRequestBody.encode(m.client_ack_body, w.uint32(16082).fork()).ldelim();
      if (m.create_voip_body != null && Object.hasOwnProperty.call(m, 'create_voip_body'))
        $root.im_proto.CreateVoipRequestBody.encode(m.create_voip_body, w.uint32(16090).fork()).ldelim();
      if (m.call_voip_body != null && Object.hasOwnProperty.call(m, 'call_voip_body'))
        $root.im_proto.CallVoipRequestBody.encode(m.call_voip_body, w.uint32(16098).fork()).ldelim();
      if (m.update_voip_body != null && Object.hasOwnProperty.call(m, 'update_voip_body'))
        $root.im_proto.UpdateVoipRequestBody.encode(m.update_voip_body, w.uint32(16106).fork()).ldelim();
      if (m.channel_heartbeat_body != null && Object.hasOwnProperty.call(m, 'channel_heartbeat_body'))
        $root.im_proto.ChannelHeartBeatRequestBody.encode(m.channel_heartbeat_body, w.uint32(16114).fork()).ldelim();
      if (m.profile_get_info != null && Object.hasOwnProperty.call(m, 'profile_get_info'))
        $root.im_proto.ProfileGetInfoRequestBody.encode(m.profile_get_info, w.uint32(16122).fork()).ldelim();
      if (m.report_client_metrics_body != null && Object.hasOwnProperty.call(m, 'report_client_metrics_body'))
        $root.im_proto.ReportClientMetricsRequestBody.encode(
          m.report_client_metrics_body,
          w.uint32(16130).fork(),
        ).ldelim();
      if (m.get_configs_body != null && Object.hasOwnProperty.call(m, 'get_configs_body'))
        $root.im_proto.GetConfigsRequestBody.encode(m.get_configs_body, w.uint32(16138).fork()).ldelim();
      if (m.unread_count_report_body != null && Object.hasOwnProperty.call(m, 'unread_count_report_body'))
        $root.im_proto.UnReadCountReportRequestBody.encode(m.unread_count_report_body, w.uint32(16146).fork()).ldelim();
      if (m.block_members_body != null && Object.hasOwnProperty.call(m, 'block_members_body'))
        $root.im_proto.BlockMembersRequestBody.encode(m.block_members_body, w.uint32(16154).fork()).ldelim();
      if (m.block_conversation_body != null && Object.hasOwnProperty.call(m, 'block_conversation_body'))
        $root.im_proto.BlockConversationRequestBody.encode(m.block_conversation_body, w.uint32(16162).fork()).ldelim();
      if (m.modify_message_ext_body != null && Object.hasOwnProperty.call(m, 'modify_message_ext_body'))
        $root.im_proto.ModifyMessageExtRequestBody.encode(m.modify_message_ext_body, w.uint32(16170).fork()).ldelim();
      if (
        m.get_conversation_audit_switch_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_audit_switch_body')
      )
        $root.im_proto.GetConversationAuditSwitchRequestBody.encode(
          m.get_conversation_audit_switch_body,
          w.uint32(16178).fork(),
        ).ldelim();
      if (
        m.update_conversation_audit_switch_body != null &&
        Object.hasOwnProperty.call(m, 'update_conversation_audit_switch_body')
      )
        $root.im_proto.UpdateConversationAuditSwitchRequestBody.encode(
          m.update_conversation_audit_switch_body,
          w.uint32(16186).fork(),
        ).ldelim();
      if (m.send_conversation_apply_body != null && Object.hasOwnProperty.call(m, 'send_conversation_apply_body'))
        $root.im_proto.SendConversationApplyRequestBody.encode(
          m.send_conversation_apply_body,
          w.uint32(16194).fork(),
        ).ldelim();
      if (m.ack_conversation_apply_body != null && Object.hasOwnProperty.call(m, 'ack_conversation_apply_body'))
        $root.im_proto.AckConversationApplyRequestBody.encode(
          m.ack_conversation_apply_body,
          w.uint32(16202).fork(),
        ).ldelim();
      if (m.get_conversation_apply_body != null && Object.hasOwnProperty.call(m, 'get_conversation_apply_body'))
        $root.im_proto.GetConversationApplyRequestBody.encode(
          m.get_conversation_apply_body,
          w.uint32(16210).fork(),
        ).ldelim();
      if (
        m.get_conversation_audit_list_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_audit_list_body')
      )
        $root.im_proto.GetConversationAuditListRequestBody.encode(
          m.get_conversation_audit_list_body,
          w.uint32(16218).fork(),
        ).ldelim();
      if (
        m.get_conversation_audit_unread_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_audit_unread_body')
      )
        $root.im_proto.GetConversationAuditUnreadRequestBody.encode(
          m.get_conversation_audit_unread_body,
          w.uint32(16226).fork(),
        ).ldelim();
      if (
        m.clear_conversation_audit_unread_body != null &&
        Object.hasOwnProperty.call(m, 'clear_conversation_audit_unread_body')
      )
        $root.im_proto.ClearConversationAuditUnreadRequestBody.encode(
          m.clear_conversation_audit_unread_body,
          w.uint32(16234).fork(),
        ).ldelim();
      if (m.get_unread_count_body != null && Object.hasOwnProperty.call(m, 'get_unread_count_body'))
        $root.im_proto.GetUnreadCountRequestBody.encode(m.get_unread_count_body, w.uint32(16242).fork()).ldelim();
      if (m.send_message_p2p_body != null && Object.hasOwnProperty.call(m, 'send_message_p2p_body'))
        $root.im_proto.SendMessageP2PRequestBody.encode(m.send_message_p2p_body, w.uint32(16250).fork()).ldelim();
      if (m.get_blocklist_body != null && Object.hasOwnProperty.call(m, 'get_blocklist_body'))
        $root.im_proto.GetBlockListRequestBody.encode(m.get_blocklist_body, w.uint32(16258).fork()).ldelim();
      if (m.set_blocklist_body != null && Object.hasOwnProperty.call(m, 'set_blocklist_body'))
        $root.im_proto.SetBlocklistRequestBody.encode(m.set_blocklist_body, w.uint32(16266).fork()).ldelim();
      if (m.check_in_blocklist_body != null && Object.hasOwnProperty.call(m, 'check_in_blocklist_body'))
        $root.im_proto.CheckInBlockListRequestBody.encode(m.check_in_blocklist_body, w.uint32(16274).fork()).ldelim();
      if (
        m.get_message_info_by_index_v2_body != null &&
        Object.hasOwnProperty.call(m, 'get_message_info_by_index_v2_body')
      )
        $root.im_proto.GetMessageInfoByIndexV2RequestBody.encode(
          m.get_message_info_by_index_v2_body,
          w.uint32(16282).fork(),
        ).ldelim();
      if (m.mark_message_body != null && Object.hasOwnProperty.call(m, 'mark_message_body'))
        $root.im_proto.MarkMessageRequestBody.encode(m.mark_message_body, w.uint32(16290).fork()).ldelim();
      if (m.pull_mark_message_body != null && Object.hasOwnProperty.call(m, 'pull_mark_message_body'))
        $root.im_proto.PullMarkMessageRequestBody.encode(m.pull_mark_message_body, w.uint32(16298).fork()).ldelim();
      if (
        m.batch_get_conversation_participants_readindex != null &&
        Object.hasOwnProperty.call(m, 'batch_get_conversation_participants_readindex')
      )
        $root.im_proto.BatchGetConversationParticipantsReadIndexRequestBody.encode(
          m.batch_get_conversation_participants_readindex,
          w.uint32(16306).fork(),
        ).ldelim();
      if (m.get_recent_message_body != null && Object.hasOwnProperty.call(m, 'get_recent_message_body'))
        $root.im_proto.GetRecentMessageReqBody.encode(m.get_recent_message_body, w.uint32(16314).fork()).ldelim();
      if (m.get_cmd_message_body != null && Object.hasOwnProperty.call(m, 'get_cmd_message_body'))
        $root.im_proto.GetCmdMessageReqBody.encode(m.get_cmd_message_body, w.uint32(16322).fork()).ldelim();
      if (
        m.get_message_info_by_index_v2_range_body != null &&
        Object.hasOwnProperty.call(m, 'get_message_info_by_index_v2_range_body')
      )
        $root.im_proto.GetMessageInfoByIndexV2RangeRequestBody.encode(
          m.get_message_info_by_index_v2_range_body,
          w.uint32(16330).fork(),
        ).ldelim();
      if (
        m.batch_get_conversation_audit_unread != null &&
        Object.hasOwnProperty.call(m, 'batch_get_conversation_audit_unread')
      )
        $root.im_proto.BatchGetConversationAuditUnreadRequestBody.encode(
          m.batch_get_conversation_audit_unread,
          w.uint32(16338).fork(),
        ).ldelim();
      if (m.message_by_init != null && Object.hasOwnProperty.call(m, 'message_by_init'))
        $root.im_proto.MessageByInitRequestBody.encode(m.message_by_init, w.uint32(16346).fork()).ldelim();
      if (
        m.previewer_messages_in_conversation_body != null &&
        Object.hasOwnProperty.call(m, 'previewer_messages_in_conversation_body')
      )
        $root.im_proto.PreviewerMessagesInConversationRequestBody.encode(
          m.previewer_messages_in_conversation_body,
          w.uint32(16354).fork(),
        ).ldelim();
      if (
        m.previewer_get_conversation_info_list_body != null &&
        Object.hasOwnProperty.call(m, 'previewer_get_conversation_info_list_body')
      )
        $root.im_proto.PreviewerGetConversationInfoListRequestBody.encode(
          m.previewer_get_conversation_info_list_body,
          w.uint32(16362).fork(),
        ).ldelim();
      if (m.send_friend_apply_body != null && Object.hasOwnProperty.call(m, 'send_friend_apply_body'))
        $root.im_proto.SendFriendApplyRequestBody.encode(m.send_friend_apply_body, w.uint32(16370).fork()).ldelim();
      if (m.get_friend_apply_list_body != null && Object.hasOwnProperty.call(m, 'get_friend_apply_list_body'))
        $root.im_proto.GetFriendApplyListRequestBody.encode(
          m.get_friend_apply_list_body,
          w.uint32(16378).fork(),
        ).ldelim();
      if (
        m.get_friend_receive_apply_list_body != null &&
        Object.hasOwnProperty.call(m, 'get_friend_receive_apply_list_body')
      )
        $root.im_proto.GetFriendReceiveApplyListRequestBody.encode(
          m.get_friend_receive_apply_list_body,
          w.uint32(16386).fork(),
        ).ldelim();
      if (m.reply_friend_apply_body != null && Object.hasOwnProperty.call(m, 'reply_friend_apply_body'))
        $root.im_proto.ReplyFriendApplyRequestBody.encode(m.reply_friend_apply_body, w.uint32(16394).fork()).ldelim();
      if (m.get_friend_list_body != null && Object.hasOwnProperty.call(m, 'get_friend_list_body'))
        $root.im_proto.GetFriendListRequestBody.encode(m.get_friend_list_body, w.uint32(16402).fork()).ldelim();
      if (m.delete_friend_body != null && Object.hasOwnProperty.call(m, 'delete_friend_body'))
        $root.im_proto.DeleteFriendRequestBody.encode(m.delete_friend_body, w.uint32(16410).fork()).ldelim();
      if (m.profile_batch_get_info_body != null && Object.hasOwnProperty.call(m, 'profile_batch_get_info_body'))
        $root.im_proto.ProfileBatchGetInfoRequestBody.encode(
          m.profile_batch_get_info_body,
          w.uint32(16418).fork(),
        ).ldelim();
      if (m.profile_search_info_body != null && Object.hasOwnProperty.call(m, 'profile_search_info_body'))
        $root.im_proto.ProfileSearchInfoRequestBody.encode(m.profile_search_info_body, w.uint32(16426).fork()).ldelim();
      if (m.mark_msg_unread_count_report != null && Object.hasOwnProperty.call(m, 'mark_msg_unread_count_report'))
        $root.im_proto.MarkMsgUnreadCountReportRequestBody.encode(
          m.mark_msg_unread_count_report,
          w.uint32(16434).fork(),
        ).ldelim();
      if (m.mark_msg_get_unread_count != null && Object.hasOwnProperty.call(m, 'mark_msg_get_unread_count'))
        $root.im_proto.MarkMsgGetUnreadCountRequestBody.encode(
          m.mark_msg_get_unread_count,
          w.uint32(16442).fork(),
        ).ldelim();
      if (m.batch_unmark_message != null && Object.hasOwnProperty.call(m, 'batch_unmark_message'))
        $root.im_proto.BatchUnmarkMessageRequestBody.encode(m.batch_unmark_message, w.uint32(16450).fork()).ldelim();
      if (m.client_batch_ack_body != null && Object.hasOwnProperty.call(m, 'client_batch_ack_body'))
        $root.im_proto.ClientBatchACKRequestBody.encode(m.client_batch_ack_body, w.uint32(16458).fork()).ldelim();
      if (
        m.media_upload_config_request_body != null &&
        Object.hasOwnProperty.call(m, 'media_upload_config_request_body')
      )
        $root.im_proto.GetMediaUploadConfigRequestBody.encode(
          m.media_upload_config_request_body,
          w.uint32(16474).fork(),
        ).ldelim();
      if (m.media_status_request_body != null && Object.hasOwnProperty.call(m, 'media_status_request_body'))
        $root.im_proto.GetMediaStatusRequestBody.encode(m.media_status_request_body, w.uint32(16482).fork()).ldelim();
      if (m.global_message_search_body != null && Object.hasOwnProperty.call(m, 'global_message_search_body'))
        $root.im_proto.GlobalMessageSearchRequestBody.encode(
          m.global_message_search_body,
          w.uint32(16802).fork(),
        ).ldelim();
      if (m.conversation_core_search_body != null && Object.hasOwnProperty.call(m, 'conversation_core_search_body'))
        $root.im_proto.ConversationCoreSearchRequestBody.encode(
          m.conversation_core_search_body,
          w.uint32(16810).fork(),
        ).ldelim();
      if (
        m.conversation_message_search_body != null &&
        Object.hasOwnProperty.call(m, 'conversation_message_search_body')
      )
        $root.im_proto.ConversationMessageSearchRequestBody.encode(
          m.conversation_message_search_body,
          w.uint32(16818).fork(),
        ).ldelim();
      if (
        m.conversation_message_pre_view_body != null &&
        Object.hasOwnProperty.call(m, 'conversation_message_pre_view_body')
      )
        $root.im_proto.ConversationMessagePreViewRequestBody.encode(
          m.conversation_message_pre_view_body,
          w.uint32(16826).fork(),
        ).ldelim();
      if (m.get_messages_body != null && Object.hasOwnProperty.call(m, 'get_messages_body'))
        $root.im_proto.GetMessagesRequestBody.encode(m.get_messages_body, w.uint32(17602).fork()).ldelim();
      if (m.vcd_clean_body != null && Object.hasOwnProperty.call(m, 'vcd_clean_body'))
        $root.im_proto.VcdCleanRequestBody.encode(m.vcd_clean_body, w.uint32(79994).fork()).ldelim();
      return w;
    };

    RequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.RequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 100:
            m.send_message_body = $root.im_proto.SendMessageRequestBody.decode(r, r.uint32());
            break;
          case 200:
            m.messages_per_user_body = $root.im_proto.MessagesPerUserRequestBody.decode(r, r.uint32());
            break;
          case 201:
            m.messages_per_user_init_body = $root.im_proto.MessagesPerUserInitRequestBody.decode(r, r.uint32());
            break;
          case 203:
            m.messages_per_user_init_v2_body = $root.im_proto.MessagesPerUserInitV2RequestBody.decode(r, r.uint32());
            break;
          case 206:
            m.messages_per_conversation_search_body = $root.im_proto.MessagesPerConversationSearchRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 210:
            m.check_messages_per_user_body = $root.im_proto.CheckMessagePerUserRequestBody.decode(r, r.uint32());
            break;
          case 211:
            m.get_message_by_id_body = $root.im_proto.GetMessageByIdRequestBody.decode(r, r.uint32());
            break;
          case 300:
            m.conversations_list_body = $root.im_proto.ConversationsListRequestBody.decode(r, r.uint32());
            break;
          case 301:
            m.messages_in_conversation_body = $root.im_proto.MessagesInConversationRequestBody.decode(r, r.uint32());
            break;
          case 302:
            m.get_messages_checkinfo_in_conversation_body =
              $root.im_proto.GetMessagesCheckInfoInConversationRequestBody.decode(r, r.uint32());
            break;
          case 303:
            m.get_messages_check_info_v2_body = $root.im_proto.GetMessagesCheckInfoV2RequestBody.decode(r, r.uint32());
            break;
          case 410:
            m.send_user_action_body = $root.im_proto.SendUserActionRequestBody.decode(r, r.uint32());
            break;
          case 411:
            m.send_input_status_body = $root.im_proto.SendInputStatusRequestBody.decode(r, r.uint32());
            break;
          case 600:
            m.get_conversation_info_body = $root.im_proto.GetConversationInfoRequestBody.decode(r, r.uint32());
            break;
          case 601:
            m.set_conversation_info_body = $root.im_proto.SetConversationInfoRequestBody.decode(r, r.uint32());
            break;
          case 602:
            m.create_conversation_body = $root.im_proto.CreateConversationRequestBody.decode(r, r.uint32());
            break;
          case 603:
            m.delete_conversation_body = $root.im_proto.DeleteConversationRequestBody.decode(r, r.uint32());
            break;
          case 604:
            m.mark_conversation_read_body = $root.im_proto.MarkConversationReadRequestBody.decode(r, r.uint32());
            break;
          case 605:
            m.conversation_participants_body = $root.im_proto.ConversationParticipantsListRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 607:
            m.get_conversation_info_list_body = $root.im_proto.GetConversationInfoListRequestBody.decode(r, r.uint32());
            break;
          case 606:
            m.report_conversation_cursor_body = $root.im_proto.ReportGetMessagesCursorRequestBody.decode(r, r.uint32());
            break;
          case 608:
            m.get_conversation_info_v2_body = $root.im_proto.GetConversationInfoV2RequestBody.decode(r, r.uint32());
            break;
          case 609:
            m.create_conversation_v2_body = $root.im_proto.CreateConversationV2RequestBody.decode(r, r.uint32());
            break;
          case 610:
            m.get_conversation_info_list_v2_body = $root.im_proto.GetConversationInfoListV2RequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 611:
            m.get_conversation_info_list_by_favorite_v2_body =
              $root.im_proto.ConversationsPerUserByFavoriteV2RequestBody.decode(r, r.uint32());
            break;
          case 612:
            m.get_conversation_info_list_by_top_v2_body = $root.im_proto.ConversationsPerUserByTopV2RequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 613:
            m.batch_mark_read_body = $root.im_proto.BatchMarkConversationReadRequestBody.decode(r, r.uint32());
            break;
          case 614:
            m.dissolve_conversation_body = $root.im_proto.DissolveConversationRequestBody.decode(r, r.uint32());
            break;
          case 615:
            m.get_conversations_checkinfo_body = $root.im_proto.GetConversationsCheckInfoRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 616:
            m.get_conversation_check_info_v2_body = $root.im_proto.GetConversationsCheckInfoV2RequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 650:
            m.conversation_add_participants_body = $root.im_proto.ConversationAddParticipantsRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 651:
            m.conversation_remove_participants_body = $root.im_proto.ConversationRemoveParticipantsRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 652:
            m.leave_conversation_body = $root.im_proto.ConversationLeaveRequestBody.decode(r, r.uint32());
            break;
          case 653:
            m.conversation_set_role_body = $root.im_proto.ConversationSetRoleRequestBody.decode(r, r.uint32());
            break;
          case 654:
            m.mget_conversation_participants_body = $root.im_proto.MgetConversationParticipantsRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 655:
            m.update_conversation_participant_body = $root.im_proto.UpdateConversationParticipantRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 656:
            m.batch_update_conversation_participant_body =
              $root.im_proto.BatchUpdateConversationParticipantRequestBody.decode(r, r.uint32());
            break;
          case 690:
            m.get_conversation_group_list_body = $root.im_proto.GetConversationGroupListRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 701:
            m.delete_message_body = $root.im_proto.DeleteMessageRequestBody.decode(r, r.uint32());
            break;
          case 702:
            m.recall_message_body = $root.im_proto.RecallMessageRequestBody.decode(r, r.uint32());
            break;
          case 703:
            m.reaction_message_body = $root.im_proto.ReactionMessageRequestBody.decode(r, r.uint32());
            break;
          case 704:
            m.sync_message_body = $root.im_proto.SyncMessageRequestBody.decode(r, r.uint32());
            break;
          case 705:
            m.modify_message_property_body = $root.im_proto.ModifyMessagePropertyRequestBody.decode(r, r.uint32());
            break;
          case 706:
            m.ack_message_body = $root.im_proto.AckMessageRequestBody.decode(r, r.uint32());
            break;
          case 801:
            m.get_group_info_body = $root.im_proto.GetGroupInfoRequestBody.decode(r, r.uint32());
            break;
          case 802:
            m.set_group_info_body = $root.im_proto.SetGroupInfoRequestBody.decode(r, r.uint32());
            break;
          case 803:
            m.get_group_info_list_body = $root.im_proto.GetGroupInfoListRequestBody.decode(r, r.uint32());
            break;
          case 901:
            m.get_conversation_core_info_body = $root.im_proto.GetConversationCoreInfoRequestBody.decode(r, r.uint32());
            break;
          case 902:
            m.set_conversation_core_info_body = $root.im_proto.SetConversationCoreInfoRequestBody.decode(r, r.uint32());
            break;
          case 903:
            m.get_conversation_core_info_list_body = $root.im_proto.GetConversationCoreInfoListRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 904:
            m.upsert_conversation_core_ext_info_body = $root.im_proto.UpsertConversationCoreExtInfoRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 905:
            m.delete_conversation_core_ext_info_body = $root.im_proto.DeleteConversationCoreExtInfoRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 920:
            m.get_conversation_setting_info_body = $root.im_proto.GetConversationSettingInfoRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 921:
            m.set_conversation_setting_info_body = $root.im_proto.SetConversationSettingInfoRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 922:
            m.upsert_conversation_setting_ext_info_body =
              $root.im_proto.UpsertConversationSettingExtInfoRequestBody.decode(r, r.uint32());
            break;
          case 923:
            m.delete_conversation_setting_ext_info_body =
              $root.im_proto.DeleteConversationSettingExtInfoRequestBody.decode(r, r.uint32());
            break;
          case 1000:
            m.get_stranger_conversation_body = $root.im_proto.GetStrangerConversationListRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 1001:
            m.get_stranger_messages_body = $root.im_proto.GetStrangerMessagesRequestBody.decode(r, r.uint32());
            break;
          case 1002:
            m.delete_stranger_message_body = $root.im_proto.DeleteStrangerMessageRequestBody.decode(r, r.uint32());
            break;
          case 1003:
            m.delete_stranger_conversation_body = $root.im_proto.DeleteStrangerConversationRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 1004:
            m.delete_stranger_all_conversation_body = $root.im_proto.DeleteStrangerAllConversationRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 1005:
            m.mark_stranger_conversation_read_body = $root.im_proto.MarkStrangerConversationReadRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 1006:
            m.mark_stranger_all_conversation_read_body =
              $root.im_proto.MarkStrangerAllConversationReadRequestBody.decode(r, r.uint32());
            break;
          case 1007:
            m.get_stranger_unread_count_body = $root.im_proto.GetStrangerUnreadCountRequestBody.decode(r, r.uint32());
            break;
          case 2000:
            m.participants_read_index_body = $root.im_proto.GetConversationParticipantsReadIndexV3RequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2001:
            m.participants_min_index_body = $root.im_proto.GetConversationParticipantsMinIndexV3RequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2003:
            m.get_upload_token_body = $root.im_proto.GetUploadTokenRequestBody.decode(r, r.uint32());
            break;
          case 2004:
            m.get_media_urls_body = $root.im_proto.GetMediaUrlsRequestBody.decode(r, r.uint32());
            break;
          case 2005:
            m.get_ticket_body = $root.im_proto.GetTicketRequestBody.decode(r, r.uint32());
            break;
          case 9999:
            m.vcd_clean_body = $root.im_proto.VcdCleanRequestBody.decode(r, r.uint32());
            break;
          case 2006:
            m.get_conversation_list_body = $root.im_proto.GetUserConversationListRequestBody.decode(r, r.uint32());
            break;
          case 2007:
            m.broadcast_send_message_body = $root.im_proto.BroadcastSendMessageRequestBody.decode(r, r.uint32());
            break;
          case 2008:
            m.broadcast_recv_message_body = $root.im_proto.BroadcastRecvMessageRequestBody.decode(r, r.uint32());
            break;
          case 2009:
            m.broadcast_user_counter_body = $root.im_proto.BroadcastUserCounterRequestBody.decode(r, r.uint32());
            break;
          case 2010:
            m.client_ack_body = $root.im_proto.ClientACKRequestBody.decode(r, r.uint32());
            break;
          case 2011:
            m.create_voip_body = $root.im_proto.CreateVoipRequestBody.decode(r, r.uint32());
            break;
          case 2012:
            m.call_voip_body = $root.im_proto.CallVoipRequestBody.decode(r, r.uint32());
            break;
          case 2013:
            m.update_voip_body = $root.im_proto.UpdateVoipRequestBody.decode(r, r.uint32());
            break;
          case 2014:
            m.channel_heartbeat_body = $root.im_proto.ChannelHeartBeatRequestBody.decode(r, r.uint32());
            break;
          case 2015:
            m.profile_get_info = $root.im_proto.ProfileGetInfoRequestBody.decode(r, r.uint32());
            break;
          case 2016:
            m.report_client_metrics_body = $root.im_proto.ReportClientMetricsRequestBody.decode(r, r.uint32());
            break;
          case 2017:
            m.get_configs_body = $root.im_proto.GetConfigsRequestBody.decode(r, r.uint32());
            break;
          case 2018:
            m.unread_count_report_body = $root.im_proto.UnReadCountReportRequestBody.decode(r, r.uint32());
            break;
          case 2019:
            m.block_members_body = $root.im_proto.BlockMembersRequestBody.decode(r, r.uint32());
            break;
          case 2020:
            m.block_conversation_body = $root.im_proto.BlockConversationRequestBody.decode(r, r.uint32());
            break;
          case 2021:
            m.modify_message_ext_body = $root.im_proto.ModifyMessageExtRequestBody.decode(r, r.uint32());
            break;
          case 2022:
            m.get_conversation_audit_switch_body = $root.im_proto.GetConversationAuditSwitchRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2023:
            m.update_conversation_audit_switch_body = $root.im_proto.UpdateConversationAuditSwitchRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2024:
            m.send_conversation_apply_body = $root.im_proto.SendConversationApplyRequestBody.decode(r, r.uint32());
            break;
          case 2025:
            m.ack_conversation_apply_body = $root.im_proto.AckConversationApplyRequestBody.decode(r, r.uint32());
            break;
          case 2026:
            m.get_conversation_apply_body = $root.im_proto.GetConversationApplyRequestBody.decode(r, r.uint32());
            break;
          case 2027:
            m.get_conversation_audit_list_body = $root.im_proto.GetConversationAuditListRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2028:
            m.get_conversation_audit_unread_body = $root.im_proto.GetConversationAuditUnreadRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2029:
            m.clear_conversation_audit_unread_body = $root.im_proto.ClearConversationAuditUnreadRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2030:
            m.get_unread_count_body = $root.im_proto.GetUnreadCountRequestBody.decode(r, r.uint32());
            break;
          case 2031:
            m.send_message_p2p_body = $root.im_proto.SendMessageP2PRequestBody.decode(r, r.uint32());
            break;
          case 2032:
            m.get_blocklist_body = $root.im_proto.GetBlockListRequestBody.decode(r, r.uint32());
            break;
          case 2033:
            m.set_blocklist_body = $root.im_proto.SetBlocklistRequestBody.decode(r, r.uint32());
            break;
          case 2034:
            m.check_in_blocklist_body = $root.im_proto.CheckInBlockListRequestBody.decode(r, r.uint32());
            break;
          case 2035:
            m.get_message_info_by_index_v2_body = $root.im_proto.GetMessageInfoByIndexV2RequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2042:
            m.batch_get_conversation_audit_unread = $root.im_proto.BatchGetConversationAuditUnreadRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2036:
            m.mark_message_body = $root.im_proto.MarkMessageRequestBody.decode(r, r.uint32());
            break;
          case 2037:
            m.pull_mark_message_body = $root.im_proto.PullMarkMessageRequestBody.decode(r, r.uint32());
            break;
          case 2038:
            m.batch_get_conversation_participants_readindex =
              $root.im_proto.BatchGetConversationParticipantsReadIndexRequestBody.decode(r, r.uint32());
            break;
          case 2039:
            m.get_recent_message_body = $root.im_proto.GetRecentMessageReqBody.decode(r, r.uint32());
            break;
          case 2040:
            m.get_cmd_message_body = $root.im_proto.GetCmdMessageReqBody.decode(r, r.uint32());
            break;
          case 2041:
            m.get_message_info_by_index_v2_range_body = $root.im_proto.GetMessageInfoByIndexV2RangeRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2043:
            m.message_by_init = $root.im_proto.MessageByInitRequestBody.decode(r, r.uint32());
            break;
          case 2044:
            m.previewer_messages_in_conversation_body =
              $root.im_proto.PreviewerMessagesInConversationRequestBody.decode(r, r.uint32());
            break;
          case 2045:
            m.previewer_get_conversation_info_list_body =
              $root.im_proto.PreviewerGetConversationInfoListRequestBody.decode(r, r.uint32());
            break;
          case 2046:
            m.send_friend_apply_body = $root.im_proto.SendFriendApplyRequestBody.decode(r, r.uint32());
            break;
          case 2047:
            m.get_friend_apply_list_body = $root.im_proto.GetFriendApplyListRequestBody.decode(r, r.uint32());
            break;
          case 2048:
            m.get_friend_receive_apply_list_body = $root.im_proto.GetFriendReceiveApplyListRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2049:
            m.reply_friend_apply_body = $root.im_proto.ReplyFriendApplyRequestBody.decode(r, r.uint32());
            break;
          case 2050:
            m.get_friend_list_body = $root.im_proto.GetFriendListRequestBody.decode(r, r.uint32());
            break;
          case 2051:
            m.delete_friend_body = $root.im_proto.DeleteFriendRequestBody.decode(r, r.uint32());
            break;
          case 2052:
            m.profile_batch_get_info_body = $root.im_proto.ProfileBatchGetInfoRequestBody.decode(r, r.uint32());
            break;
          case 2053:
            m.profile_search_info_body = $root.im_proto.ProfileSearchInfoRequestBody.decode(r, r.uint32());
            break;
          case 2054:
            m.mark_msg_unread_count_report = $root.im_proto.MarkMsgUnreadCountReportRequestBody.decode(r, r.uint32());
            break;
          case 2055:
            m.mark_msg_get_unread_count = $root.im_proto.MarkMsgGetUnreadCountRequestBody.decode(r, r.uint32());
            break;
          case 2056:
            m.batch_unmark_message = $root.im_proto.BatchUnmarkMessageRequestBody.decode(r, r.uint32());
            break;
          case 2057:
            m.client_batch_ack_body = $root.im_proto.ClientBatchACKRequestBody.decode(r, r.uint32());
            break;
          case 2059:
            m.media_upload_config_request_body = $root.im_proto.GetMediaUploadConfigRequestBody.decode(r, r.uint32());
            break;
          case 2060:
            m.media_status_request_body = $root.im_proto.GetMediaStatusRequestBody.decode(r, r.uint32());
            break;
          case 2100:
            m.global_message_search_body = $root.im_proto.GlobalMessageSearchRequestBody.decode(r, r.uint32());
            break;
          case 2101:
            m.conversation_core_search_body = $root.im_proto.ConversationCoreSearchRequestBody.decode(r, r.uint32());
            break;
          case 2102:
            m.conversation_message_search_body = $root.im_proto.ConversationMessageSearchRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2103:
            m.conversation_message_pre_view_body = $root.im_proto.ConversationMessagePreViewRequestBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2200:
            m.get_messages_body = $root.im_proto.GetMessagesRequestBody.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return RequestBody;
  })();

  im_proto.Request = (function () {
    function Request(p) {
      this.headers = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    Request.prototype.cmd = 0;
    Request.prototype.sequence_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Request.prototype.sdk_version = '';
    Request.prototype.token = '';
    Request.prototype.refer = 0;
    Request.prototype.inbox_type = 0;
    Request.prototype.build_number = '';
    Request.prototype.body = null;
    Request.prototype.device_id = '';
    Request.prototype.channel = '';
    Request.prototype.device_platform = '';
    Request.prototype.device_type = '';
    Request.prototype.os_version = '';
    Request.prototype.version_code = '';
    Request.prototype.headers = $util.emptyObject;
    Request.prototype.config_id = 0;
    Request.prototype.token_info = null;
    Request.prototype.auth_type = 0;
    Request.prototype.msg_trace = null;
    Request.prototype.retry_count = 0;

    Request.create = function create(properties) {
      return new Request(properties);
    };

    Request.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cmd != null && Object.hasOwnProperty.call(m, 'cmd')) w.uint32(8).int32(m.cmd);
      if (m.sequence_id != null && Object.hasOwnProperty.call(m, 'sequence_id')) w.uint32(16).int64(m.sequence_id);
      if (m.sdk_version != null && Object.hasOwnProperty.call(m, 'sdk_version')) w.uint32(26).string(m.sdk_version);
      if (m.token != null && Object.hasOwnProperty.call(m, 'token')) w.uint32(34).string(m.token);
      if (m.refer != null && Object.hasOwnProperty.call(m, 'refer')) w.uint32(40).int32(m.refer);
      if (m.inbox_type != null && Object.hasOwnProperty.call(m, 'inbox_type')) w.uint32(48).int32(m.inbox_type);
      if (m.build_number != null && Object.hasOwnProperty.call(m, 'build_number')) w.uint32(58).string(m.build_number);
      if (m.body != null && Object.hasOwnProperty.call(m, 'body'))
        $root.im_proto.RequestBody.encode(m.body, w.uint32(66).fork()).ldelim();
      if (m.device_id != null && Object.hasOwnProperty.call(m, 'device_id')) w.uint32(74).string(m.device_id);
      if (m.channel != null && Object.hasOwnProperty.call(m, 'channel')) w.uint32(82).string(m.channel);
      if (m.device_platform != null && Object.hasOwnProperty.call(m, 'device_platform'))
        w.uint32(90).string(m.device_platform);
      if (m.device_type != null && Object.hasOwnProperty.call(m, 'device_type')) w.uint32(98).string(m.device_type);
      if (m.os_version != null && Object.hasOwnProperty.call(m, 'os_version')) w.uint32(106).string(m.os_version);
      if (m.version_code != null && Object.hasOwnProperty.call(m, 'version_code')) w.uint32(114).string(m.version_code);
      if (m.headers != null && Object.hasOwnProperty.call(m, 'headers')) {
        for (var ks = Object.keys(m.headers), i = 0; i < ks.length; ++i) {
          w.uint32(122).fork().uint32(10).string(ks[i]).uint32(18).string(m.headers[ks[i]]).ldelim();
        }
      }
      if (m.config_id != null && Object.hasOwnProperty.call(m, 'config_id')) w.uint32(128).int32(m.config_id);
      if (m.token_info != null && Object.hasOwnProperty.call(m, 'token_info'))
        $root.im_proto.TokenInfo.encode(m.token_info, w.uint32(138).fork()).ldelim();
      if (m.auth_type != null && Object.hasOwnProperty.call(m, 'auth_type')) w.uint32(144).int32(m.auth_type);
      if (m.msg_trace != null && Object.hasOwnProperty.call(m, 'msg_trace'))
        $root.im_proto.MsgTrace.encode(m.msg_trace, w.uint32(154).fork()).ldelim();
      if (m.retry_count != null && Object.hasOwnProperty.call(m, 'retry_count')) w.uint32(160).int32(m.retry_count);
      return w;
    };

    Request.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.Request(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cmd = r.int32();
            break;
          case 2:
            m.sequence_id = r.int64();
            break;
          case 3:
            m.sdk_version = r.string();
            break;
          case 4:
            m.token = r.string();
            break;
          case 5:
            m.refer = r.int32();
            break;
          case 6:
            m.inbox_type = r.int32();
            break;
          case 7:
            m.build_number = r.string();
            break;
          case 8:
            m.body = $root.im_proto.RequestBody.decode(r, r.uint32());
            break;
          case 9:
            m.device_id = r.string();
            break;
          case 10:
            m.channel = r.string();
            break;
          case 11:
            m.device_platform = r.string();
            break;
          case 12:
            m.device_type = r.string();
            break;
          case 13:
            m.os_version = r.string();
            break;
          case 14:
            m.version_code = r.string();
            break;
          case 15:
            if (m.headers === $util.emptyObject) m.headers = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.headers[k] = value;
            break;
          case 16:
            m.config_id = r.int32();
            break;
          case 17:
            m.token_info = $root.im_proto.TokenInfo.decode(r, r.uint32());
            break;
          case 18:
            m.auth_type = r.int32();
            break;
          case 19:
            m.msg_trace = $root.im_proto.MsgTrace.decode(r, r.uint32());
            break;
          case 20:
            m.retry_count = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Request;
  })();

  im_proto.TokenInfo = (function () {
    function TokenInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    TokenInfo.prototype.mark_id = 0;
    TokenInfo.prototype.type = 0;
    TokenInfo.prototype.app_id = 0;
    TokenInfo.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    TokenInfo.prototype.timestamp = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    TokenInfo.prototype.app_id_without_hook = 0;
    TokenInfo.prototype.user_id_without_hook = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    TokenInfo.create = function create(properties) {
      return new TokenInfo(properties);
    };

    TokenInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.mark_id != null && Object.hasOwnProperty.call(m, 'mark_id')) w.uint32(8).int32(m.mark_id);
      if (m.type != null && Object.hasOwnProperty.call(m, 'type')) w.uint32(16).int32(m.type);
      if (m.app_id != null && Object.hasOwnProperty.call(m, 'app_id')) w.uint32(24).int32(m.app_id);
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(32).int64(m.user_id);
      if (m.timestamp != null && Object.hasOwnProperty.call(m, 'timestamp')) w.uint32(40).int64(m.timestamp);
      if (m.app_id_without_hook != null && Object.hasOwnProperty.call(m, 'app_id_without_hook'))
        w.uint32(48).int32(m.app_id_without_hook);
      if (m.user_id_without_hook != null && Object.hasOwnProperty.call(m, 'user_id_without_hook'))
        w.uint32(56).int64(m.user_id_without_hook);
      return w;
    };

    TokenInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.TokenInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.mark_id = r.int32();
            break;
          case 2:
            m.type = r.int32();
            break;
          case 3:
            m.app_id = r.int32();
            break;
          case 4:
            m.user_id = r.int64();
            break;
          case 5:
            m.timestamp = r.int64();
            break;
          case 6:
            m.app_id_without_hook = r.int32();
            break;
          case 7:
            m.user_id_without_hook = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return TokenInfo;
  })();

  im_proto.ResponseBody = (function () {
    function ResponseBody(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ResponseBody.prototype.send_message_body = null;
    ResponseBody.prototype.messages_per_user_body = null;
    ResponseBody.prototype.messages_per_user_init_body = null;
    ResponseBody.prototype.messages_per_user_init_v2_body = null;
    ResponseBody.prototype.messages_per_conversation_search_body = null;
    ResponseBody.prototype.check_messages_per_user_body = null;
    ResponseBody.prototype.get_message_by_id_body = null;
    ResponseBody.prototype.conversations_list_body = null;
    ResponseBody.prototype.messages_in_conversation_body = null;
    ResponseBody.prototype.get_messages_checkinfo_in_conversation_body = null;
    ResponseBody.prototype.get_message_check_info_v2_body = null;
    ResponseBody.prototype.send_user_action_body = null;
    ResponseBody.prototype.send_input_status_body = null;
    ResponseBody.prototype.has_new_message_notify = null;
    ResponseBody.prototype.mark_conversation_read_notify = null;
    ResponseBody.prototype.conversation_info_updated_notify = null;
    ResponseBody.prototype.stranger_has_new_message_notify = null;
    ResponseBody.prototype.has_new_direct_push_notify = null;
    ResponseBody.prototype.input_status_notify = null;
    ResponseBody.prototype.biz_has_new_direct_push_notify = null;
    ResponseBody.prototype.new_friend_message_notify = null;
    ResponseBody.prototype.get_conversation_info_body = null;
    ResponseBody.prototype.set_conversation_info_body = null;
    ResponseBody.prototype.create_conversation_body = null;
    ResponseBody.prototype.get_conversations_info_list_body = null;
    ResponseBody.prototype.batch_mark_read_body = null;
    ResponseBody.prototype.get_conversations_checkinfo_body = null;
    ResponseBody.prototype.get_conversations_check_info_v2_body = null;
    ResponseBody.prototype.get_conversation_info_v2_body = null;
    ResponseBody.prototype.create_conversation_v2_body = null;
    ResponseBody.prototype.get_conversation_info_list_v2_body = null;
    ResponseBody.prototype.get_conversation_info_list_by_favorite_v2_body = null;
    ResponseBody.prototype.get_conversation_info_list_by_top_v2_body = null;
    ResponseBody.prototype.conversation_participants_body = null;
    ResponseBody.prototype.conversation_add_participants_body = null;
    ResponseBody.prototype.conversation_remove_participants_body = null;
    ResponseBody.prototype.conversation_set_role_body = null;
    ResponseBody.prototype.mget_conversation_participants_body = null;
    ResponseBody.prototype.update_conversation_participant_body = null;
    ResponseBody.prototype.batch_update_conversation_participant_body = null;
    ResponseBody.prototype.get_conversation_group_list_body = null;
    ResponseBody.prototype.reaction_message_body = null;
    ResponseBody.prototype.sync_message_body = null;
    ResponseBody.prototype.modify_message_property_body = null;
    ResponseBody.prototype.ack_message_body = null;
    ResponseBody.prototype.get_group_info_body = null;
    ResponseBody.prototype.set_group_info_body = null;
    ResponseBody.prototype.get_groups_info_body = null;
    ResponseBody.prototype.get_conversation_core_info_body = null;
    ResponseBody.prototype.set_conversation_core_info_body = null;
    ResponseBody.prototype.get_conversation_core_info_list_body = null;
    ResponseBody.prototype.upsert_conversation_core_ext_info_body = null;
    ResponseBody.prototype.delete_conversation_core_ext_info_body = null;
    ResponseBody.prototype.get_conversation_setting_info_body = null;
    ResponseBody.prototype.set_conversation_setting_info_body = null;
    ResponseBody.prototype.upsert_conversation_setting_ext_info_body = null;
    ResponseBody.prototype.delete_conversation_setting_ext_info_body = null;
    ResponseBody.prototype.get_stranger_conversation_body = null;
    ResponseBody.prototype.get_stranger_messages_body = null;
    ResponseBody.prototype.delete_stranger_message_body = null;
    ResponseBody.prototype.delete_stranger_conversation_body = null;
    ResponseBody.prototype.delete_stranger_all_conversation_body = null;
    ResponseBody.prototype.mark_stranger_conversation_read_body = null;
    ResponseBody.prototype.mark_stranger_all_conversation_read_body = null;
    ResponseBody.prototype.get_stranger_unread_count_body = null;
    ResponseBody.prototype.participants_read_index_body = null;
    ResponseBody.prototype.participants_min_index_body = null;
    ResponseBody.prototype.get_upload_token_body = null;
    ResponseBody.prototype.get_media_urls_body = null;
    ResponseBody.prototype.get_ticket_body = null;
    ResponseBody.prototype.vcd_clean_body = null;
    ResponseBody.prototype.get_conversation_list_body = null;
    ResponseBody.prototype.broadcast_send_message_body = null;
    ResponseBody.prototype.broadcast_recv_message_body = null;
    ResponseBody.prototype.broadcast_user_counter_body = null;
    ResponseBody.prototype.client_ack_body = null;
    ResponseBody.prototype.create_voip_body = null;
    ResponseBody.prototype.call_voip_body = null;
    ResponseBody.prototype.update_voip_body = null;
    ResponseBody.prototype.channel_heartbeat_body = null;
    ResponseBody.prototype.profile_get_info = null;
    ResponseBody.prototype.report_client_metrics_body = null;
    ResponseBody.prototype.get_configs_body = null;
    ResponseBody.prototype.unread_count_report_body = null;
    ResponseBody.prototype.block_members_body = null;
    ResponseBody.prototype.block_conversation_body = null;
    ResponseBody.prototype.modify_message_ext_body = null;
    ResponseBody.prototype.get_conversation_audit_switch_body = null;
    ResponseBody.prototype.update_conversation_audit_switch_body = null;
    ResponseBody.prototype.send_conversation_apply_body = null;
    ResponseBody.prototype.ack_conversation_apply_body = null;
    ResponseBody.prototype.get_conversation_apply_body = null;
    ResponseBody.prototype.get_conversation_audit_list_body = null;
    ResponseBody.prototype.get_conversation_audit_unread_body = null;
    ResponseBody.prototype.clear_conversation_audit_unread_body = null;
    ResponseBody.prototype.get_unread_count_body = null;
    ResponseBody.prototype.send_message_p2p_body = null;
    ResponseBody.prototype.get_blocklist_body = null;
    ResponseBody.prototype.set_blocklist_body = null;
    ResponseBody.prototype.check_in_blocklist_body = null;
    ResponseBody.prototype.get_message_info_by_index_v2_body = null;
    ResponseBody.prototype.batch_get_conversation_audit_unread_body = null;
    ResponseBody.prototype.mark_message_body = null;
    ResponseBody.prototype.pull_mark_message_body = null;
    ResponseBody.prototype.batch_get_conversation_participants_readindex = null;
    ResponseBody.prototype.get_recent_message_body = null;
    ResponseBody.prototype.get_cmd_message_body = null;
    ResponseBody.prototype.get_message_info_by_index_v2_range_body = null;
    ResponseBody.prototype.message_by_init = null;
    ResponseBody.prototype.previewer_messages_in_conversation_body = null;
    ResponseBody.prototype.previewer_get_conversation_info_list_body = null;
    ResponseBody.prototype.send_friend_apply_body = null;
    ResponseBody.prototype.get_friend_apply_list_body = null;
    ResponseBody.prototype.get_friend_receive_apply_list_body = null;
    ResponseBody.prototype.reply_friend_apply_body = null;
    ResponseBody.prototype.get_friend_list_body = null;
    ResponseBody.prototype.delete_friend_body = null;
    ResponseBody.prototype.profile_batch_get_info_body = null;
    ResponseBody.prototype.profile_search_info_body = null;
    ResponseBody.prototype.mark_msg_unread_count_report = null;
    ResponseBody.prototype.mark_msg_get_unread_count = null;
    ResponseBody.prototype.batch_unmark_message = null;
    ResponseBody.prototype.client_batch_ack_body = null;
    ResponseBody.prototype.media_upload_config_response_body = null;
    ResponseBody.prototype.media_status_response_body = null;
    ResponseBody.prototype.global_message_search_body = null;
    ResponseBody.prototype.conversation_core_search_body = null;
    ResponseBody.prototype.conversation_message_search_body = null;
    ResponseBody.prototype.conversation_message_pre_view_body = null;
    ResponseBody.prototype.get_messages_body = null;

    ResponseBody.create = function create(properties) {
      return new ResponseBody(properties);
    };

    ResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.send_message_body != null && Object.hasOwnProperty.call(m, 'send_message_body'))
        $root.im_proto.SendMessageResponseBody.encode(m.send_message_body, w.uint32(802).fork()).ldelim();
      if (m.messages_per_user_body != null && Object.hasOwnProperty.call(m, 'messages_per_user_body'))
        $root.im_proto.MessagesPerUserResponseBody.encode(m.messages_per_user_body, w.uint32(1602).fork()).ldelim();
      if (m.messages_per_user_init_body != null && Object.hasOwnProperty.call(m, 'messages_per_user_init_body'))
        $root.im_proto.MessagesPerUserInitResponseBody.encode(
          m.messages_per_user_init_body,
          w.uint32(1610).fork(),
        ).ldelim();
      if (m.messages_per_user_init_v2_body != null && Object.hasOwnProperty.call(m, 'messages_per_user_init_v2_body'))
        $root.im_proto.MessagesPerUserInitV2ResponseBody.encode(
          m.messages_per_user_init_v2_body,
          w.uint32(1626).fork(),
        ).ldelim();
      if (
        m.messages_per_conversation_search_body != null &&
        Object.hasOwnProperty.call(m, 'messages_per_conversation_search_body')
      )
        $root.im_proto.MessagesPerConversationSearchResponseBody.encode(
          m.messages_per_conversation_search_body,
          w.uint32(1650).fork(),
        ).ldelim();
      if (m.check_messages_per_user_body != null && Object.hasOwnProperty.call(m, 'check_messages_per_user_body'))
        $root.im_proto.CheckMessagesPerUserResponseBody.encode(
          m.check_messages_per_user_body,
          w.uint32(1682).fork(),
        ).ldelim();
      if (m.get_message_by_id_body != null && Object.hasOwnProperty.call(m, 'get_message_by_id_body'))
        $root.im_proto.GetMessageByIdResponseBody.encode(m.get_message_by_id_body, w.uint32(1690).fork()).ldelim();
      if (m.conversations_list_body != null && Object.hasOwnProperty.call(m, 'conversations_list_body'))
        $root.im_proto.ConversationsListResponseBody.encode(m.conversations_list_body, w.uint32(2402).fork()).ldelim();
      if (m.messages_in_conversation_body != null && Object.hasOwnProperty.call(m, 'messages_in_conversation_body'))
        $root.im_proto.MessagesInConversationResponseBody.encode(
          m.messages_in_conversation_body,
          w.uint32(2410).fork(),
        ).ldelim();
      if (
        m.get_messages_checkinfo_in_conversation_body != null &&
        Object.hasOwnProperty.call(m, 'get_messages_checkinfo_in_conversation_body')
      )
        $root.im_proto.GetMessagesCheckInfoInConversationResponseBody.encode(
          m.get_messages_checkinfo_in_conversation_body,
          w.uint32(2418).fork(),
        ).ldelim();
      if (m.get_message_check_info_v2_body != null && Object.hasOwnProperty.call(m, 'get_message_check_info_v2_body'))
        $root.im_proto.GetMessagesCheckInfoV2ResponseBody.encode(
          m.get_message_check_info_v2_body,
          w.uint32(2426).fork(),
        ).ldelim();
      if (m.send_user_action_body != null && Object.hasOwnProperty.call(m, 'send_user_action_body'))
        $root.im_proto.SendUserActionResponseBody.encode(m.send_user_action_body, w.uint32(3282).fork()).ldelim();
      if (m.send_input_status_body != null && Object.hasOwnProperty.call(m, 'send_input_status_body'))
        $root.im_proto.SendInputStatusResponseBody.encode(m.send_input_status_body, w.uint32(3290).fork()).ldelim();
      if (m.has_new_message_notify != null && Object.hasOwnProperty.call(m, 'has_new_message_notify'))
        $root.im_proto.NewMessageNotify.encode(m.has_new_message_notify, w.uint32(4002).fork()).ldelim();
      if (m.mark_conversation_read_notify != null && Object.hasOwnProperty.call(m, 'mark_conversation_read_notify'))
        $root.im_proto.MarkConversationReadNotify.encode(
          m.mark_conversation_read_notify,
          w.uint32(4010).fork(),
        ).ldelim();
      if (
        m.conversation_info_updated_notify != null &&
        Object.hasOwnProperty.call(m, 'conversation_info_updated_notify')
      )
        $root.im_proto.ConversationInfoUpdatedNotify.encode(
          m.conversation_info_updated_notify,
          w.uint32(4018).fork(),
        ).ldelim();
      if (m.stranger_has_new_message_notify != null && Object.hasOwnProperty.call(m, 'stranger_has_new_message_notify'))
        $root.im_proto.StrangerNewMessageNotify.encode(
          m.stranger_has_new_message_notify,
          w.uint32(4026).fork(),
        ).ldelim();
      if (m.has_new_direct_push_notify != null && Object.hasOwnProperty.call(m, 'has_new_direct_push_notify'))
        $root.im_proto.NewDirectPushNotify.encode(m.has_new_direct_push_notify, w.uint32(4034).fork()).ldelim();
      if (m.new_friend_message_notify != null && Object.hasOwnProperty.call(m, 'new_friend_message_notify'))
        $root.im_proto.NewFriendMessageNotify.encode(m.new_friend_message_notify, w.uint32(4058).fork()).ldelim();
      if (m.input_status_notify != null && Object.hasOwnProperty.call(m, 'input_status_notify'))
        $root.im_proto.InputStatusNotify.encode(m.input_status_notify, w.uint32(4082).fork()).ldelim();
      if (m.biz_has_new_direct_push_notify != null && Object.hasOwnProperty.call(m, 'biz_has_new_direct_push_notify'))
        $root.im_proto.BizNewDirectPushNotify.encode(m.biz_has_new_direct_push_notify, w.uint32(4090).fork()).ldelim();
      if (m.get_conversation_info_body != null && Object.hasOwnProperty.call(m, 'get_conversation_info_body'))
        $root.im_proto.GetConversationInfoResponseBody.encode(
          m.get_conversation_info_body,
          w.uint32(4802).fork(),
        ).ldelim();
      if (m.set_conversation_info_body != null && Object.hasOwnProperty.call(m, 'set_conversation_info_body'))
        $root.im_proto.SetConversationInfoResponseBody.encode(
          m.set_conversation_info_body,
          w.uint32(4810).fork(),
        ).ldelim();
      if (m.create_conversation_body != null && Object.hasOwnProperty.call(m, 'create_conversation_body'))
        $root.im_proto.CreateConversationResponseBody.encode(
          m.create_conversation_body,
          w.uint32(4818).fork(),
        ).ldelim();
      if (m.conversation_participants_body != null && Object.hasOwnProperty.call(m, 'conversation_participants_body'))
        $root.im_proto.ConversationParticipantsListResponseBody.encode(
          m.conversation_participants_body,
          w.uint32(4842).fork(),
        ).ldelim();
      if (
        m.get_conversations_info_list_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversations_info_list_body')
      )
        $root.im_proto.GetConversationInfoListResponseBody.encode(
          m.get_conversations_info_list_body,
          w.uint32(4858).fork(),
        ).ldelim();
      if (m.get_conversation_info_v2_body != null && Object.hasOwnProperty.call(m, 'get_conversation_info_v2_body'))
        $root.im_proto.GetConversationInfoV2ResponseBody.encode(
          m.get_conversation_info_v2_body,
          w.uint32(4866).fork(),
        ).ldelim();
      if (m.create_conversation_v2_body != null && Object.hasOwnProperty.call(m, 'create_conversation_v2_body'))
        $root.im_proto.CreateConversationV2ResponseBody.encode(
          m.create_conversation_v2_body,
          w.uint32(4874).fork(),
        ).ldelim();
      if (
        m.get_conversation_info_list_v2_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_info_list_v2_body')
      )
        $root.im_proto.GetConversationInfoListV2ResponseBody.encode(
          m.get_conversation_info_list_v2_body,
          w.uint32(4882).fork(),
        ).ldelim();
      if (
        m.get_conversation_info_list_by_favorite_v2_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_info_list_by_favorite_v2_body')
      )
        $root.im_proto.GetConversationInfoListByFavoriteV2ResponseBody.encode(
          m.get_conversation_info_list_by_favorite_v2_body,
          w.uint32(4890).fork(),
        ).ldelim();
      if (
        m.get_conversation_info_list_by_top_v2_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_info_list_by_top_v2_body')
      )
        $root.im_proto.GetConversationInfoListByTopV2ResponseBody.encode(
          m.get_conversation_info_list_by_top_v2_body,
          w.uint32(4898).fork(),
        ).ldelim();
      if (m.batch_mark_read_body != null && Object.hasOwnProperty.call(m, 'batch_mark_read_body'))
        $root.im_proto.BatchMarkConversationReadResponseBody.encode(
          m.batch_mark_read_body,
          w.uint32(4906).fork(),
        ).ldelim();
      if (
        m.get_conversations_checkinfo_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversations_checkinfo_body')
      )
        $root.im_proto.GetConversationsCheckInfoResponseBody.encode(
          m.get_conversations_checkinfo_body,
          w.uint32(4922).fork(),
        ).ldelim();
      if (
        m.get_conversations_check_info_v2_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversations_check_info_v2_body')
      )
        $root.im_proto.GetConversationsCheckInfoV2ResponseBody.encode(
          m.get_conversations_check_info_v2_body,
          w.uint32(4930).fork(),
        ).ldelim();
      if (
        m.conversation_add_participants_body != null &&
        Object.hasOwnProperty.call(m, 'conversation_add_participants_body')
      )
        $root.im_proto.ConversationAddParticipantsResponseBody.encode(
          m.conversation_add_participants_body,
          w.uint32(5202).fork(),
        ).ldelim();
      if (
        m.conversation_remove_participants_body != null &&
        Object.hasOwnProperty.call(m, 'conversation_remove_participants_body')
      )
        $root.im_proto.ConversationRemoveParticipantsResponseBody.encode(
          m.conversation_remove_participants_body,
          w.uint32(5210).fork(),
        ).ldelim();
      if (m.conversation_set_role_body != null && Object.hasOwnProperty.call(m, 'conversation_set_role_body'))
        $root.im_proto.ConversationSetRoleResponseBody.encode(
          m.conversation_set_role_body,
          w.uint32(5226).fork(),
        ).ldelim();
      if (
        m.mget_conversation_participants_body != null &&
        Object.hasOwnProperty.call(m, 'mget_conversation_participants_body')
      )
        $root.im_proto.MgetConversationParticipantsResponseBody.encode(
          m.mget_conversation_participants_body,
          w.uint32(5234).fork(),
        ).ldelim();
      if (
        m.update_conversation_participant_body != null &&
        Object.hasOwnProperty.call(m, 'update_conversation_participant_body')
      )
        $root.im_proto.UpdateConversationParticipantResponseBody.encode(
          m.update_conversation_participant_body,
          w.uint32(5242).fork(),
        ).ldelim();
      if (
        m.batch_update_conversation_participant_body != null &&
        Object.hasOwnProperty.call(m, 'batch_update_conversation_participant_body')
      )
        $root.im_proto.BatchUpdateConversationParticipantResponseBody.encode(
          m.batch_update_conversation_participant_body,
          w.uint32(5250).fork(),
        ).ldelim();
      if (
        m.get_conversation_group_list_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_group_list_body')
      )
        $root.im_proto.GetConversationGroupListResponseBody.encode(
          m.get_conversation_group_list_body,
          w.uint32(5522).fork(),
        ).ldelim();
      if (m.reaction_message_body != null && Object.hasOwnProperty.call(m, 'reaction_message_body'))
        $root.im_proto.ReactionMessageResponseBody.encode(m.reaction_message_body, w.uint32(5626).fork()).ldelim();
      if (m.sync_message_body != null && Object.hasOwnProperty.call(m, 'sync_message_body'))
        $root.im_proto.SyncMessageResponseBody.encode(m.sync_message_body, w.uint32(5634).fork()).ldelim();
      if (m.modify_message_property_body != null && Object.hasOwnProperty.call(m, 'modify_message_property_body'))
        $root.im_proto.ModifyMessagePropertyResponseBody.encode(
          m.modify_message_property_body,
          w.uint32(5642).fork(),
        ).ldelim();
      if (m.ack_message_body != null && Object.hasOwnProperty.call(m, 'ack_message_body'))
        $root.im_proto.AckMessageResponseBody.encode(m.ack_message_body, w.uint32(5650).fork()).ldelim();
      if (m.get_group_info_body != null && Object.hasOwnProperty.call(m, 'get_group_info_body'))
        $root.im_proto.GetGroupInfoResponseBody.encode(m.get_group_info_body, w.uint32(6410).fork()).ldelim();
      if (m.set_group_info_body != null && Object.hasOwnProperty.call(m, 'set_group_info_body'))
        $root.im_proto.SetGroupInfoResponseBody.encode(m.set_group_info_body, w.uint32(6418).fork()).ldelim();
      if (m.get_groups_info_body != null && Object.hasOwnProperty.call(m, 'get_groups_info_body'))
        $root.im_proto.GetGroupInfoListResponseBody.encode(m.get_groups_info_body, w.uint32(6426).fork()).ldelim();
      if (m.get_conversation_core_info_body != null && Object.hasOwnProperty.call(m, 'get_conversation_core_info_body'))
        $root.im_proto.GetConversationCoreInfoResponseBody.encode(
          m.get_conversation_core_info_body,
          w.uint32(7210).fork(),
        ).ldelim();
      if (m.set_conversation_core_info_body != null && Object.hasOwnProperty.call(m, 'set_conversation_core_info_body'))
        $root.im_proto.SetConversationCoreInfoResponseBody.encode(
          m.set_conversation_core_info_body,
          w.uint32(7218).fork(),
        ).ldelim();
      if (
        m.get_conversation_core_info_list_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_core_info_list_body')
      )
        $root.im_proto.GetConversationCoreInfoListResponseBody.encode(
          m.get_conversation_core_info_list_body,
          w.uint32(7226).fork(),
        ).ldelim();
      if (
        m.upsert_conversation_core_ext_info_body != null &&
        Object.hasOwnProperty.call(m, 'upsert_conversation_core_ext_info_body')
      )
        $root.im_proto.UpsertConversationCoreExtInfoResponseBody.encode(
          m.upsert_conversation_core_ext_info_body,
          w.uint32(7234).fork(),
        ).ldelim();
      if (
        m.delete_conversation_core_ext_info_body != null &&
        Object.hasOwnProperty.call(m, 'delete_conversation_core_ext_info_body')
      )
        $root.im_proto.DeleteConversationCoreExtInfoResponseBody.encode(
          m.delete_conversation_core_ext_info_body,
          w.uint32(7242).fork(),
        ).ldelim();
      if (
        m.get_conversation_setting_info_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_setting_info_body')
      )
        $root.im_proto.GetConversationSettingInfoResponseBody.encode(
          m.get_conversation_setting_info_body,
          w.uint32(7362).fork(),
        ).ldelim();
      if (
        m.set_conversation_setting_info_body != null &&
        Object.hasOwnProperty.call(m, 'set_conversation_setting_info_body')
      )
        $root.im_proto.SetConversationSettingInfoResponseBody.encode(
          m.set_conversation_setting_info_body,
          w.uint32(7370).fork(),
        ).ldelim();
      if (
        m.upsert_conversation_setting_ext_info_body != null &&
        Object.hasOwnProperty.call(m, 'upsert_conversation_setting_ext_info_body')
      )
        $root.im_proto.UpsertConversationSettingExtInfoResponseBody.encode(
          m.upsert_conversation_setting_ext_info_body,
          w.uint32(7378).fork(),
        ).ldelim();
      if (
        m.delete_conversation_setting_ext_info_body != null &&
        Object.hasOwnProperty.call(m, 'delete_conversation_setting_ext_info_body')
      )
        $root.im_proto.DeleteConversationSettingExtInfoResponseBody.encode(
          m.delete_conversation_setting_ext_info_body,
          w.uint32(7386).fork(),
        ).ldelim();
      if (m.get_stranger_conversation_body != null && Object.hasOwnProperty.call(m, 'get_stranger_conversation_body'))
        $root.im_proto.GetStrangerConversationListResponseBody.encode(
          m.get_stranger_conversation_body,
          w.uint32(8002).fork(),
        ).ldelim();
      if (m.get_stranger_messages_body != null && Object.hasOwnProperty.call(m, 'get_stranger_messages_body'))
        $root.im_proto.GetStrangerMessagesResponseBody.encode(
          m.get_stranger_messages_body,
          w.uint32(8010).fork(),
        ).ldelim();
      if (m.delete_stranger_message_body != null && Object.hasOwnProperty.call(m, 'delete_stranger_message_body'))
        $root.im_proto.DeleteStrangerMessageResponseBody.encode(
          m.delete_stranger_message_body,
          w.uint32(8018).fork(),
        ).ldelim();
      if (
        m.delete_stranger_conversation_body != null &&
        Object.hasOwnProperty.call(m, 'delete_stranger_conversation_body')
      )
        $root.im_proto.DeleteStrangerConversationResponseBody.encode(
          m.delete_stranger_conversation_body,
          w.uint32(8026).fork(),
        ).ldelim();
      if (
        m.delete_stranger_all_conversation_body != null &&
        Object.hasOwnProperty.call(m, 'delete_stranger_all_conversation_body')
      )
        $root.im_proto.DeleteStrangerAllConversationResponseBody.encode(
          m.delete_stranger_all_conversation_body,
          w.uint32(8034).fork(),
        ).ldelim();
      if (
        m.mark_stranger_conversation_read_body != null &&
        Object.hasOwnProperty.call(m, 'mark_stranger_conversation_read_body')
      )
        $root.im_proto.MarkStrangerConversationReadResponseBody.encode(
          m.mark_stranger_conversation_read_body,
          w.uint32(8042).fork(),
        ).ldelim();
      if (
        m.mark_stranger_all_conversation_read_body != null &&
        Object.hasOwnProperty.call(m, 'mark_stranger_all_conversation_read_body')
      )
        $root.im_proto.MarkStrangerAllConversationReadResponseBody.encode(
          m.mark_stranger_all_conversation_read_body,
          w.uint32(8050).fork(),
        ).ldelim();
      if (m.get_stranger_unread_count_body != null && Object.hasOwnProperty.call(m, 'get_stranger_unread_count_body'))
        $root.im_proto.GetStrangerUnreadCountResponseBody.encode(
          m.get_stranger_unread_count_body,
          w.uint32(8058).fork(),
        ).ldelim();
      if (m.participants_read_index_body != null && Object.hasOwnProperty.call(m, 'participants_read_index_body'))
        $root.im_proto.GetConversationParticipantsReadIndexV3ResponseBody.encode(
          m.participants_read_index_body,
          w.uint32(16002).fork(),
        ).ldelim();
      if (m.participants_min_index_body != null && Object.hasOwnProperty.call(m, 'participants_min_index_body'))
        $root.im_proto.GetConversationParticipantsMinIndexV3ResponseBody.encode(
          m.participants_min_index_body,
          w.uint32(16010).fork(),
        ).ldelim();
      if (m.get_upload_token_body != null && Object.hasOwnProperty.call(m, 'get_upload_token_body'))
        $root.im_proto.GetUploadTokenResponseBody.encode(m.get_upload_token_body, w.uint32(16026).fork()).ldelim();
      if (m.get_media_urls_body != null && Object.hasOwnProperty.call(m, 'get_media_urls_body'))
        $root.im_proto.GetMediaUrlsResponseBody.encode(m.get_media_urls_body, w.uint32(16034).fork()).ldelim();
      if (m.get_ticket_body != null && Object.hasOwnProperty.call(m, 'get_ticket_body'))
        $root.im_proto.GetTicketResponseBody.encode(m.get_ticket_body, w.uint32(16042).fork()).ldelim();
      if (m.get_conversation_list_body != null && Object.hasOwnProperty.call(m, 'get_conversation_list_body'))
        $root.im_proto.GetUserConversationListResponseBody.encode(
          m.get_conversation_list_body,
          w.uint32(16050).fork(),
        ).ldelim();
      if (m.broadcast_send_message_body != null && Object.hasOwnProperty.call(m, 'broadcast_send_message_body'))
        $root.im_proto.BroadcastSendMessageResponseBody.encode(
          m.broadcast_send_message_body,
          w.uint32(16058).fork(),
        ).ldelim();
      if (m.broadcast_recv_message_body != null && Object.hasOwnProperty.call(m, 'broadcast_recv_message_body'))
        $root.im_proto.BroadcastRecvMessageResponseBody.encode(
          m.broadcast_recv_message_body,
          w.uint32(16066).fork(),
        ).ldelim();
      if (m.broadcast_user_counter_body != null && Object.hasOwnProperty.call(m, 'broadcast_user_counter_body'))
        $root.im_proto.BroadcastUserCounterResponseBody.encode(
          m.broadcast_user_counter_body,
          w.uint32(16074).fork(),
        ).ldelim();
      if (m.client_ack_body != null && Object.hasOwnProperty.call(m, 'client_ack_body'))
        $root.im_proto.ClientACKResponseBody.encode(m.client_ack_body, w.uint32(16082).fork()).ldelim();
      if (m.create_voip_body != null && Object.hasOwnProperty.call(m, 'create_voip_body'))
        $root.im_proto.CreateVoipResponseBody.encode(m.create_voip_body, w.uint32(16090).fork()).ldelim();
      if (m.call_voip_body != null && Object.hasOwnProperty.call(m, 'call_voip_body'))
        $root.im_proto.CallVoipResponseBody.encode(m.call_voip_body, w.uint32(16098).fork()).ldelim();
      if (m.update_voip_body != null && Object.hasOwnProperty.call(m, 'update_voip_body'))
        $root.im_proto.UpdateVoipResponseBody.encode(m.update_voip_body, w.uint32(16106).fork()).ldelim();
      if (m.channel_heartbeat_body != null && Object.hasOwnProperty.call(m, 'channel_heartbeat_body'))
        $root.im_proto.ChannelHeartBeatResponseBody.encode(m.channel_heartbeat_body, w.uint32(16114).fork()).ldelim();
      if (m.profile_get_info != null && Object.hasOwnProperty.call(m, 'profile_get_info'))
        $root.im_proto.ProfileGetInfoResponseBody.encode(m.profile_get_info, w.uint32(16122).fork()).ldelim();
      if (m.report_client_metrics_body != null && Object.hasOwnProperty.call(m, 'report_client_metrics_body'))
        $root.im_proto.ReportClientMetricsResponseBody.encode(
          m.report_client_metrics_body,
          w.uint32(16130).fork(),
        ).ldelim();
      if (m.get_configs_body != null && Object.hasOwnProperty.call(m, 'get_configs_body'))
        $root.im_proto.GetConfigsResponseBody.encode(m.get_configs_body, w.uint32(16138).fork()).ldelim();
      if (m.unread_count_report_body != null && Object.hasOwnProperty.call(m, 'unread_count_report_body'))
        $root.im_proto.UnReadCountReportResponseBody.encode(
          m.unread_count_report_body,
          w.uint32(16146).fork(),
        ).ldelim();
      if (m.block_members_body != null && Object.hasOwnProperty.call(m, 'block_members_body'))
        $root.im_proto.BlockMembersResponseBody.encode(m.block_members_body, w.uint32(16154).fork()).ldelim();
      if (m.block_conversation_body != null && Object.hasOwnProperty.call(m, 'block_conversation_body'))
        $root.im_proto.BlockConversationResponseBody.encode(m.block_conversation_body, w.uint32(16162).fork()).ldelim();
      if (m.modify_message_ext_body != null && Object.hasOwnProperty.call(m, 'modify_message_ext_body'))
        $root.im_proto.ModifyMessageExtResponseBody.encode(m.modify_message_ext_body, w.uint32(16170).fork()).ldelim();
      if (
        m.get_conversation_audit_switch_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_audit_switch_body')
      )
        $root.im_proto.GetConversationAuditSwitchResponseBody.encode(
          m.get_conversation_audit_switch_body,
          w.uint32(16178).fork(),
        ).ldelim();
      if (
        m.update_conversation_audit_switch_body != null &&
        Object.hasOwnProperty.call(m, 'update_conversation_audit_switch_body')
      )
        $root.im_proto.UpdateConversationAuditSwitchResponseBody.encode(
          m.update_conversation_audit_switch_body,
          w.uint32(16186).fork(),
        ).ldelim();
      if (m.send_conversation_apply_body != null && Object.hasOwnProperty.call(m, 'send_conversation_apply_body'))
        $root.im_proto.SendConversationApplyResponseBody.encode(
          m.send_conversation_apply_body,
          w.uint32(16194).fork(),
        ).ldelim();
      if (m.ack_conversation_apply_body != null && Object.hasOwnProperty.call(m, 'ack_conversation_apply_body'))
        $root.im_proto.AckConversationApplyResponseBody.encode(
          m.ack_conversation_apply_body,
          w.uint32(16202).fork(),
        ).ldelim();
      if (m.get_conversation_apply_body != null && Object.hasOwnProperty.call(m, 'get_conversation_apply_body'))
        $root.im_proto.GetConversationApplyResponseBody.encode(
          m.get_conversation_apply_body,
          w.uint32(16210).fork(),
        ).ldelim();
      if (
        m.get_conversation_audit_list_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_audit_list_body')
      )
        $root.im_proto.GetConversationAuditListResponseBody.encode(
          m.get_conversation_audit_list_body,
          w.uint32(16218).fork(),
        ).ldelim();
      if (
        m.get_conversation_audit_unread_body != null &&
        Object.hasOwnProperty.call(m, 'get_conversation_audit_unread_body')
      )
        $root.im_proto.GetConversationAuditUnreadResponseBody.encode(
          m.get_conversation_audit_unread_body,
          w.uint32(16226).fork(),
        ).ldelim();
      if (
        m.clear_conversation_audit_unread_body != null &&
        Object.hasOwnProperty.call(m, 'clear_conversation_audit_unread_body')
      )
        $root.im_proto.ClearConversationAuditUnreadResponseBody.encode(
          m.clear_conversation_audit_unread_body,
          w.uint32(16234).fork(),
        ).ldelim();
      if (m.get_unread_count_body != null && Object.hasOwnProperty.call(m, 'get_unread_count_body'))
        $root.im_proto.GetUnreadCountResponseBody.encode(m.get_unread_count_body, w.uint32(16242).fork()).ldelim();
      if (m.send_message_p2p_body != null && Object.hasOwnProperty.call(m, 'send_message_p2p_body'))
        $root.im_proto.SendMessageP2PResponseBody.encode(m.send_message_p2p_body, w.uint32(16250).fork()).ldelim();
      if (m.get_blocklist_body != null && Object.hasOwnProperty.call(m, 'get_blocklist_body'))
        $root.im_proto.GetBlockListResponseBody.encode(m.get_blocklist_body, w.uint32(16258).fork()).ldelim();
      if (m.set_blocklist_body != null && Object.hasOwnProperty.call(m, 'set_blocklist_body'))
        $root.im_proto.SetBlocklistResponseBody.encode(m.set_blocklist_body, w.uint32(16266).fork()).ldelim();
      if (m.check_in_blocklist_body != null && Object.hasOwnProperty.call(m, 'check_in_blocklist_body'))
        $root.im_proto.CheckInBlockListResponseBody.encode(m.check_in_blocklist_body, w.uint32(16274).fork()).ldelim();
      if (
        m.get_message_info_by_index_v2_body != null &&
        Object.hasOwnProperty.call(m, 'get_message_info_by_index_v2_body')
      )
        $root.im_proto.GetMessageInfoByIndexV2ResponseBody.encode(
          m.get_message_info_by_index_v2_body,
          w.uint32(16282).fork(),
        ).ldelim();
      if (m.mark_message_body != null && Object.hasOwnProperty.call(m, 'mark_message_body'))
        $root.im_proto.MarkMessageResponseBody.encode(m.mark_message_body, w.uint32(16290).fork()).ldelim();
      if (m.pull_mark_message_body != null && Object.hasOwnProperty.call(m, 'pull_mark_message_body'))
        $root.im_proto.PullMarkMessageResponseBody.encode(m.pull_mark_message_body, w.uint32(16298).fork()).ldelim();
      if (
        m.batch_get_conversation_participants_readindex != null &&
        Object.hasOwnProperty.call(m, 'batch_get_conversation_participants_readindex')
      )
        $root.im_proto.BatchGetConversationParticipantsReadIndexResponseBody.encode(
          m.batch_get_conversation_participants_readindex,
          w.uint32(16306).fork(),
        ).ldelim();
      if (m.get_recent_message_body != null && Object.hasOwnProperty.call(m, 'get_recent_message_body'))
        $root.im_proto.GetRecentMessageRespBody.encode(m.get_recent_message_body, w.uint32(16314).fork()).ldelim();
      if (m.get_cmd_message_body != null && Object.hasOwnProperty.call(m, 'get_cmd_message_body'))
        $root.im_proto.GetCmdMessageRespBody.encode(m.get_cmd_message_body, w.uint32(16322).fork()).ldelim();
      if (
        m.get_message_info_by_index_v2_range_body != null &&
        Object.hasOwnProperty.call(m, 'get_message_info_by_index_v2_range_body')
      )
        $root.im_proto.GetMessageInfoByIndexV2RangeResponseBody.encode(
          m.get_message_info_by_index_v2_range_body,
          w.uint32(16330).fork(),
        ).ldelim();
      if (
        m.batch_get_conversation_audit_unread_body != null &&
        Object.hasOwnProperty.call(m, 'batch_get_conversation_audit_unread_body')
      )
        $root.im_proto.BatchGetConversationAuditUnreadResponseBody.encode(
          m.batch_get_conversation_audit_unread_body,
          w.uint32(16338).fork(),
        ).ldelim();
      if (m.message_by_init != null && Object.hasOwnProperty.call(m, 'message_by_init'))
        $root.im_proto.MessageByInitResponseBody.encode(m.message_by_init, w.uint32(16346).fork()).ldelim();
      if (
        m.previewer_messages_in_conversation_body != null &&
        Object.hasOwnProperty.call(m, 'previewer_messages_in_conversation_body')
      )
        $root.im_proto.PreviewerMessagesInConversationResponseBody.encode(
          m.previewer_messages_in_conversation_body,
          w.uint32(16354).fork(),
        ).ldelim();
      if (
        m.previewer_get_conversation_info_list_body != null &&
        Object.hasOwnProperty.call(m, 'previewer_get_conversation_info_list_body')
      )
        $root.im_proto.PreviewerGetConversationInfoListResponseBody.encode(
          m.previewer_get_conversation_info_list_body,
          w.uint32(16362).fork(),
        ).ldelim();
      if (m.send_friend_apply_body != null && Object.hasOwnProperty.call(m, 'send_friend_apply_body'))
        $root.im_proto.SendFriendApplyResponseBody.encode(m.send_friend_apply_body, w.uint32(16370).fork()).ldelim();
      if (m.get_friend_apply_list_body != null && Object.hasOwnProperty.call(m, 'get_friend_apply_list_body'))
        $root.im_proto.GetFriendApplyListResponseBody.encode(
          m.get_friend_apply_list_body,
          w.uint32(16378).fork(),
        ).ldelim();
      if (
        m.get_friend_receive_apply_list_body != null &&
        Object.hasOwnProperty.call(m, 'get_friend_receive_apply_list_body')
      )
        $root.im_proto.GetFriendReceiveApplyListResponseBody.encode(
          m.get_friend_receive_apply_list_body,
          w.uint32(16386).fork(),
        ).ldelim();
      if (m.reply_friend_apply_body != null && Object.hasOwnProperty.call(m, 'reply_friend_apply_body'))
        $root.im_proto.ReplyFriendApplyResponseBody.encode(m.reply_friend_apply_body, w.uint32(16394).fork()).ldelim();
      if (m.get_friend_list_body != null && Object.hasOwnProperty.call(m, 'get_friend_list_body'))
        $root.im_proto.GetFriendListResponseBody.encode(m.get_friend_list_body, w.uint32(16402).fork()).ldelim();
      if (m.delete_friend_body != null && Object.hasOwnProperty.call(m, 'delete_friend_body'))
        $root.im_proto.DeleteFriendResponseBody.encode(m.delete_friend_body, w.uint32(16410).fork()).ldelim();
      if (m.profile_batch_get_info_body != null && Object.hasOwnProperty.call(m, 'profile_batch_get_info_body'))
        $root.im_proto.ProfileBatchGetInfoResponseBody.encode(
          m.profile_batch_get_info_body,
          w.uint32(16418).fork(),
        ).ldelim();
      if (m.profile_search_info_body != null && Object.hasOwnProperty.call(m, 'profile_search_info_body'))
        $root.im_proto.ProfileSearchInfoResponseBody.encode(
          m.profile_search_info_body,
          w.uint32(16426).fork(),
        ).ldelim();
      if (m.mark_msg_unread_count_report != null && Object.hasOwnProperty.call(m, 'mark_msg_unread_count_report'))
        $root.im_proto.MarkMsgUnreadCountReportResponseBody.encode(
          m.mark_msg_unread_count_report,
          w.uint32(16434).fork(),
        ).ldelim();
      if (m.mark_msg_get_unread_count != null && Object.hasOwnProperty.call(m, 'mark_msg_get_unread_count'))
        $root.im_proto.MarkMsgGetUnreadCountResponseBody.encode(
          m.mark_msg_get_unread_count,
          w.uint32(16442).fork(),
        ).ldelim();
      if (m.batch_unmark_message != null && Object.hasOwnProperty.call(m, 'batch_unmark_message'))
        $root.im_proto.BatchUnmarkMessageResponseBody.encode(m.batch_unmark_message, w.uint32(16450).fork()).ldelim();
      if (m.client_batch_ack_body != null && Object.hasOwnProperty.call(m, 'client_batch_ack_body'))
        $root.im_proto.ClientBatchACKResponseBody.encode(m.client_batch_ack_body, w.uint32(16458).fork()).ldelim();
      if (
        m.media_upload_config_response_body != null &&
        Object.hasOwnProperty.call(m, 'media_upload_config_response_body')
      )
        $root.im_proto.GetMediaUploadConfigResponseBody.encode(
          m.media_upload_config_response_body,
          w.uint32(16474).fork(),
        ).ldelim();
      if (m.media_status_response_body != null && Object.hasOwnProperty.call(m, 'media_status_response_body'))
        $root.im_proto.GetMediaStatusResponseBody.encode(m.media_status_response_body, w.uint32(16482).fork()).ldelim();
      if (m.global_message_search_body != null && Object.hasOwnProperty.call(m, 'global_message_search_body'))
        $root.im_proto.GlobalMessageSearchResponseBody.encode(
          m.global_message_search_body,
          w.uint32(16802).fork(),
        ).ldelim();
      if (m.conversation_core_search_body != null && Object.hasOwnProperty.call(m, 'conversation_core_search_body'))
        $root.im_proto.ConversationCoreSearchResponseBody.encode(
          m.conversation_core_search_body,
          w.uint32(16810).fork(),
        ).ldelim();
      if (
        m.conversation_message_search_body != null &&
        Object.hasOwnProperty.call(m, 'conversation_message_search_body')
      )
        $root.im_proto.ConversationMessageSearchResponseBody.encode(
          m.conversation_message_search_body,
          w.uint32(16818).fork(),
        ).ldelim();
      if (
        m.conversation_message_pre_view_body != null &&
        Object.hasOwnProperty.call(m, 'conversation_message_pre_view_body')
      )
        $root.im_proto.ConversationMessagePreViewResponseBody.encode(
          m.conversation_message_pre_view_body,
          w.uint32(16826).fork(),
        ).ldelim();
      if (m.get_messages_body != null && Object.hasOwnProperty.call(m, 'get_messages_body'))
        $root.im_proto.GetMessagesResponseBody.encode(m.get_messages_body, w.uint32(17602).fork()).ldelim();
      if (m.vcd_clean_body != null && Object.hasOwnProperty.call(m, 'vcd_clean_body'))
        $root.im_proto.VcdCleanResponseBody.encode(m.vcd_clean_body, w.uint32(79994).fork()).ldelim();
      return w;
    };

    ResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 100:
            m.send_message_body = $root.im_proto.SendMessageResponseBody.decode(r, r.uint32());
            break;
          case 200:
            m.messages_per_user_body = $root.im_proto.MessagesPerUserResponseBody.decode(r, r.uint32());
            break;
          case 201:
            m.messages_per_user_init_body = $root.im_proto.MessagesPerUserInitResponseBody.decode(r, r.uint32());
            break;
          case 203:
            m.messages_per_user_init_v2_body = $root.im_proto.MessagesPerUserInitV2ResponseBody.decode(r, r.uint32());
            break;
          case 206:
            m.messages_per_conversation_search_body = $root.im_proto.MessagesPerConversationSearchResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 210:
            m.check_messages_per_user_body = $root.im_proto.CheckMessagesPerUserResponseBody.decode(r, r.uint32());
            break;
          case 211:
            m.get_message_by_id_body = $root.im_proto.GetMessageByIdResponseBody.decode(r, r.uint32());
            break;
          case 300:
            m.conversations_list_body = $root.im_proto.ConversationsListResponseBody.decode(r, r.uint32());
            break;
          case 301:
            m.messages_in_conversation_body = $root.im_proto.MessagesInConversationResponseBody.decode(r, r.uint32());
            break;
          case 302:
            m.get_messages_checkinfo_in_conversation_body =
              $root.im_proto.GetMessagesCheckInfoInConversationResponseBody.decode(r, r.uint32());
            break;
          case 303:
            m.get_message_check_info_v2_body = $root.im_proto.GetMessagesCheckInfoV2ResponseBody.decode(r, r.uint32());
            break;
          case 410:
            m.send_user_action_body = $root.im_proto.SendUserActionResponseBody.decode(r, r.uint32());
            break;
          case 411:
            m.send_input_status_body = $root.im_proto.SendInputStatusResponseBody.decode(r, r.uint32());
            break;
          case 500:
            m.has_new_message_notify = $root.im_proto.NewMessageNotify.decode(r, r.uint32());
            break;
          case 501:
            m.mark_conversation_read_notify = $root.im_proto.MarkConversationReadNotify.decode(r, r.uint32());
            break;
          case 502:
            m.conversation_info_updated_notify = $root.im_proto.ConversationInfoUpdatedNotify.decode(r, r.uint32());
            break;
          case 503:
            m.stranger_has_new_message_notify = $root.im_proto.StrangerNewMessageNotify.decode(r, r.uint32());
            break;
          case 504:
            m.has_new_direct_push_notify = $root.im_proto.NewDirectPushNotify.decode(r, r.uint32());
            break;
          case 510:
            m.input_status_notify = $root.im_proto.InputStatusNotify.decode(r, r.uint32());
            break;
          case 511:
            m.biz_has_new_direct_push_notify = $root.im_proto.BizNewDirectPushNotify.decode(r, r.uint32());
            break;
          case 507:
            m.new_friend_message_notify = $root.im_proto.NewFriendMessageNotify.decode(r, r.uint32());
            break;
          case 600:
            m.get_conversation_info_body = $root.im_proto.GetConversationInfoResponseBody.decode(r, r.uint32());
            break;
          case 601:
            m.set_conversation_info_body = $root.im_proto.SetConversationInfoResponseBody.decode(r, r.uint32());
            break;
          case 602:
            m.create_conversation_body = $root.im_proto.CreateConversationResponseBody.decode(r, r.uint32());
            break;
          case 607:
            m.get_conversations_info_list_body = $root.im_proto.GetConversationInfoListResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 613:
            m.batch_mark_read_body = $root.im_proto.BatchMarkConversationReadResponseBody.decode(r, r.uint32());
            break;
          case 615:
            m.get_conversations_checkinfo_body = $root.im_proto.GetConversationsCheckInfoResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 616:
            m.get_conversations_check_info_v2_body = $root.im_proto.GetConversationsCheckInfoV2ResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 608:
            m.get_conversation_info_v2_body = $root.im_proto.GetConversationInfoV2ResponseBody.decode(r, r.uint32());
            break;
          case 609:
            m.create_conversation_v2_body = $root.im_proto.CreateConversationV2ResponseBody.decode(r, r.uint32());
            break;
          case 610:
            m.get_conversation_info_list_v2_body = $root.im_proto.GetConversationInfoListV2ResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 611:
            m.get_conversation_info_list_by_favorite_v2_body =
              $root.im_proto.GetConversationInfoListByFavoriteV2ResponseBody.decode(r, r.uint32());
            break;
          case 612:
            m.get_conversation_info_list_by_top_v2_body =
              $root.im_proto.GetConversationInfoListByTopV2ResponseBody.decode(r, r.uint32());
            break;
          case 605:
            m.conversation_participants_body = $root.im_proto.ConversationParticipantsListResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 650:
            m.conversation_add_participants_body = $root.im_proto.ConversationAddParticipantsResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 651:
            m.conversation_remove_participants_body = $root.im_proto.ConversationRemoveParticipantsResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 653:
            m.conversation_set_role_body = $root.im_proto.ConversationSetRoleResponseBody.decode(r, r.uint32());
            break;
          case 654:
            m.mget_conversation_participants_body = $root.im_proto.MgetConversationParticipantsResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 655:
            m.update_conversation_participant_body = $root.im_proto.UpdateConversationParticipantResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 656:
            m.batch_update_conversation_participant_body =
              $root.im_proto.BatchUpdateConversationParticipantResponseBody.decode(r, r.uint32());
            break;
          case 690:
            m.get_conversation_group_list_body = $root.im_proto.GetConversationGroupListResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 703:
            m.reaction_message_body = $root.im_proto.ReactionMessageResponseBody.decode(r, r.uint32());
            break;
          case 704:
            m.sync_message_body = $root.im_proto.SyncMessageResponseBody.decode(r, r.uint32());
            break;
          case 705:
            m.modify_message_property_body = $root.im_proto.ModifyMessagePropertyResponseBody.decode(r, r.uint32());
            break;
          case 706:
            m.ack_message_body = $root.im_proto.AckMessageResponseBody.decode(r, r.uint32());
            break;
          case 801:
            m.get_group_info_body = $root.im_proto.GetGroupInfoResponseBody.decode(r, r.uint32());
            break;
          case 802:
            m.set_group_info_body = $root.im_proto.SetGroupInfoResponseBody.decode(r, r.uint32());
            break;
          case 803:
            m.get_groups_info_body = $root.im_proto.GetGroupInfoListResponseBody.decode(r, r.uint32());
            break;
          case 901:
            m.get_conversation_core_info_body = $root.im_proto.GetConversationCoreInfoResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 902:
            m.set_conversation_core_info_body = $root.im_proto.SetConversationCoreInfoResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 903:
            m.get_conversation_core_info_list_body = $root.im_proto.GetConversationCoreInfoListResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 904:
            m.upsert_conversation_core_ext_info_body = $root.im_proto.UpsertConversationCoreExtInfoResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 905:
            m.delete_conversation_core_ext_info_body = $root.im_proto.DeleteConversationCoreExtInfoResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 920:
            m.get_conversation_setting_info_body = $root.im_proto.GetConversationSettingInfoResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 921:
            m.set_conversation_setting_info_body = $root.im_proto.SetConversationSettingInfoResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 922:
            m.upsert_conversation_setting_ext_info_body =
              $root.im_proto.UpsertConversationSettingExtInfoResponseBody.decode(r, r.uint32());
            break;
          case 923:
            m.delete_conversation_setting_ext_info_body =
              $root.im_proto.DeleteConversationSettingExtInfoResponseBody.decode(r, r.uint32());
            break;
          case 1000:
            m.get_stranger_conversation_body = $root.im_proto.GetStrangerConversationListResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 1001:
            m.get_stranger_messages_body = $root.im_proto.GetStrangerMessagesResponseBody.decode(r, r.uint32());
            break;
          case 1002:
            m.delete_stranger_message_body = $root.im_proto.DeleteStrangerMessageResponseBody.decode(r, r.uint32());
            break;
          case 1003:
            m.delete_stranger_conversation_body = $root.im_proto.DeleteStrangerConversationResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 1004:
            m.delete_stranger_all_conversation_body = $root.im_proto.DeleteStrangerAllConversationResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 1005:
            m.mark_stranger_conversation_read_body = $root.im_proto.MarkStrangerConversationReadResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 1006:
            m.mark_stranger_all_conversation_read_body =
              $root.im_proto.MarkStrangerAllConversationReadResponseBody.decode(r, r.uint32());
            break;
          case 1007:
            m.get_stranger_unread_count_body = $root.im_proto.GetStrangerUnreadCountResponseBody.decode(r, r.uint32());
            break;
          case 2000:
            m.participants_read_index_body = $root.im_proto.GetConversationParticipantsReadIndexV3ResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2001:
            m.participants_min_index_body = $root.im_proto.GetConversationParticipantsMinIndexV3ResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2003:
            m.get_upload_token_body = $root.im_proto.GetUploadTokenResponseBody.decode(r, r.uint32());
            break;
          case 2004:
            m.get_media_urls_body = $root.im_proto.GetMediaUrlsResponseBody.decode(r, r.uint32());
            break;
          case 2005:
            m.get_ticket_body = $root.im_proto.GetTicketResponseBody.decode(r, r.uint32());
            break;
          case 9999:
            m.vcd_clean_body = $root.im_proto.VcdCleanResponseBody.decode(r, r.uint32());
            break;
          case 2006:
            m.get_conversation_list_body = $root.im_proto.GetUserConversationListResponseBody.decode(r, r.uint32());
            break;
          case 2007:
            m.broadcast_send_message_body = $root.im_proto.BroadcastSendMessageResponseBody.decode(r, r.uint32());
            break;
          case 2008:
            m.broadcast_recv_message_body = $root.im_proto.BroadcastRecvMessageResponseBody.decode(r, r.uint32());
            break;
          case 2009:
            m.broadcast_user_counter_body = $root.im_proto.BroadcastUserCounterResponseBody.decode(r, r.uint32());
            break;
          case 2010:
            m.client_ack_body = $root.im_proto.ClientACKResponseBody.decode(r, r.uint32());
            break;
          case 2011:
            m.create_voip_body = $root.im_proto.CreateVoipResponseBody.decode(r, r.uint32());
            break;
          case 2012:
            m.call_voip_body = $root.im_proto.CallVoipResponseBody.decode(r, r.uint32());
            break;
          case 2013:
            m.update_voip_body = $root.im_proto.UpdateVoipResponseBody.decode(r, r.uint32());
            break;
          case 2014:
            m.channel_heartbeat_body = $root.im_proto.ChannelHeartBeatResponseBody.decode(r, r.uint32());
            break;
          case 2015:
            m.profile_get_info = $root.im_proto.ProfileGetInfoResponseBody.decode(r, r.uint32());
            break;
          case 2016:
            m.report_client_metrics_body = $root.im_proto.ReportClientMetricsResponseBody.decode(r, r.uint32());
            break;
          case 2017:
            m.get_configs_body = $root.im_proto.GetConfigsResponseBody.decode(r, r.uint32());
            break;
          case 2018:
            m.unread_count_report_body = $root.im_proto.UnReadCountReportResponseBody.decode(r, r.uint32());
            break;
          case 2019:
            m.block_members_body = $root.im_proto.BlockMembersResponseBody.decode(r, r.uint32());
            break;
          case 2020:
            m.block_conversation_body = $root.im_proto.BlockConversationResponseBody.decode(r, r.uint32());
            break;
          case 2021:
            m.modify_message_ext_body = $root.im_proto.ModifyMessageExtResponseBody.decode(r, r.uint32());
            break;
          case 2022:
            m.get_conversation_audit_switch_body = $root.im_proto.GetConversationAuditSwitchResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2023:
            m.update_conversation_audit_switch_body = $root.im_proto.UpdateConversationAuditSwitchResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2024:
            m.send_conversation_apply_body = $root.im_proto.SendConversationApplyResponseBody.decode(r, r.uint32());
            break;
          case 2025:
            m.ack_conversation_apply_body = $root.im_proto.AckConversationApplyResponseBody.decode(r, r.uint32());
            break;
          case 2026:
            m.get_conversation_apply_body = $root.im_proto.GetConversationApplyResponseBody.decode(r, r.uint32());
            break;
          case 2027:
            m.get_conversation_audit_list_body = $root.im_proto.GetConversationAuditListResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2028:
            m.get_conversation_audit_unread_body = $root.im_proto.GetConversationAuditUnreadResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2029:
            m.clear_conversation_audit_unread_body = $root.im_proto.ClearConversationAuditUnreadResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2030:
            m.get_unread_count_body = $root.im_proto.GetUnreadCountResponseBody.decode(r, r.uint32());
            break;
          case 2031:
            m.send_message_p2p_body = $root.im_proto.SendMessageP2PResponseBody.decode(r, r.uint32());
            break;
          case 2032:
            m.get_blocklist_body = $root.im_proto.GetBlockListResponseBody.decode(r, r.uint32());
            break;
          case 2033:
            m.set_blocklist_body = $root.im_proto.SetBlocklistResponseBody.decode(r, r.uint32());
            break;
          case 2034:
            m.check_in_blocklist_body = $root.im_proto.CheckInBlockListResponseBody.decode(r, r.uint32());
            break;
          case 2035:
            m.get_message_info_by_index_v2_body = $root.im_proto.GetMessageInfoByIndexV2ResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2042:
            m.batch_get_conversation_audit_unread_body =
              $root.im_proto.BatchGetConversationAuditUnreadResponseBody.decode(r, r.uint32());
            break;
          case 2036:
            m.mark_message_body = $root.im_proto.MarkMessageResponseBody.decode(r, r.uint32());
            break;
          case 2037:
            m.pull_mark_message_body = $root.im_proto.PullMarkMessageResponseBody.decode(r, r.uint32());
            break;
          case 2038:
            m.batch_get_conversation_participants_readindex =
              $root.im_proto.BatchGetConversationParticipantsReadIndexResponseBody.decode(r, r.uint32());
            break;
          case 2039:
            m.get_recent_message_body = $root.im_proto.GetRecentMessageRespBody.decode(r, r.uint32());
            break;
          case 2040:
            m.get_cmd_message_body = $root.im_proto.GetCmdMessageRespBody.decode(r, r.uint32());
            break;
          case 2041:
            m.get_message_info_by_index_v2_range_body = $root.im_proto.GetMessageInfoByIndexV2RangeResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2043:
            m.message_by_init = $root.im_proto.MessageByInitResponseBody.decode(r, r.uint32());
            break;
          case 2044:
            m.previewer_messages_in_conversation_body =
              $root.im_proto.PreviewerMessagesInConversationResponseBody.decode(r, r.uint32());
            break;
          case 2045:
            m.previewer_get_conversation_info_list_body =
              $root.im_proto.PreviewerGetConversationInfoListResponseBody.decode(r, r.uint32());
            break;
          case 2046:
            m.send_friend_apply_body = $root.im_proto.SendFriendApplyResponseBody.decode(r, r.uint32());
            break;
          case 2047:
            m.get_friend_apply_list_body = $root.im_proto.GetFriendApplyListResponseBody.decode(r, r.uint32());
            break;
          case 2048:
            m.get_friend_receive_apply_list_body = $root.im_proto.GetFriendReceiveApplyListResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2049:
            m.reply_friend_apply_body = $root.im_proto.ReplyFriendApplyResponseBody.decode(r, r.uint32());
            break;
          case 2050:
            m.get_friend_list_body = $root.im_proto.GetFriendListResponseBody.decode(r, r.uint32());
            break;
          case 2051:
            m.delete_friend_body = $root.im_proto.DeleteFriendResponseBody.decode(r, r.uint32());
            break;
          case 2052:
            m.profile_batch_get_info_body = $root.im_proto.ProfileBatchGetInfoResponseBody.decode(r, r.uint32());
            break;
          case 2053:
            m.profile_search_info_body = $root.im_proto.ProfileSearchInfoResponseBody.decode(r, r.uint32());
            break;
          case 2054:
            m.mark_msg_unread_count_report = $root.im_proto.MarkMsgUnreadCountReportResponseBody.decode(r, r.uint32());
            break;
          case 2055:
            m.mark_msg_get_unread_count = $root.im_proto.MarkMsgGetUnreadCountResponseBody.decode(r, r.uint32());
            break;
          case 2056:
            m.batch_unmark_message = $root.im_proto.BatchUnmarkMessageResponseBody.decode(r, r.uint32());
            break;
          case 2057:
            m.client_batch_ack_body = $root.im_proto.ClientBatchACKResponseBody.decode(r, r.uint32());
            break;
          case 2059:
            m.media_upload_config_response_body = $root.im_proto.GetMediaUploadConfigResponseBody.decode(r, r.uint32());
            break;
          case 2060:
            m.media_status_response_body = $root.im_proto.GetMediaStatusResponseBody.decode(r, r.uint32());
            break;
          case 2100:
            m.global_message_search_body = $root.im_proto.GlobalMessageSearchResponseBody.decode(r, r.uint32());
            break;
          case 2101:
            m.conversation_core_search_body = $root.im_proto.ConversationCoreSearchResponseBody.decode(r, r.uint32());
            break;
          case 2102:
            m.conversation_message_search_body = $root.im_proto.ConversationMessageSearchResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2103:
            m.conversation_message_pre_view_body = $root.im_proto.ConversationMessagePreViewResponseBody.decode(
              r,
              r.uint32(),
            );
            break;
          case 2200:
            m.get_messages_body = $root.im_proto.GetMessagesResponseBody.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ResponseBody;
  })();

  im_proto.Response = (function () {
    function Response(p) {
      this.headers = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    Response.prototype.cmd = 0;
    Response.prototype.sequence_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Response.prototype.status_code = 0;
    Response.prototype.error_desc = '';
    Response.prototype.inbox_type = 0;
    Response.prototype.body = null;
    Response.prototype.log_id = '';
    Response.prototype.headers = $util.emptyObject;
    Response.prototype.start_time_stamp = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Response.prototype.request_arrived_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Response.prototype.server_execution_end_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    Response.prototype.retry_count = 0;
    Response.prototype.server_start_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    Response.create = function create(properties) {
      return new Response(properties);
    };

    Response.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cmd != null && Object.hasOwnProperty.call(m, 'cmd')) w.uint32(8).int32(m.cmd);
      if (m.sequence_id != null && Object.hasOwnProperty.call(m, 'sequence_id')) w.uint32(16).int64(m.sequence_id);
      if (m.status_code != null && Object.hasOwnProperty.call(m, 'status_code')) w.uint32(24).int32(m.status_code);
      if (m.error_desc != null && Object.hasOwnProperty.call(m, 'error_desc')) w.uint32(34).string(m.error_desc);
      if (m.inbox_type != null && Object.hasOwnProperty.call(m, 'inbox_type')) w.uint32(40).int32(m.inbox_type);
      if (m.body != null && Object.hasOwnProperty.call(m, 'body'))
        $root.im_proto.ResponseBody.encode(m.body, w.uint32(50).fork()).ldelim();
      if (m.log_id != null && Object.hasOwnProperty.call(m, 'log_id')) w.uint32(58).string(m.log_id);
      if (m.headers != null && Object.hasOwnProperty.call(m, 'headers')) {
        for (var ks = Object.keys(m.headers), i = 0; i < ks.length; ++i) {
          w.uint32(66).fork().uint32(10).string(ks[i]).uint32(18).string(m.headers[ks[i]]).ldelim();
        }
      }
      if (m.start_time_stamp != null && Object.hasOwnProperty.call(m, 'start_time_stamp'))
        w.uint32(72).int64(m.start_time_stamp);
      if (m.request_arrived_time != null && Object.hasOwnProperty.call(m, 'request_arrived_time'))
        w.uint32(80).int64(m.request_arrived_time);
      if (m.server_execution_end_time != null && Object.hasOwnProperty.call(m, 'server_execution_end_time'))
        w.uint32(88).int64(m.server_execution_end_time);
      if (m.retry_count != null && Object.hasOwnProperty.call(m, 'retry_count')) w.uint32(96).int32(m.retry_count);
      if (m.server_start_time != null && Object.hasOwnProperty.call(m, 'server_start_time'))
        w.uint32(104).int64(m.server_start_time);
      return w;
    };

    Response.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.Response(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.cmd = r.int32();
            break;
          case 2:
            m.sequence_id = r.int64();
            break;
          case 3:
            m.status_code = r.int32();
            break;
          case 4:
            m.error_desc = r.string();
            break;
          case 5:
            m.inbox_type = r.int32();
            break;
          case 6:
            m.body = $root.im_proto.ResponseBody.decode(r, r.uint32());
            break;
          case 7:
            m.log_id = r.string();
            break;
          case 8:
            if (m.headers === $util.emptyObject) m.headers = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.headers[k] = value;
            break;
          case 9:
            m.start_time_stamp = r.int64();
            break;
          case 10:
            m.request_arrived_time = r.int64();
            break;
          case 11:
            m.server_execution_end_time = r.int64();
            break;
          case 12:
            m.retry_count = r.int32();
            break;
          case 13:
            m.server_start_time = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Response;
  })();

  im_proto.BaseText = (function () {
    function BaseText(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BaseText.prototype.text = '';

    BaseText.create = function create(properties) {
      return new BaseText(properties);
    };

    BaseText.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.text != null && Object.hasOwnProperty.call(m, 'text')) w.uint32(10).string(m.text);
      return w;
    };

    BaseText.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BaseText();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.text = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BaseText;
  })();

  im_proto.BaseImage = (function () {
    function BaseImage(p) {
      this.url_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BaseImage.prototype.image_id = '';
    BaseImage.prototype.url_list = $util.emptyArray;
    BaseImage.prototype.display_name = '';
    BaseImage.prototype.resolution = null;
    BaseImage.prototype.decrypt_key = '';
    BaseImage.prototype.fallback_icon_type = 0;

    BaseImage.create = function create(properties) {
      return new BaseImage(properties);
    };

    BaseImage.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.image_id != null && Object.hasOwnProperty.call(m, 'image_id')) w.uint32(10).string(m.image_id);
      if (m.url_list != null && m.url_list.length) {
        for (var i = 0; i < m.url_list.length; ++i) w.uint32(18).string(m.url_list[i]);
      }
      if (m.display_name != null && Object.hasOwnProperty.call(m, 'display_name')) w.uint32(34).string(m.display_name);
      if (m.resolution != null && Object.hasOwnProperty.call(m, 'resolution'))
        $root.im_proto.Resolution.encode(m.resolution, w.uint32(42).fork()).ldelim();
      if (m.decrypt_key != null && Object.hasOwnProperty.call(m, 'decrypt_key')) w.uint32(50).string(m.decrypt_key);
      if (m.fallback_icon_type != null && Object.hasOwnProperty.call(m, 'fallback_icon_type'))
        w.uint32(56).int32(m.fallback_icon_type);
      return w;
    };

    BaseImage.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BaseImage();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.image_id = r.string();
            break;
          case 2:
            if (!(m.url_list && m.url_list.length)) m.url_list = [];
            m.url_list.push(r.string());
            break;
          case 4:
            m.display_name = r.string();
            break;
          case 5:
            m.resolution = $root.im_proto.Resolution.decode(r, r.uint32());
            break;
          case 6:
            m.decrypt_key = r.string();
            break;
          case 7:
            m.fallback_icon_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BaseImage;
  })();

  im_proto.IconType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'Default')] = 0;
    values[(valuesById[1] = 'ServerError')] = 1;
    values[(valuesById[2] = 'Moderation')] = 2;
    values[(valuesById[3] = 'Loading')] = 3;
    return values;
  })();

  im_proto.BaseVideo = (function () {
    function BaseVideo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BaseVideo.prototype.video_id = '';
    BaseVideo.prototype.video_type = 0;
    BaseVideo.prototype.cover = null;
    BaseVideo.prototype.video_model = '';
    BaseVideo.prototype.linkInfo = null;
    BaseVideo.prototype.resolution = null;

    BaseVideo.create = function create(properties) {
      return new BaseVideo(properties);
    };

    BaseVideo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.video_id != null && Object.hasOwnProperty.call(m, 'video_id')) w.uint32(10).string(m.video_id);
      if (m.video_type != null && Object.hasOwnProperty.call(m, 'video_type')) w.uint32(16).int32(m.video_type);
      if (m.cover != null && Object.hasOwnProperty.call(m, 'cover'))
        $root.im_proto.BaseImage.encode(m.cover, w.uint32(26).fork()).ldelim();
      if (m.video_model != null && Object.hasOwnProperty.call(m, 'video_model')) w.uint32(34).string(m.video_model);
      if (m.linkInfo != null && Object.hasOwnProperty.call(m, 'linkInfo'))
        $root.im_proto.LinkInfo.encode(m.linkInfo, w.uint32(42).fork()).ldelim();
      if (m.resolution != null && Object.hasOwnProperty.call(m, 'resolution'))
        $root.im_proto.Resolution.encode(m.resolution, w.uint32(50).fork()).ldelim();
      return w;
    };

    BaseVideo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BaseVideo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.video_id = r.string();
            break;
          case 2:
            m.video_type = r.int32();
            break;
          case 3:
            m.cover = $root.im_proto.BaseImage.decode(r, r.uint32());
            break;
          case 4:
            m.video_model = r.string();
            break;
          case 5:
            m.linkInfo = $root.im_proto.LinkInfo.decode(r, r.uint32());
            break;
          case 6:
            m.resolution = $root.im_proto.Resolution.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BaseVideo;
  })();

  im_proto.VideoType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'Video')] = 0;
    values[(valuesById[1] = 'Live')] = 1;
    return values;
  })();

  im_proto.BaseUser = (function () {
    function BaseUser(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BaseUser.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BaseUser.prototype.nickname = null;
    BaseUser.prototype.description = null;
    BaseUser.prototype.avatar = null;
    BaseUser.prototype.link_info = null;
    BaseUser.prototype.username = null;
    BaseUser.prototype.follower_count = 0;
    BaseUser.prototype.is_verify = false;

    BaseUser.create = function create(properties) {
      return new BaseUser(properties);
    };

    BaseUser.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(8).int64(m.user_id);
      if (m.nickname != null && Object.hasOwnProperty.call(m, 'nickname'))
        $root.im_proto.BaseText.encode(m.nickname, w.uint32(18).fork()).ldelim();
      if (m.description != null && Object.hasOwnProperty.call(m, 'description'))
        $root.im_proto.BaseText.encode(m.description, w.uint32(26).fork()).ldelim();
      if (m.avatar != null && Object.hasOwnProperty.call(m, 'avatar'))
        $root.im_proto.BaseImage.encode(m.avatar, w.uint32(34).fork()).ldelim();
      if (m.link_info != null && Object.hasOwnProperty.call(m, 'link_info'))
        $root.im_proto.LinkInfo.encode(m.link_info, w.uint32(42).fork()).ldelim();
      if (m.username != null && Object.hasOwnProperty.call(m, 'username'))
        $root.im_proto.BaseText.encode(m.username, w.uint32(50).fork()).ldelim();
      if (m.follower_count != null && Object.hasOwnProperty.call(m, 'follower_count'))
        w.uint32(56).int32(m.follower_count);
      if (m.is_verify != null && Object.hasOwnProperty.call(m, 'is_verify')) w.uint32(64).bool(m.is_verify);
      return w;
    };

    BaseUser.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BaseUser();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.int64();
            break;
          case 2:
            m.nickname = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 3:
            m.description = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 4:
            m.avatar = $root.im_proto.BaseImage.decode(r, r.uint32());
            break;
          case 5:
            m.link_info = $root.im_proto.LinkInfo.decode(r, r.uint32());
            break;
          case 6:
            m.username = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 7:
            m.follower_count = r.int32();
            break;
          case 8:
            m.is_verify = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BaseUser;
  })();

  im_proto.Button = (function () {
    function Button(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    Button.prototype.text = null;
    Button.prototype.style = null;
    Button.prototype.link_info = null;

    Button.create = function create(properties) {
      return new Button(properties);
    };

    Button.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.text != null && Object.hasOwnProperty.call(m, 'text'))
        $root.im_proto.BaseText.encode(m.text, w.uint32(10).fork()).ldelim();
      if (m.style != null && Object.hasOwnProperty.call(m, 'style'))
        $root.im_proto.ButtonStyle.encode(m.style, w.uint32(18).fork()).ldelim();
      if (m.link_info != null && Object.hasOwnProperty.call(m, 'link_info'))
        $root.im_proto.LinkInfo.encode(m.link_info, w.uint32(34).fork()).ldelim();
      return w;
    };

    Button.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.Button();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.text = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 2:
            m.style = $root.im_proto.ButtonStyle.decode(r, r.uint32());
            break;
          case 4:
            m.link_info = $root.im_proto.LinkInfo.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Button;
  })();

  im_proto.ButtonStyle = (function () {
    function ButtonStyle(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ButtonStyle.prototype.height = 0;
    ButtonStyle.prototype.width = 0;

    ButtonStyle.create = function create(properties) {
      return new ButtonStyle(properties);
    };

    ButtonStyle.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.height != null && Object.hasOwnProperty.call(m, 'height')) w.uint32(8).int32(m.height);
      if (m.width != null && Object.hasOwnProperty.call(m, 'width')) w.uint32(16).int32(m.width);
      return w;
    };

    ButtonStyle.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ButtonStyle();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.height = r.int32();
            break;
          case 2:
            m.width = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ButtonStyle;
  })();

  im_proto.TTL = (function () {
    function TTL(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    TTL.prototype.expired_at = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    TTL.create = function create(properties) {
      return new TTL(properties);
    };

    TTL.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.expired_at != null && Object.hasOwnProperty.call(m, 'expired_at')) w.uint32(8).int64(m.expired_at);
      return w;
    };

    TTL.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.TTL();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.expired_at = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return TTL;
  })();

  im_proto.BaseReq = (function () {
    function BaseReq(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BaseReq.prototype.query_data = null;

    BaseReq.create = function create(properties) {
      return new BaseReq(properties);
    };

    BaseReq.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.query_data != null && Object.hasOwnProperty.call(m, 'query_data'))
        $root.im_proto.QueryData.encode(m.query_data, w.uint32(10).fork()).ldelim();
      return w;
    };

    BaseReq.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BaseReq();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.query_data = $root.im_proto.QueryData.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BaseReq;
  })();

  im_proto.FallbackInfo = (function () {
    function FallbackInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    FallbackInfo.prototype.image = null;
    FallbackInfo.prototype.text = null;
    FallbackInfo.prototype.link_info = null;

    FallbackInfo.create = function create(properties) {
      return new FallbackInfo(properties);
    };

    FallbackInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.image != null && Object.hasOwnProperty.call(m, 'image'))
        $root.im_proto.BaseImage.encode(m.image, w.uint32(10).fork()).ldelim();
      if (m.text != null && Object.hasOwnProperty.call(m, 'text'))
        $root.im_proto.BaseText.encode(m.text, w.uint32(18).fork()).ldelim();
      if (m.link_info != null && Object.hasOwnProperty.call(m, 'link_info'))
        $root.im_proto.LinkInfo.encode(m.link_info, w.uint32(26).fork()).ldelim();
      return w;
    };

    FallbackInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.FallbackInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.image = $root.im_proto.BaseImage.decode(r, r.uint32());
            break;
          case 2:
            m.text = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 3:
            m.link_info = $root.im_proto.LinkInfo.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return FallbackInfo;
  })();

  im_proto.BaseResp = (function () {
    function BaseResp(p) {
      this.context_menu = [];
      this.extra = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BaseResp.prototype.ttl = null;
    BaseResp.prototype.context_menu = $util.emptyArray;
    BaseResp.prototype.min_version = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    BaseResp.prototype.extra = $util.emptyObject;

    BaseResp.create = function create(properties) {
      return new BaseResp(properties);
    };

    BaseResp.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.ttl != null && Object.hasOwnProperty.call(m, 'ttl'))
        $root.im_proto.TTL.encode(m.ttl, w.uint32(10).fork()).ldelim();
      if (m.context_menu != null && m.context_menu.length) {
        for (var i = 0; i < m.context_menu.length; ++i) w.uint32(18).string(m.context_menu[i]);
      }
      if (m.min_version != null && Object.hasOwnProperty.call(m, 'min_version')) w.uint32(24).int64(m.min_version);
      if (m.extra != null && Object.hasOwnProperty.call(m, 'extra')) {
        for (var ks = Object.keys(m.extra), i = 0; i < ks.length; ++i) {
          w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.extra[ks[i]]).ldelim();
        }
      }
      return w;
    };

    BaseResp.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BaseResp(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.ttl = $root.im_proto.TTL.decode(r, r.uint32());
            break;
          case 2:
            if (!(m.context_menu && m.context_menu.length)) m.context_menu = [];
            m.context_menu.push(r.string());
            break;
          case 3:
            m.min_version = r.int64();
            break;
          case 4:
            if (m.extra === $util.emptyObject) m.extra = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.extra[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BaseResp;
  })();

  im_proto.QueryData = (function () {
    function QueryData(p) {
      this.extra = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    QueryData.prototype.resource_id = '';
    QueryData.prototype.extra = $util.emptyObject;

    QueryData.create = function create(properties) {
      return new QueryData(properties);
    };

    QueryData.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.resource_id != null && Object.hasOwnProperty.call(m, 'resource_id')) w.uint32(10).string(m.resource_id);
      if (m.extra != null && Object.hasOwnProperty.call(m, 'extra')) {
        for (var ks = Object.keys(m.extra), i = 0; i < ks.length; ++i) {
          w.uint32(18).fork().uint32(10).string(ks[i]).uint32(18).string(m.extra[ks[i]]).ldelim();
        }
      }
      return w;
    };

    QueryData.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.QueryData(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.resource_id = r.string();
            break;
          case 2:
            if (m.extra === $util.emptyObject) m.extra = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.extra[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return QueryData;
  })();

  im_proto.LinkInfo = (function () {
    function LinkInfo(p) {
      this.url_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    LinkInfo.prototype.url_list = $util.emptyArray;
    LinkInfo.prototype.action_type = 0;

    LinkInfo.create = function create(properties) {
      return new LinkInfo(properties);
    };

    LinkInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.url_list != null && m.url_list.length) {
        for (var i = 0; i < m.url_list.length; ++i) w.uint32(10).string(m.url_list[i]);
      }
      if (m.action_type != null && Object.hasOwnProperty.call(m, 'action_type')) w.uint32(16).int32(m.action_type);
      return w;
    };

    LinkInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.LinkInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.url_list && m.url_list.length)) m.url_list = [];
            m.url_list.push(r.string());
            break;
          case 2:
            m.action_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return LinkInfo;
  })();

  im_proto.LinkType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'DeepLink')] = 0;
    values[(valuesById[1] = 'H5Link')] = 1;
    values[(valuesById[2] = 'FollowUser')] = 2;
    values[(valuesById[3] = 'Callback')] = 3;
    values[(valuesById[4] = 'Show')] = 4;
    values[(valuesById[5] = 'Refresh')] = 5;
    return values;
  })();

  im_proto.PreviewHint = (function () {
    function PreviewHint(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    PreviewHint.prototype.sender_preview_text = null;
    PreviewHint.prototype.receiver_preview_text = null;
    PreviewHint.prototype.quote_preview_text = null;

    PreviewHint.create = function create(properties) {
      return new PreviewHint(properties);
    };

    PreviewHint.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.sender_preview_text != null && Object.hasOwnProperty.call(m, 'sender_preview_text'))
        $root.im_proto.BaseText.encode(m.sender_preview_text, w.uint32(10).fork()).ldelim();
      if (m.receiver_preview_text != null && Object.hasOwnProperty.call(m, 'receiver_preview_text'))
        $root.im_proto.BaseText.encode(m.receiver_preview_text, w.uint32(18).fork()).ldelim();
      if (m.quote_preview_text != null && Object.hasOwnProperty.call(m, 'quote_preview_text'))
        $root.im_proto.BaseText.encode(m.quote_preview_text, w.uint32(26).fork()).ldelim();
      return w;
    };

    PreviewHint.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.PreviewHint();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.sender_preview_text = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 2:
            m.receiver_preview_text = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 3:
            m.quote_preview_text = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PreviewHint;
  })();

  im_proto.Resolution = (function () {
    function Resolution(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    Resolution.prototype.width = 0;
    Resolution.prototype.height = 0;

    Resolution.create = function create(properties) {
      return new Resolution(properties);
    };

    Resolution.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.width != null && Object.hasOwnProperty.call(m, 'width')) w.uint32(8).int32(m.width);
      if (m.height != null && Object.hasOwnProperty.call(m, 'height')) w.uint32(16).int32(m.height);
      return w;
    };

    Resolution.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.Resolution();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.width = r.int32();
            break;
          case 2:
            m.height = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Resolution;
  })();

  im_proto.PictureCard = (function () {
    function PictureCard(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    PictureCard.prototype.image = null;
    PictureCard.prototype.thumbnail = null;
    PictureCard.prototype.preview_hint = null;
    PictureCard.prototype.link_info = null;
    PictureCard.prototype.fallback = null;
    PictureCard.prototype.image_mint = null;
    PictureCard.prototype.thumbnail_mint = null;
    PictureCard.prototype.req_base = null;
    PictureCard.prototype.resp_base = null;

    PictureCard.create = function create(properties) {
      return new PictureCard(properties);
    };

    PictureCard.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.image != null && Object.hasOwnProperty.call(m, 'image'))
        $root.im_proto.BaseImage.encode(m.image, w.uint32(10).fork()).ldelim();
      if (m.thumbnail != null && Object.hasOwnProperty.call(m, 'thumbnail'))
        $root.im_proto.BaseImage.encode(m.thumbnail, w.uint32(18).fork()).ldelim();
      if (m.preview_hint != null && Object.hasOwnProperty.call(m, 'preview_hint'))
        $root.im_proto.PreviewHint.encode(m.preview_hint, w.uint32(26).fork()).ldelim();
      if (m.link_info != null && Object.hasOwnProperty.call(m, 'link_info'))
        $root.im_proto.LinkInfo.encode(m.link_info, w.uint32(34).fork()).ldelim();
      if (m.fallback != null && Object.hasOwnProperty.call(m, 'fallback'))
        $root.im_proto.PictureCardFallbackInfo.encode(m.fallback, w.uint32(42).fork()).ldelim();
      if (m.image_mint != null && Object.hasOwnProperty.call(m, 'image_mint'))
        $root.im_proto.BaseImage.encode(m.image_mint, w.uint32(50).fork()).ldelim();
      if (m.thumbnail_mint != null && Object.hasOwnProperty.call(m, 'thumbnail_mint'))
        $root.im_proto.BaseImage.encode(m.thumbnail_mint, w.uint32(58).fork()).ldelim();
      if (m.req_base != null && Object.hasOwnProperty.call(m, 'req_base'))
        $root.im_proto.BaseReq.encode(m.req_base, w.uint32(1602).fork()).ldelim();
      if (m.resp_base != null && Object.hasOwnProperty.call(m, 'resp_base'))
        $root.im_proto.BaseResp.encode(m.resp_base, w.uint32(1610).fork()).ldelim();
      return w;
    };

    PictureCard.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.PictureCard();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.image = $root.im_proto.BaseImage.decode(r, r.uint32());
            break;
          case 2:
            m.thumbnail = $root.im_proto.BaseImage.decode(r, r.uint32());
            break;
          case 3:
            m.preview_hint = $root.im_proto.PreviewHint.decode(r, r.uint32());
            break;
          case 4:
            m.link_info = $root.im_proto.LinkInfo.decode(r, r.uint32());
            break;
          case 5:
            m.fallback = $root.im_proto.PictureCardFallbackInfo.decode(r, r.uint32());
            break;
          case 6:
            m.image_mint = $root.im_proto.BaseImage.decode(r, r.uint32());
            break;
          case 7:
            m.thumbnail_mint = $root.im_proto.BaseImage.decode(r, r.uint32());
            break;
          case 200:
            m.req_base = $root.im_proto.BaseReq.decode(r, r.uint32());
            break;
          case 201:
            m.resp_base = $root.im_proto.BaseResp.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PictureCard;
  })();

  im_proto.PictureCardFallbackInfo = (function () {
    function PictureCardFallbackInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    PictureCardFallbackInfo.prototype.image = null;
    PictureCardFallbackInfo.prototype.text = null;
    PictureCardFallbackInfo.prototype.link_info = null;

    PictureCardFallbackInfo.create = function create(properties) {
      return new PictureCardFallbackInfo(properties);
    };

    PictureCardFallbackInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.image != null && Object.hasOwnProperty.call(m, 'image'))
        $root.im_proto.BaseImage.encode(m.image, w.uint32(10).fork()).ldelim();
      if (m.text != null && Object.hasOwnProperty.call(m, 'text'))
        $root.im_proto.BaseText.encode(m.text, w.uint32(18).fork()).ldelim();
      if (m.link_info != null && Object.hasOwnProperty.call(m, 'link_info'))
        $root.im_proto.LinkInfo.encode(m.link_info, w.uint32(26).fork()).ldelim();
      return w;
    };

    PictureCardFallbackInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.PictureCardFallbackInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.image = $root.im_proto.BaseImage.decode(r, r.uint32());
            break;
          case 2:
            m.text = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 3:
            m.link_info = $root.im_proto.LinkInfo.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PictureCardFallbackInfo;
  })();

  im_proto.IMUploadScene = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'MultimediaMessaging')] = 1;
    values[(valuesById[2] = 'StickerCreation')] = 2;
    values[(valuesById[3] = 'PublicMultimediaMessaging')] = 3;
    return values;
  })();

  im_proto.IMUploadAuthToken = (function () {
    function IMUploadAuthToken(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    IMUploadAuthToken.prototype.access_key_id = '';
    IMUploadAuthToken.prototype.session_token = '';
    IMUploadAuthToken.prototype.secret_access_key = '';
    IMUploadAuthToken.prototype.expire_time = '';
    IMUploadAuthToken.prototype.current_time = '';

    IMUploadAuthToken.create = function create(properties) {
      return new IMUploadAuthToken(properties);
    };

    IMUploadAuthToken.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.access_key_id != null && Object.hasOwnProperty.call(m, 'access_key_id'))
        w.uint32(10).string(m.access_key_id);
      if (m.session_token != null && Object.hasOwnProperty.call(m, 'session_token'))
        w.uint32(18).string(m.session_token);
      if (m.secret_access_key != null && Object.hasOwnProperty.call(m, 'secret_access_key'))
        w.uint32(26).string(m.secret_access_key);
      if (m.expire_time != null && Object.hasOwnProperty.call(m, 'expire_time')) w.uint32(34).string(m.expire_time);
      if (m.current_time != null && Object.hasOwnProperty.call(m, 'current_time')) w.uint32(42).string(m.current_time);
      return w;
    };

    IMUploadAuthToken.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.IMUploadAuthToken();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.access_key_id = r.string();
            break;
          case 2:
            m.session_token = r.string();
            break;
          case 3:
            m.secret_access_key = r.string();
            break;
          case 4:
            m.expire_time = r.string();
            break;
          case 5:
            m.current_time = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return IMUploadAuthToken;
  })();

  im_proto.IMVideoUploadConfig = (function () {
    function IMVideoUploadConfig(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    IMVideoUploadConfig.prototype.space_name = '';
    IMVideoUploadConfig.prototype.host = '';
    IMVideoUploadConfig.prototype.auth_token = null;

    IMVideoUploadConfig.create = function create(properties) {
      return new IMVideoUploadConfig(properties);
    };

    IMVideoUploadConfig.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.space_name != null && Object.hasOwnProperty.call(m, 'space_name')) w.uint32(10).string(m.space_name);
      if (m.host != null && Object.hasOwnProperty.call(m, 'host')) w.uint32(18).string(m.host);
      if (m.auth_token != null && Object.hasOwnProperty.call(m, 'auth_token'))
        $root.im_proto.IMUploadAuthToken.encode(m.auth_token, w.uint32(26).fork()).ldelim();
      return w;
    };

    IMVideoUploadConfig.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.IMVideoUploadConfig();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.space_name = r.string();
            break;
          case 2:
            m.host = r.string();
            break;
          case 3:
            m.auth_token = $root.im_proto.IMUploadAuthToken.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return IMVideoUploadConfig;
  })();

  im_proto.IMImageUploadConfig = (function () {
    function IMImageUploadConfig(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    IMImageUploadConfig.prototype.service_id = '';
    IMImageUploadConfig.prototype.host = '';
    IMImageUploadConfig.prototype.auth_token = null;

    IMImageUploadConfig.create = function create(properties) {
      return new IMImageUploadConfig(properties);
    };

    IMImageUploadConfig.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.service_id != null && Object.hasOwnProperty.call(m, 'service_id')) w.uint32(10).string(m.service_id);
      if (m.host != null && Object.hasOwnProperty.call(m, 'host')) w.uint32(18).string(m.host);
      if (m.auth_token != null && Object.hasOwnProperty.call(m, 'auth_token'))
        $root.im_proto.IMUploadAuthToken.encode(m.auth_token, w.uint32(26).fork()).ldelim();
      return w;
    };

    IMImageUploadConfig.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.IMImageUploadConfig();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.service_id = r.string();
            break;
          case 2:
            m.host = r.string();
            break;
          case 3:
            m.auth_token = $root.im_proto.IMUploadAuthToken.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return IMImageUploadConfig;
  })();

  im_proto.tiktok_v1_im_upload_config_request = (function () {
    function tiktok_v1_im_upload_config_request(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    tiktok_v1_im_upload_config_request.prototype.upload_scene = 1;

    tiktok_v1_im_upload_config_request.create = function create(properties) {
      return new tiktok_v1_im_upload_config_request(properties);
    };

    tiktok_v1_im_upload_config_request.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.upload_scene != null && Object.hasOwnProperty.call(m, 'upload_scene')) w.uint32(8).int32(m.upload_scene);
      return w;
    };

    tiktok_v1_im_upload_config_request.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.tiktok_v1_im_upload_config_request();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.upload_scene = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return tiktok_v1_im_upload_config_request;
  })();

  im_proto.tiktok_v1_im_upload_config_response = (function () {
    function tiktok_v1_im_upload_config_response(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    tiktok_v1_im_upload_config_response.prototype.status_code = 0;
    tiktok_v1_im_upload_config_response.prototype.status_msg = '';
    tiktok_v1_im_upload_config_response.prototype.upload_scene = 1;
    tiktok_v1_im_upload_config_response.prototype.video_upload_config = null;
    tiktok_v1_im_upload_config_response.prototype.image_upload_config = null;

    tiktok_v1_im_upload_config_response.create = function create(properties) {
      return new tiktok_v1_im_upload_config_response(properties);
    };

    tiktok_v1_im_upload_config_response.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int32(m.status_code);
      if (m.status_msg != null && Object.hasOwnProperty.call(m, 'status_msg')) w.uint32(18).string(m.status_msg);
      if (m.upload_scene != null && Object.hasOwnProperty.call(m, 'upload_scene')) w.uint32(24).int32(m.upload_scene);
      if (m.video_upload_config != null && Object.hasOwnProperty.call(m, 'video_upload_config'))
        $root.im_proto.IMVideoUploadConfig.encode(m.video_upload_config, w.uint32(34).fork()).ldelim();
      if (m.image_upload_config != null && Object.hasOwnProperty.call(m, 'image_upload_config'))
        $root.im_proto.IMImageUploadConfig.encode(m.image_upload_config, w.uint32(42).fork()).ldelim();
      return w;
    };

    tiktok_v1_im_upload_config_response.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.tiktok_v1_im_upload_config_response();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.status_code = r.int32();
            break;
          case 2:
            m.status_msg = r.string();
            break;
          case 3:
            m.upload_scene = r.int32();
            break;
          case 4:
            m.video_upload_config = $root.im_proto.IMVideoUploadConfig.decode(r, r.uint32());
            break;
          case 5:
            m.image_upload_config = $root.im_proto.IMImageUploadConfig.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('status_code'))
        throw $util.ProtocolError("missing required 'status_code'", { instance: m });
      return m;
    };

    return tiktok_v1_im_upload_config_response;
  })();

  im_proto.MessageContent = (function () {
    function MessageContent(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    MessageContent.prototype.image_card = null;
    MessageContent.prototype.picture_card = null;
    MessageContent.prototype.video_card = null;
    MessageContent.prototype.info_card = null;
    MessageContent.prototype.sticker_card = null;
    MessageContent.prototype.common_msg_card = null;
    MessageContent.prototype.dynamic_card = null;

    MessageContent.create = function create(properties) {
      return new MessageContent(properties);
    };

    MessageContent.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.image_card != null && Object.hasOwnProperty.call(m, 'image_card'))
        $root.im_proto.ImageCard.encode(m.image_card, w.uint32(18).fork()).ldelim();
      if (m.picture_card != null && Object.hasOwnProperty.call(m, 'picture_card'))
        $root.im_proto.PictureCard.encode(m.picture_card, w.uint32(34).fork()).ldelim();
      if (m.video_card != null && Object.hasOwnProperty.call(m, 'video_card'))
        $root.im_proto.VideoCard.encode(m.video_card, w.uint32(42).fork()).ldelim();
      if (m.info_card != null && Object.hasOwnProperty.call(m, 'info_card'))
        $root.im_proto.InfoCard.encode(m.info_card, w.uint32(50).fork()).ldelim();
      if (m.sticker_card != null && Object.hasOwnProperty.call(m, 'sticker_card'))
        $root.im_proto.StickerCard.encode(m.sticker_card, w.uint32(58).fork()).ldelim();
      if (m.common_msg_card != null && Object.hasOwnProperty.call(m, 'common_msg_card'))
        $root.im_proto.CommonMsgCard.encode(m.common_msg_card, w.uint32(802).fork()).ldelim();
      if (m.dynamic_card != null && Object.hasOwnProperty.call(m, 'dynamic_card'))
        $root.im_proto.DynamicCard.encode(m.dynamic_card, w.uint32(810).fork()).ldelim();
      return w;
    };

    MessageContent.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.MessageContent();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 2:
            m.image_card = $root.im_proto.ImageCard.decode(r, r.uint32());
            break;
          case 4:
            m.picture_card = $root.im_proto.PictureCard.decode(r, r.uint32());
            break;
          case 5:
            m.video_card = $root.im_proto.VideoCard.decode(r, r.uint32());
            break;
          case 6:
            m.info_card = $root.im_proto.InfoCard.decode(r, r.uint32());
            break;
          case 7:
            m.sticker_card = $root.im_proto.StickerCard.decode(r, r.uint32());
            break;
          case 100:
            m.common_msg_card = $root.im_proto.CommonMsgCard.decode(r, r.uint32());
            break;
          case 101:
            m.dynamic_card = $root.im_proto.DynamicCard.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return MessageContent;
  })();

  im_proto.VideoCard = (function () {
    function VideoCard(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    VideoCard.prototype.video = null;
    VideoCard.prototype.preview_hint = null;
    VideoCard.prototype.link_info = null;
    VideoCard.prototype.fallback = null;
    VideoCard.prototype.req_base = null;
    VideoCard.prototype.resp_base = null;

    VideoCard.create = function create(properties) {
      return new VideoCard(properties);
    };

    VideoCard.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.video != null && Object.hasOwnProperty.call(m, 'video'))
        $root.im_proto.BaseVideo.encode(m.video, w.uint32(10).fork()).ldelim();
      if (m.preview_hint != null && Object.hasOwnProperty.call(m, 'preview_hint'))
        $root.im_proto.PreviewHint.encode(m.preview_hint, w.uint32(18).fork()).ldelim();
      if (m.link_info != null && Object.hasOwnProperty.call(m, 'link_info'))
        $root.im_proto.LinkInfo.encode(m.link_info, w.uint32(26).fork()).ldelim();
      if (m.fallback != null && Object.hasOwnProperty.call(m, 'fallback'))
        $root.im_proto.VideoCardFallbackInfo.encode(m.fallback, w.uint32(34).fork()).ldelim();
      if (m.req_base != null && Object.hasOwnProperty.call(m, 'req_base'))
        $root.im_proto.BaseReq.encode(m.req_base, w.uint32(1602).fork()).ldelim();
      if (m.resp_base != null && Object.hasOwnProperty.call(m, 'resp_base'))
        $root.im_proto.BaseResp.encode(m.resp_base, w.uint32(1610).fork()).ldelim();
      return w;
    };

    VideoCard.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.VideoCard();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.video = $root.im_proto.BaseVideo.decode(r, r.uint32());
            break;
          case 2:
            m.preview_hint = $root.im_proto.PreviewHint.decode(r, r.uint32());
            break;
          case 3:
            m.link_info = $root.im_proto.LinkInfo.decode(r, r.uint32());
            break;
          case 4:
            m.fallback = $root.im_proto.VideoCardFallbackInfo.decode(r, r.uint32());
            break;
          case 200:
            m.req_base = $root.im_proto.BaseReq.decode(r, r.uint32());
            break;
          case 201:
            m.resp_base = $root.im_proto.BaseResp.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return VideoCard;
  })();

  im_proto.VideoCardFallbackInfo = (function () {
    function VideoCardFallbackInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    VideoCardFallbackInfo.prototype.image = null;
    VideoCardFallbackInfo.prototype.text = null;
    VideoCardFallbackInfo.prototype.link_info = null;

    VideoCardFallbackInfo.create = function create(properties) {
      return new VideoCardFallbackInfo(properties);
    };

    VideoCardFallbackInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.image != null && Object.hasOwnProperty.call(m, 'image'))
        $root.im_proto.BaseImage.encode(m.image, w.uint32(10).fork()).ldelim();
      if (m.text != null && Object.hasOwnProperty.call(m, 'text'))
        $root.im_proto.BaseText.encode(m.text, w.uint32(18).fork()).ldelim();
      if (m.link_info != null && Object.hasOwnProperty.call(m, 'link_info'))
        $root.im_proto.LinkInfo.encode(m.link_info, w.uint32(26).fork()).ldelim();
      return w;
    };

    VideoCardFallbackInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.VideoCardFallbackInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.image = $root.im_proto.BaseImage.decode(r, r.uint32());
            break;
          case 2:
            m.text = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 3:
            m.link_info = $root.im_proto.LinkInfo.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return VideoCardFallbackInfo;
  })();

  im_proto.WelcomeCard = (function () {
    function WelcomeCard(p) {
      this.images = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    WelcomeCard.prototype.title = null;
    WelcomeCard.prototype.button = null;
    WelcomeCard.prototype.images = $util.emptyArray;
    WelcomeCard.prototype.position = 0;
    WelcomeCard.prototype.req_base = null;
    WelcomeCard.prototype.resp_base = null;

    WelcomeCard.create = function create(properties) {
      return new WelcomeCard(properties);
    };

    WelcomeCard.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.title != null && Object.hasOwnProperty.call(m, 'title'))
        $root.im_proto.BaseText.encode(m.title, w.uint32(10).fork()).ldelim();
      if (m.button != null && Object.hasOwnProperty.call(m, 'button'))
        $root.im_proto.Button.encode(m.button, w.uint32(18).fork()).ldelim();
      if (m.images != null && m.images.length) {
        for (var i = 0; i < m.images.length; ++i)
          $root.im_proto.BaseImage.encode(m.images[i], w.uint32(26).fork()).ldelim();
      }
      if (m.position != null && Object.hasOwnProperty.call(m, 'position')) w.uint32(32).int32(m.position);
      if (m.req_base != null && Object.hasOwnProperty.call(m, 'req_base'))
        $root.im_proto.BaseReq.encode(m.req_base, w.uint32(1602).fork()).ldelim();
      if (m.resp_base != null && Object.hasOwnProperty.call(m, 'resp_base'))
        $root.im_proto.BaseResp.encode(m.resp_base, w.uint32(1610).fork()).ldelim();
      return w;
    };

    WelcomeCard.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.WelcomeCard();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.title = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 2:
            m.button = $root.im_proto.Button.decode(r, r.uint32());
            break;
          case 3:
            if (!(m.images && m.images.length)) m.images = [];
            m.images.push($root.im_proto.BaseImage.decode(r, r.uint32()));
            break;
          case 4:
            m.position = r.int32();
            break;
          case 200:
            m.req_base = $root.im_proto.BaseReq.decode(r, r.uint32());
            break;
          case 201:
            m.resp_base = $root.im_proto.BaseResp.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return WelcomeCard;
  })();

  im_proto.Position = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'top')] = 0;
    values[(valuesById[1] = 'middle')] = 1;
    values[(valuesById[2] = 'bottom')] = 2;
    return values;
  })();

  im_proto.FocusCard = (function () {
    function FocusCard(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    FocusCard.prototype.image = null;
    FocusCard.prototype.focus_card_info = null;
    FocusCard.prototype.description = null;
    FocusCard.prototype.text1 = null;
    FocusCard.prototype.text2 = null;
    FocusCard.prototype.link_info = null;
    FocusCard.prototype.req_base = null;
    FocusCard.prototype.resp_base = null;

    FocusCard.create = function create(properties) {
      return new FocusCard(properties);
    };

    FocusCard.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.image != null && Object.hasOwnProperty.call(m, 'image'))
        $root.im_proto.BaseImage.encode(m.image, w.uint32(10).fork()).ldelim();
      if (m.focus_card_info != null && Object.hasOwnProperty.call(m, 'focus_card_info'))
        $root.im_proto.FocusCardInfo.encode(m.focus_card_info, w.uint32(18).fork()).ldelim();
      if (m.description != null && Object.hasOwnProperty.call(m, 'description'))
        $root.im_proto.BaseText.encode(m.description, w.uint32(26).fork()).ldelim();
      if (m.text1 != null && Object.hasOwnProperty.call(m, 'text1'))
        $root.im_proto.BaseText.encode(m.text1, w.uint32(34).fork()).ldelim();
      if (m.text2 != null && Object.hasOwnProperty.call(m, 'text2'))
        $root.im_proto.BaseText.encode(m.text2, w.uint32(42).fork()).ldelim();
      if (m.link_info != null && Object.hasOwnProperty.call(m, 'link_info'))
        $root.im_proto.LinkInfo.encode(m.link_info, w.uint32(50).fork()).ldelim();
      if (m.req_base != null && Object.hasOwnProperty.call(m, 'req_base'))
        $root.im_proto.BaseReq.encode(m.req_base, w.uint32(1602).fork()).ldelim();
      if (m.resp_base != null && Object.hasOwnProperty.call(m, 'resp_base'))
        $root.im_proto.BaseResp.encode(m.resp_base, w.uint32(1610).fork()).ldelim();
      return w;
    };

    FocusCard.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.FocusCard();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.image = $root.im_proto.BaseImage.decode(r, r.uint32());
            break;
          case 2:
            m.focus_card_info = $root.im_proto.FocusCardInfo.decode(r, r.uint32());
            break;
          case 3:
            m.description = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 4:
            m.text1 = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 5:
            m.text2 = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 6:
            m.link_info = $root.im_proto.LinkInfo.decode(r, r.uint32());
            break;
          case 200:
            m.req_base = $root.im_proto.BaseReq.decode(r, r.uint32());
            break;
          case 201:
            m.resp_base = $root.im_proto.BaseResp.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return FocusCard;
  })();

  im_proto.FocusCardInfo = (function () {
    function FocusCardInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    FocusCardInfo.prototype.thumbnail = null;
    FocusCardInfo.prototype.text = null;

    FocusCardInfo.create = function create(properties) {
      return new FocusCardInfo(properties);
    };

    FocusCardInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.thumbnail != null && Object.hasOwnProperty.call(m, 'thumbnail'))
        $root.im_proto.BaseImage.encode(m.thumbnail, w.uint32(10).fork()).ldelim();
      if (m.text != null && Object.hasOwnProperty.call(m, 'text'))
        $root.im_proto.BaseText.encode(m.text, w.uint32(18).fork()).ldelim();
      return w;
    };

    FocusCardInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.FocusCardInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.thumbnail = $root.im_proto.BaseImage.decode(r, r.uint32());
            break;
          case 2:
            m.text = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return FocusCardInfo;
  })();

  im_proto.ImageCard = (function () {
    function ImageCard(p) {
      this.videos = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ImageCard.prototype.title = null;
    ImageCard.prototype.videos = $util.emptyArray;
    ImageCard.prototype.link_info = null;
    ImageCard.prototype.preview_hint = null;
    ImageCard.prototype.req_base = null;
    ImageCard.prototype.resp_base = null;

    ImageCard.create = function create(properties) {
      return new ImageCard(properties);
    };

    ImageCard.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.title != null && Object.hasOwnProperty.call(m, 'title'))
        $root.im_proto.ImageCardTitle.encode(m.title, w.uint32(10).fork()).ldelim();
      if (m.videos != null && m.videos.length) {
        for (var i = 0; i < m.videos.length; ++i)
          $root.im_proto.BaseVideo.encode(m.videos[i], w.uint32(18).fork()).ldelim();
      }
      if (m.link_info != null && Object.hasOwnProperty.call(m, 'link_info'))
        $root.im_proto.LinkInfo.encode(m.link_info, w.uint32(26).fork()).ldelim();
      if (m.preview_hint != null && Object.hasOwnProperty.call(m, 'preview_hint'))
        $root.im_proto.PreviewHint.encode(m.preview_hint, w.uint32(34).fork()).ldelim();
      if (m.req_base != null && Object.hasOwnProperty.call(m, 'req_base'))
        $root.im_proto.BaseReq.encode(m.req_base, w.uint32(1602).fork()).ldelim();
      if (m.resp_base != null && Object.hasOwnProperty.call(m, 'resp_base'))
        $root.im_proto.BaseResp.encode(m.resp_base, w.uint32(1610).fork()).ldelim();
      return w;
    };

    ImageCard.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ImageCard();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.title = $root.im_proto.ImageCardTitle.decode(r, r.uint32());
            break;
          case 2:
            if (!(m.videos && m.videos.length)) m.videos = [];
            m.videos.push($root.im_proto.BaseVideo.decode(r, r.uint32()));
            break;
          case 3:
            m.link_info = $root.im_proto.LinkInfo.decode(r, r.uint32());
            break;
          case 4:
            m.preview_hint = $root.im_proto.PreviewHint.decode(r, r.uint32());
            break;
          case 200:
            m.req_base = $root.im_proto.BaseReq.decode(r, r.uint32());
            break;
          case 201:
            m.resp_base = $root.im_proto.BaseResp.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ImageCard;
  })();

  im_proto.ImageCardTitle = (function () {
    function ImageCardTitle(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ImageCardTitle.prototype.image = null;
    ImageCardTitle.prototype.title = null;
    ImageCardTitle.prototype.subtitle = null;
    ImageCardTitle.prototype.button = null;

    ImageCardTitle.create = function create(properties) {
      return new ImageCardTitle(properties);
    };

    ImageCardTitle.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.image != null && Object.hasOwnProperty.call(m, 'image'))
        $root.im_proto.BaseImage.encode(m.image, w.uint32(10).fork()).ldelim();
      if (m.title != null && Object.hasOwnProperty.call(m, 'title'))
        $root.im_proto.BaseText.encode(m.title, w.uint32(18).fork()).ldelim();
      if (m.subtitle != null && Object.hasOwnProperty.call(m, 'subtitle'))
        $root.im_proto.BaseText.encode(m.subtitle, w.uint32(26).fork()).ldelim();
      if (m.button != null && Object.hasOwnProperty.call(m, 'button'))
        $root.im_proto.Button.encode(m.button, w.uint32(34).fork()).ldelim();
      return w;
    };

    ImageCardTitle.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ImageCardTitle();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.image = $root.im_proto.BaseImage.decode(r, r.uint32());
            break;
          case 2:
            m.title = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 3:
            m.subtitle = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 4:
            m.button = $root.im_proto.Button.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ImageCardTitle;
  })();

  im_proto.StickerCard = (function () {
    function StickerCard(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    StickerCard.prototype.sticker = null;
    StickerCard.prototype.preview_hint = null;
    StickerCard.prototype.fallback = null;
    StickerCard.prototype.sticker_creator_user_info = null;
    StickerCard.prototype.req_base = null;
    StickerCard.prototype.resp_base = null;

    StickerCard.create = function create(properties) {
      return new StickerCard(properties);
    };

    StickerCard.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.sticker != null && Object.hasOwnProperty.call(m, 'sticker'))
        $root.im_proto.BaseImage.encode(m.sticker, w.uint32(10).fork()).ldelim();
      if (m.preview_hint != null && Object.hasOwnProperty.call(m, 'preview_hint'))
        $root.im_proto.PreviewHint.encode(m.preview_hint, w.uint32(18).fork()).ldelim();
      if (m.fallback != null && Object.hasOwnProperty.call(m, 'fallback'))
        $root.im_proto.StickerCardFallbackInfo.encode(m.fallback, w.uint32(26).fork()).ldelim();
      if (m.sticker_creator_user_info != null && Object.hasOwnProperty.call(m, 'sticker_creator_user_info'))
        $root.im_proto.UserInfo.encode(m.sticker_creator_user_info, w.uint32(34).fork()).ldelim();
      if (m.req_base != null && Object.hasOwnProperty.call(m, 'req_base'))
        $root.im_proto.BaseReq.encode(m.req_base, w.uint32(1602).fork()).ldelim();
      if (m.resp_base != null && Object.hasOwnProperty.call(m, 'resp_base'))
        $root.im_proto.BaseResp.encode(m.resp_base, w.uint32(1610).fork()).ldelim();
      return w;
    };

    StickerCard.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.StickerCard();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.sticker = $root.im_proto.BaseImage.decode(r, r.uint32());
            break;
          case 2:
            m.preview_hint = $root.im_proto.PreviewHint.decode(r, r.uint32());
            break;
          case 3:
            m.fallback = $root.im_proto.StickerCardFallbackInfo.decode(r, r.uint32());
            break;
          case 4:
            m.sticker_creator_user_info = $root.im_proto.UserInfo.decode(r, r.uint32());
            break;
          case 200:
            m.req_base = $root.im_proto.BaseReq.decode(r, r.uint32());
            break;
          case 201:
            m.resp_base = $root.im_proto.BaseResp.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return StickerCard;
  })();

  im_proto.StickerCardFallbackInfo = (function () {
    function StickerCardFallbackInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    StickerCardFallbackInfo.prototype.placeholder = null;

    StickerCardFallbackInfo.create = function create(properties) {
      return new StickerCardFallbackInfo(properties);
    };

    StickerCardFallbackInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.placeholder != null && Object.hasOwnProperty.call(m, 'placeholder'))
        $root.im_proto.BaseImage.encode(m.placeholder, w.uint32(10).fork()).ldelim();
      return w;
    };

    StickerCardFallbackInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.StickerCardFallbackInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.placeholder = $root.im_proto.BaseImage.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return StickerCardFallbackInfo;
  })();

  im_proto.CommonMsgCard = (function () {
    function CommonMsgCard(p) {
      this.text_map = {};
      this.image_map = {};
      this.link_map = {};
      this.button_map = {};
      this.video_map = {};
      this.user_map = {};
      this.business_image_map = {};
      this.business_video_map = {};
      this.business_user_map = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    CommonMsgCard.prototype.text_map = $util.emptyObject;
    CommonMsgCard.prototype.image_map = $util.emptyObject;
    CommonMsgCard.prototype.link_map = $util.emptyObject;
    CommonMsgCard.prototype.button_map = $util.emptyObject;
    CommonMsgCard.prototype.video_map = $util.emptyObject;
    CommonMsgCard.prototype.user_map = $util.emptyObject;
    CommonMsgCard.prototype.fallback_info = null;
    CommonMsgCard.prototype.preview_hint = null;
    CommonMsgCard.prototype.business_image_map = $util.emptyObject;
    CommonMsgCard.prototype.business_video_map = $util.emptyObject;
    CommonMsgCard.prototype.business_user_map = $util.emptyObject;
    CommonMsgCard.prototype.extra_content = $util.newBuffer([]);
    CommonMsgCard.prototype.req_base = null;
    CommonMsgCard.prototype.resp_base = null;

    CommonMsgCard.create = function create(properties) {
      return new CommonMsgCard(properties);
    };

    CommonMsgCard.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.text_map != null && Object.hasOwnProperty.call(m, 'text_map')) {
        for (var ks = Object.keys(m.text_map), i = 0; i < ks.length; ++i) {
          w.uint32(10).fork().uint32(10).string(ks[i]);
          $root.im_proto.BaseText.encode(m.text_map[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
        }
      }
      if (m.image_map != null && Object.hasOwnProperty.call(m, 'image_map')) {
        for (var ks = Object.keys(m.image_map), i = 0; i < ks.length; ++i) {
          w.uint32(18).fork().uint32(10).string(ks[i]);
          $root.im_proto.BaseImage.encode(m.image_map[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
        }
      }
      if (m.link_map != null && Object.hasOwnProperty.call(m, 'link_map')) {
        for (var ks = Object.keys(m.link_map), i = 0; i < ks.length; ++i) {
          w.uint32(26).fork().uint32(10).string(ks[i]);
          $root.im_proto.LinkInfo.encode(m.link_map[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
        }
      }
      if (m.button_map != null && Object.hasOwnProperty.call(m, 'button_map')) {
        for (var ks = Object.keys(m.button_map), i = 0; i < ks.length; ++i) {
          w.uint32(34).fork().uint32(10).string(ks[i]);
          $root.im_proto.Button.encode(m.button_map[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
        }
      }
      if (m.video_map != null && Object.hasOwnProperty.call(m, 'video_map')) {
        for (var ks = Object.keys(m.video_map), i = 0; i < ks.length; ++i) {
          w.uint32(42).fork().uint32(10).string(ks[i]);
          $root.im_proto.BaseVideo.encode(m.video_map[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
        }
      }
      if (m.user_map != null && Object.hasOwnProperty.call(m, 'user_map')) {
        for (var ks = Object.keys(m.user_map), i = 0; i < ks.length; ++i) {
          w.uint32(50).fork().uint32(10).string(ks[i]);
          $root.im_proto.BaseUser.encode(m.user_map[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
        }
      }
      if (m.fallback_info != null && Object.hasOwnProperty.call(m, 'fallback_info'))
        $root.im_proto.FallbackInfo.encode(m.fallback_info, w.uint32(58).fork()).ldelim();
      if (m.preview_hint != null && Object.hasOwnProperty.call(m, 'preview_hint'))
        $root.im_proto.PreviewHint.encode(m.preview_hint, w.uint32(66).fork()).ldelim();
      if (m.business_image_map != null && Object.hasOwnProperty.call(m, 'business_image_map')) {
        for (var ks = Object.keys(m.business_image_map), i = 0; i < ks.length; ++i) {
          w.uint32(802).fork().uint32(10).string(ks[i]);
          $root.im_proto.BaseImage.encode(m.business_image_map[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
        }
      }
      if (m.business_video_map != null && Object.hasOwnProperty.call(m, 'business_video_map')) {
        for (var ks = Object.keys(m.business_video_map), i = 0; i < ks.length; ++i) {
          w.uint32(810).fork().uint32(10).string(ks[i]);
          $root.im_proto.BaseVideo.encode(m.business_video_map[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
        }
      }
      if (m.business_user_map != null && Object.hasOwnProperty.call(m, 'business_user_map')) {
        for (var ks = Object.keys(m.business_user_map), i = 0; i < ks.length; ++i) {
          w.uint32(818).fork().uint32(10).string(ks[i]);
          $root.im_proto.BaseUser.encode(m.business_user_map[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
        }
      }
      if (m.extra_content != null && Object.hasOwnProperty.call(m, 'extra_content'))
        w.uint32(1602).bytes(m.extra_content);
      if (m.req_base != null && Object.hasOwnProperty.call(m, 'req_base'))
        $root.im_proto.BaseReq.encode(m.req_base, w.uint32(1610).fork()).ldelim();
      if (m.resp_base != null && Object.hasOwnProperty.call(m, 'resp_base'))
        $root.im_proto.BaseResp.encode(m.resp_base, w.uint32(1618).fork()).ldelim();
      return w;
    };

    CommonMsgCard.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.CommonMsgCard(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (m.text_map === $util.emptyObject) m.text_map = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = null;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = $root.im_proto.BaseText.decode(r, r.uint32());
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.text_map[k] = value;
            break;
          case 2:
            if (m.image_map === $util.emptyObject) m.image_map = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = null;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = $root.im_proto.BaseImage.decode(r, r.uint32());
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.image_map[k] = value;
            break;
          case 3:
            if (m.link_map === $util.emptyObject) m.link_map = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = null;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = $root.im_proto.LinkInfo.decode(r, r.uint32());
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.link_map[k] = value;
            break;
          case 4:
            if (m.button_map === $util.emptyObject) m.button_map = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = null;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = $root.im_proto.Button.decode(r, r.uint32());
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.button_map[k] = value;
            break;
          case 5:
            if (m.video_map === $util.emptyObject) m.video_map = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = null;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = $root.im_proto.BaseVideo.decode(r, r.uint32());
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.video_map[k] = value;
            break;
          case 6:
            if (m.user_map === $util.emptyObject) m.user_map = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = null;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = $root.im_proto.BaseUser.decode(r, r.uint32());
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.user_map[k] = value;
            break;
          case 7:
            m.fallback_info = $root.im_proto.FallbackInfo.decode(r, r.uint32());
            break;
          case 8:
            m.preview_hint = $root.im_proto.PreviewHint.decode(r, r.uint32());
            break;
          case 100:
            if (m.business_image_map === $util.emptyObject) m.business_image_map = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = null;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = $root.im_proto.BaseImage.decode(r, r.uint32());
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.business_image_map[k] = value;
            break;
          case 101:
            if (m.business_video_map === $util.emptyObject) m.business_video_map = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = null;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = $root.im_proto.BaseVideo.decode(r, r.uint32());
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.business_video_map[k] = value;
            break;
          case 102:
            if (m.business_user_map === $util.emptyObject) m.business_user_map = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = null;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = $root.im_proto.BaseUser.decode(r, r.uint32());
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.business_user_map[k] = value;
            break;
          case 200:
            m.extra_content = r.bytes();
            break;
          case 201:
            m.req_base = $root.im_proto.BaseReq.decode(r, r.uint32());
            break;
          case 202:
            m.resp_base = $root.im_proto.BaseResp.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return CommonMsgCard;
  })();

  im_proto.UiLocationType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[10001] = 'MessageNormal')] = 10001;
    values[(valuesById[10002] = 'MessageCenter')] = 10002;
    values[(valuesById[20001] = 'BannerTop')] = 20001;
    values[(valuesById[20002] = 'BannerBottom')] = 20002;
    values[(valuesById[30001] = 'PopupTop')] = 30001;
    values[(valuesById[30002] = 'PopupBottom')] = 30002;
    return values;
  })();

  im_proto.DynamicInfo = (function () {
    function DynamicInfo(p) {
      this.ab_dynamic_infos = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DynamicInfo.prototype.card_key = '';
    DynamicInfo.prototype.schema = '';
    DynamicInfo.prototype.card_template = '';
    DynamicInfo.prototype.business_type = '';
    DynamicInfo.prototype.business_id = '';
    DynamicInfo.prototype.default_height = 0;
    DynamicInfo.prototype.default_width = 0;
    DynamicInfo.prototype.ui_location_type = 10001;
    DynamicInfo.prototype.raw_data = '';
    DynamicInfo.prototype.ab_key = '';
    DynamicInfo.prototype.ab_dynamic_infos = $util.emptyObject;

    DynamicInfo.create = function create(properties) {
      return new DynamicInfo(properties);
    };

    DynamicInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.card_key != null && Object.hasOwnProperty.call(m, 'card_key')) w.uint32(10).string(m.card_key);
      if (m.schema != null && Object.hasOwnProperty.call(m, 'schema')) w.uint32(18).string(m.schema);
      if (m.card_template != null && Object.hasOwnProperty.call(m, 'card_template'))
        w.uint32(26).string(m.card_template);
      if (m.business_type != null && Object.hasOwnProperty.call(m, 'business_type'))
        w.uint32(34).string(m.business_type);
      if (m.business_id != null && Object.hasOwnProperty.call(m, 'business_id')) w.uint32(42).string(m.business_id);
      if (m.default_height != null && Object.hasOwnProperty.call(m, 'default_height'))
        w.uint32(48).int32(m.default_height);
      if (m.default_width != null && Object.hasOwnProperty.call(m, 'default_width'))
        w.uint32(56).int32(m.default_width);
      if (m.ui_location_type != null && Object.hasOwnProperty.call(m, 'ui_location_type'))
        w.uint32(64).int32(m.ui_location_type);
      if (m.raw_data != null && Object.hasOwnProperty.call(m, 'raw_data')) w.uint32(74).string(m.raw_data);
      if (m.ab_key != null && Object.hasOwnProperty.call(m, 'ab_key')) w.uint32(162).string(m.ab_key);
      if (m.ab_dynamic_infos != null && Object.hasOwnProperty.call(m, 'ab_dynamic_infos')) {
        for (var ks = Object.keys(m.ab_dynamic_infos), i = 0; i < ks.length; ++i) {
          w.uint32(170).fork().uint32(10).string(ks[i]);
          $root.im_proto.DynamicInfo.encode(m.ab_dynamic_infos[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
        }
      }
      return w;
    };

    DynamicInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DynamicInfo(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.card_key = r.string();
            break;
          case 2:
            m.schema = r.string();
            break;
          case 3:
            m.card_template = r.string();
            break;
          case 4:
            m.business_type = r.string();
            break;
          case 5:
            m.business_id = r.string();
            break;
          case 6:
            m.default_height = r.int32();
            break;
          case 7:
            m.default_width = r.int32();
            break;
          case 8:
            m.ui_location_type = r.int32();
            break;
          case 9:
            m.raw_data = r.string();
            break;
          case 20:
            m.ab_key = r.string();
            break;
          case 21:
            if (m.ab_dynamic_infos === $util.emptyObject) m.ab_dynamic_infos = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = null;
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = $root.im_proto.DynamicInfo.decode(r, r.uint32());
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ab_dynamic_infos[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DynamicInfo;
  })();

  im_proto.DynamicCard = (function () {
    function DynamicCard(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    DynamicCard.prototype.dynamic_info = null;
    DynamicCard.prototype.fallback_info = null;
    DynamicCard.prototype.preview_hint = null;
    DynamicCard.prototype.req_base = null;
    DynamicCard.prototype.resp_base = null;

    DynamicCard.create = function create(properties) {
      return new DynamicCard(properties);
    };

    DynamicCard.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.dynamic_info != null && Object.hasOwnProperty.call(m, 'dynamic_info'))
        $root.im_proto.DynamicInfo.encode(m.dynamic_info, w.uint32(10).fork()).ldelim();
      if (m.fallback_info != null && Object.hasOwnProperty.call(m, 'fallback_info'))
        $root.im_proto.FallbackInfo.encode(m.fallback_info, w.uint32(82).fork()).ldelim();
      if (m.preview_hint != null && Object.hasOwnProperty.call(m, 'preview_hint'))
        $root.im_proto.PreviewHint.encode(m.preview_hint, w.uint32(90).fork()).ldelim();
      if (m.req_base != null && Object.hasOwnProperty.call(m, 'req_base'))
        $root.im_proto.BaseReq.encode(m.req_base, w.uint32(1610).fork()).ldelim();
      if (m.resp_base != null && Object.hasOwnProperty.call(m, 'resp_base'))
        $root.im_proto.BaseResp.encode(m.resp_base, w.uint32(1618).fork()).ldelim();
      return w;
    };

    DynamicCard.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.DynamicCard();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.dynamic_info = $root.im_proto.DynamicInfo.decode(r, r.uint32());
            break;
          case 10:
            m.fallback_info = $root.im_proto.FallbackInfo.decode(r, r.uint32());
            break;
          case 11:
            m.preview_hint = $root.im_proto.PreviewHint.decode(r, r.uint32());
            break;
          case 201:
            m.req_base = $root.im_proto.BaseReq.decode(r, r.uint32());
            break;
          case 202:
            m.resp_base = $root.im_proto.BaseResp.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DynamicCard;
  })();

  im_proto.UserInfo = (function () {
    function UserInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    UserInfo.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    UserInfo.prototype.nick_name = '';
    UserInfo.prototype.avatar_thumb = null;

    UserInfo.create = function create(properties) {
      return new UserInfo(properties);
    };

    UserInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(8).int64(m.user_id);
      if (m.nick_name != null && Object.hasOwnProperty.call(m, 'nick_name')) w.uint32(18).string(m.nick_name);
      if (m.avatar_thumb != null && Object.hasOwnProperty.call(m, 'avatar_thumb'))
        $root.im_proto.BaseImage.encode(m.avatar_thumb, w.uint32(26).fork()).ldelim();
      return w;
    };

    UserInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.UserInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.int64();
            break;
          case 2:
            m.nick_name = r.string();
            break;
          case 3:
            m.avatar_thumb = $root.im_proto.BaseImage.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UserInfo;
  })();

  im_proto.InfoCard = (function () {
    function InfoCard(p) {
      this.buttons = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    InfoCard.prototype.title = null;
    InfoCard.prototype.content = null;
    InfoCard.prototype.video = null;
    InfoCard.prototype.buttons = $util.emptyArray;
    InfoCard.prototype.link_info = null;
    InfoCard.prototype.req_base = null;
    InfoCard.prototype.resp_base = null;

    InfoCard.create = function create(properties) {
      return new InfoCard(properties);
    };

    InfoCard.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.title != null && Object.hasOwnProperty.call(m, 'title'))
        $root.im_proto.InfoCardTitle.encode(m.title, w.uint32(10).fork()).ldelim();
      if (m.content != null && Object.hasOwnProperty.call(m, 'content'))
        $root.im_proto.InfoCardContent.encode(m.content, w.uint32(18).fork()).ldelim();
      if (m.video != null && Object.hasOwnProperty.call(m, 'video'))
        $root.im_proto.BaseVideo.encode(m.video, w.uint32(26).fork()).ldelim();
      if (m.buttons != null && m.buttons.length) {
        for (var i = 0; i < m.buttons.length; ++i)
          $root.im_proto.InfoCardButton.encode(m.buttons[i], w.uint32(34).fork()).ldelim();
      }
      if (m.link_info != null && Object.hasOwnProperty.call(m, 'link_info'))
        $root.im_proto.LinkInfo.encode(m.link_info, w.uint32(50).fork()).ldelim();
      if (m.req_base != null && Object.hasOwnProperty.call(m, 'req_base'))
        $root.im_proto.BaseReq.encode(m.req_base, w.uint32(1602).fork()).ldelim();
      if (m.resp_base != null && Object.hasOwnProperty.call(m, 'resp_base'))
        $root.im_proto.BaseResp.encode(m.resp_base, w.uint32(1610).fork()).ldelim();
      return w;
    };

    InfoCard.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.InfoCard();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.title = $root.im_proto.InfoCardTitle.decode(r, r.uint32());
            break;
          case 2:
            m.content = $root.im_proto.InfoCardContent.decode(r, r.uint32());
            break;
          case 3:
            m.video = $root.im_proto.BaseVideo.decode(r, r.uint32());
            break;
          case 4:
            if (!(m.buttons && m.buttons.length)) m.buttons = [];
            m.buttons.push($root.im_proto.InfoCardButton.decode(r, r.uint32()));
            break;
          case 6:
            m.link_info = $root.im_proto.LinkInfo.decode(r, r.uint32());
            break;
          case 200:
            m.req_base = $root.im_proto.BaseReq.decode(r, r.uint32());
            break;
          case 201:
            m.resp_base = $root.im_proto.BaseResp.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return InfoCard;
  })();

  im_proto.InfoCardContent = (function () {
    function InfoCardContent(p) {
      this.contents = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    InfoCardContent.prototype.description = null;
    InfoCardContent.prototype.contents = $util.emptyArray;

    InfoCardContent.create = function create(properties) {
      return new InfoCardContent(properties);
    };

    InfoCardContent.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.description != null && Object.hasOwnProperty.call(m, 'description'))
        $root.im_proto.BaseText.encode(m.description, w.uint32(10).fork()).ldelim();
      if (m.contents != null && m.contents.length) {
        for (var i = 0; i < m.contents.length; ++i)
          $root.im_proto.BaseText.encode(m.contents[i], w.uint32(18).fork()).ldelim();
      }
      return w;
    };

    InfoCardContent.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.InfoCardContent();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.description = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 2:
            if (!(m.contents && m.contents.length)) m.contents = [];
            m.contents.push($root.im_proto.BaseText.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return InfoCardContent;
  })();

  im_proto.InfoCardTitle = (function () {
    function InfoCardTitle(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    InfoCardTitle.prototype.title = null;
    InfoCardTitle.prototype.image = null;

    InfoCardTitle.create = function create(properties) {
      return new InfoCardTitle(properties);
    };

    InfoCardTitle.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.title != null && Object.hasOwnProperty.call(m, 'title'))
        $root.im_proto.BaseText.encode(m.title, w.uint32(10).fork()).ldelim();
      if (m.image != null && Object.hasOwnProperty.call(m, 'image'))
        $root.im_proto.BaseImage.encode(m.image, w.uint32(18).fork()).ldelim();
      return w;
    };

    InfoCardTitle.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.InfoCardTitle();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.title = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 2:
            m.image = $root.im_proto.BaseImage.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return InfoCardTitle;
  })();

  im_proto.InfoCardButton = (function () {
    function InfoCardButton(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    InfoCardButton.prototype.text = null;
    InfoCardButton.prototype.hint = null;
    InfoCardButton.prototype.link = null;
    InfoCardButton.prototype.type = 1;

    InfoCardButton.create = function create(properties) {
      return new InfoCardButton(properties);
    };

    InfoCardButton.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.text != null && Object.hasOwnProperty.call(m, 'text'))
        $root.im_proto.BaseText.encode(m.text, w.uint32(10).fork()).ldelim();
      if (m.hint != null && Object.hasOwnProperty.call(m, 'hint'))
        $root.im_proto.BaseText.encode(m.hint, w.uint32(18).fork()).ldelim();
      if (m.link != null && Object.hasOwnProperty.call(m, 'link'))
        $root.im_proto.LinkInfo.encode(m.link, w.uint32(26).fork()).ldelim();
      if (m.type != null && Object.hasOwnProperty.call(m, 'type')) w.uint32(32).int32(m.type);
      return w;
    };

    InfoCardButton.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.InfoCardButton();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.text = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 2:
            m.hint = $root.im_proto.BaseText.decode(r, r.uint32());
            break;
          case 3:
            m.link = $root.im_proto.LinkInfo.decode(r, r.uint32());
            break;
          case 4:
            m.type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return InfoCardButton;
  })();

  im_proto.ButtonType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[1] = 'DEFAULT')] = 1;
    values[(valuesById[2] = 'CLICKABLE_TEXT')] = 2;
    return values;
  })();

  im_proto.CommerceUserLevel = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'WITHOUT_LEVEL')] = 0;
    values[(valuesById[1] = 'ONE')] = 1;
    values[(valuesById[2] = 'TWO')] = 2;
    values[(valuesById[3] = 'THREE')] = 3;
    return values;
  })();

  im_proto.PrimaryImageType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'PrimaryImageTypeUnknown')] = 0;
    values[(valuesById[1] = 'PrimaryImageTypeFilter')] = 1;
    values[(valuesById[2] = 'PrimaryImageTypeSkc')] = 2;
    values[(valuesById[3] = 'PrimaryImageTypeIntent')] = 3;
    values[(valuesById[4] = 'PrimaryImageTypeWhiteBackground')] = 4;
    values[(valuesById[5] = 'PrimaryImageTypePure')] = 5;
    values[(valuesById[6] = 'PrimaryImageTypeIntelligence')] = 6;
    values[(valuesById[7] = 'PrimaryImageTypeLong')] = 7;
    values[(valuesById[8] = 'PrimaryImageTypeDefault')] = 8;
    return values;
  })();

  im_proto.UrlStruct = (function () {
    function UrlStruct(p) {
      this.url_list = [];
      this.url_prefix = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    UrlStruct.prototype.uri = '';
    UrlStruct.prototype.url_list = $util.emptyArray;
    UrlStruct.prototype.width = 0;
    UrlStruct.prototype.height = 0;
    UrlStruct.prototype.url_key = '';
    UrlStruct.prototype.data_size = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    UrlStruct.prototype.file_hash = '';
    UrlStruct.prototype.invalid = false;
    UrlStruct.prototype.file_cs = '';
    UrlStruct.prototype.type = 0;
    UrlStruct.prototype.url_sub_type = 0;
    UrlStruct.prototype.md5 = '';
    UrlStruct.prototype.player_access_key = '';
    UrlStruct.prototype.url_prefix = $util.emptyArray;
    UrlStruct.prototype.image_media_model = null;
    UrlStruct.prototype.primary_image_type = 0;
    UrlStruct.prototype.image_index = 0;
    UrlStruct.prototype.preview = null;

    UrlStruct.create = function create(properties) {
      return new UrlStruct(properties);
    };

    UrlStruct.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.uri != null && Object.hasOwnProperty.call(m, 'uri')) w.uint32(10).string(m.uri);
      if (m.url_list != null && m.url_list.length) {
        for (var i = 0; i < m.url_list.length; ++i) w.uint32(18).string(m.url_list[i]);
      }
      if (m.width != null && Object.hasOwnProperty.call(m, 'width')) w.uint32(24).int32(m.width);
      if (m.height != null && Object.hasOwnProperty.call(m, 'height')) w.uint32(32).int32(m.height);
      if (m.url_key != null && Object.hasOwnProperty.call(m, 'url_key')) w.uint32(42).string(m.url_key);
      if (m.data_size != null && Object.hasOwnProperty.call(m, 'data_size')) w.uint32(48).int64(m.data_size);
      if (m.file_hash != null && Object.hasOwnProperty.call(m, 'file_hash')) w.uint32(58).string(m.file_hash);
      if (m.invalid != null && Object.hasOwnProperty.call(m, 'invalid')) w.uint32(64).bool(m.invalid);
      if (m.file_cs != null && Object.hasOwnProperty.call(m, 'file_cs')) w.uint32(74).string(m.file_cs);
      if (m.type != null && Object.hasOwnProperty.call(m, 'type')) w.uint32(80).int32(m.type);
      if (m.url_sub_type != null && Object.hasOwnProperty.call(m, 'url_sub_type')) w.uint32(88).int32(m.url_sub_type);
      if (m.md5 != null && Object.hasOwnProperty.call(m, 'md5')) w.uint32(98).string(m.md5);
      if (m.player_access_key != null && Object.hasOwnProperty.call(m, 'player_access_key'))
        w.uint32(106).string(m.player_access_key);
      if (m.url_prefix != null && m.url_prefix.length) {
        for (var i = 0; i < m.url_prefix.length; ++i) w.uint32(114).string(m.url_prefix[i]);
      }
      if (m.image_media_model != null && Object.hasOwnProperty.call(m, 'image_media_model'))
        $root.im_proto.ImageMediaModel.encode(m.image_media_model, w.uint32(122).fork()).ldelim();
      if (m.primary_image_type != null && Object.hasOwnProperty.call(m, 'primary_image_type'))
        w.uint32(128).int32(m.primary_image_type);
      if (m.image_index != null && Object.hasOwnProperty.call(m, 'image_index')) w.uint32(136).int32(m.image_index);
      if (m.preview != null && Object.hasOwnProperty.call(m, 'preview'))
        $root.im_proto.PreviewStruct.encode(m.preview, w.uint32(146).fork()).ldelim();
      return w;
    };

    UrlStruct.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.UrlStruct();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.uri = r.string();
            break;
          case 2:
            if (!(m.url_list && m.url_list.length)) m.url_list = [];
            m.url_list.push(r.string());
            break;
          case 3:
            m.width = r.int32();
            break;
          case 4:
            m.height = r.int32();
            break;
          case 5:
            m.url_key = r.string();
            break;
          case 6:
            m.data_size = r.int64();
            break;
          case 7:
            m.file_hash = r.string();
            break;
          case 8:
            m.invalid = r.bool();
            break;
          case 9:
            m.file_cs = r.string();
            break;
          case 10:
            m.type = r.int32();
            break;
          case 11:
            m.url_sub_type = r.int32();
            break;
          case 12:
            m.md5 = r.string();
            break;
          case 13:
            m.player_access_key = r.string();
            break;
          case 14:
            if (!(m.url_prefix && m.url_prefix.length)) m.url_prefix = [];
            m.url_prefix.push(r.string());
            break;
          case 15:
            m.image_media_model = $root.im_proto.ImageMediaModel.decode(r, r.uint32());
            break;
          case 16:
            m.primary_image_type = r.int32();
            break;
          case 17:
            m.image_index = r.int32();
            break;
          case 18:
            m.preview = $root.im_proto.PreviewStruct.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UrlStruct;
  })();

  im_proto.ImagePackSourceInfo = (function () {
    function ImagePackSourceInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ImagePackSourceInfo.prototype.tenant = '';
    ImagePackSourceInfo.prototype.pack_scene = '';
    ImagePackSourceInfo.prototype.biz_pack_source = '';

    ImagePackSourceInfo.create = function create(properties) {
      return new ImagePackSourceInfo(properties);
    };

    ImagePackSourceInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.tenant != null && Object.hasOwnProperty.call(m, 'tenant')) w.uint32(10).string(m.tenant);
      if (m.pack_scene != null && Object.hasOwnProperty.call(m, 'pack_scene')) w.uint32(18).string(m.pack_scene);
      if (m.biz_pack_source != null && Object.hasOwnProperty.call(m, 'biz_pack_source'))
        w.uint32(26).string(m.biz_pack_source);
      return w;
    };

    ImagePackSourceInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ImagePackSourceInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.tenant = r.string();
            break;
          case 2:
            m.pack_scene = r.string();
            break;
          case 3:
            m.biz_pack_source = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ImagePackSourceInfo;
  })();

  im_proto.ImageMetaInfo = (function () {
    function ImageMetaInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ImageMetaInfo.prototype.width = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ImageMetaInfo.prototype.height = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ImageMetaInfo.prototype.size = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ImageMetaInfo.prototype.bitrate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ImageMetaInfo.prototype.definition = '';
    ImageMetaInfo.prototype.quality = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    ImageMetaInfo.create = function create(properties) {
      return new ImageMetaInfo(properties);
    };

    ImageMetaInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.width != null && Object.hasOwnProperty.call(m, 'width')) w.uint32(8).int64(m.width);
      if (m.height != null && Object.hasOwnProperty.call(m, 'height')) w.uint32(16).int64(m.height);
      if (m.size != null && Object.hasOwnProperty.call(m, 'size')) w.uint32(24).int64(m.size);
      if (m.bitrate != null && Object.hasOwnProperty.call(m, 'bitrate')) w.uint32(32).int64(m.bitrate);
      if (m.definition != null && Object.hasOwnProperty.call(m, 'definition')) w.uint32(42).string(m.definition);
      if (m.quality != null && Object.hasOwnProperty.call(m, 'quality')) w.uint32(48).int64(m.quality);
      return w;
    };

    ImageMetaInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ImageMetaInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.width = r.int64();
            break;
          case 2:
            m.height = r.int64();
            break;
          case 3:
            m.size = r.int64();
            break;
          case 4:
            m.bitrate = r.int64();
            break;
          case 5:
            m.definition = r.string();
            break;
          case 6:
            m.quality = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ImageMetaInfo;
  })();

  im_proto.ImageMediaModel = (function () {
    function ImageMediaModel(p) {
      this.ladder_infos = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ImageMediaModel.prototype.original_uri = '';
    ImageMediaModel.prototype.original_meta_info = null;
    ImageMediaModel.prototype.ladder_infos = $util.emptyArray;
    ImageMediaModel.prototype.expire_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ImageMediaModel.prototype.pack_source_info = null;

    ImageMediaModel.create = function create(properties) {
      return new ImageMediaModel(properties);
    };

    ImageMediaModel.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.original_uri != null && Object.hasOwnProperty.call(m, 'original_uri')) w.uint32(10).string(m.original_uri);
      if (m.original_meta_info != null && Object.hasOwnProperty.call(m, 'original_meta_info'))
        $root.im_proto.ImageMetaInfo.encode(m.original_meta_info, w.uint32(18).fork()).ldelim();
      if (m.ladder_infos != null && m.ladder_infos.length) {
        for (var i = 0; i < m.ladder_infos.length; ++i)
          $root.im_proto.ImageLadderInfo.encode(m.ladder_infos[i], w.uint32(26).fork()).ldelim();
      }
      if (m.expire_time != null && Object.hasOwnProperty.call(m, 'expire_time')) w.uint32(32).int64(m.expire_time);
      if (m.pack_source_info != null && Object.hasOwnProperty.call(m, 'pack_source_info'))
        $root.im_proto.ImagePackSourceInfo.encode(m.pack_source_info, w.uint32(42).fork()).ldelim();
      return w;
    };

    ImageMediaModel.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ImageMediaModel();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.original_uri = r.string();
            break;
          case 2:
            m.original_meta_info = $root.im_proto.ImageMetaInfo.decode(r, r.uint32());
            break;
          case 3:
            if (!(m.ladder_infos && m.ladder_infos.length)) m.ladder_infos = [];
            m.ladder_infos.push($root.im_proto.ImageLadderInfo.decode(r, r.uint32()));
            break;
          case 4:
            m.expire_time = r.int64();
            break;
          case 5:
            m.pack_source_info = $root.im_proto.ImagePackSourceInfo.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ImageMediaModel;
  })();

  im_proto.ImageLadderInfo = (function () {
    function ImageLadderInfo(p) {
      this.url_list = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ImageLadderInfo.prototype.ladder_name = '';
    ImageLadderInfo.prototype.uri = '';
    ImageLadderInfo.prototype.url_list = $util.emptyArray;
    ImageLadderInfo.prototype.meta_info = null;
    ImageLadderInfo.prototype.process_config = null;

    ImageLadderInfo.create = function create(properties) {
      return new ImageLadderInfo(properties);
    };

    ImageLadderInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.ladder_name != null && Object.hasOwnProperty.call(m, 'ladder_name')) w.uint32(10).string(m.ladder_name);
      if (m.uri != null && Object.hasOwnProperty.call(m, 'uri')) w.uint32(18).string(m.uri);
      if (m.url_list != null && m.url_list.length) {
        for (var i = 0; i < m.url_list.length; ++i) w.uint32(26).string(m.url_list[i]);
      }
      if (m.meta_info != null && Object.hasOwnProperty.call(m, 'meta_info'))
        $root.im_proto.ImageMetaInfo.encode(m.meta_info, w.uint32(34).fork()).ldelim();
      if (m.process_config != null && Object.hasOwnProperty.call(m, 'process_config'))
        $root.im_proto.ImageProcessConfig.encode(m.process_config, w.uint32(42).fork()).ldelim();
      return w;
    };

    ImageLadderInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ImageLadderInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.ladder_name = r.string();
            break;
          case 2:
            m.uri = r.string();
            break;
          case 3:
            if (!(m.url_list && m.url_list.length)) m.url_list = [];
            m.url_list.push(r.string());
            break;
          case 4:
            m.meta_info = $root.im_proto.ImageMetaInfo.decode(r, r.uint32());
            break;
          case 5:
            m.process_config = $root.im_proto.ImageProcessConfig.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ImageLadderInfo;
  })();

  im_proto.ImageProcessConfig = (function () {
    function ImageProcessConfig(p) {
      this.params = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ImageProcessConfig.prototype.template = '';
    ImageProcessConfig.prototype.usage = '';
    ImageProcessConfig.prototype.params = $util.emptyArray;

    ImageProcessConfig.create = function create(properties) {
      return new ImageProcessConfig(properties);
    };

    ImageProcessConfig.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.template != null && Object.hasOwnProperty.call(m, 'template')) w.uint32(10).string(m.template);
      if (m.usage != null && Object.hasOwnProperty.call(m, 'usage')) w.uint32(18).string(m.usage);
      if (m.params != null && m.params.length) {
        for (var i = 0; i < m.params.length; ++i)
          $root.im_proto.ImageProcessConfigParam.encode(m.params[i], w.uint32(26).fork()).ldelim();
      }
      return w;
    };

    ImageProcessConfig.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ImageProcessConfig();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.template = r.string();
            break;
          case 2:
            m.usage = r.string();
            break;
          case 3:
            if (!(m.params && m.params.length)) m.params = [];
            m.params.push($root.im_proto.ImageProcessConfigParam.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ImageProcessConfig;
  })();

  im_proto.ImageProcessConfigParam = (function () {
    function ImageProcessConfigParam(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ImageProcessConfigParam.prototype.param_key = '';
    ImageProcessConfigParam.prototype.param_value = '';

    ImageProcessConfigParam.create = function create(properties) {
      return new ImageProcessConfigParam(properties);
    };

    ImageProcessConfigParam.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.param_key != null && Object.hasOwnProperty.call(m, 'param_key')) w.uint32(10).string(m.param_key);
      if (m.param_value != null && Object.hasOwnProperty.call(m, 'param_value')) w.uint32(18).string(m.param_value);
      return w;
    };

    ImageProcessConfigParam.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ImageProcessConfigParam();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.param_key = r.string();
            break;
          case 2:
            m.param_value = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ImageProcessConfigParam;
  })();

  im_proto.ImUserInfoCanShareMessageType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'UNKNOWN_TYPE')] = 0;
    values[(valuesById[1] = 'ON_TYPE')] = 1;
    values[(valuesById[2] = 'OFF_TYPE')] = 2;
    return values;
  })();

  im_proto.FollowStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[-1] = 'FollowRelationUnknown')] = -1;
    values[(valuesById[0] = 'NoRelationStatus')] = 0;
    values[(valuesById[1] = 'FollowingStatus')] = 1;
    values[(valuesById[2] = 'FollowEachOtherStatus')] = 2;
    values[(valuesById[4] = 'FollowRequestStatus')] = 4;
    return values;
  })();

  im_proto.VerificationType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'UNCERTIFIED')] = 0;
    values[(valuesById[1] = 'DEFAULT')] = 1;
    values[(valuesById[2] = 'ORIGINAL_MUSICIAN')] = 2;
    values[(valuesById[3] = 'EFFECT_ARTIST')] = 3;
    return values;
  })();

  im_proto.UserActivityStatus = (function () {
    function UserActivityStatus(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    UserActivityStatus.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    UserActivityStatus.prototype.active_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    UserActivityStatus.prototype.inactive_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    UserActivityStatus.prototype.now_status = 0;

    UserActivityStatus.create = function create(properties) {
      return new UserActivityStatus(properties);
    };

    UserActivityStatus.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(8).int64(m.user_id);
      if (m.active_time != null && Object.hasOwnProperty.call(m, 'active_time')) w.uint32(16).int64(m.active_time);
      if (m.inactive_time != null && Object.hasOwnProperty.call(m, 'inactive_time'))
        w.uint32(24).int64(m.inactive_time);
      if (m.now_status != null && Object.hasOwnProperty.call(m, 'now_status')) w.uint32(32).int32(m.now_status);
      return w;
    };

    UserActivityStatus.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.UserActivityStatus();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.int64();
            break;
          case 2:
            m.active_time = r.int64();
            break;
          case 3:
            m.inactive_time = r.int64();
            break;
          case 4:
            m.now_status = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UserActivityStatus;
  })();

  im_proto.ImUserInfoStruct = (function () {
    function ImUserInfoStruct(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ImUserInfoStruct.prototype.uid = '';
    ImUserInfoStruct.prototype.short_id = '';
    ImUserInfoStruct.prototype.nickname = '';
    ImUserInfoStruct.prototype.avatar_thumb = null;
    ImUserInfoStruct.prototype.signature = '';
    ImUserInfoStruct.prototype.follow_status = -1;
    ImUserInfoStruct.prototype.enterprise_verify_reason = '';
    ImUserInfoStruct.prototype.verification_type = 0;
    ImUserInfoStruct.prototype.custom_verify = '';
    ImUserInfoStruct.prototype.unique_id = '';
    ImUserInfoStruct.prototype.commerce_user_level = 0;
    ImUserInfoStruct.prototype.remark_name = '';
    ImUserInfoStruct.prototype.is_block = false;
    ImUserInfoStruct.prototype.sec_uid = '';
    ImUserInfoStruct.prototype.can_share_message = 0;
    ImUserInfoStruct.prototype.follow_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ImUserInfoStruct.prototype.follower_status = 0;
    ImUserInfoStruct.prototype.activity_status = null;
    ImUserInfoStruct.prototype.avatar_medium = null;

    ImUserInfoStruct.create = function create(properties) {
      return new ImUserInfoStruct(properties);
    };

    ImUserInfoStruct.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(10).string(m.uid);
      w.uint32(18).string(m.short_id);
      w.uint32(26).string(m.nickname);
      $root.im_proto.UrlStruct.encode(m.avatar_thumb, w.uint32(34).fork()).ldelim();
      w.uint32(42).string(m.signature);
      if (m.follow_status != null && Object.hasOwnProperty.call(m, 'follow_status'))
        w.uint32(48).int32(m.follow_status);
      if (m.enterprise_verify_reason != null && Object.hasOwnProperty.call(m, 'enterprise_verify_reason'))
        w.uint32(58).string(m.enterprise_verify_reason);
      if (m.verification_type != null && Object.hasOwnProperty.call(m, 'verification_type'))
        w.uint32(80).int32(m.verification_type);
      if (m.custom_verify != null && Object.hasOwnProperty.call(m, 'custom_verify'))
        w.uint32(90).string(m.custom_verify);
      if (m.unique_id != null && Object.hasOwnProperty.call(m, 'unique_id')) w.uint32(98).string(m.unique_id);
      if (m.commerce_user_level != null && Object.hasOwnProperty.call(m, 'commerce_user_level'))
        w.uint32(104).int32(m.commerce_user_level);
      if (m.remark_name != null && Object.hasOwnProperty.call(m, 'remark_name')) w.uint32(114).string(m.remark_name);
      if (m.is_block != null && Object.hasOwnProperty.call(m, 'is_block')) w.uint32(128).bool(m.is_block);
      if (m.sec_uid != null && Object.hasOwnProperty.call(m, 'sec_uid')) w.uint32(138).string(m.sec_uid);
      if (m.can_share_message != null && Object.hasOwnProperty.call(m, 'can_share_message'))
        w.uint32(144).int32(m.can_share_message);
      if (m.follow_time != null && Object.hasOwnProperty.call(m, 'follow_time')) w.uint32(160).int64(m.follow_time);
      if (m.follower_status != null && Object.hasOwnProperty.call(m, 'follower_status'))
        w.uint32(168).int32(m.follower_status);
      if (m.activity_status != null && Object.hasOwnProperty.call(m, 'activity_status'))
        $root.im_proto.UserActivityStatus.encode(m.activity_status, w.uint32(178).fork()).ldelim();
      if (m.avatar_medium != null && Object.hasOwnProperty.call(m, 'avatar_medium'))
        $root.im_proto.UrlStruct.encode(m.avatar_medium, w.uint32(186).fork()).ldelim();
      return w;
    };

    ImUserInfoStruct.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ImUserInfoStruct();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.uid = r.string();
            break;
          case 2:
            m.short_id = r.string();
            break;
          case 3:
            m.nickname = r.string();
            break;
          case 4:
            m.avatar_thumb = $root.im_proto.UrlStruct.decode(r, r.uint32());
            break;
          case 5:
            m.signature = r.string();
            break;
          case 6:
            m.follow_status = r.int32();
            break;
          case 7:
            m.enterprise_verify_reason = r.string();
            break;
          case 10:
            m.verification_type = r.int32();
            break;
          case 11:
            m.custom_verify = r.string();
            break;
          case 12:
            m.unique_id = r.string();
            break;
          case 13:
            m.commerce_user_level = r.int32();
            break;
          case 14:
            m.remark_name = r.string();
            break;
          case 16:
            m.is_block = r.bool();
            break;
          case 17:
            m.sec_uid = r.string();
            break;
          case 18:
            m.can_share_message = r.int32();
            break;
          case 20:
            m.follow_time = r.int64();
            break;
          case 21:
            m.follower_status = r.int32();
            break;
          case 22:
            m.activity_status = $root.im_proto.UserActivityStatus.decode(r, r.uint32());
            break;
          case 23:
            m.avatar_medium = $root.im_proto.UrlStruct.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('uid')) throw $util.ProtocolError("missing required 'uid'", { instance: m });
      if (!m.hasOwnProperty('short_id')) throw $util.ProtocolError("missing required 'short_id'", { instance: m });
      if (!m.hasOwnProperty('nickname')) throw $util.ProtocolError("missing required 'nickname'", { instance: m });
      if (!m.hasOwnProperty('avatar_thumb'))
        throw $util.ProtocolError("missing required 'avatar_thumb'", { instance: m });
      if (!m.hasOwnProperty('signature')) throw $util.ProtocolError("missing required 'signature'", { instance: m });
      return m;
    };

    return ImUserInfoStruct;
  })();

  im_proto.IMUserShareStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'ShareMessage_UNKNOWN')] = 0;
    values[(valuesById[1] = 'ShareMessage_ALLOWED')] = 1;
    values[(valuesById[2] = 'ShareMessage_NOTALLOWED')] = 2;
    return values;
  })();

  im_proto.IMTTNUserShareStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'TTNShare_UNKNOWN')] = 0;
    values[(valuesById[1] = 'TTNShare_ALLOWED')] = 1;
    values[(valuesById[2] = 'TTNShare_NOT_ALLOWED')] = 2;
    values[(valuesById[3] = 'TTNShare_DISABLED')] = 3;
    return values;
  })();

  im_proto.SharePermission = (function () {
    function SharePermission(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    SharePermission.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    SharePermission.prototype.user_share_status = 0;
    SharePermission.prototype.ttn_share_status = 0;
    SharePermission.prototype.update_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    SharePermission.create = function create(properties) {
      return new SharePermission(properties);
    };

    SharePermission.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.user_id);
      w.uint32(16).int32(m.user_share_status);
      w.uint32(24).int32(m.ttn_share_status);
      w.uint32(32).int64(m.update_time);
      return w;
    };

    SharePermission.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.SharePermission();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.int64();
            break;
          case 2:
            m.user_share_status = r.int32();
            break;
          case 3:
            m.ttn_share_status = r.int32();
            break;
          case 4:
            m.update_time = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('user_id')) throw $util.ProtocolError("missing required 'user_id'", { instance: m });
      if (!m.hasOwnProperty('user_share_status'))
        throw $util.ProtocolError("missing required 'user_share_status'", { instance: m });
      if (!m.hasOwnProperty('ttn_share_status'))
        throw $util.ProtocolError("missing required 'ttn_share_status'", { instance: m });
      if (!m.hasOwnProperty('update_time'))
        throw $util.ProtocolError("missing required 'update_time'", { instance: m });
      return m;
    };

    return SharePermission;
  })();

  im_proto.IMShareFilterType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'IM_SHARE_FILTER_TYPE_UNKNOWN')] = 0;
    values[(valuesById[1] = 'IM_SHARE_FILTER_TYPE_TO_FYP')] = 1;
    return values;
  })();

  im_proto.IMUserB2CAccountInfo = (function () {
    function IMUserB2CAccountInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    IMUserB2CAccountInfo.prototype.user_tags = '';

    IMUserB2CAccountInfo.create = function create(properties) {
      return new IMUserB2CAccountInfo(properties);
    };

    IMUserB2CAccountInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_tags != null && Object.hasOwnProperty.call(m, 'user_tags')) w.uint32(10).string(m.user_tags);
      return w;
    };

    IMUserB2CAccountInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.IMUserB2CAccountInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_tags = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return IMUserB2CAccountInfo;
  })();

  im_proto.IMUserCameraInfo = (function () {
    function IMUserCameraInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    IMUserCameraInfo.prototype.feature_result = null;

    IMUserCameraInfo.create = function create(properties) {
      return new IMUserCameraInfo(properties);
    };

    IMUserCameraInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.feature_result != null && Object.hasOwnProperty.call(m, 'feature_result'))
        $root.im_proto.IMFeatureResult.encode(m.feature_result, w.uint32(10).fork()).ldelim();
      return w;
    };

    IMUserCameraInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.IMUserCameraInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.feature_result = $root.im_proto.IMFeatureResult.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return IMUserCameraInfo;
  })();

  im_proto.IMFeatureResult = (function () {
    function IMFeatureResult(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    IMFeatureResult.prototype.status = 0;

    IMFeatureResult.create = function create(properties) {
      return new IMFeatureResult(properties);
    };

    IMFeatureResult.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.status != null && Object.hasOwnProperty.call(m, 'status')) w.uint32(8).int32(m.status);
      return w;
    };

    IMFeatureResult.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.IMFeatureResult();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.status = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return IMFeatureResult;
  })();

  im_proto.IMFeatureStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'IM_FEATURE_STATUS_UNKNOWN')] = 0;
    values[(valuesById[1] = 'IM_FEATURE_STATUS_ALLOWED')] = 1;
    values[(valuesById[2] = 'IM_FEATURE_STATUS_DISALLOWED')] = 2;
    return values;
  })();

  im_proto.IMUserBizInfo = (function () {
    function IMUserBizInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    IMUserBizInfo.prototype.share_filter_type = 0;
    IMUserBizInfo.prototype.affinity_score = 0;
    IMUserBizInfo.prototype.user_share_status = 0;
    IMUserBizInfo.prototype.user_b2c_account_info = null;
    IMUserBizInfo.prototype.camera_info = null;
    IMUserBizInfo.prototype.update_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    IMUserBizInfo.create = function create(properties) {
      return new IMUserBizInfo(properties);
    };

    IMUserBizInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.share_filter_type != null && Object.hasOwnProperty.call(m, 'share_filter_type'))
        w.uint32(8).int32(m.share_filter_type);
      if (m.affinity_score != null && Object.hasOwnProperty.call(m, 'affinity_score'))
        w.uint32(17).double(m.affinity_score);
      if (m.user_share_status != null && Object.hasOwnProperty.call(m, 'user_share_status'))
        w.uint32(24).int32(m.user_share_status);
      if (m.user_b2c_account_info != null && Object.hasOwnProperty.call(m, 'user_b2c_account_info'))
        $root.im_proto.IMUserB2CAccountInfo.encode(m.user_b2c_account_info, w.uint32(34).fork()).ldelim();
      if (m.camera_info != null && Object.hasOwnProperty.call(m, 'camera_info'))
        $root.im_proto.IMUserCameraInfo.encode(m.camera_info, w.uint32(42).fork()).ldelim();
      if (m.update_time != null && Object.hasOwnProperty.call(m, 'update_time')) w.uint32(800).int64(m.update_time);
      return w;
    };

    IMUserBizInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.IMUserBizInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.share_filter_type = r.int32();
            break;
          case 2:
            m.affinity_score = r.double();
            break;
          case 3:
            m.user_share_status = r.int32();
            break;
          case 4:
            m.user_b2c_account_info = $root.im_proto.IMUserB2CAccountInfo.decode(r, r.uint32());
            break;
          case 5:
            m.camera_info = $root.im_proto.IMUserCameraInfo.decode(r, r.uint32());
            break;
          case 100:
            m.update_time = r.int64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return IMUserBizInfo;
  })();

  im_proto.IMUserProfileInfo = (function () {
    function IMUserProfileInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    IMUserProfileInfo.prototype.im_user_profile = null;
    IMUserProfileInfo.prototype.share_permission = null;
    IMUserProfileInfo.prototype.im_biz_info = null;

    IMUserProfileInfo.create = function create(properties) {
      return new IMUserProfileInfo(properties);
    };

    IMUserProfileInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      $root.im_proto.IMUserBaseInfo.encode(m.im_user_profile, w.uint32(10).fork()).ldelim();
      if (m.share_permission != null && Object.hasOwnProperty.call(m, 'share_permission'))
        $root.im_proto.SharePermission.encode(m.share_permission, w.uint32(18).fork()).ldelim();
      if (m.im_biz_info != null && Object.hasOwnProperty.call(m, 'im_biz_info'))
        $root.im_proto.IMUserBizInfo.encode(m.im_biz_info, w.uint32(26).fork()).ldelim();
      return w;
    };

    IMUserProfileInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.IMUserProfileInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.im_user_profile = $root.im_proto.IMUserBaseInfo.decode(r, r.uint32());
            break;
          case 2:
            m.share_permission = $root.im_proto.SharePermission.decode(r, r.uint32());
            break;
          case 3:
            m.im_biz_info = $root.im_proto.IMUserBizInfo.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('im_user_profile'))
        throw $util.ProtocolError("missing required 'im_user_profile'", { instance: m });
      return m;
    };

    return IMUserProfileInfo;
  })();

  im_proto.PreviewStruct = (function () {
    function PreviewStruct(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    PreviewStruct.prototype.data = '';
    PreviewStruct.prototype.preview_type = 0;

    PreviewStruct.create = function create(properties) {
      return new PreviewStruct(properties);
    };

    PreviewStruct.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.data != null && Object.hasOwnProperty.call(m, 'data')) w.uint32(10).string(m.data);
      if (m.preview_type != null && Object.hasOwnProperty.call(m, 'preview_type')) w.uint32(16).int32(m.preview_type);
      return w;
    };

    PreviewStruct.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.PreviewStruct();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.data = r.string();
            break;
          case 2:
            m.preview_type = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PreviewStruct;
  })();

  im_proto.UserNowStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'NoVisibleNow')] = 0;
    values[(valuesById[1] = 'HasVisibleNow')] = 1;
    values[(valuesById[2] = 'ViewedVisibleNow')] = 2;
    return values;
  })();

  im_proto.FollowerStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[-1] = 'FollowerRelationUnknown')] = -1;
    values[(valuesById[0] = 'FollowerNotFollowStatus')] = 0;
    values[(valuesById[1] = 'FollowerFollowStatus')] = 1;
    return values;
  })();

  im_proto.BlockInfo = (function () {
    function BlockInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    BlockInfo.prototype.block = false;
    BlockInfo.prototype.blocked_by = false;

    BlockInfo.create = function create(properties) {
      return new BlockInfo(properties);
    };

    BlockInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.block != null && Object.hasOwnProperty.call(m, 'block')) w.uint32(8).bool(m.block);
      if (m.blocked_by != null && Object.hasOwnProperty.call(m, 'blocked_by')) w.uint32(16).bool(m.blocked_by);
      return w;
    };

    BlockInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.BlockInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.block = r.bool();
            break;
          case 2:
            m.blocked_by = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return BlockInfo;
  })();

  im_proto.FakeDataStruct = (function () {
    function FakeDataStruct(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    FakeDataStruct.prototype.fake_nickname = '';
    FakeDataStruct.prototype.fake_username = '';
    FakeDataStruct.prototype.is_fake_avatar = false;
    FakeDataStruct.prototype.is_fake_bio = false;

    FakeDataStruct.create = function create(properties) {
      return new FakeDataStruct(properties);
    };

    FakeDataStruct.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.fake_nickname != null && Object.hasOwnProperty.call(m, 'fake_nickname'))
        w.uint32(10).string(m.fake_nickname);
      if (m.fake_username != null && Object.hasOwnProperty.call(m, 'fake_username'))
        w.uint32(18).string(m.fake_username);
      if (m.is_fake_avatar != null && Object.hasOwnProperty.call(m, 'is_fake_avatar'))
        w.uint32(24).bool(m.is_fake_avatar);
      if (m.is_fake_bio != null && Object.hasOwnProperty.call(m, 'is_fake_bio')) w.uint32(32).bool(m.is_fake_bio);
      return w;
    };

    FakeDataStruct.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.FakeDataStruct();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.fake_nickname = r.string();
            break;
          case 2:
            m.fake_username = r.string();
            break;
          case 3:
            m.is_fake_avatar = r.bool();
            break;
          case 4:
            m.is_fake_bio = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return FakeDataStruct;
  })();

  im_proto.UserType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'UserTypeUnknown')] = 0;
    values[(valuesById[1] = 'UserTypeConversation')] = 1;
    values[(valuesById[2] = 'UserTypeFriends')] = 2;
    values[(valuesById[3] = 'UserTypeMafFriends')] = 3;
    values[(valuesById[4] = 'UserTypeFollowing')] = 4;
    return values;
  })();

  im_proto.IMUserBaseInfo = (function () {
    function IMUserBaseInfo(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    IMUserBaseInfo.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    IMUserBaseInfo.prototype.avatars = null;
    IMUserBaseInfo.prototype.nick_name = '';
    IMUserBaseInfo.prototype.follow_status = -1;
    IMUserBaseInfo.prototype.maf_status = 0;
    IMUserBaseInfo.prototype.update_time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    IMUserBaseInfo.prototype.unique_id = '';
    IMUserBaseInfo.prototype.rec_type = '';
    IMUserBaseInfo.prototype.user_type = 0;
    IMUserBaseInfo.prototype.follower_status = -1;
    IMUserBaseInfo.prototype.block_info = null;
    IMUserBaseInfo.prototype.recommend_reason = '';
    IMUserBaseInfo.prototype.enterprise_verify_reason = '';
    IMUserBaseInfo.prototype.user_verify_reason = '';
    IMUserBaseInfo.prototype.user_verify_type = 0;
    IMUserBaseInfo.prototype.deleted = 0;
    IMUserBaseInfo.prototype.following_count = 0;
    IMUserBaseInfo.prototype.follower_count = 0;
    IMUserBaseInfo.prototype.fake_data_info = null;

    IMUserBaseInfo.create = function create(properties) {
      return new IMUserBaseInfo(properties);
    };

    IMUserBaseInfo.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int64(m.user_id);
      $root.im_proto.Avatars.encode(m.avatars, w.uint32(18).fork()).ldelim();
      w.uint32(26).string(m.nick_name);
      w.uint32(32).int32(m.follow_status);
      w.uint32(40).int32(m.maf_status);
      w.uint32(48).int64(m.update_time);
      w.uint32(58).string(m.unique_id);
      w.uint32(66).string(m.rec_type);
      w.uint32(72).int32(m.user_type);
      if (m.follower_status != null && Object.hasOwnProperty.call(m, 'follower_status'))
        w.uint32(80).int32(m.follower_status);
      if (m.block_info != null && Object.hasOwnProperty.call(m, 'block_info'))
        $root.im_proto.BlockInfo.encode(m.block_info, w.uint32(90).fork()).ldelim();
      if (m.recommend_reason != null && Object.hasOwnProperty.call(m, 'recommend_reason'))
        w.uint32(98).string(m.recommend_reason);
      if (m.enterprise_verify_reason != null && Object.hasOwnProperty.call(m, 'enterprise_verify_reason'))
        w.uint32(106).string(m.enterprise_verify_reason);
      if (m.user_verify_reason != null && Object.hasOwnProperty.call(m, 'user_verify_reason'))
        w.uint32(114).string(m.user_verify_reason);
      if (m.user_verify_type != null && Object.hasOwnProperty.call(m, 'user_verify_type'))
        w.uint32(120).int32(m.user_verify_type);
      if (m.deleted != null && Object.hasOwnProperty.call(m, 'deleted')) w.uint32(128).int32(m.deleted);
      if (m.following_count != null && Object.hasOwnProperty.call(m, 'following_count'))
        w.uint32(136).int32(m.following_count);
      if (m.follower_count != null && Object.hasOwnProperty.call(m, 'follower_count'))
        w.uint32(144).int32(m.follower_count);
      if (m.fake_data_info != null && Object.hasOwnProperty.call(m, 'fake_data_info'))
        $root.im_proto.FakeDataStruct.encode(m.fake_data_info, w.uint32(154).fork()).ldelim();
      return w;
    };

    IMUserBaseInfo.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.IMUserBaseInfo();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.int64();
            break;
          case 2:
            m.avatars = $root.im_proto.Avatars.decode(r, r.uint32());
            break;
          case 3:
            m.nick_name = r.string();
            break;
          case 4:
            m.follow_status = r.int32();
            break;
          case 5:
            m.maf_status = r.int32();
            break;
          case 6:
            m.update_time = r.int64();
            break;
          case 7:
            m.unique_id = r.string();
            break;
          case 8:
            m.rec_type = r.string();
            break;
          case 9:
            m.user_type = r.int32();
            break;
          case 10:
            m.follower_status = r.int32();
            break;
          case 11:
            m.block_info = $root.im_proto.BlockInfo.decode(r, r.uint32());
            break;
          case 12:
            m.recommend_reason = r.string();
            break;
          case 13:
            m.enterprise_verify_reason = r.string();
            break;
          case 14:
            m.user_verify_reason = r.string();
            break;
          case 15:
            m.user_verify_type = r.int32();
            break;
          case 16:
            m.deleted = r.int32();
            break;
          case 17:
            m.following_count = r.int32();
            break;
          case 18:
            m.follower_count = r.int32();
            break;
          case 19:
            m.fake_data_info = $root.im_proto.FakeDataStruct.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('user_id')) throw $util.ProtocolError("missing required 'user_id'", { instance: m });
      if (!m.hasOwnProperty('avatars')) throw $util.ProtocolError("missing required 'avatars'", { instance: m });
      if (!m.hasOwnProperty('nick_name')) throw $util.ProtocolError("missing required 'nick_name'", { instance: m });
      if (!m.hasOwnProperty('follow_status'))
        throw $util.ProtocolError("missing required 'follow_status'", { instance: m });
      if (!m.hasOwnProperty('maf_status')) throw $util.ProtocolError("missing required 'maf_status'", { instance: m });
      if (!m.hasOwnProperty('update_time'))
        throw $util.ProtocolError("missing required 'update_time'", { instance: m });
      if (!m.hasOwnProperty('unique_id')) throw $util.ProtocolError("missing required 'unique_id'", { instance: m });
      if (!m.hasOwnProperty('rec_type')) throw $util.ProtocolError("missing required 'rec_type'", { instance: m });
      if (!m.hasOwnProperty('user_type')) throw $util.ProtocolError("missing required 'user_type'", { instance: m });
      return m;
    };

    return IMUserBaseInfo;
  })();

  im_proto.Avatars = (function () {
    function Avatars(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    Avatars.prototype.avatar_small = null;
    Avatars.prototype.avatar_medium = null;

    Avatars.create = function create(properties) {
      return new Avatars(properties);
    };

    Avatars.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.avatar_small != null && Object.hasOwnProperty.call(m, 'avatar_small'))
        $root.im_proto.UrlStruct.encode(m.avatar_small, w.uint32(10).fork()).ldelim();
      if (m.avatar_medium != null && Object.hasOwnProperty.call(m, 'avatar_medium'))
        $root.im_proto.UrlStruct.encode(m.avatar_medium, w.uint32(18).fork()).ldelim();
      return w;
    };

    Avatars.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.Avatars();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.avatar_small = $root.im_proto.UrlStruct.decode(r, r.uint32());
            break;
          case 2:
            m.avatar_medium = $root.im_proto.UrlStruct.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Avatars;
  })();

  im_proto.IMMafStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'Status_Unknown')] = 0;
    values[(valuesById[1] = 'Status_MAF')] = 1;
    values[(valuesById[2] = 'Status_NOT_MAF')] = 2;
    return values;
  })();

  im_proto.IMUserDeleteStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'IM_USER_DELETE_STATUS_NONE')] = 0;
    values[(valuesById[1] = 'IM_USER_DELETE_STATUS_ACCOUNT_DELETED')] = 1;
    values[(valuesById[2] = 'IM_USER_DELETE_STATUS_FTC')] = 2;
    return values;
  })();

  im_proto.tiktok_v1_im_user_profile_request = (function () {
    function tiktok_v1_im_user_profile_request(p) {
      this.user_ids = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    tiktok_v1_im_user_profile_request.prototype.user_ids = $util.emptyArray;
    tiktok_v1_im_user_profile_request.prototype.source = '';

    tiktok_v1_im_user_profile_request.create = function create(properties) {
      return new tiktok_v1_im_user_profile_request(properties);
    };

    tiktok_v1_im_user_profile_request.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_ids != null && m.user_ids.length) {
        for (var i = 0; i < m.user_ids.length; ++i) w.uint32(10).string(m.user_ids[i]);
      }
      if (m.source != null && Object.hasOwnProperty.call(m, 'source')) w.uint32(82).string(m.source);
      return w;
    };

    tiktok_v1_im_user_profile_request.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.tiktok_v1_im_user_profile_request();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.user_ids && m.user_ids.length)) m.user_ids = [];
            m.user_ids.push(r.string());
            break;
          case 10:
            m.source = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return tiktok_v1_im_user_profile_request;
  })();

  im_proto.tiktok_v1_im_user_profile_response = (function () {
    function tiktok_v1_im_user_profile_response(p) {
      this.users = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    tiktok_v1_im_user_profile_response.prototype.users = $util.emptyArray;
    tiktok_v1_im_user_profile_response.prototype.status_code = 0;
    tiktok_v1_im_user_profile_response.prototype.status_msg = '';

    tiktok_v1_im_user_profile_response.create = function create(properties) {
      return new tiktok_v1_im_user_profile_response(properties);
    };

    tiktok_v1_im_user_profile_response.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.users != null && m.users.length) {
        for (var i = 0; i < m.users.length; ++i)
          $root.im_proto.IMUserProfileInfo.encode(m.users[i], w.uint32(10).fork()).ldelim();
      }
      w.uint32(16).int32(m.status_code);
      if (m.status_msg != null && Object.hasOwnProperty.call(m, 'status_msg')) w.uint32(26).string(m.status_msg);
      return w;
    };

    tiktok_v1_im_user_profile_response.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.tiktok_v1_im_user_profile_response();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.users && m.users.length)) m.users = [];
            m.users.push($root.im_proto.IMUserProfileInfo.decode(r, r.uint32()));
            break;
          case 2:
            m.status_code = r.int32();
            break;
          case 3:
            m.status_msg = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('status_code'))
        throw $util.ProtocolError("missing required 'status_code'", { instance: m });
      return m;
    };

    return tiktok_v1_im_user_profile_response;
  })();

  im_proto.GroupNameDefinition = (function () {
    function GroupNameDefinition(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GroupNameDefinition.prototype.user_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GroupNameDefinition.prototype.custom_group_name = '';

    GroupNameDefinition.create = function create(properties) {
      return new GroupNameDefinition(properties);
    };

    GroupNameDefinition.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.user_id != null && Object.hasOwnProperty.call(m, 'user_id')) w.uint32(8).int64(m.user_id);
      if (m.custom_group_name != null && Object.hasOwnProperty.call(m, 'custom_group_name'))
        w.uint32(18).string(m.custom_group_name);
      return w;
    };

    GroupNameDefinition.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GroupNameDefinition();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.user_id = r.int64();
            break;
          case 2:
            m.custom_group_name = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GroupNameDefinition;
  })();

  im_proto.GroupListReqParam = (function () {
    function GroupListReqParam(p) {
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GroupListReqParam.prototype.group_name = null;
    GroupListReqParam.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GroupListReqParam.prototype.direction = 0;
    GroupListReqParam.prototype.limit = 0;

    GroupListReqParam.create = function create(properties) {
      return new GroupListReqParam(properties);
    };

    GroupListReqParam.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.group_name != null && Object.hasOwnProperty.call(m, 'group_name'))
        $root.im_proto.GroupNameDefinition.encode(m.group_name, w.uint32(10).fork()).ldelim();
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(16).int64(m.cursor);
      if (m.direction != null && Object.hasOwnProperty.call(m, 'direction')) w.uint32(24).int32(m.direction);
      if (m.limit != null && Object.hasOwnProperty.call(m, 'limit')) w.uint32(32).int32(m.limit);
      return w;
    };

    GroupListReqParam.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GroupListReqParam();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.group_name = $root.im_proto.GroupNameDefinition.decode(r, r.uint32());
            break;
          case 2:
            m.cursor = r.int64();
            break;
          case 3:
            m.direction = r.int32();
            break;
          case 4:
            m.limit = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GroupListReqParam;
  })();

  im_proto.GetConversationGroupListRequestBody = (function () {
    function GetConversationGroupListRequestBody(p) {
      this.group_list_req_param = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationGroupListRequestBody.prototype.inbox_type = 0;
    GetConversationGroupListRequestBody.prototype.only_conversation_short_id = false;
    GetConversationGroupListRequestBody.prototype.group_list_req_param = $util.emptyArray;

    GetConversationGroupListRequestBody.create = function create(properties) {
      return new GetConversationGroupListRequestBody(properties);
    };

    GetConversationGroupListRequestBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.inbox_type != null && Object.hasOwnProperty.call(m, 'inbox_type')) w.uint32(8).int32(m.inbox_type);
      if (m.only_conversation_short_id != null && Object.hasOwnProperty.call(m, 'only_conversation_short_id'))
        w.uint32(16).bool(m.only_conversation_short_id);
      if (m.group_list_req_param != null && m.group_list_req_param.length) {
        for (var i = 0; i < m.group_list_req_param.length; ++i)
          $root.im_proto.GroupListReqParam.encode(m.group_list_req_param[i], w.uint32(26).fork()).ldelim();
      }
      return w;
    };

    GetConversationGroupListRequestBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationGroupListRequestBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.inbox_type = r.int32();
            break;
          case 2:
            m.only_conversation_short_id = r.bool();
            break;
          case 3:
            if (!(m.group_list_req_param && m.group_list_req_param.length)) m.group_list_req_param = [];
            m.group_list_req_param.push($root.im_proto.GroupListReqParam.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationGroupListRequestBody;
  })();

  im_proto.GetConversationGroupListResponseBody = (function () {
    function GetConversationGroupListResponseBody(p) {
      this.data = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GetConversationGroupListResponseBody.prototype.data = $util.emptyArray;

    GetConversationGroupListResponseBody.create = function create(properties) {
      return new GetConversationGroupListResponseBody(properties);
    };

    GetConversationGroupListResponseBody.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.data != null && m.data.length) {
        for (var i = 0; i < m.data.length; ++i)
          $root.im_proto.GroupListData.encode(m.data[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    GetConversationGroupListResponseBody.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GetConversationGroupListResponseBody();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.data && m.data.length)) m.data = [];
            m.data.push($root.im_proto.GroupListData.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetConversationGroupListResponseBody;
  })();

  im_proto.GroupListData = (function () {
    function GroupListData(p) {
      this.conversations = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    GroupListData.prototype.group_name = null;
    GroupListData.prototype.cursor = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    GroupListData.prototype.has_more = false;
    GroupListData.prototype.total_count = 0;
    GroupListData.prototype.conversations = $util.emptyArray;

    GroupListData.create = function create(properties) {
      return new GroupListData(properties);
    };

    GroupListData.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.group_name != null && Object.hasOwnProperty.call(m, 'group_name'))
        $root.im_proto.GroupNameDefinition.encode(m.group_name, w.uint32(10).fork()).ldelim();
      if (m.cursor != null && Object.hasOwnProperty.call(m, 'cursor')) w.uint32(16).int64(m.cursor);
      if (m.has_more != null && Object.hasOwnProperty.call(m, 'has_more')) w.uint32(24).bool(m.has_more);
      if (m.total_count != null && Object.hasOwnProperty.call(m, 'total_count')) w.uint32(32).int32(m.total_count);
      if (m.conversations != null && m.conversations.length) {
        for (var i = 0; i < m.conversations.length; ++i)
          $root.im_proto.ConversationInfoWithMessage.encode(m.conversations[i], w.uint32(42).fork()).ldelim();
      }
      return w;
    };

    GroupListData.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.GroupListData();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.group_name = $root.im_proto.GroupNameDefinition.decode(r, r.uint32());
            break;
          case 2:
            m.cursor = r.int64();
            break;
          case 3:
            m.has_more = r.bool();
            break;
          case 4:
            m.total_count = r.int32();
            break;
          case 5:
            if (!(m.conversations && m.conversations.length)) m.conversations = [];
            m.conversations.push($root.im_proto.ConversationInfoWithMessage.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GroupListData;
  })();

  im_proto.ConversationInfoWithMessage = (function () {
    function ConversationInfoWithMessage(p) {
      this.messages = [];
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationInfoWithMessage.prototype.conversation_info = null;
    ConversationInfoWithMessage.prototype.messages = $util.emptyArray;

    ConversationInfoWithMessage.create = function create(properties) {
      return new ConversationInfoWithMessage(properties);
    };

    ConversationInfoWithMessage.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.conversation_info != null && Object.hasOwnProperty.call(m, 'conversation_info'))
        $root.im_proto.ConversationInfoV2.encode(m.conversation_info, w.uint32(10).fork()).ldelim();
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(18).fork()).ldelim();
      }
      return w;
    };

    ConversationInfoWithMessage.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationInfoWithMessage();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.conversation_info = $root.im_proto.ConversationInfoV2.decode(r, r.uint32());
            break;
          case 2:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ConversationInfoWithMessage;
  })();

  im_proto.ConversationGroupPushType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'Unknown')] = 0;
    values[(valuesById[1] = 'GroupAddConversation')] = 1;
    values[(valuesById[2] = 'GroupDeleteConversation')] = 2;
    values[(valuesById[3] = 'GroupConversationNewMsg')] = 3;
    values[(valuesById[4] = 'GroupConversationCoreInfoUpdate')] = 4;
    values[(valuesById[5] = 'GroupConversationParticipantsUpdate')] = 5;
    return values;
  })();

  im_proto.ConversationGroupPushContent = (function () {
    function ConversationGroupPushContent(p) {
      this.groups = [];
      this.ext = {};
      if (p) for (var ks = Object.keys(p), i = 0; i < ks.length; ++i) if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    ConversationGroupPushContent.prototype.push_type = 0;
    ConversationGroupPushContent.prototype.groups = $util.emptyArray;
    ConversationGroupPushContent.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    ConversationGroupPushContent.prototype.message_body = null;
    ConversationGroupPushContent.prototype.ext = $util.emptyObject;

    ConversationGroupPushContent.create = function create(properties) {
      return new ConversationGroupPushContent(properties);
    };

    ConversationGroupPushContent.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      w.uint32(8).int32(m.push_type);
      if (m.groups != null && m.groups.length) {
        for (var i = 0; i < m.groups.length; ++i)
          $root.im_proto.GroupNameDefinition.encode(m.groups[i], w.uint32(18).fork()).ldelim();
      }
      w.uint32(24).int64(m.conversation_short_id);
      if (m.message_body != null && Object.hasOwnProperty.call(m, 'message_body'))
        $root.im_proto.MessageBody.encode(m.message_body, w.uint32(34).fork()).ldelim();
      if (m.ext != null && Object.hasOwnProperty.call(m, 'ext')) {
        for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
          w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
        }
      }
      return w;
    };

    ConversationGroupPushContent.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.im_proto.ConversationGroupPushContent(),
        k,
        value;
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.push_type = r.int32();
            break;
          case 2:
            if (!(m.groups && m.groups.length)) m.groups = [];
            m.groups.push($root.im_proto.GroupNameDefinition.decode(r, r.uint32()));
            break;
          case 3:
            m.conversation_short_id = r.int64();
            break;
          case 4:
            m.message_body = $root.im_proto.MessageBody.decode(r, r.uint32());
            break;
          case 5:
            if (m.ext === $util.emptyObject) m.ext = {};
            var c2 = r.uint32() + r.pos;
            k = '';
            value = '';
            while (r.pos < c2) {
              var tag2 = r.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  k = r.string();
                  break;
                case 2:
                  value = r.string();
                  break;
                default:
                  r.skipType(tag2 & 7);
                  break;
              }
            }
            m.ext[k] = value;
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      if (!m.hasOwnProperty('push_type')) throw $util.ProtocolError("missing required 'push_type'", { instance: m });
      if (!m.hasOwnProperty('conversation_short_id'))
        throw $util.ProtocolError("missing required 'conversation_short_id'", { instance: m });
      return m;
    };

    return ConversationGroupPushContent;
  })();

  return im_proto;
})());

export { $root as default };
